function numeralFemaleEnding(condition) {
    var val = condition % 10;
    return val === 3 && condition !== 13
        ? condition + "-ью"
        : condition + "-ую";
}
function numeralMaleEnding(condition) {
    var val = condition % 10;
    if ((condition >= 10 && condition <= 20)
        || (val === 0 && condition !== 0 && condition % 100 !== 40)
        || (val === 1 || val === 4 || val === 5 || val === 9)) {
        return condition + "-ый";
    }
    return val === 3 ? condition + "-ий" : condition + "-ой";
}
function numeralNeuterEnding(condition) {
    var val = condition % 10;
    return val === 3 && condition !== 13 ? condition + "-ье" : condition + "-ое";
}
function plural(count, parameters) {
    var m10 = count % 10;
    var m100 = count % 100;
    if (m10 === 1 && m100 !== 11) {
        return parameters[0];
    }
    if (m10 >= 2 && m10 <= 4 && (m100 < 10 || m100 >= 20)) {
        return parameters[1];
    }
    return parameters[2];
}
function signed(condition) {
    if (condition === 0) {
        return '0';
    }
    var num = Number.parseFloat(condition.toFixed(2));
    if (condition > 0) {
        return '+' + num.toString();
    }
    return num.toString();
}
function europeanHandicapCondition(condition) {
    if (condition < 0) {
        return "0:" + Math.abs(condition);
    }
    else {
        return Math.abs(condition) + ":0";
    }
}
var bo_b1 = function (match, outcome) { return 'Фора'; };
var bo_c1 = function (match, outcome) { return 'Тотал матча'; };
var bo_d1 = function (match, outcome) { return "\u0422\u043E\u0442\u0430\u043B: ".concat(match.homeTeam); };
var bo_e1 = function (match, outcome) { return "\u0422\u043E\u0442\u0430\u043B: ".concat(match.awayTeam); };
var bo_f1 = function (match, outcome) { return 'Чет/Нечет тотала матча'; };
var bo_g1 = function (match, outcome) { return "".concat(match.homeTeam, " - ").concat(match.awayTeam); };
var bo_h1 = function (match, outcome) { return "".concat(outcome.teamOne, " - ").concat(outcome.teamTwo); };
var bo_i1 = function (match, outcome) { return "".concat(outcome.teamOne); };
var bo_j1 = function (match, outcome) { return 'Фора в первом сете'; };
var bo_k1 = function (match, outcome) { return 'Фора во втором сете'; };
var bo_l1 = function (match, outcome) { return 'Фора в третьем сете'; };
var bo_m1 = function (match, outcome) { return 'Тотал первого сета'; };
var bo_n1 = function (match, outcome) { return 'Тотал второго сета'; };
var bo_o1 = function (match, outcome) { return 'Тотал третьего сета'; };
var bo_p1 = function (match, outcome) { return 'Тотал сетов в матче'; };
var bo_q1 = function (match, outcome) { return 'Счет матча'; };
var bo_r1 = function (match, outcome) { return 'Результат первого сета'; };
var bo_s1 = function (match, outcome) { return 'Результат второго сета'; };
var bo_t1 = function (match, outcome) { return 'Результат третьего сета'; };
var bo_u1 = function (match, outcome) { return "\u0422\u043E\u0442\u0430\u043B: ".concat(match.homeTeam, " \u0432 \u043F\u0435\u0440\u0432\u043E\u043C \u0441\u0435\u0442\u0435"); };
var bo_v1 = function (match, outcome) { return "\u0422\u043E\u0442\u0430\u043B: ".concat(match.homeTeam, " \u0432\u043E \u0432\u0442\u043E\u0440\u043E\u043C \u0441\u0435\u0442\u0435"); };
var bo_w1 = function (match, outcome) { return "\u0422\u043E\u0442\u0430\u043B: ".concat(match.homeTeam, " \u0432 \u0442\u0440\u0435\u0442\u044C\u0435\u043C \u0441\u0435\u0442\u0435"); };
var bo_x1 = function (match, outcome) { return "\u0422\u043E\u0442\u0430\u043B: ".concat(match.awayTeam, " \u0432 \u043F\u0435\u0440\u0432\u043E\u043C \u0441\u0435\u0442\u0435"); };
var bo_y1 = function (match, outcome) { return "\u0422\u043E\u0442\u0430\u043B: ".concat(match.awayTeam, " \u0432\u043E \u0432\u0442\u043E\u0440\u043E\u043C \u0441\u0435\u0442\u0435"); };
var bo_z1 = function (match, outcome) { return "\u0422\u043E\u0442\u0430\u043B: ".concat(match.awayTeam, " \u0432 \u0442\u0440\u0435\u0442\u044C\u0435\u043C \u0441\u0435\u0442\u0435"); };
var bo_a2 = function (match, outcome) { return "".concat(match.homeTeam, " \u043F\u043E\u0431\u0435\u0434\u0438\u0442 \u0440\u043E\u0432\u043D\u043E \u0432 ").concat(outcome.condition, " ").concat(plural(outcome.condition, ['очко', 'очка', 'очков']), " \u0432 \u043F\u0435\u0440\u0432\u043E\u043C \u0441\u0435\u0442\u0435"); };
var bo_b2 = function (match, outcome) { return "".concat(match.homeTeam, " \u043F\u043E\u0431\u0435\u0434\u0438\u0442 \u0440\u043E\u0432\u043D\u043E \u0432 ").concat(outcome.condition, " ").concat(plural(outcome.condition, ['очко', 'очка', 'очков']), " \u0432\u043E \u0432\u0442\u043E\u0440\u043E\u043C \u0441\u0435\u0442\u0435"); };
var bo_c2 = function (match, outcome) { return "".concat(match.homeTeam, " \u043F\u043E\u0431\u0435\u0434\u0438\u0442 \u0440\u043E\u0432\u043D\u043E \u0432 ").concat(outcome.condition, " ").concat(plural(outcome.condition, ['очко', 'очка', 'очков']), " \u0432 \u0442\u0440\u0435\u0442\u044C\u0435\u043C \u0441\u0435\u0442\u0435"); };
var bo_d2 = function (match, outcome) { return "".concat(match.awayTeam, " \u043F\u043E\u0431\u0435\u0434\u0438\u0442 \u0440\u043E\u0432\u043D\u043E \u0432 ").concat(outcome.condition, " ").concat(plural(outcome.condition, ['очко', 'очка', 'очков']), " \u0432 \u043F\u0435\u0440\u0432\u043E\u043C \u0441\u0435\u0442\u0435"); };
var bo_e2 = function (match, outcome) { return "".concat(match.awayTeam, " \u043F\u043E\u0431\u0435\u0434\u0438\u0442 \u0440\u043E\u0432\u043D\u043E \u0432 ").concat(outcome.condition, " ").concat(plural(outcome.condition, ['очко', 'очка', 'очков']), " \u0432\u043E \u0432\u0442\u043E\u0440\u043E\u043C \u0441\u0435\u0442\u0435"); };
var bo_f2 = function (match, outcome) { return "".concat(match.awayTeam, " \u043F\u043E\u0431\u0435\u0434\u0438\u0442 \u0440\u043E\u0432\u043D\u043E \u0432 ").concat(outcome.condition, " ").concat(plural(outcome.condition, ['очко', 'очка', 'очков']), " \u0432 \u0442\u0440\u0435\u0442\u044C\u0435\u043C \u0441\u0435\u0442\u0435"); };
var bo_g2 = function (match, outcome) { return "\u041A\u0442\u043E \u043F\u0435\u0440\u0432\u044B\u043C \u043D\u0430\u0431\u0435\u0440\u0435\u0442 ".concat(outcome.condition, " ").concat(plural(outcome.condition, ['очко', 'очков', 'очков']), " \u0432 1\u043E\u043C \u0441\u0435\u0442\u0435"); };
var bo_h2 = function (match, outcome) { return "\u041A\u0442\u043E \u043F\u0435\u0440\u0432\u044B\u043C \u043D\u0430\u0431\u0435\u0440\u0435\u0442 ".concat(outcome.condition, " ").concat(plural(outcome.condition, ['очко', 'очков', 'очков']), " \u0432\u043E 2\u043E\u043C \u0441\u0435\u0442\u0435"); };
var bo_i2 = function (match, outcome) { return "\u041A\u0442\u043E \u043F\u0435\u0440\u0432\u044B\u043C \u043D\u0430\u0431\u0435\u0440\u0435\u0442 ".concat(outcome.condition, " ").concat(plural(outcome.condition, ['очко', 'очков', 'очков']), " \u0432 3\u0435\u043C \u0441\u0435\u0442\u0435"); };
var bo_j2 = function (match, outcome) { return "\u041A\u0442\u043E \u0432\u044B\u0438\u0433\u0440\u0430\u0435\u0442 ".concat(numeralNeuterEnding(outcome.condition), " \u043E\u0447\u043A\u043E \u0432 \u043F\u0435\u0440\u0432\u043E\u043C \u0441\u0435\u0442\u0435"); };
var bo_k2 = function (match, outcome) { return "\u041A\u0442\u043E \u0432\u044B\u0438\u0433\u0440\u0430\u0435\u0442 ".concat(numeralNeuterEnding(outcome.condition), " \u043E\u0447\u043A\u043E \u0432\u043E \u0432\u0442\u043E\u0440\u043E\u043C \u0441\u0435\u0442\u0435"); };
var bo_l2 = function (match, outcome) { return "\u041A\u0442\u043E \u0432\u044B\u0438\u0433\u0440\u0430\u0435\u0442 ".concat(numeralNeuterEnding(outcome.condition), " \u043E\u0447\u043A\u043E \u0432 \u0442\u0440\u0435\u0442\u044C\u0435\u043C \u0441\u0435\u0442\u0435"); };
var bo_m2 = function (match, outcome) { return 'Победа в минисете до 10 очков первого сета'; };
var bo_n2 = function (match, outcome) { return 'Победа в минисете до 10 очков второго сета'; };
var bo_o2 = function (match, outcome) { return 'Победа в минисете до 10 очков третьего сета'; };
var bo_p2 = function (match, outcome) { return 'Фора в минисете до 10 очков первого сета'; };
var bo_q2 = function (match, outcome) { return 'Фора в минисете до 10 очков второго сета'; };
var bo_r2 = function (match, outcome) { return 'Фора в минисете до 10 очков третьего сета'; };
var bo_s2 = function (match, outcome) { return 'Тотал в минисете до 10 очков первого сета'; };
var bo_t2 = function (match, outcome) { return 'Тотал в минисете до 10 очков второго сета'; };
var bo_u2 = function (match, outcome) { return 'Тотал в минисете до 10 очков третьего сета'; };
var bo_v2 = function (match, outcome) { return 'Победа в минисете до 15 очков первого сета'; };
var bo_w2 = function (match, outcome) { return 'Победа в минисете до 15 очков второго сета'; };
var bo_x2 = function (match, outcome) { return 'Победа в минисете до 15 очков третьего сета'; };
var bo_y2 = function (match, outcome) { return 'Фора в минисете до 15 очков первого сета'; };
var bo_z2 = function (match, outcome) { return 'Фора в минисете до 15 очков второго сета'; };
var bo_a3 = function (match, outcome) { return 'Фора в минисете до 15 очков третьего сета'; };
var bo_b3 = function (match, outcome) { return 'Тотал в минисете до 15 очков первого сета'; };
var bo_c3 = function (match, outcome) { return 'Тотал в минисете до 15 очков второго сета'; };
var bo_d3 = function (match, outcome) { return 'Тотал в минисете до 15 очков третьего сета'; };
var bo_e3 = function (match, outcome) { return "\u0422\u043E\u0442\u0430\u043B: ".concat(match.homeTeam, " \u0432 \u043F\u0435\u0440\u0432\u043E\u043C \u0442\u0430\u0439\u043C\u0435"); };
var bo_f3 = function (match, outcome) { return 'Фора в первом тайме'; };
var bo_g3 = function (match, outcome) { return 'Результат первого тайма'; };
var bo_h3 = function (match, outcome) { return "\u0422\u043E\u0442\u0430\u043B: ".concat(match.awayTeam, " \u0432 \u043F\u0435\u0440\u0432\u043E\u043C \u0442\u0430\u0439\u043C\u0435"); };
var bo_i3 = function (match, outcome) { return "\u041A\u0442\u043E \u0437\u0430\u0431\u044C\u0435\u0442 ".concat(numeralMaleEnding(outcome.condition), " \u0433\u043E\u043B?"); };
var bo_j3 = function (match, outcome) { return 'Двойной исход'; };
var bo_k3 = function (match, outcome) { return 'Тотал первого тайма'; };
var bo_l3 = function (match, outcome) { return "\u041F\u043E\u0431\u0435\u0434\u0430 \u0438 \u0442\u043E\u0442\u0430\u043B \u043C\u0430\u0442\u0447\u0430 ".concat(outcome.condition); };
var bo_m3 = function (match, outcome) { return "".concat(match.homeTeam, " \u043F\u043E\u0431\u0435\u0434\u0438\u0442 \u0440\u043E\u0432\u043D\u043E \u0432 ").concat(outcome.condition, " ").concat(plural(outcome.condition, ['гол', 'гола', 'голов'])); };
var bo_n3 = function (match, outcome) { return "".concat(match.awayTeam, " \u043F\u043E\u0431\u0435\u0434\u0438\u0442 \u0440\u043E\u0432\u043D\u043E \u0432 ").concat(outcome.condition, " ").concat(plural(outcome.condition, ['гол', 'гола', 'голов'])); };
var bo_o3 = function (match, outcome) { return 'Точный тотал матча'; };
var bo_p3 = function (match, outcome) { return 'Сколько команд забьёт'; };
var bo_q3 = function (match, outcome) { return 'Точный счет'; };
var bo_r3 = function (match, outcome) { return 'Азиатская фора'; };
var bo_s3 = function (match, outcome) { return 'Фора в первой четверти'; };
var bo_t3 = function (match, outcome) { return 'Фора во второй четверти'; };
var bo_u3 = function (match, outcome) { return 'Фора в третьей четверти'; };
var bo_v3 = function (match, outcome) { return 'Фора в четвертой четверти'; };
var bo_w3 = function (match, outcome) { return 'Тотал первой четверти'; };
var bo_x3 = function (match, outcome) { return 'Тотал второй четверти'; };
var bo_y3 = function (match, outcome) { return 'Тотал третьей четверти'; };
var bo_z3 = function (match, outcome) { return 'Тотал четвертой четверти'; };
var bo_a4 = function (match, outcome) { return 'Результат первой четверти'; };
var bo_b4 = function (match, outcome) { return 'Результат второй четверти'; };
var bo_c4 = function (match, outcome) { return 'Результат третьей четверти'; };
var bo_d4 = function (match, outcome) { return 'Результат четвертой четверти'; };
var bo_e4 = function (match, outcome) { return "\u0422\u043E\u0442\u0430\u043B: ".concat(match.homeTeam, " \u0432 \u043F\u0435\u0440\u0432\u043E\u0439 \u0447\u0435\u0442\u0432\u0435\u0440\u0442\u0438"); };
var bo_f4 = function (match, outcome) { return "\u0422\u043E\u0442\u0430\u043B: ".concat(match.homeTeam, " \u0432\u043E \u0432\u0442\u043E\u0440\u043E\u0439 \u0447\u0435\u0442\u0432\u0435\u0440\u0442\u0438"); };
var bo_g4 = function (match, outcome) { return "\u0422\u043E\u0442\u0430\u043B: ".concat(match.homeTeam, " \u0432 \u0442\u0440\u0435\u0442\u044C\u0435\u0439 \u0447\u0435\u0442\u0432\u0435\u0440\u0442\u0438"); };
var bo_h4 = function (match, outcome) { return "\u0422\u043E\u0442\u0430\u043B: ".concat(match.homeTeam, " \u0432 \u0447\u0435\u0442\u0432\u0435\u0440\u0442\u043E\u0439 \u0447\u0435\u0442\u0432\u0435\u0440\u0442\u0438"); };
var bo_i4 = function (match, outcome) { return "\u0422\u043E\u0442\u0430\u043B: ".concat(match.awayTeam, " \u0432 \u043F\u0435\u0440\u0432\u043E\u0439 \u0447\u0435\u0442\u0432\u0435\u0440\u0442\u0438"); };
var bo_j4 = function (match, outcome) { return "\u0422\u043E\u0442\u0430\u043B: ".concat(match.awayTeam, " \u0432\u043E \u0432\u0442\u043E\u0440\u043E\u0439 \u0447\u0435\u0442\u0432\u0435\u0440\u0442\u0438"); };
var bo_k4 = function (match, outcome) { return "\u0422\u043E\u0442\u0430\u043B: ".concat(match.awayTeam, " \u0432 \u0442\u0440\u0435\u0442\u044C\u0435\u0439 \u0447\u0435\u0442\u0432\u0435\u0440\u0442\u0438"); };
var bo_l4 = function (match, outcome) { return "\u0422\u043E\u0442\u0430\u043B: ".concat(match.awayTeam, " \u0432 \u0447\u0435\u0442\u0432\u0435\u0440\u0442\u043E\u0439 \u0447\u0435\u0442\u0432\u0435\u0440\u0442\u0438"); };
var bo_m4 = function (match, outcome) { return 'Тотал первой половины'; };
var bo_n4 = function (match, outcome) { return 'Результат во второй половине'; };
var bo_o4 = function (match, outcome) { return 'Тотал второй половины'; };
var bo_p4 = function (match, outcome) { return 'Фора в первой половине'; };
var bo_q4 = function (match, outcome) { return 'Фора во второй половине'; };
var bo_r4 = function (match, outcome) { return 'Результат в первой половине'; };
var bo_s4 = function (match, outcome) { return "\u0422\u043E\u0442\u0430\u043B: ".concat(match.homeTeam, " \u0432 \u043F\u0435\u0440\u0432\u043E\u0439 \u043F\u043E\u043B\u043E\u0432\u0438\u043D\u0435"); };
var bo_t4 = function (match, outcome) { return "\u0422\u043E\u0442\u0430\u043B: ".concat(match.homeTeam, " \u0432\u043E \u0432\u0442\u043E\u0440\u043E\u0439 \u043F\u043E\u043B\u043E\u0432\u0438\u043D\u0435"); };
var bo_u4 = function (match, outcome) { return "\u0422\u043E\u0442\u0430\u043B: ".concat(match.awayTeam, " \u0432 \u043F\u0435\u0440\u0432\u043E\u0439 \u043F\u043E\u043B\u043E\u0432\u0438\u043D\u0435"); };
var bo_v4 = function (match, outcome) { return "\u0422\u043E\u0442\u0430\u043B: ".concat(match.awayTeam, " \u0432\u043E \u0432\u0442\u043E\u0440\u043E\u0439 \u043F\u043E\u043B\u043E\u0432\u0438\u043D\u0435"); };
var bo_w4 = function (match, outcome) { return "\u041A\u0442\u043E \u043F\u0435\u0440\u0432\u044B\u043C \u043D\u0430\u0431\u0435\u0440\u0435\u0442 ".concat(outcome.condition, " ").concat(plural(outcome.condition, ['очко', 'очков', 'очков']), " \u0432 1\u043E\u0439 \u0447\u0435\u0442\u0432\u0435\u0440\u0442\u0438"); };
var bo_x4 = function (match, outcome) { return "\u041A\u0442\u043E \u043F\u0435\u0440\u0432\u044B\u043C \u043D\u0430\u0431\u0435\u0440\u0435\u0442 ".concat(outcome.condition, " ").concat(plural(outcome.condition, ['очко', 'очков', 'очков']), " \u0432\u043E 2\u043E\u0439 \u0447\u0435\u0442\u0432\u0435\u0440\u0442\u0438"); };
var bo_y4 = function (match, outcome) { return "\u041A\u0442\u043E \u043F\u0435\u0440\u0432\u044B\u043C \u043D\u0430\u0431\u0435\u0440\u0435\u0442 ".concat(outcome.condition, " ").concat(plural(outcome.condition, ['очко', 'очков', 'очков']), " \u0432 3\u0435\u0439 \u0447\u0435\u0442\u0432\u0435\u0440\u0442\u0438"); };
var bo_z4 = function (match, outcome) { return "\u041A\u0442\u043E \u043F\u0435\u0440\u0432\u044B\u043C \u043D\u0430\u0431\u0435\u0440\u0435\u0442 ".concat(outcome.condition, " ").concat(plural(outcome.condition, ['очко', 'очков', 'очков']), " \u0432 4\u043E\u0439 \u0447\u0435\u0442\u0432\u0435\u0440\u0442\u0438"); };
var bo_a5 = function (match, outcome) { return 'Точный тотал первой четверти'; };
var bo_b5 = function (match, outcome) { return 'Точный тотал второй четверти'; };
var bo_c5 = function (match, outcome) { return 'Точный тотал третьей четверти'; };
var bo_d5 = function (match, outcome) { return 'Точный тотал четвертой четверти'; };
var bo_e5 = function (match, outcome) { return "".concat(match.homeTeam, " \u043F\u043E\u0431\u0435\u0434\u0438\u0442 \u0441 \u0440\u0430\u0437\u043D\u0438\u0446\u0435\u0439"); };
var bo_f5 = function (match, outcome) { return "".concat(match.awayTeam, " \u043F\u043E\u0431\u0435\u0434\u0438\u0442 \u0441 \u0440\u0430\u0437\u043D\u0438\u0446\u0435\u0439"); };
var bo_g5 = function (match, outcome) { return 'Проход'; };
var bo_h5 = function (match, outcome) { return "".concat(match.homeTeam, " \u0432\u044B\u0438\u0433\u0440\u0430\u0435\u0442 \u0432\u0441\u0435 \u0447\u0435\u0442\u0432\u0435\u0440\u0442\u0438"); };
var bo_i5 = function (match, outcome) { return "".concat(match.awayTeam, " \u0432\u044B\u0438\u0433\u0440\u0430\u0435\u0442 \u0432\u0441\u0435 \u0447\u0435\u0442\u0432\u0435\u0440\u0442\u0438"); };
var bo_j5 = function (match, outcome) { return "".concat(match.homeTeam, " \u0432\u044B\u0438\u0433\u0440\u0430\u0435\u0442 \u043E\u0431\u0435 \u043F\u043E\u043B\u043E\u0432\u0438\u043D\u044B"); };
var bo_k5 = function (match, outcome) { return "".concat(match.awayTeam, " \u0432\u044B\u0438\u0433\u0440\u0430\u0435\u0442 \u043E\u0431\u0435 \u043F\u043E\u043B\u043E\u0432\u0438\u043D\u044B"); };
var bo_l5 = function (match, outcome) { return 'Самая результативная половина'; };
var bo_m5 = function (match, outcome) { return 'Самая результативная четверть'; };
var bo_n5 = function (match, outcome) { return 'Тотал самой результативной четверти'; };
var bo_o5 = function (match, outcome) { return 'Тотал самой нерезультативной четверти'; };
var bo_p5 = function (match, outcome) { return "".concat(match.homeTeam, " \u0432\u044B\u0438\u0433\u0440\u0430\u0435\u0442 \u043F\u0435\u0440\u0432\u0443\u044E \u0447\u0435\u0442\u0432\u0435\u0440\u0442\u044C \u0438 \u043C\u0430\u0442\u0447"); };
var bo_q5 = function (match, outcome) { return "".concat(match.awayTeam, " \u0432\u044B\u0438\u0433\u0440\u0430\u0435\u0442 \u043F\u0435\u0440\u0432\u0443\u044E \u0447\u0435\u0442\u0432\u0435\u0440\u0442\u044C \u0438 \u043C\u0430\u0442\u0447"); };
var bo_r5 = function (match, outcome) { return "".concat(match.homeTeam, " \u0432\u044B\u0438\u0433\u0440\u0430\u0435\u0442 \u043F\u0435\u0440\u0432\u0443\u044E \u043F\u043E\u043B\u043E\u0432\u0438\u043D\u0443 \u0438 \u043C\u0430\u0442\u0447"); };
var bo_s5 = function (match, outcome) { return "".concat(match.awayTeam, " \u0432\u044B\u0438\u0433\u0440\u0430\u0435\u0442 \u043F\u0435\u0440\u0432\u0443\u044E \u043F\u043E\u043B\u043E\u0432\u0438\u043D\u0443 \u0438 \u043C\u0430\u0442\u0447"); };
var bo_t5 = function (match, outcome) { return 'Будет ли овертайм'; };
var bo_u5 = function (match, outcome) { return 'Победа с разницей'; };
var bo_v5 = function (match, outcome) { return 'Победа с разницей в первой четверти'; };
var bo_w5 = function (match, outcome) { return 'Победа с разницей во второй четверти'; };
var bo_x5 = function (match, outcome) { return 'Победа с разницей в третьей четверти'; };
var bo_y5 = function (match, outcome) { return 'Победа с разницей в четвертой четверти'; };
var bo_z5 = function (match, outcome) { return "\u0422\u043E\u0442\u0430\u043B: ".concat(outcome.playerName, " (").concat(match.homeTeam, ")"); };
var bo_a6 = function (match, outcome) { return "\u0422\u043E\u0442\u0430\u043B: ".concat(outcome.playerName, " (").concat(match.awayTeam, ")"); };
var bo_b6 = function (match, outcome) { return 'Тотал: 3-очковые броски'; };
var bo_c6 = function (match, outcome) { return 'Тотал: 2-очковые броски'; };
var bo_d6 = function (match, outcome) { return "\u0422\u043E\u0442\u0430\u043B: ".concat(match.homeTeam, " 3-\u043E\u0447\u043A\u043E\u0432\u044B\u0435 \u0431\u0440\u043E\u0441\u043A\u0438"); };
var bo_e6 = function (match, outcome) { return "\u0422\u043E\u0442\u0430\u043B: ".concat(match.awayTeam, " 3-\u043E\u0447\u043A\u043E\u0432\u044B\u0435 \u0431\u0440\u043E\u0441\u043A\u0438"); };
var bo_f6 = function (match, outcome) { return "\u0422\u043E\u0442\u0430\u043B: ".concat(match.homeTeam, " 2-\u043E\u0447\u043A\u043E\u0432\u044B\u0435 \u0431\u0440\u043E\u0441\u043A\u0438"); };
var bo_g6 = function (match, outcome) { return "\u0422\u043E\u0442\u0430\u043B: ".concat(match.awayTeam, " 2-\u043E\u0447\u043A\u043E\u0432\u044B\u0435 \u0431\u0440\u043E\u0441\u043A\u0438"); };
var bo_h6 = function (match, outcome) { return 'Фора 3-очковых бросков'; };
var bo_i6 = function (match, outcome) { return 'Фора 2-очковых бросков'; };
var bo_j6 = function (match, outcome) { return 'Результат по 3-очковым броскам'; };
var bo_k6 = function (match, outcome) { return 'Результат по 2-очковым броскам'; };
var bo_l6 = function (match, outcome) { return 'Самая НЕ результативная четверть'; };
var bo_m6 = function (match, outcome) { return 'Тотал передач в матче'; };
var bo_n6 = function (match, outcome) { return "\u0422\u043E\u0442\u0430\u043B \u043F\u0435\u0440\u0435\u0434\u0430\u0447 ".concat(match.homeTeam, " \u0432 \u043C\u0430\u0442\u0447\u0435"); };
var bo_o6 = function (match, outcome) { return "\u0422\u043E\u0442\u0430\u043B \u043F\u0435\u0440\u0435\u0434\u0430\u0447 ".concat(match.awayTeam, " \u0432 \u043C\u0430\u0442\u0447\u0435"); };
var bo_p6 = function (match, outcome) { return 'Фора по передачам в матче'; };
var bo_q6 = function (match, outcome) { return 'Победа по передачам в матче'; };
var bo_r6 = function (match, outcome) { return 'Первый 2-очковый бросок в матче'; };
var bo_s6 = function (match, outcome) { return 'Первый 3-очковый бросок в матче'; };
var bo_t6 = function (match, outcome) { return 'Первый штрафной бросок в матче'; };
var bo_u6 = function (match, outcome) { return 'Что будет раньше'; };
var bo_v6 = function (match, outcome) { return 'Наибольшее количество очков в четверти'; };
var bo_w6 = function (match, outcome) { return "\u041A\u0442\u043E \u043F\u0435\u0440\u0432\u044B\u043C \u043D\u0430\u0431\u0435\u0440\u0435\u0442 ".concat(outcome.condition, " ").concat(plural(outcome.condition, ['очко', 'очков', 'очков']), " \u0432 \u043C\u0430\u0442\u0447\u0435"); };
var bo_x6 = function (match, outcome) { return 'Тотал трипл-даблов в матче'; };
var bo_y6 = function (match, outcome) { return 'Тотал дабл-даблов в матче'; };
var bo_z6 = function (match, outcome) { return "\u041A\u0442\u043E \u043F\u0435\u0440\u0432\u044B\u043C \u043D\u0430\u0431\u0435\u0440\u0435\u0442 ".concat(outcome.condition, " ").concat(plural(outcome.condition, ['очко', 'очков', 'очков']), " \u0432 \u043F\u0435\u0440\u0432\u043E\u0439 \u0447\u0435\u0442\u0432\u0435\u0440\u0442\u0438"); };
var bo_a7 = function (match, outcome) { return "\u041A\u0442\u043E \u043F\u0435\u0440\u0432\u044B\u043C \u043D\u0430\u0431\u0435\u0440\u0435\u0442 ".concat(outcome.condition, " ").concat(plural(outcome.condition, ['очко', 'очков', 'очков']), " \u0432\u043E \u0432\u0442\u043E\u0440\u043E\u0439 \u0447\u0435\u0442\u0432\u0435\u0440\u0442\u0438"); };
var bo_b7 = function (match, outcome) { return "\u041A\u0442\u043E \u043F\u0435\u0440\u0432\u044B\u043C \u043D\u0430\u0431\u0435\u0440\u0435\u0442 ".concat(outcome.condition, " ").concat(plural(outcome.condition, ['очко', 'очков', 'очков']), " \u0432 \u0442\u0440\u0435\u0442\u044C\u0435\u0439 \u0447\u0435\u0442\u0432\u0435\u0440\u0442\u0438"); };
var bo_c7 = function (match, outcome) { return "\u041A\u0442\u043E \u043F\u0435\u0440\u0432\u044B\u043C \u043D\u0430\u0431\u0435\u0440\u0435\u0442 ".concat(outcome.condition, " ").concat(plural(outcome.condition, ['очко', 'очков', 'очков']), " \u0432 \u0447\u0435\u0442\u0432\u0435\u0440\u0442\u043E\u0439 \u0447\u0435\u0442\u0432\u0435\u0440\u0442\u0438"); };
var bo_d7 = function (match, outcome) { return 'Разница очков в матче'; };
var bo_e7 = function (match, outcome) { return 'Разница очков в первой четверти'; };
var bo_f7 = function (match, outcome) { return 'Разница очков во второй четверти'; };
var bo_g7 = function (match, outcome) { return 'Разница очков в третьей четверти'; };
var bo_h7 = function (match, outcome) { return 'Разница очков в четвертой четверти'; };
var bo_i7 = function (match, outcome) { return 'Результат первой половины'; };
var bo_j7 = function (match, outcome) { return 'Результат второй половины'; };
var bo_k7 = function (match, outcome) { return 'Точный тотал первой половины'; };
var bo_l7 = function (match, outcome) { return 'Точный тотал второй половины'; };
var bo_m7 = function (match, outcome) { return 'Победа с разницей в первой половине'; };
var bo_n7 = function (match, outcome) { return 'Победа с разницей во второй половине'; };
var bo_o7 = function (match, outcome) { return "\u041A\u0442\u043E \u043F\u0435\u0440\u0432\u044B\u043C \u043D\u0430\u0431\u0435\u0440\u0435\u0442 ".concat(outcome.condition, " ").concat(plural(outcome.condition, ['очко', 'очков', 'очков']), " \u0432 1\u043E\u0439 \u043F\u043E\u043B\u043E\u0432\u0438\u043D\u0435"); };
var bo_p7 = function (match, outcome) { return "\u041A\u0442\u043E \u043F\u0435\u0440\u0432\u044B\u043C \u043D\u0430\u0431\u0435\u0440\u0435\u0442 ".concat(outcome.condition, " ").concat(plural(outcome.condition, ['очко', 'очков', 'очков']), " \u0432\u043E 2\u043E\u0439 \u043F\u043E\u043B\u043E\u0432\u0438\u043D\u0435"); };
var bo_q7 = function (match, outcome) { return 'Тотал самой результативной половины'; };
var bo_r7 = function (match, outcome) { return 'Тотал самой НЕрезультативной половины'; };
var bo_s7 = function (match, outcome) { return "\u041A\u0442\u043E \u043F\u0435\u0440\u0432\u044B\u043C \u043D\u0430\u0431\u0435\u0440\u0435\u0442 ".concat(outcome.condition, " ").concat(plural(outcome.condition, ['очко', 'очков', 'очков']), " \u0432 \u043F\u0435\u0440\u0432\u043E\u0439 \u043F\u043E\u043B\u043E\u0432\u0438\u043D\u0435"); };
var bo_t7 = function (match, outcome) { return "\u041A\u0442\u043E \u043F\u0435\u0440\u0432\u044B\u043C \u043D\u0430\u0431\u0435\u0440\u0435\u0442 ".concat(outcome.condition, " ").concat(plural(outcome.condition, ['очко', 'очков', 'очков']), " \u0432\u043E \u0432\u0442\u043E\u0440\u043E\u0439 \u043F\u043E\u043B\u043E\u0432\u0438\u043D\u0435"); };
var bo_u7 = function (match, outcome) { return 'Тотал первого периода'; };
var bo_v7 = function (match, outcome) { return 'Тотал второго периода'; };
var bo_w7 = function (match, outcome) { return 'Тотал третьего периода'; };
var bo_x7 = function (match, outcome) { return 'Результат первого периода'; };
var bo_y7 = function (match, outcome) { return 'Результат второго периода'; };
var bo_z7 = function (match, outcome) { return 'Результат третьего периода'; };
var bo_a8 = function (match, outcome) { return 'Победа с учетом пенальти'; };
var bo_b8 = function (match, outcome) { return 'Победа с разницей 1'; };
var bo_c8 = function (match, outcome) { return 'Победа с разницей 2'; };
var bo_d8 = function (match, outcome) { return 'Сколько команд забьет в 1-м периоде?'; };
var bo_e8 = function (match, outcome) { return 'Сколько команд забьет в 2-м периоде?'; };
var bo_f8 = function (match, outcome) { return 'Сколько команд забьет в 3-м периоде?'; };
var bo_g8 = function (match, outcome) { return 'Период-Матч'; };
var bo_h8 = function (match, outcome) { return 'Тотал овертайма'; };
var bo_i8 = function (match, outcome) { return 'Результат оветайма'; };
var bo_j8 = function (match, outcome) { return 'Фора в овертайме'; };
var bo_k8 = function (match, outcome) { return 'Фора в первом периоде'; };
var bo_l8 = function (match, outcome) { return 'Фора во втором периоде'; };
var bo_m8 = function (match, outcome) { return 'Фора в третьем периоде'; };
var bo_n8 = function (match, outcome) { return 'Точный счет первого периода'; };
var bo_o8 = function (match, outcome) { return 'Точный счет второго периода'; };
var bo_p8 = function (match, outcome) { return 'Точный счет третьего периода'; };
var bo_q8 = function (match, outcome) { return "\u041A\u0442\u043E \u043F\u0435\u0440\u0432\u044B\u043C \u043D\u0430\u0431\u0435\u0440\u0435\u0442 ".concat(outcome.condition, " ").concat(plural(outcome.condition, ['очко', 'очка', 'очков']), " \u0432 1\u043E\u043C \u0441\u0435\u0442\u0435"); };
var bo_r8 = function (match, outcome) { return "\u041A\u0442\u043E \u043F\u0435\u0440\u0432\u044B\u043C \u043D\u0430\u0431\u0435\u0440\u0435\u0442 ".concat(outcome.condition, " ").concat(plural(outcome.condition, ['очко', 'очка', 'очков']), " \u0432\u043E 2\u043E\u043C \u0441\u0435\u0442\u0435"); };
var bo_s8 = function (match, outcome) { return "\u041A\u0442\u043E \u043F\u0435\u0440\u0432\u044B\u043C \u043D\u0430\u0431\u0435\u0440\u0435\u0442 ".concat(outcome.condition, " ").concat(plural(outcome.condition, ['очко', 'очка', 'очков']), " \u0432 3\u0435\u043C \u0441\u0435\u0442\u0435"); };
var bo_t8 = function (match, outcome) { return 'Фора по партиям в матче'; };
var bo_u8 = function (match, outcome) { return 'Точный тотал первого сета'; };
var bo_v8 = function (match, outcome) { return 'Точный тотал второго сета'; };
var bo_w8 = function (match, outcome) { return 'Точный тотал третьего сета'; };
var bo_x8 = function (match, outcome) { return "".concat(match.homeTeam, " \u043F\u043E\u0431\u0435\u0434\u0438\u0442 \u0441 \u0440\u0430\u0437\u043D\u0438\u0446\u0435\u0439 \u0432 \u043F\u0435\u0440\u0432\u043E\u043C \u0441\u0435\u0442\u0435"); };
var bo_y8 = function (match, outcome) { return "".concat(match.homeTeam, " \u043F\u043E\u0431\u0435\u0434\u0438\u0442 \u0441 \u0440\u0430\u0437\u043D\u0438\u0446\u0435\u0439 \u0432\u043E \u0432\u0442\u043E\u0440\u043E\u043C \u0441\u0435\u0442\u0435"); };
var bo_z8 = function (match, outcome) { return "".concat(match.homeTeam, " \u043F\u043E\u0431\u0435\u0434\u0438\u0442 \u0441 \u0440\u0430\u0437\u043D\u0438\u0446\u0435\u0439 \u0432 \u0442\u0440\u0435\u0442\u044C\u0435\u043C \u0441\u0435\u0442\u0435"); };
var bo_a9 = function (match, outcome) { return "".concat(match.awayTeam, " \u043F\u043E\u0431\u0435\u0434\u0438\u0442 \u0441 \u0440\u0430\u0437\u043D\u0438\u0446\u0435\u0439 \u0432 \u043F\u0435\u0440\u0432\u043E\u043C \u0441\u0435\u0442\u0435"); };
var bo_b9 = function (match, outcome) { return "".concat(match.awayTeam, " \u043F\u043E\u0431\u0435\u0434\u0438\u0442 \u0441 \u0440\u0430\u0437\u043D\u0438\u0446\u0435\u0439 \u0432\u043E \u0432\u0442\u043E\u0440\u043E\u043C \u0441\u0435\u0442\u0435"); };
var bo_c9 = function (match, outcome) { return "".concat(match.awayTeam, " \u043F\u043E\u0431\u0435\u0434\u0438\u0442 \u0441 \u0440\u0430\u0437\u043D\u0438\u0446\u0435\u0439 \u0432 \u0442\u0440\u0435\u0442\u044C\u0435\u043C \u0441\u0435\u0442\u0435"); };
var bo_d9 = function (match, outcome) { return 'Чет/Нечет первого сета'; };
var bo_e9 = function (match, outcome) { return 'Чет/Нечет второго сета'; };
var bo_f9 = function (match, outcome) { return 'Чет/Нечет третьего сета'; };
var bo_g9 = function (match, outcome) { return "\u041F\u043E\u0431\u0435\u0434\u0430 \u0438 \u0442\u043E\u0442\u0430\u043B \u043F\u0435\u0440\u0432\u043E\u0433\u043E \u0441\u0435\u0442\u0430 ".concat(outcome.condition); };
var bo_h9 = function (match, outcome) { return "\u041F\u043E\u0431\u0435\u0434\u0430 \u0438 \u0442\u043E\u0442\u0430\u043B \u0432\u0442\u043E\u0440\u043E\u0433\u043E \u0441\u0435\u0442\u0430 ".concat(outcome.condition); };
var bo_i9 = function (match, outcome) { return "\u041F\u043E\u0431\u0435\u0434\u0430 \u0438 \u0442\u043E\u0442\u0430\u043B \u0442\u0440\u0435\u0442\u044C\u0435\u0433\u043E \u0441\u0435\u0442\u0430 ".concat(outcome.condition); };
var bo_j9 = function (match, outcome) { return 'Победа с разницей в первом сете'; };
var bo_k9 = function (match, outcome) { return 'Победа с разницей во втором сете'; };
var bo_l9 = function (match, outcome) { return 'Победа с разницей в третьем сете'; };
var bo_m9 = function (match, outcome) { return 'Тотал на первом огневом рубеже'; };
var bo_n9 = function (match, outcome) { return 'Тотал на втором огневом рубеже'; };
var bo_o9 = function (match, outcome) { return 'Тотал на третьем огневом рубеже'; };
var bo_p9 = function (match, outcome) { return 'Тотал на четвертом огневом рубеже'; };
var bo_q9 = function (match, outcome) { return 'Тотал на пятом огневом рубеже'; };
var bo_r9 = function (match, outcome) { return 'Тотал на шестом огневом рубеже'; };
var bo_s9 = function (match, outcome) { return 'Тотал на седьмом огневом рубеже'; };
var bo_t9 = function (match, outcome) { return 'Тотал на восьмом огневом рубеже'; };
var bo_u9 = function (match, outcome) { return "\u0422\u043E\u0442\u0430\u043B: ".concat(match.homeTeam, " \u043D\u0430 \u043F\u0435\u0440\u0432\u043E\u043C \u043E\u0433\u043D\u0435\u0432\u043E\u043C \u0440\u0443\u0431\u0435\u0436\u0435"); };
var bo_v9 = function (match, outcome) { return "\u0422\u043E\u0442\u0430\u043B: ".concat(match.homeTeam, " \u043D\u0430 \u0432\u0442\u043E\u0440\u043E\u043C \u043E\u0433\u043D\u0435\u0432\u043E\u043C \u0440\u0443\u0431\u0435\u0436\u0435"); };
var bo_w9 = function (match, outcome) { return "\u0422\u043E\u0442\u0430\u043B: ".concat(match.homeTeam, " \u043D\u0430 \u0442\u0435\u0440\u0442\u044C\u0435\u043C \u043E\u0433\u043D\u0435\u0432\u043E\u043C \u0440\u0443\u0431\u0435\u0436\u0435"); };
var bo_x9 = function (match, outcome) { return "\u0422\u043E\u0442\u0430\u043B: ".concat(match.homeTeam, " \u043D\u0430 \u0447\u0435\u0442\u0432\u0435\u0440\u0442\u043E\u043C \u043E\u0433\u043D\u0435\u0432\u043E\u043C \u0440\u0443\u0431\u0435\u0436\u0435"); };
var bo_y9 = function (match, outcome) { return "\u0422\u043E\u0442\u0430\u043B: ".concat(match.homeTeam, " \u043D\u0430 \u043F\u044F\u0442\u043E\u043C \u043E\u0433\u043D\u0435\u0432\u043E\u043C \u0440\u0443\u0431\u0435\u0436\u0435"); };
var bo_z9 = function (match, outcome) { return "\u0422\u043E\u0442\u0430\u043B: ".concat(match.homeTeam, " \u043D\u0430 \u0448\u0435\u0441\u0442\u043E\u043C \u043E\u0433\u043D\u0435\u0432\u043E\u043C \u0440\u0443\u0431\u0435\u0436\u0435"); };
var bo_a10 = function (match, outcome) { return "\u0422\u043E\u0442\u0430\u043B: ".concat(match.homeTeam, " \u043D\u0430 \u0441\u0435\u0434\u044C\u043C\u043E\u043C \u043E\u0433\u043D\u0435\u0432\u043E\u043C \u0440\u0443\u0431\u0435\u0436\u0435"); };
var bo_b10 = function (match, outcome) { return "\u0422\u043E\u0442\u0430\u043B: ".concat(match.homeTeam, " \u043D\u0430 \u0432\u043E\u0441\u044C\u043C\u043E\u043C \u043E\u0433\u043D\u0435\u0432\u043E\u043C \u0440\u0443\u0431\u0435\u0436\u0435"); };
var bo_c10 = function (match, outcome) { return "\u0422\u043E\u0442\u0430\u043B: ".concat(match.awayTeam, " \u043D\u0430 \u043F\u0435\u0440\u0432\u043E\u043C \u043E\u0433\u043D\u0435\u0432\u043E\u043C \u0440\u0443\u0431\u0435\u0436\u0435"); };
var bo_d10 = function (match, outcome) { return "\u0422\u043E\u0442\u0430\u043B: ".concat(match.awayTeam, " \u043D\u0430 \u0432\u0442\u043E\u0440\u043E\u043C \u043E\u0433\u043D\u0435\u0432\u043E\u043C \u0440\u0443\u0431\u0435\u0436\u0435"); };
var bo_e10 = function (match, outcome) { return "\u0422\u043E\u0442\u0430\u043B: ".concat(match.awayTeam, " \u043D\u0430 \u0442\u0435\u0440\u0442\u044C\u0435\u043C \u043E\u0433\u043D\u0435\u0432\u043E\u043C \u0440\u0443\u0431\u0435\u0436\u0435"); };
var bo_f10 = function (match, outcome) { return "\u0422\u043E\u0442\u0430\u043B: ".concat(match.awayTeam, " \u043D\u0430 \u0447\u0435\u0442\u0432\u0435\u0440\u0442\u043E\u043C \u043E\u0433\u043D\u0435\u0432\u043E\u043C \u0440\u0443\u0431\u0435\u0436\u0435"); };
var bo_g10 = function (match, outcome) { return "\u0422\u043E\u0442\u0430\u043B: ".concat(match.awayTeam, " \u043D\u0430 \u043F\u044F\u0442\u043E\u043C \u043E\u0433\u043D\u0435\u0432\u043E\u043C \u0440\u0443\u0431\u0435\u0436\u0435"); };
var bo_h10 = function (match, outcome) { return "\u0422\u043E\u0442\u0430\u043B: ".concat(match.awayTeam, " \u043D\u0430 \u0448\u0435\u0441\u0442\u043E\u043C \u043E\u0433\u043D\u0435\u0432\u043E\u043C \u0440\u0443\u0431\u0435\u0436\u0435"); };
var bo_i10 = function (match, outcome) { return "\u0422\u043E\u0442\u0430\u043B: ".concat(match.awayTeam, " \u043D\u0430 \u0441\u0435\u0434\u044C\u043C\u043E\u043C \u043E\u0433\u043D\u0435\u0432\u043E\u043C \u0440\u0443\u0431\u0435\u0436\u0435"); };
var bo_j10 = function (match, outcome) { return "\u0422\u043E\u0442\u0430\u043B: ".concat(match.awayTeam, " \u043D\u0430 \u0432\u043E\u0441\u044C\u043C\u043E\u043C \u043E\u0433\u043D\u0435\u0432\u043E\u043C \u0440\u0443\u0431\u0435\u0436\u0435"); };
var bo_k10 = function (match, outcome) { return 'Фора на первом огневом рубеже'; };
var bo_l10 = function (match, outcome) { return 'Фора на втором огневом рубеже'; };
var bo_m10 = function (match, outcome) { return 'Фора на третьем огневом рубеже'; };
var bo_n10 = function (match, outcome) { return 'Фора на четвертом огневом рубеже'; };
var bo_o10 = function (match, outcome) { return 'Фора на пятом огневом рубеже'; };
var bo_p10 = function (match, outcome) { return 'Фора на шестом огневом рубеже'; };
var bo_q10 = function (match, outcome) { return 'Фора на седьмом огневом рубеже'; };
var bo_r10 = function (match, outcome) { return 'Фора на восьмом огневом рубеже'; };
var bo_s10 = function (match, outcome) { return 'Результат на первом огневом рубеже'; };
var bo_t10 = function (match, outcome) { return 'Результат на втором огневом рубеже'; };
var bo_u10 = function (match, outcome) { return 'Результат на третьем огневом рубеже'; };
var bo_v10 = function (match, outcome) { return 'Результат на четвертом огневом рубеже'; };
var bo_w10 = function (match, outcome) { return 'Результат на пятом огневом рубеже'; };
var bo_x10 = function (match, outcome) { return 'Результат на шестом огневом рубеже'; };
var bo_y10 = function (match, outcome) { return 'Результат на седьмом огневом рубеже'; };
var bo_z10 = function (match, outcome) { return 'Результат на восьмом огневом рубеже'; };
var bo_a11 = function (match, outcome) { return 'Точный тотал на первом огневом рубеже'; };
var bo_b11 = function (match, outcome) { return 'Точный тотал на втором огневом рубеже'; };
var bo_c11 = function (match, outcome) { return 'Точный тотал на третьем огневом рубеже'; };
var bo_d11 = function (match, outcome) { return 'Точный тотал на четвертом огневом рубеже'; };
var bo_e11 = function (match, outcome) { return 'Точный тотал на пятом огневом рубеже'; };
var bo_f11 = function (match, outcome) { return 'Точный тотал на шестом огневом рубеже'; };
var bo_g11 = function (match, outcome) { return 'Точный тотал на седьмом огневом рубеже'; };
var bo_h11 = function (match, outcome) { return 'Точный тотал на восьмом огневом рубеже'; };
var bo_i11 = function (match, outcome) { return 'Будет ли досрочная победа?'; };
var bo_j11 = function (match, outcome) { return 'Метод победы в бою'; };
var bo_k11 = function (match, outcome) { return 'Победа в бою'; };
var bo_l11 = function (match, outcome) { return 'Тотал'; };
var bo_m11 = function (match, outcome) { return "\u041A\u0442\u043E \u0432\u044B\u0438\u0433\u0440\u0430\u0435\u0442 ".concat(outcome.condition, " \u0440\u0430\u0443\u043D\u0434?"); };
var bo_n11 = function (match, outcome) { return 'FirstBlood'; };
var bo_o11 = function (match, outcome) { return "FirstBlood \u0432 ".concat(outcome.condition, " \u0440\u0430\u0443\u043D\u0434\u0435"); };
var bo_p11 = function (match, outcome) { return "\u041A\u0442\u043E \u0432\u044B\u0438\u0433\u0440\u0430\u0435\u0442 ".concat(outcome.condition, " \u043A\u0430\u0440\u0442\u0443?"); };
var bo_q11 = function (match, outcome) { return "FirstBlood \u0432 ".concat(outcome.condition, " \u043A\u0430\u0440\u0442\u0435"); };
var bo_r11 = function (match, outcome) { return "\u041A\u0442\u043E \u043F\u0435\u0440\u0432\u044B\u043C \u043D\u0430\u0431\u0435\u0440\u0435\u0442 ".concat(outcome.condition, " \u0443\u0431\u0438\u0439\u0441\u0442\u0432 \u0432 1\u043E\u0439 \u043A\u0430\u0440\u0442\u0435"); };
var bo_s11 = function (match, outcome) { return "\u041A\u0442\u043E \u043F\u0435\u0440\u0432\u044B\u043C \u043D\u0430\u0431\u0435\u0440\u0435\u0442 ".concat(outcome.condition, " \u0443\u0431\u0438\u0439\u0441\u0442\u0432 \u0432\u043E 2\u043E\u0439 \u043A\u0430\u0440\u0442\u0435"); };
var bo_t11 = function (match, outcome) { return "\u041A\u0442\u043E \u043F\u0435\u0440\u0432\u044B\u043C \u043D\u0430\u0431\u0435\u0440\u0435\u0442 ".concat(outcome.condition, " \u0443\u0431\u0438\u0439\u0441\u0442\u0432 \u0432 3\u0435\u0439 \u043A\u0430\u0440\u0442\u0435"); };
var bo_u11 = function (match, outcome) { return "\u041A\u0442\u043E \u043F\u0435\u0440\u0432\u044B\u043C \u043D\u0430\u0431\u0435\u0440\u0435\u0442 ".concat(outcome.condition, " \u0443\u0431\u0438\u0439\u0441\u0442\u0432 \u0432 4\u043E\u0439 \u043A\u0430\u0440\u0442\u0435"); };
var bo_v11 = function (match, outcome) { return "\u041A\u0442\u043E \u043F\u0435\u0440\u0432\u044B\u043C \u043D\u0430\u0431\u0435\u0440\u0435\u0442 ".concat(outcome.condition, " \u0443\u0431\u0438\u0439\u0441\u0442\u0432 \u0432 5\u043E\u0439 \u043A\u0430\u0440\u0442\u0435"); };
var bo_w11 = function (match, outcome) { return 'Результат в матче'; };
var bo_x11 = function (match, outcome) { return 'Победа в первой карте'; };
var bo_y11 = function (match, outcome) { return 'Победа во второй карте'; };
var bo_z11 = function (match, outcome) { return 'Победа в третьей карте'; };
var bo_a12 = function (match, outcome) { return 'Победа в четвертой карте'; };
var bo_b12 = function (match, outcome) { return 'Победа в пятой карте'; };
var bo_c12 = function (match, outcome) { return 'First blood в первой карте'; };
var bo_d12 = function (match, outcome) { return 'First blood во второй карте'; };
var bo_e12 = function (match, outcome) { return 'First blood в третьей карте'; };
var bo_f12 = function (match, outcome) { return 'First blood в четвертой карте'; };
var bo_g12 = function (match, outcome) { return 'First blood в пятой карте'; };
var bo_h12 = function (match, outcome) { return 'Победа с учетом буллитов'; };
var bo_i12 = function (match, outcome) { return "".concat(match.homeTeam, " \u0432\u044B\u0438\u0433\u0440\u0430\u0435\u0442 \u0432 \u043E\u0431\u043E\u0438\u0445 \u0442\u0430\u0439\u043C\u0430\u0445"); };
var bo_j12 = function (match, outcome) { return "".concat(match.awayTeam, " \u0432\u044B\u0438\u0433\u0440\u0430\u0435\u0442 \u0432 \u043E\u0431\u043E\u0438\u0445 \u0442\u0430\u0439\u043C\u0430\u0445"); };
var bo_k12 = function (match, outcome) { return "\u041A\u043E\u043C\u0430\u043D\u0434, \u0437\u0430\u0431\u0438\u0432\u0448\u0438\u0445 ".concat(outcome.conditionTwo, " \u0438 \u0431\u043E\u043B\u0435\u0435 \u0433\u043E\u043B\u043E\u0432\u00A0\u00A0(\u0438\u0445 \u0442\u043E\u0442\u0430\u043B)"); };
var bo_l12 = function (match, outcome) { return 'Самая результативная команда (её тотал)'; };
var bo_m12 = function (match, outcome) { return 'Самый результативный тайм (тотал)'; };
var bo_n12 = function (match, outcome) { return "\u041E\u0431\u0430 \u0442\u0430\u0439\u043C\u0430 \u043C\u0435\u043D\u044C\u0448\u0435 \u0447\u0435\u043C ".concat(outcome.condition); };
var bo_o12 = function (match, outcome) { return "\u041E\u0431\u0430 \u0442\u0430\u0439\u043C\u0430 \u0431\u043E\u043B\u044C\u0448\u0435 \u0447\u0435\u043C ".concat(outcome.condition); };
var bo_p12 = function (match, outcome) { return 'Чет/Нечет первого тайма'; };
var bo_q12 = function (match, outcome) { return 'Чет/Нечет второго тайма'; };
var bo_r12 = function (match, outcome) { return "\u0421\u043A\u043E\u043B\u044C\u043A\u043E \u0433\u043E\u043B\u043E\u0432 \u0437\u0430\u0431\u044C\u0435\u0442 ".concat(match.homeTeam, " \u0432 \u043F\u0435\u0440\u0432\u043E\u043C \u0442\u0430\u0439\u043C\u0435?"); };
var bo_s12 = function (match, outcome) { return "\u0421\u043A\u043E\u043B\u044C\u043A\u043E \u0433\u043E\u043B\u043E\u0432 \u0437\u0430\u0431\u044C\u0435\u0442 ".concat(match.homeTeam, " \u0432\u043E \u0432\u0442\u043E\u0440\u043E\u043C \u0442\u0430\u0439\u043C\u0435?"); };
var bo_t12 = function (match, outcome) { return "\u0421\u043A\u043E\u043B\u044C\u043A\u043E \u0433\u043E\u043B\u043E\u0432 \u0437\u0430\u0431\u044C\u0435\u0442 ".concat(match.awayTeam, " \u0432 \u043F\u0435\u0440\u0432\u043E\u043C \u0442\u0430\u0439\u043C\u0435?"); };
var bo_u12 = function (match, outcome) { return "\u0421\u043A\u043E\u043B\u044C\u043A\u043E \u0433\u043E\u043B\u043E\u0432 \u0437\u0430\u0431\u044C\u0435\u0442 ".concat(match.awayTeam, " \u0432\u043E \u0432\u0442\u043E\u0440\u043E\u043C \u0442\u0430\u0439\u043C\u0435?"); };
var bo_v12 = function (match, outcome) { return "\u0421\u043A\u043E\u043B\u044C\u043A\u043E \u0433\u043E\u043B\u043E\u0432 \u0437\u0430\u0431\u044C\u0435\u0442 ".concat(match.homeTeam, " \u0432 \u043C\u0430\u0442\u0447\u0435?"); };
var bo_w12 = function (match, outcome) { return "\u0421\u043A\u043E\u043B\u044C\u043A\u043E \u0433\u043E\u043B\u043E\u0432 \u0437\u0430\u0431\u044C\u0435\u0442 ".concat(match.awayTeam, " \u0432 \u043C\u0430\u0442\u0447\u0435?"); };
var bo_x12 = function (match, outcome) { return 'Самая нерезультативная команда (её тотал)'; };
var bo_y12 = function (match, outcome) { return "\u0417\u0430\u0431\u044C\u0435\u0442 \u043B\u0438 ".concat(match.homeTeam, " \u0442\u043E\u043B\u044C\u043A\u043E \u0432 \u043F\u0435\u0440\u0432\u043E\u043C \u0442\u0430\u0439\u043C\u0435?"); };
var bo_z12 = function (match, outcome) { return "\u0417\u0430\u0431\u044C\u0435\u0442 \u043B\u0438 ".concat(match.awayTeam, " \u0442\u043E\u043B\u044C\u043A\u043E \u0432 \u043F\u0435\u0440\u0432\u043E\u043C \u0442\u0430\u0439\u043C\u0435?"); };
var bo_a13 = function (match, outcome) { return "\u0417\u0430\u0431\u044C\u0435\u0442 \u043B\u0438 ".concat(match.homeTeam, " \u0442\u043E\u043B\u044C\u043A\u043E \u0432\u043E \u0432\u0442\u043E\u0440\u043E\u043C \u0442\u0430\u0439\u043C\u0435?"); };
var bo_b13 = function (match, outcome) { return "\u0417\u0430\u0431\u044C\u0435\u0442 \u043B\u0438 ".concat(match.awayTeam, " \u0442\u043E\u043B\u044C\u043A\u043E \u0432\u043E \u0432\u0442\u043E\u0440\u043E\u043C \u0442\u0430\u0439\u043C\u0435?"); };
var bo_c13 = function (match, outcome) { return 'Сколько команд забьёт в первом тайме'; };
var bo_d13 = function (match, outcome) { return 'Сколько команд забьёт во втором тайме'; };
var bo_e13 = function (match, outcome) { return "\u0421\u043A\u043E\u043B\u044C\u043A\u043E \u043A\u043E\u043C\u0430\u043D\u0434 \u0437\u0430\u0431\u044C\u0451\u0442 \u0431\u043E\u043B\u044C\u0448\u0435 ".concat(outcome.condition, " ").concat(plural(outcome.condition, ['гола', 'голов', 'голов'])); };
var bo_f13 = function (match, outcome) { return 'Как будет забит первый гол?'; };
var bo_g13 = function (match, outcome) { return 'Выход в следующий круг'; };
var bo_h13 = function (match, outcome) { return 'Кто начнет с центра поля?'; };
var bo_i13 = function (match, outcome) { return 'Два гола подряд одной командой'; };
var bo_j13 = function (match, outcome) { return "".concat(match.homeTeam, " \u043E\u0434\u0435\u0440\u0436\u0438\u0442 \u0432\u043E\u043B\u0435\u0432\u0443\u044E \u043F\u043E\u0431\u0435\u0434\u0443"); };
var bo_k13 = function (match, outcome) { return "\u041A\u0442\u043E \u043F\u043E\u043B\u0443\u0447\u0438\u0442 ".concat(numeralFemaleEnding(outcome.condition), " \u0416\u041A"); };
var bo_l13 = function (match, outcome) { return "".concat(match.awayTeam, " \u043E\u0434\u0435\u0440\u0436\u0438\u0442 \u0432\u043E\u043B\u0435\u0432\u0443\u044E \u043F\u043E\u0431\u0435\u0434\u0443"); };
var bo_m13 = function (match, outcome) { return 'Что в матче произойдет раньше?'; };
var bo_n13 = function (match, outcome) { return 'Дубль'; };
var bo_o13 = function (match, outcome) { return 'Хет-трик'; };
var bo_p13 = function (match, outcome) { return "\u041A\u0442\u043E \u043F\u043E\u0434\u0430\u0441\u0442 ".concat(numeralMaleEnding(outcome.condition), " \u0443\u0433\u043B\u043E\u0432\u043E\u0439"); };
var bo_q13 = function (match, outcome) { return "\u041A\u043E\u043C\u0430\u043D\u0434, \u0437\u0430\u0431\u0438\u0432\u0448\u0438\u0445 \u0440\u043E\u0432\u043D\u043E ".concat(outcome.conditionTwo, " ").concat(plural(outcome.conditionTwo, ['гол', 'гола', 'голов']), "\u00A0(\u0438\u0445 \u0442\u043E\u0442\u0430\u043B)"); };
var bo_r13 = function (match, outcome) { return "\u0417\u0430\u0431\u044C\u044E\u0442 \u043B\u0438 \u0432 \u043C\u0430\u0442\u0447\u0435 \u0440\u043E\u0432\u043D\u043E ".concat(outcome.condition, " ").concat(plural(outcome.condition, ['гол', 'гола', 'голов'])); };
var bo_s13 = function (match, outcome) { return 'Кто забьет последний гол?'; };
var bo_t13 = function (match, outcome) { return 'Автогол'; };
var bo_u13 = function (match, outcome) { return 'Забьет ли игрок вышедший на замену?'; };
var bo_v13 = function (match, outcome) { return 'Время последнего гола'; };
var bo_w13 = function (match, outcome) { return 'Обладатель Кубка'; };
var bo_x13 = function (match, outcome) { return 'Обладатель Суперкубка'; };
var bo_y13 = function (match, outcome) { return "\u0412 \u043A\u0430\u043A\u043E\u043C \u0442\u0430\u0439\u043C\u0435 \u0431\u0443\u0434\u0435\u0442 \u0437\u0430\u0431\u0438\u0442 ".concat(numeralMaleEnding(outcome.condition), " \u0433\u043E\u043B?"); };
var bo_z13 = function (match, outcome) { return 'Двойной исход с 1 по 15 минуту'; };
var bo_a14 = function (match, outcome) { return 'Двойной исход с 16 по 30 минуту'; };
var bo_b14 = function (match, outcome) { return 'Двойной исход с 31 минуты до перерыва'; };
var bo_c14 = function (match, outcome) { return 'Двойной исход с 46 по 60 минуту'; };
var bo_d14 = function (match, outcome) { return 'Двойной исход с 61 по 75 минуту'; };
var bo_e14 = function (match, outcome) { return 'Двойной исход с 76 минуты до конца ОВ'; };
var bo_f14 = function (match, outcome) { return "\u0417\u0430\u0431\u044C\u0435\u0442 \u043B\u0438 ".concat(match.homeTeam, " ").concat(numeralMaleEnding(outcome.condition), " \u043F\u0435\u043D\u0430\u043B\u044C\u0442\u0438? (\u0441\u0435\u0440\u0438\u044F \u043F\u0435\u043D\u0430\u043B\u044C\u0442\u0438)"); };
var bo_g14 = function (match, outcome) { return "\u0417\u0430\u0431\u044C\u0435\u0442 \u043B\u0438 ".concat(match.awayTeam, " ").concat(numeralMaleEnding(outcome.condition), " \u043F\u0435\u043D\u0430\u043B\u044C\u0442\u0438? (\u0441\u0435\u0440\u0438\u044F \u043F\u0435\u043D\u0430\u043B\u044C\u0442\u0438)"); };
var bo_h14 = function (match, outcome) { return "".concat(match.homeTeam, " \u0437\u0430\u0431\u044C\u0435\u0442 \u0441\u0432\u043E\u0439 ").concat(numeralMaleEnding(outcome.condition), " \u0433\u043E\u043B"); };
var bo_i14 = function (match, outcome) { return "".concat(match.awayTeam, " \u0437\u0430\u0431\u044C\u0435\u0442 \u0441\u0432\u043E\u0439 ").concat(numeralMaleEnding(outcome.condition), " \u0433\u043E\u043B"); };
var bo_j14 = function (match, outcome) { return 'Тотал угловых в первом тайме'; };
var bo_k14 = function (match, outcome) { return 'Тотал ЖК в первом тайме'; };
var bo_l14 = function (match, outcome) { return 'Фора по угловым в матче'; };
var bo_m14 = function (match, outcome) { return 'Фора по угловым в первом тайме'; };
var bo_n14 = function (match, outcome) { return 'Фора по ЖК'; };
var bo_o14 = function (match, outcome) { return 'Фора по ЖК в первом тайме'; };
var bo_p14 = function (match, outcome) { return 'Результат матча по угловым'; };
var bo_q14 = function (match, outcome) { return 'Результат первого тайма по угловым'; };
var bo_r14 = function (match, outcome) { return 'Результат матча по ЖК'; };
var bo_s14 = function (match, outcome) { return 'Результат первого тайма по ЖК'; };
var bo_t14 = function (match, outcome) { return "\u041A\u0442\u043E \u043F\u0435\u0440\u0432\u044B\u043C \u0437\u0430\u0431\u044C\u0435\u0442 ".concat(outcome.condition, " ").concat(plural(outcome.condition, ['гол', 'гола', 'голов'])); };
var bo_u14 = function (match, outcome) { return "\u0411\u0443\u0434\u0435\u0442 \u043B\u0438 \u0437\u0430\u0431\u0438\u0442 ".concat(numeralMaleEnding(outcome.condition), " \u043F\u0435\u043D\u0430\u043B\u044C\u0442\u0438"); };
var bo_v14 = function (match, outcome) { return 'Ауты'; };
var bo_w14 = function (match, outcome) { return 'Тайм-Матч'; };
var bo_x14 = function (match, outcome) { return 'Тотал матча (Азия)'; };
var bo_y14 = function (match, outcome) { return 'Тотал угловых'; };
var bo_z14 = function (match, outcome) { return 'Как закончится матч?'; };
var bo_a15 = function (match, outcome) { return 'Пенальти (тотал)'; };
var bo_b15 = function (match, outcome) { return 'Тотал красных карточек'; };
var bo_c15 = function (match, outcome) { return 'Время первого гола'; };
var bo_d15 = function (match, outcome) { return 'Сумма минут голов'; };
var bo_e15 = function (match, outcome) { return 'Тотал второго тайма'; };
var bo_f15 = function (match, outcome) { return 'Фора во втором тайме'; };
var bo_g15 = function (match, outcome) { return 'Удары в створ ворот'; };
var bo_h15 = function (match, outcome) { return 'Тотал желтых карточек'; };
var bo_i15 = function (match, outcome) { return 'Результат второго тайма'; };
var bo_j15 = function (match, outcome) { return 'Фора в матче с 1 по 15 минуту'; };
var bo_k15 = function (match, outcome) { return 'Фора в матче с 16 по 30 минуту'; };
var bo_l15 = function (match, outcome) { return 'Фора в матче с 31 минуты до перерыва'; };
var bo_m15 = function (match, outcome) { return 'Фора в матче с 46 по 60 минуту'; };
var bo_n15 = function (match, outcome) { return 'Фора в матче с 61 по 75 минуту'; };
var bo_o15 = function (match, outcome) { return 'Фора в матче с 76 минуты до конца ОВ'; };
var bo_p15 = function (match, outcome) { return "".concat(match.homeTeam, " \u0433\u043E\u043B\u044B"); };
var bo_q15 = function (match, outcome) { return "".concat(match.awayTeam, " \u0433\u043E\u043B\u044B"); };
var bo_r15 = function (match, outcome) { return 'Тотал замен'; };
var bo_s15 = function (match, outcome) { return 'Тотал матча с 1 по 15 минуту'; };
var bo_t15 = function (match, outcome) { return 'Тотал матча с 16 по 30 минуту'; };
var bo_u15 = function (match, outcome) { return 'Тотал матча с 31 минуты до перерыва'; };
var bo_v15 = function (match, outcome) { return 'Тотал матча с 46 по 60 минуту'; };
var bo_w15 = function (match, outcome) { return 'Тотал матча с 61 по 75 минуту'; };
var bo_x15 = function (match, outcome) { return 'Тотал матча с 76 минуты до конца ОВ'; };
var bo_y15 = function (match, outcome) { return "\u0422\u043E\u0442\u0430\u043B: ".concat(match.homeTeam, " \u0441 1 \u043F\u043E 15 \u043C\u0438\u043D\u0443\u0442\u0443"); };
var bo_z15 = function (match, outcome) { return "\u0422\u043E\u0442\u0430\u043B: ".concat(match.homeTeam, " \u0441 16 \u043F\u043E 30 \u043C\u0438\u043D\u0443\u0442\u0443"); };
var bo_a16 = function (match, outcome) { return "\u0422\u043E\u0442\u0430\u043B: ".concat(match.homeTeam, " \u0441 31 \u043C\u0438\u043D\u0443\u0442\u044B \u0434\u043E \u043F\u0435\u0440\u0435\u0440\u044B\u0432\u0430"); };
var bo_b16 = function (match, outcome) { return "\u0422\u043E\u0442\u0430\u043B: ".concat(match.homeTeam, " \u0441 46 \u043F\u043E 60 \u043C\u0438\u043D\u0443\u0442\u0443"); };
var bo_c16 = function (match, outcome) { return "\u0422\u043E\u0442\u0430\u043B: ".concat(match.homeTeam, " \u0441 61 \u043F\u043E 75 \u043C\u0438\u043D\u0443\u0442\u0443"); };
var bo_d16 = function (match, outcome) { return "\u0422\u043E\u0442\u0430\u043B: ".concat(match.homeTeam, " \u0441 76 \u043C\u0438\u043D\u0443\u0442\u044B \u0434\u043E \u043A\u043E\u043D\u0446\u0430 \u041E\u0412"); };
var bo_e16 = function (match, outcome) { return "\u0422\u043E\u0442\u0430\u043B: ".concat(match.awayTeam, " \u0441 1 \u043F\u043E 15 \u043C\u0438\u043D\u0443\u0442\u0443"); };
var bo_f16 = function (match, outcome) { return "\u0422\u043E\u0442\u0430\u043B: ".concat(match.awayTeam, " \u0441 16 \u043F\u043E 30 \u043C\u0438\u043D\u0443\u0442\u0443"); };
var bo_g16 = function (match, outcome) { return "\u0422\u043E\u0442\u0430\u043B: ".concat(match.awayTeam, " \u0441 31 \u043C\u0438\u043D\u0443\u0442\u044B \u0434\u043E \u043F\u0435\u0440\u0435\u0440\u044B\u0432\u0430"); };
var bo_h16 = function (match, outcome) { return "\u0422\u043E\u0442\u0430\u043B: ".concat(match.awayTeam, " \u0441 46 \u043F\u043E 60 \u043C\u0438\u043D\u0443\u0442\u0443"); };
var bo_i16 = function (match, outcome) { return "\u0422\u043E\u0442\u0430\u043B: ".concat(match.awayTeam, " \u0441 61 \u043F\u043E 75 \u043C\u0438\u043D\u0443\u0442\u0443"); };
var bo_j16 = function (match, outcome) { return "\u0422\u043E\u0442\u0430\u043B: ".concat(match.awayTeam, " \u0441 76 \u043C\u0438\u043D\u0443\u0442\u044B \u0434\u043E \u043A\u043E\u043D\u0446\u0430 \u041E\u0412"); };
var bo_k16 = function (match, outcome) { return 'Точный тотал первого тайма'; };
var bo_l16 = function (match, outcome) { return 'Точный тотал второго тайма'; };
var bo_m16 = function (match, outcome) { return "".concat(match.homeTeam, " \u0432\u044B\u0438\u0433\u0440\u0430\u0435\u0442 \u0438 \u043D\u0435 \u043F\u0440\u043E\u043F\u0443\u0441\u0442\u0438\u0442"); };
var bo_n16 = function (match, outcome) { return "".concat(match.awayTeam, " \u0432\u044B\u0438\u0433\u0440\u0430\u0435\u0442 \u0438 \u043D\u0435 \u043F\u0440\u043E\u043F\u0443\u0441\u0442\u0438\u0442"); };
var bo_o16 = function (match, outcome) { return "".concat(match.homeTeam, " \u0437\u0430\u0431\u044C\u0435\u0442 \u0440\u043E\u0432\u043D\u043E ").concat(outcome.condition, " ").concat(plural(outcome.condition, ['гол', 'гола', 'голов'])); };
var bo_p16 = function (match, outcome) { return "".concat(match.awayTeam, " \u0437\u0430\u0431\u044C\u0435\u0442 \u0440\u043E\u0432\u043D\u043E ").concat(outcome.condition, " ").concat(plural(outcome.condition, ['гол', 'гола', 'голов'])); };
var bo_q16 = function (match, outcome) { return 'Точный счет первого тайма'; };
var bo_r16 = function (match, outcome) { return 'Точный счет второго тайма'; };
var bo_s16 = function (match, outcome) { return 'Тотал не забитых пенальти'; };
var bo_t16 = function (match, outcome) { return "\u041E\u0431\u0435 \u043A\u043E\u043C\u0430\u043D\u0434\u044B \u0437\u0430\u0431\u044C\u044E\u0442 \u043C\u0435\u043D\u044C\u0448\u0435 \u0447\u0435\u043C ".concat(outcome.condition); };
var bo_u16 = function (match, outcome) { return "\u041E\u0431\u0435 \u043A\u043E\u043C\u0430\u043D\u0434\u044B \u0437\u0430\u0431\u044C\u044E\u0442 \u0431\u043E\u043B\u044C\u0448\u0435 \u0447\u0435\u043C ".concat(outcome.condition); };
var bo_v16 = function (match, outcome) { return 'Сравнение таймов (голы)'; };
var bo_w16 = function (match, outcome) { return 'Победа в матче с 1 по 15 минуту'; };
var bo_x16 = function (match, outcome) { return 'Победа в матче с 16 по 30 минуту'; };
var bo_y16 = function (match, outcome) { return 'Победа в матче с 31 минуты до перерыва'; };
var bo_z16 = function (match, outcome) { return 'Победа в матче с 46 по 60 минуту'; };
var bo_a17 = function (match, outcome) { return 'Победа в матче с 61 по 75 минуту'; };
var bo_b17 = function (match, outcome) { return 'Победа в матче с 76 минуты до конца ОВ'; };
var bo_c17 = function (match, outcome) { return "".concat(match.homeTeam, " \u0432\u044B\u0438\u0433\u0440\u0430\u0435\u0442 \u0432 \u043E\u0434\u043D\u043E\u043C \u0438\u0437 \u0442\u0430\u0439\u043C\u043E\u0432"); };
var bo_d17 = function (match, outcome) { return "".concat(match.awayTeam, " \u0432\u044B\u0438\u0433\u0440\u0430\u0435\u0442 \u0432 \u043E\u0434\u043D\u043E\u043C \u0438\u0437 \u0442\u0430\u0439\u043C\u043E\u0432"); };
var bo_e17 = function (match, outcome) { return "\u041A\u043E\u043C\u0430\u043D\u0434, \u0437\u0430\u0431\u0438\u0432\u0448\u0438\u0445 \u043E\u0442 ".concat(outcome.conditionTwo, " \u0434\u043E ").concat(outcome.conditionThree, " \u0433\u043E\u043B\u043E\u0432\u00A0(\u0438\u0445 \u0442\u043E\u0442\u0430\u043B)"); };
var bo_f17 = function (match, outcome) { return "\u0422\u043E\u0442\u0430\u043B: ".concat(match.homeTeam, " \u0432\u043E \u0432\u0442\u043E\u0440\u043E\u043C \u0442\u0430\u0439\u043C\u0435"); };
var bo_g17 = function (match, outcome) { return "\u0422\u043E\u0442\u0430\u043B: ".concat(match.awayTeam, " \u0432\u043E \u0432\u0442\u043E\u0440\u043E\u043C \u0442\u0430\u0439\u043C\u0435"); };
var bo_h17 = function (match, outcome) { return "\u0417\u0430\u0431\u044C\u0435\u0442 \u043B\u0438 ".concat(outcome.playerName, " (").concat(match.homeTeam, ") \u0433\u043E\u043B?"); };
var bo_i17 = function (match, outcome) { return "\u0417\u0430\u0431\u044C\u0435\u0442 \u043B\u0438 ".concat(outcome.playerName, " (").concat(match.awayTeam, ") \u0433\u043E\u043B?"); };
var bo_j17 = function (match, outcome) { return 'Результат матча'; };
var bo_k17 = function (match, outcome) { return 'Фора матча'; };
var bo_l17 = function (match, outcome) { return 'Тотал хозяев'; };
var bo_m17 = function (match, outcome) { return 'Тотал гостей'; };
var bo_n17 = function (match, outcome) { return 'Тотал самого результативного матча'; };
var bo_o17 = function (match, outcome) { return 'Тотал самого НЕрезультативного матча'; };
var bo_p17 = function (match, outcome) { return 'Тотал матчей без голов'; };
var bo_q17 = function (match, outcome) { return 'Тотал побед хозяев'; };
var bo_r17 = function (match, outcome) { return 'Тотал побед гостей'; };
var bo_s17 = function (match, outcome) { return 'Тотал ничьих'; };
var bo_t17 = function (match, outcome) { return 'Обе команды забьют: 1 тайм/2 тайм'; };
var bo_u17 = function (match, outcome) { return "\u0422\u043E\u0442\u0430\u043B ".concat(outcome.condition, " \u0438 \u041E\u0431\u0435 \u0437\u0430\u0431\u044C\u044E\u0442"); };
var bo_v17 = function (match, outcome) { return "".concat(match.homeTeam, " \u0437\u0430\u0431\u044C\u0435\u0442 \u0438 \u043D\u0435 \u0432\u044B\u0438\u0433\u0440\u0430\u0435\u0442"); };
var bo_w17 = function (match, outcome) { return "".concat(match.awayTeam, " \u0437\u0430\u0431\u044C\u0435\u0442 \u0438 \u043D\u0435 \u0432\u044B\u0438\u0433\u0440\u0430\u0435\u0442"); };
var bo_x17 = function (match, outcome) { return 'Метод победы в матче'; };
var bo_y17 = function (match, outcome) { return 'Компенсированное время в 1ом тайме'; };
var bo_z17 = function (match, outcome) { return 'Компенсированное время во 2ом тайме'; };
var bo_a18 = function (match, outcome) { return 'Будет ли в матче штанга/перекладина'; };
var bo_b18 = function (match, outcome) { return 'Время первой замены'; };
var bo_c18 = function (match, outcome) { return "\u041A\u0440\u0430\u0441\u043D\u0443\u044E \u043A\u0430\u0440\u0442\u043E\u0447\u043A\u0443 \u043F\u043E\u043B\u0443\u0447\u0438\u0442 \u0438\u0433\u0440\u043E\u043A ".concat(match.homeTeam); };
var bo_d18 = function (match, outcome) { return "\u041A\u0440\u0430\u0441\u043D\u0443\u044E \u043A\u0430\u0440\u0442\u043E\u0447\u043A\u0443 \u043F\u043E\u043B\u0443\u0447\u0438\u0442 \u0438\u0433\u0440\u043E\u043A ".concat(match.awayTeam); };
var bo_e18 = function (match, outcome) { return 'Будет ли пенальти и удаление'; };
var bo_f18 = function (match, outcome) { return 'Гол в компенсированное время'; };
var bo_g18 = function (match, outcome) { return 'ЖК за симуляцию'; };
var bo_h18 = function (match, outcome) { return 'ЖК за снятую футболку'; };
var bo_i18 = function (match, outcome) { return 'Угловые с каждого флажка'; };
var bo_j18 = function (match, outcome) { return 'Кто займет 3-е место?'; };
var bo_k18 = function (match, outcome) { return "\u0422\u043E\u0442\u0430\u043B: ".concat(match.awayTeam, "  (\u0414\u043E\u043F.\u0432\u0440\u0435\u043C\u044F)"); };
var bo_l18 = function (match, outcome) { return "\u0422\u043E\u0442\u0430\u043B: ".concat(match.homeTeam, "  (\u0414\u043E\u043F.\u0432\u0440\u0435\u043C\u044F)"); };
var bo_m18 = function (match, outcome) { return 'Двойной исход (Доп.время)'; };
var bo_n18 = function (match, outcome) { return 'Точный счет  (Доп.время)'; };
var bo_o18 = function (match, outcome) { return 'Фора (Доп.время)'; };
var bo_p18 = function (match, outcome) { return 'Тотал  (Доп.время)'; };
var bo_q18 = function (match, outcome) { return 'Результат (Доп.время)'; };
var bo_r18 = function (match, outcome) { return "\u041A\u0442\u043E \u0437\u0430\u0431\u044C\u0435\u0442 ".concat(numeralMaleEnding(outcome.condition), " \u0433\u043E\u043B \u0432 \u0434\u043E\u043F.\u0432.?"); };
var bo_s18 = function (match, outcome) { return 'Фора в первом дополнительном времени'; };
var bo_t18 = function (match, outcome) { return 'Тотал первого дополнительного  времени'; };
var bo_u18 = function (match, outcome) { return 'Результат в первом дополнительном времени'; };
var bo_v18 = function (match, outcome) { return 'Фора во втором дополнительном времени'; };
var bo_w18 = function (match, outcome) { return 'Тотал второго дополнительного  времени'; };
var bo_x18 = function (match, outcome) { return 'Результат во второе дополнительное время'; };
var bo_y18 = function (match, outcome) { return 'Точный счет в серии пенальти'; };
var bo_z18 = function (match, outcome) { return "\u0422\u043E\u0442\u0430\u043B \u0437\u0430\u0431\u0438\u0442\u044B\u0445 \u043F\u0435\u043D\u0430\u043B\u044C\u0442\u0438: ".concat(match.awayTeam, " (\u0441\u0435\u0440\u0438\u044F \u043F\u0435\u043D\u0430\u043B\u044C\u0442\u0438)"); };
var bo_a19 = function (match, outcome) { return "\u0422\u043E\u0442\u0430\u043B \u0437\u0430\u0431\u0438\u0442\u044B\u0445 \u043F\u0435\u043D\u0430\u043B\u044C\u0442\u0438: ".concat(match.homeTeam, " (\u0441\u0435\u0440\u0438\u044F \u043F\u0435\u043D\u0430\u043B\u044C\u0442\u0438)"); };
var bo_b19 = function (match, outcome) { return 'Тотал забитых пенальти (серия пенальти)'; };
var bo_c19 = function (match, outcome) { return 'Тотал незабитых пенальти (серия пенальти)'; };
var bo_d19 = function (match, outcome) { return "\u0415\u0432\u0440\u043E\u043F\u0435\u0439\u0441\u043A\u0430\u044F \u0444\u043E\u0440\u0430 ".concat(europeanHandicapCondition(outcome.condition)); };
var bo_e19 = function (match, outcome) { return "\u0415\u0432\u0440\u043E\u043F\u0435\u0439\u0441\u043A\u0430\u044F \u0444\u043E\u0440\u0430 ".concat(europeanHandicapCondition(outcome.condition), " \u0432 1\u043E\u043C \u0442\u0430\u0439\u043C\u0435"); };
var bo_f19 = function (match, outcome) { return "\u0415\u0432\u0440\u043E\u043F\u0435\u0439\u0441\u043A\u0430\u044F \u0444\u043E\u0440\u0430 ".concat(europeanHandicapCondition(outcome.condition), " \u0432\u043E 2\u043E\u043C \u0442\u0430\u0439\u043C\u0435"); };
var bo_g19 = function (match, outcome) { return "\u041A\u0442\u043E \u0437\u0430\u0431\u044C\u0435\u0442 ".concat(numeralMaleEnding(outcome.condition), " \u0433\u043E\u043B \u0432 \u043F\u0435\u0440\u0432\u043E\u043C \u0442\u0430\u0439\u043C\u0435?"); };
var bo_h19 = function (match, outcome) { return "\u041E\u0441\u0442\u0430\u0442\u043E\u043A \u043C\u0430\u0442\u0447\u0430 (\u0442\u0435\u043A\u0443\u0449\u0438\u0439 \u0441\u0447\u0435\u0442 ".concat(outcome.condition, ":").concat(outcome.conditionTwo, ")"); };
var bo_i19 = function (match, outcome) { return "\u041E\u0441\u0442\u0430\u0442\u043E\u043A \u043F\u0435\u0440\u0432\u043E\u0433\u043E \u0442\u0430\u0439\u043C\u0430 (\u0442\u0435\u043A\u0443\u0449\u0438\u0439 \u0441\u0447\u0435\u0442 ".concat(outcome.condition, ":").concat(outcome.conditionTwo, ")"); };
var bo_j19 = function (match, outcome) { return "\u0422\u043E\u0442\u0430\u043B \u0443\u0433\u043B\u043E\u0432\u044B\u0445 \u0432 \u043F\u0435\u0440\u0432\u043E\u043C \u0442\u0430\u0439\u043C\u0435: ".concat(match.homeTeam); };
var bo_k19 = function (match, outcome) { return "\u0422\u043E\u0442\u0430\u043B \u0443\u0433\u043B\u043E\u0432\u044B\u0445 \u0432 \u043F\u0435\u0440\u0432\u043E\u043C \u0442\u0430\u0439\u043C\u0435: ".concat(match.awayTeam); };
var bo_l19 = function (match, outcome) { return "\u0422\u043E\u0442\u0430\u043B \u0443\u0433\u043B\u043E\u0432\u044B\u0445: ".concat(match.homeTeam); };
var bo_m19 = function (match, outcome) { return "\u0422\u043E\u0442\u0430\u043B \u0443\u0433\u043B\u043E\u0432\u044B\u0445: ".concat(match.awayTeam); };
var bo_n19 = function (match, outcome) { return 'Время первого гола (мин)'; };
var bo_o19 = function (match, outcome) { return 'Двойной исход первого тайма'; };
var bo_p19 = function (match, outcome) { return 'Двойной исход второго тайма'; };
var bo_q19 = function (match, outcome) { return 'Обе забьют?'; };
var bo_r19 = function (match, outcome) { return 'не забитых пенальти'; };
var bo_s19 = function (match, outcome) { return "\u041F\u043E\u0431\u0435\u0434\u0430 ".concat(match.homeTeam, " \u0441 \u0440\u0430\u0437\u043D\u0438\u0446\u0435\u0439 \u0432 \u043F\u0435\u0440\u0432\u043E\u043C \u0442\u0430\u0439\u043C\u0435"); };
var bo_t19 = function (match, outcome) { return "\u041F\u043E\u0431\u0435\u0434\u0430 ".concat(match.homeTeam, " \u0441 \u0440\u0430\u0437\u043D\u0438\u0446\u0435\u0439 \u0432\u043E \u0432\u0442\u043E\u0440\u043E\u043C \u0442\u0430\u0439\u043C\u0435"); };
var bo_u19 = function (match, outcome) { return "\u041F\u043E\u0431\u0435\u0434\u0430 ".concat(match.awayTeam, " \u0441 \u0440\u0430\u0437\u043D\u0438\u0446\u0435\u0439 \u0432 \u043F\u0435\u0440\u0432\u043E\u043C \u0442\u0430\u0439\u043C\u0435"); };
var bo_v19 = function (match, outcome) { return "\u041F\u043E\u0431\u0435\u0434\u0430 ".concat(match.awayTeam, " \u0441 \u0440\u0430\u0437\u043D\u0438\u0446\u0435\u0439 \u0432\u043E \u0432\u0442\u043E\u0440\u043E\u043C \u0442\u0430\u0439\u043C\u0435"); };
var bo_w19 = function (match, outcome) { return 'Хет-трики (их тотал)'; };
var bo_x19 = function (match, outcome) { return 'Чет/Нечет первого периода'; };
var bo_y19 = function (match, outcome) { return 'Чет/Нечет второго периода'; };
var bo_z19 = function (match, outcome) { return 'Чет/Нечет третьего периода'; };
var bo_a20 = function (match, outcome) { return 'Самый результативный период (тотал)'; };
var bo_b20 = function (match, outcome) { return 'Самый нерезультативный период (тотал)'; };
var bo_c20 = function (match, outcome) { return 'Точный тотал первого периода'; };
var bo_d20 = function (match, outcome) { return 'Точный тотал второго периода'; };
var bo_e20 = function (match, outcome) { return 'Точный тотал третьего периода'; };
var bo_f20 = function (match, outcome) { return "\u0422\u043E\u0442\u0430\u043B: ".concat(match.homeTeam, " \u0432 \u043F\u0435\u0440\u0432\u043E\u043C \u043F\u0435\u0440\u0438\u043E\u0434\u0435"); };
var bo_g20 = function (match, outcome) { return "\u0422\u043E\u0442\u0430\u043B: ".concat(match.homeTeam, " \u0432\u043E \u0432\u0442\u043E\u0440\u043E\u043C \u043F\u0435\u0440\u0438\u043E\u0434\u0435"); };
var bo_h20 = function (match, outcome) { return "\u0422\u043E\u0442\u0430\u043B: ".concat(match.homeTeam, " \u0432 \u0442\u0440\u0435\u0442\u044C\u0435\u043C \u043F\u0435\u0440\u0438\u043E\u0434\u0435"); };
var bo_i20 = function (match, outcome) { return "\u0422\u043E\u0442\u0430\u043B: ".concat(match.awayTeam, " \u0432 \u043F\u0435\u0440\u0432\u043E\u043C \u043F\u0435\u0440\u0438\u043E\u0434\u0435"); };
var bo_j20 = function (match, outcome) { return "\u0422\u043E\u0442\u0430\u043B: ".concat(match.awayTeam, " \u0432\u043E \u0432\u0442\u043E\u0440\u043E\u043C \u043F\u0435\u0440\u0438\u043E\u0434\u0435"); };
var bo_k20 = function (match, outcome) { return "\u0422\u043E\u0442\u0430\u043B: ".concat(match.awayTeam, " \u0432 \u0442\u0440\u0435\u0442\u044C\u0435\u043C \u043F\u0435\u0440\u0438\u043E\u0434\u0435"); };
var bo_l20 = function (match, outcome) { return 'Обе команды забьют'; };
var bo_m20 = function (match, outcome) { return "\u0417\u0430\u0431\u044C\u0435\u0442 \u043B\u0438 ".concat(match.homeTeam, " ").concat(numeralMaleEnding(outcome.condition), " \u0431\u0443\u043B\u043B\u0438\u0442?"); };
var bo_n20 = function (match, outcome) { return "\u0417\u0430\u0431\u044C\u0435\u0442 \u043B\u0438 ".concat(match.awayTeam, " ").concat(numeralMaleEnding(outcome.condition), " \u0431\u0443\u043B\u043B\u0438\u0442?"); };
var bo_o20 = function (match, outcome) { return 'Победа с учетом ОТ'; };
var bo_p20 = function (match, outcome) { return "".concat(match.homeTeam, " \u0437\u0430\u0431\u044C\u0435\u0442 \u0432 \u043A\u0430\u0436\u0434\u043E\u043C \u043F\u0435\u0440\u0438\u043E\u0434\u0435"); };
var bo_q20 = function (match, outcome) { return "".concat(match.awayTeam, " \u0437\u0430\u0431\u044C\u0435\u0442 \u0432 \u043A\u0430\u0436\u0434\u043E\u043C \u043F\u0435\u0440\u0438\u043E\u0434\u0435"); };
var bo_r20 = function (match, outcome) { return 'Забьют во всех периодах'; };
var bo_s20 = function (match, outcome) { return 'Сравнение первого и второго периода'; };
var bo_t20 = function (match, outcome) { return 'Сравнение первого и третьего периода'; };
var bo_u20 = function (match, outcome) { return 'Сравнение второго и третьего периода'; };
var bo_v20 = function (match, outcome) { return "".concat(match.homeTeam, " \u043F\u043E\u0431\u0435\u0434\u0438\u0442 \u0432 \u043E\u0434\u043D\u043E\u043C \u0438\u0437 \u043F\u0435\u0440\u0438\u043E\u0434\u043E\u0432"); };
var bo_w20 = function (match, outcome) { return "".concat(match.awayTeam, " \u043F\u043E\u0431\u0435\u0434\u0438\u0442 \u0432 \u043E\u0434\u043D\u043E\u043C \u0438\u0437 \u043F\u0435\u0440\u0438\u043E\u0434\u043E\u0432"); };
var bo_x20 = function (match, outcome) { return 'Ничья хоты бы в одном периоде'; };
var bo_y20 = function (match, outcome) { return 'Победа в матче с 1 по 10 минуту'; };
var bo_z20 = function (match, outcome) { return 'Победа в матче с 11 по 20 минуту'; };
var bo_a21 = function (match, outcome) { return 'Победа в матче с 21 по 30 минуту'; };
var bo_b21 = function (match, outcome) { return 'Победа в матче с 31 по 40 минуту'; };
var bo_c21 = function (match, outcome) { return 'Победа в матче с 41 по 50 минуту'; };
var bo_d21 = function (match, outcome) { return 'Победа в матче с 51 по 60 минуту'; };
var bo_e21 = function (match, outcome) { return 'Фора в матче с 1 по 10 минуту'; };
var bo_f21 = function (match, outcome) { return 'Фора в матче с 11 по 20 минуту'; };
var bo_g21 = function (match, outcome) { return 'Фора в матче с 21 по 30 минуту'; };
var bo_h21 = function (match, outcome) { return 'Фора в матче с 31 по 40 минуту'; };
var bo_i21 = function (match, outcome) { return 'Фора в матче с 41 по 50 минуту'; };
var bo_j21 = function (match, outcome) { return 'Фора в матче с 51 по 60 минуту'; };
var bo_k21 = function (match, outcome) { return 'Тотал матча с 1 по 10 минуту'; };
var bo_l21 = function (match, outcome) { return 'Тотал матча с 11 по 20 минуту'; };
var bo_m21 = function (match, outcome) { return 'Тотал матча с 21 по 30 минуту'; };
var bo_n21 = function (match, outcome) { return 'Тотал матча с 31 по 40 минуту'; };
var bo_o21 = function (match, outcome) { return 'Тотал матча с 41 по 50 минуту'; };
var bo_p21 = function (match, outcome) { return 'Тотал матча с 51 по 60 минуту'; };
var bo_q21 = function (match, outcome) { return 'Чет/Нечет наибольшего выпавшего шара'; };
var bo_r21 = function (match, outcome) { return 'Чет/Нечет наименьшего выпавшего шара'; };
var bo_s21 = function (match, outcome) { return 'Чет/Нечет первого выпавшего шара'; };
var bo_t21 = function (match, outcome) { return 'Чет/Нечет последнего выпавшего шара'; };
var bo_u21 = function (match, outcome) { return 'Первый меньше/больше последнего'; };
var bo_v21 = function (match, outcome) { return 'Все шары четные'; };
var bo_w21 = function (match, outcome) { return 'Все шары нечетные'; };
var bo_x21 = function (match, outcome) { return 'Хотя бы два шара с соседними номерами'; };
var bo_y21 = function (match, outcome) { return 'Наименьший выпавший шар'; };
var bo_z21 = function (match, outcome) { return 'Наибольший выпавший шар'; };
var bo_a22 = function (match, outcome) { return 'Сумма выпавших шаров'; };
var bo_b22 = function (match, outcome) { return "\u0425\u043E\u0442\u044F \u0431\u044B \u043E\u0434\u0438\u043D \u0438\u0437 \u0432\u044B\u043F\u0430\u0432\u0448\u0438\u0445 \u0448\u0430\u0440\u043E\u0432 \u043A\u0440\u0430\u0442\u0435\u043D ".concat(outcome.condition); };
var bo_c22 = function (match, outcome) { return 'Разница между наименьшим и наибольшим шарами'; };
var bo_d22 = function (match, outcome) { return 'Сумма нечетных шаров'; };
var bo_e22 = function (match, outcome) { return 'Сумма четных шаров'; };
var bo_f22 = function (match, outcome) { return 'Первый выпавший шар'; };
var bo_g22 = function (match, outcome) { return 'Второй выпавший шар'; };
var bo_h22 = function (match, outcome) { return 'Третий выпавший шар'; };
var bo_i22 = function (match, outcome) { return 'Четвертый выпавший шар'; };
var bo_j22 = function (match, outcome) { return 'Пятый выпавший шар'; };
var bo_k22 = function (match, outcome) { return 'Шестой выпавший шар'; };
var bo_l22 = function (match, outcome) { return 'Седьмой выпавший шар'; };
var bo_m22 = function (match, outcome) { return "\u0425\u043E\u0442\u044F \u0431\u044B \u043E\u0434\u0438\u043D \u0448\u0430\u0440 \u043F\u043E\u043F\u0430\u0434\u0435\u0442 \u0432 \u0438\u043D\u0442\u0435\u0440\u0432\u0430\u043B \u043E\u0442 ".concat(outcome.condition, " \u0434\u043E ").concat(outcome.conditionTwo); };
var bo_n22 = function (match, outcome) { return 'Сумма наименьшего и наибольшего шаров'; };
var bo_o22 = function (match, outcome) { return "".concat(match.homeTeam, " \u043F\u043E\u0431\u0435\u0434\u0438\u0442 \u0411\u043E\u043B\u0435\u0432\u044B\u043C/\u0423\u0434\u0443\u0448\u0430\u044E\u0449\u0438\u043C/\u0414\u043E\u0431\u0440\u043E\u0432\u043E\u043B\u044C\u043D\u043E\u0439 \u0441\u0434\u0430\u0447\u0435\u0439"); };
var bo_p22 = function (match, outcome) { return "".concat(match.awayTeam, " \u043F\u043E\u0431\u0435\u0434\u0438\u0442 \u0411\u043E\u043B\u0435\u0432\u044B\u043C/\u0423\u0434\u0443\u0448\u0430\u044E\u0449\u0438\u043C/\u0414\u043E\u0431\u0440\u043E\u0432\u043E\u043B\u044C\u043D\u043E\u0439 \u0441\u0434\u0430\u0447\u0435\u0439"); };
var bo_q22 = function (match, outcome) { return "".concat(match.homeTeam, " \u043F\u043E\u0431\u0435\u0434\u0438\u0442 \u041D\u043E\u043A\u0430\u0443\u0442\u043E\u043C/\u0422\u0435\u0445\u043D\u0438\u0447. \u043D\u043E\u043A\u0430\u0443\u0442\u043E\u043C/\u0414\u0438\u0441\u043A\u0432\u0430\u043B\u0438\u0444\u0438\u043A\u0430\u0446\u0438\u0435\u0439"); };
var bo_r22 = function (match, outcome) { return "".concat(match.awayTeam, " \u043F\u043E\u0431\u0435\u0434\u0438\u0442 \u041D\u043E\u043A\u0430\u0443\u0442\u043E\u043C/\u0422\u0435\u0445\u043D\u0438\u0447. \u043D\u043E\u043A\u0430\u0443\u0442\u043E\u043C/\u0414\u0438\u0441\u043A\u0432\u0430\u043B\u0438\u0444\u0438\u043A\u0430\u0446\u0438\u0435\u0439"); };
var bo_s22 = function (match, outcome) { return 'Тотал медалей'; };
var bo_t22 = function (match, outcome) { return 'Результат двадцать девятой партии'; };
var bo_u22 = function (match, outcome) { return 'Результат тридцатой партии'; };
var bo_v22 = function (match, outcome) { return 'Результат тридцать первой партии'; };
var bo_w22 = function (match, outcome) { return 'Результат тридцать второй партии'; };
var bo_x22 = function (match, outcome) { return 'Результат тридцать третьей партии'; };
var bo_y22 = function (match, outcome) { return 'Результат тридцать четвертой партии'; };
var bo_z22 = function (match, outcome) { return 'Результат тридцать пятой партии'; };
var bo_a23 = function (match, outcome) { return 'Результат тридцать шестой партии'; };
var bo_b23 = function (match, outcome) { return 'Результат тридцать седьмой партии'; };
var bo_c23 = function (match, outcome) { return 'Чет/Нечет восемнадцатой партии'; };
var bo_d23 = function (match, outcome) { return 'Чет/Нечет девятнадцатой партии'; };
var bo_e23 = function (match, outcome) { return 'Чет/Нечет двадцатой партии'; };
var bo_f23 = function (match, outcome) { return 'Чет/Нечет двадцать первой партии'; };
var bo_g23 = function (match, outcome) { return 'Чет/Нечет двадцать второй партии'; };
var bo_h23 = function (match, outcome) { return 'Чет/Нечет двадцать третьей партии'; };
var bo_i23 = function (match, outcome) { return 'Чет/Нечет двадцать четвертой партии'; };
var bo_j23 = function (match, outcome) { return 'Чет/Нечет двадцать пятой партии'; };
var bo_k23 = function (match, outcome) { return 'Чет/Нечет двадцать шестой партии'; };
var bo_l23 = function (match, outcome) { return 'Чет/Нечет двадцать седьмой партии'; };
var bo_m23 = function (match, outcome) { return 'Чет/Нечет двадцать восьмой партии'; };
var bo_n23 = function (match, outcome) { return 'Чет/Нечет двадцать девятой партии'; };
var bo_o23 = function (match, outcome) { return 'Чет/Нечет тридцатой партии'; };
var bo_p23 = function (match, outcome) { return 'Чет/Нечет тридцать первой партии'; };
var bo_q23 = function (match, outcome) { return 'Чет/Нечет тридцать второй партии'; };
var bo_r23 = function (match, outcome) { return 'Чет/Нечет тридцать третьей партии'; };
var bo_s23 = function (match, outcome) { return 'Чет/Нечет тридцать четвертой партии'; };
var bo_t23 = function (match, outcome) { return 'Чет/Нечет тридцать пятой партии'; };
var bo_u23 = function (match, outcome) { return 'Чет/Нечет тридцать шестой партии'; };
var bo_v23 = function (match, outcome) { return 'Чет/Нечет тридцать седьмой партии'; };
var bo_w23 = function (match, outcome) { return 'Какой цветной шар будет забит первым в первой партии?'; };
var bo_x23 = function (match, outcome) { return 'Какой цветной шар будет забит первым во второй партии?'; };
var bo_y23 = function (match, outcome) { return 'Какой цветной шар будет забит первым в третьей партии?'; };
var bo_z23 = function (match, outcome) { return 'Какой цветной шар будет забит первым в четвертой партии?'; };
var bo_a24 = function (match, outcome) { return 'Какой цветной шар будет забит первым в пятой партии?'; };
var bo_b24 = function (match, outcome) { return 'Какой цветной шар будет забит первым в шестой партии?'; };
var bo_c24 = function (match, outcome) { return 'Какой цветной шар будет забит первым в седьмой партии?'; };
var bo_d24 = function (match, outcome) { return 'Какой цветной шар будет забит первым в восьмой партии?'; };
var bo_e24 = function (match, outcome) { return 'Какой цветной шар будет забит первым в девятой партии?'; };
var bo_f24 = function (match, outcome) { return 'Какой цветной шар будет забит первым в десятой партии?'; };
var bo_g24 = function (match, outcome) { return 'Какой цветной шар будет забит первым в одиннадцатой партии?'; };
var bo_h24 = function (match, outcome) { return 'Какой цветной шар будет забит первым в двенадцатой партии?'; };
var bo_i24 = function (match, outcome) { return 'Какой цветной шар будет забит первым в тринадцатой партии?'; };
var bo_j24 = function (match, outcome) { return 'Какой цветной шар будет забит первым в четырнадцатой партии?'; };
var bo_k24 = function (match, outcome) { return 'Какой цветной шар будет забит первым в пятнадцатой партии?'; };
var bo_l24 = function (match, outcome) { return 'Какой цветной шар будет забит первым в шестнадцатой партии?'; };
var bo_m24 = function (match, outcome) { return 'Какой цветной шар будет забит первым в семнадцатой партии?'; };
var bo_n24 = function (match, outcome) { return 'Какой цветной шар будет забит первым в восемнадцатой партии?'; };
var bo_o24 = function (match, outcome) { return 'Какой цветной шар будет забит первым в девятнадцатой партии?'; };
var bo_p24 = function (match, outcome) { return 'Какой цветной шар будет забит первым в двадцатой партии?'; };
var bo_q24 = function (match, outcome) { return 'Какой цветной шар будет забит первым в двадцать первой партии?'; };
var bo_r24 = function (match, outcome) { return 'Какой цветной шар будет забит первым в двадцать второй партии?'; };
var bo_s24 = function (match, outcome) { return 'Какой цветной шар будет забит первым в двадцать третьей партии?'; };
var bo_t24 = function (match, outcome) { return 'Какой цветной шар будет забит первым в двадцать четвертой партии?'; };
var bo_u24 = function (match, outcome) { return 'Какой цветной шар будет забит первым в двадцать пятой партии?'; };
var bo_v24 = function (match, outcome) { return 'Какой цветной шар будет забит первым в двадцать шестой партии?'; };
var bo_w24 = function (match, outcome) { return 'Какой цветной шар будет забит первым в двадцать седьмой партии?'; };
var bo_x24 = function (match, outcome) { return 'Какой цветной шар будет забит первым в двадцать восьмой партии?'; };
var bo_y24 = function (match, outcome) { return 'Какой цветной шар будет забит первым в двадцать девятой партии?'; };
var bo_z24 = function (match, outcome) { return 'Какой цветной шар будет забит первым в тридцатой партии?'; };
var bo_a25 = function (match, outcome) { return 'Какой цветной шар будет забит первым в тридцать первой партии?'; };
var bo_b25 = function (match, outcome) { return 'Какой цветной шар будет забит первым в тридцать второй партии?'; };
var bo_c25 = function (match, outcome) { return 'Какой цветной шар будет забит первым в тридцать третьей партии?'; };
var bo_d25 = function (match, outcome) { return 'Какой цветной шар будет забит первым в тридцать четвертой партии?'; };
var bo_e25 = function (match, outcome) { return 'Какой цветной шар будет забит первым в тридцать пятой партии?'; };
var bo_f25 = function (match, outcome) { return 'Какой цветной шар будет забит первым в тридцать шестой партии?'; };
var bo_g25 = function (match, outcome) { return 'Какой цветной шар будет забит первым в тридцать седьмой партии?'; };
var bo_h25 = function (match, outcome) { return 'Результат первой партии'; };
var bo_i25 = function (match, outcome) { return 'Результат второй партии'; };
var bo_j25 = function (match, outcome) { return 'Результат третьей партии'; };
var bo_k25 = function (match, outcome) { return 'Результат четвертой партии'; };
var bo_l25 = function (match, outcome) { return 'Результат пятой партии'; };
var bo_m25 = function (match, outcome) { return 'Результат шестой партии'; };
var bo_n25 = function (match, outcome) { return 'Результат седьмой партии'; };
var bo_o25 = function (match, outcome) { return 'Результат восьмой партии'; };
var bo_p25 = function (match, outcome) { return 'Результат девятой партии'; };
var bo_q25 = function (match, outcome) { return 'Результат десятой партии'; };
var bo_r25 = function (match, outcome) { return 'Результат одиннадцатой партии'; };
var bo_s25 = function (match, outcome) { return 'Результат двенадцатой партии'; };
var bo_t25 = function (match, outcome) { return 'Результат тринадцатой партии'; };
var bo_u25 = function (match, outcome) { return 'Результат четырнадцатой партии'; };
var bo_v25 = function (match, outcome) { return 'Результат пятнадцатой партии'; };
var bo_w25 = function (match, outcome) { return 'Результат шестнадцатой партии'; };
var bo_x25 = function (match, outcome) { return 'Результат семнадцатой партии'; };
var bo_y25 = function (match, outcome) { return 'Результат восемнадцатой партии'; };
var bo_z25 = function (match, outcome) { return 'Результат девятнадцатой партии'; };
var bo_a26 = function (match, outcome) { return 'Результат двадцатой партии'; };
var bo_b26 = function (match, outcome) { return 'Результат двадцать первой партии'; };
var bo_c26 = function (match, outcome) { return 'Результат двадцать второй партии'; };
var bo_d26 = function (match, outcome) { return 'Результат двадцать третьей партии'; };
var bo_e26 = function (match, outcome) { return 'Результат двадцать четвертой партии'; };
var bo_f26 = function (match, outcome) { return 'Результат двадцать пятой партии'; };
var bo_g26 = function (match, outcome) { return 'Результат двадцать шестой партии'; };
var bo_h26 = function (match, outcome) { return 'Результат двадцать седьмой партии'; };
var bo_i26 = function (match, outcome) { return 'Результат двадцать восьмой партии'; };
var bo_j26 = function (match, outcome) { return 'Кто первым(ой) забьет шар в седьмой партии ?'; };
var bo_k26 = function (match, outcome) { return 'Кто первым(ой) забьет шар в восьмой партии ?'; };
var bo_l26 = function (match, outcome) { return 'Кто первым(ой) забьет шар в девятой партии ?'; };
var bo_m26 = function (match, outcome) { return 'Кто первым(ой) забьет шар в десятой партии ?'; };
var bo_n26 = function (match, outcome) { return 'Кто первым(ой) забьет шар в одиннадцатой партии ?'; };
var bo_o26 = function (match, outcome) { return 'Кто первым(ой) забьет шар в двенадцатой партии ?'; };
var bo_p26 = function (match, outcome) { return 'Кто первым(ой) забьет шар в тринадцатой партии ?'; };
var bo_q26 = function (match, outcome) { return 'Кто первым(ой) забьет шар в четырнадцатой партии ?'; };
var bo_r26 = function (match, outcome) { return 'Кто первым(ой) забьет шар в пятнадцатой партии ?'; };
var bo_s26 = function (match, outcome) { return 'Кто первым(ой) забьет шар в шестнадцатой партии ?'; };
var bo_t26 = function (match, outcome) { return 'Кто первым(ой) забьет шар в семнадцатой партии ?'; };
var bo_u26 = function (match, outcome) { return 'Кто первым(ой) забьет шар в восемнадцатой партии ?'; };
var bo_v26 = function (match, outcome) { return 'Кто первым(ой) забьет шар в девятнадцатой партии ?'; };
var bo_w26 = function (match, outcome) { return 'Кто первым(ой) забьет шар в двадцатой партии ?'; };
var bo_x26 = function (match, outcome) { return 'Кто первым(ой) забьет шар в двадцать первой партии ?'; };
var bo_y26 = function (match, outcome) { return 'Кто первым(ой) забьет шар в двадцать второй партии ?'; };
var bo_z26 = function (match, outcome) { return 'Кто первым(ой) забьет шар в двадцать третьей партии ?'; };
var bo_a27 = function (match, outcome) { return 'Кто первым(ой) забьет шар в двадцать четвертой партии ?'; };
var bo_b27 = function (match, outcome) { return 'Кто первым(ой) забьет шар в двадцать пятой партии ?'; };
var bo_c27 = function (match, outcome) { return 'Кто первым(ой) забьет шар в двадцать шестой партии ?'; };
var bo_d27 = function (match, outcome) { return 'Кто первым(ой) забьет шар в двадцать седьмой партии ?'; };
var bo_e27 = function (match, outcome) { return 'Кто первым(ой) забьет шар в двадцать восьмой партии ?'; };
var bo_f27 = function (match, outcome) { return 'Кто первым(ой) забьет шар в двадцать девятой партии ?'; };
var bo_g27 = function (match, outcome) { return 'Кто первым(ой) забьет шар в тридцатой партии ?'; };
var bo_h27 = function (match, outcome) { return 'Кто первым(ой) забьет шар в тридцать первой партии ?'; };
var bo_i27 = function (match, outcome) { return 'Кто первым(ой) забьет шар в тридцать второй партии ?'; };
var bo_j27 = function (match, outcome) { return 'Кто первым(ой) забьет шар в тридцать третьей партии ?'; };
var bo_k27 = function (match, outcome) { return 'Кто первым(ой) забьет шар в тридцать четвертой партии ?'; };
var bo_l27 = function (match, outcome) { return 'Кто первым(ой) забьет шар в тридцать пятой партии ?'; };
var bo_m27 = function (match, outcome) { return 'Кто первым(ой) забьет шар в тридцать шестой партии ?'; };
var bo_n27 = function (match, outcome) { return 'Кто первым(ой) забьет шар в тридцать седьмой партии ?'; };
var bo_o27 = function (match, outcome) { return "\u041A\u0442\u043E \u043F\u0435\u0440\u0432\u044B\u043C \u043D\u0430\u0431\u0435\u0440\u0435\u0442 ".concat(outcome.condition, " ").concat(plural(outcome.condition, ['очко', 'очков', 'очков']), " \u0432 \u043F\u0435\u0440\u0432\u043E\u0439 \u043F\u0430\u0440\u0442\u0438\u0438"); };
var bo_p27 = function (match, outcome) { return "\u041A\u0442\u043E \u043F\u0435\u0440\u0432\u044B\u043C \u043D\u0430\u0431\u0435\u0440\u0435\u0442 ".concat(outcome.condition, " ").concat(plural(outcome.condition, ['очко', 'очков', 'очков']), " \u0432\u043E \u0432\u0442\u043E\u0440\u043E\u0439 \u043F\u0430\u0440\u0442\u0438\u0438"); };
var bo_q27 = function (match, outcome) { return "\u041A\u0442\u043E \u043F\u0435\u0440\u0432\u044B\u043C \u043D\u0430\u0431\u0435\u0440\u0435\u0442 ".concat(outcome.condition, " ").concat(plural(outcome.condition, ['очко', 'очков', 'очков']), " \u0432 \u0442\u0440\u0435\u0442\u044C\u0435\u0439 \u043F\u0430\u0440\u0442\u0438\u0438"); };
var bo_r27 = function (match, outcome) { return "\u041A\u0442\u043E \u043F\u0435\u0440\u0432\u044B\u043C \u043D\u0430\u0431\u0435\u0440\u0435\u0442 ".concat(outcome.condition, " ").concat(plural(outcome.condition, ['очко', 'очков', 'очков']), " \u0432 \u0447\u0435\u0442\u0432\u0435\u0440\u0442\u043E\u0439 \u043F\u0430\u0440\u0442\u0438\u0438"); };
var bo_s27 = function (match, outcome) { return "\u041A\u0442\u043E \u043F\u0435\u0440\u0432\u044B\u043C \u043D\u0430\u0431\u0435\u0440\u0435\u0442 ".concat(outcome.condition, " ").concat(plural(outcome.condition, ['очко', 'очков', 'очков']), " \u0432 \u043F\u044F\u0442\u043E\u0439 \u043F\u0430\u0440\u0442\u0438\u0438"); };
var bo_t27 = function (match, outcome) { return "\u041A\u0442\u043E \u043F\u0435\u0440\u0432\u044B\u043C \u043D\u0430\u0431\u0435\u0440\u0435\u0442 ".concat(outcome.condition, " ").concat(plural(outcome.condition, ['очко', 'очков', 'очков']), " \u0432 \u0448\u0435\u0441\u0442\u043E\u0439 \u043F\u0430\u0440\u0442\u0438\u0438"); };
var bo_u27 = function (match, outcome) { return "\u041A\u0442\u043E \u043F\u0435\u0440\u0432\u044B\u043C \u043D\u0430\u0431\u0435\u0440\u0435\u0442 ".concat(outcome.condition, " ").concat(plural(outcome.condition, ['очко', 'очков', 'очков']), " \u0432 \u0441\u0435\u0434\u044C\u043C\u043E\u0439 \u043F\u0430\u0440\u0442\u0438\u0438"); };
var bo_v27 = function (match, outcome) { return "\u041A\u0442\u043E \u043F\u0435\u0440\u0432\u044B\u043C \u043D\u0430\u0431\u0435\u0440\u0435\u0442 ".concat(outcome.condition, " ").concat(plural(outcome.condition, ['очко', 'очков', 'очков']), " \u0432 \u0432\u043E\u0441\u044C\u043C\u043E\u0439 \u043F\u0430\u0440\u0442\u0438\u0438"); };
var bo_w27 = function (match, outcome) { return "\u041A\u0442\u043E \u043F\u0435\u0440\u0432\u044B\u043C \u043D\u0430\u0431\u0435\u0440\u0435\u0442 ".concat(outcome.condition, " ").concat(plural(outcome.condition, ['очко', 'очков', 'очков']), " \u0432 \u0434\u0435\u0432\u044F\u0442\u043E\u0439 \u043F\u0430\u0440\u0442\u0438\u0438"); };
var bo_x27 = function (match, outcome) { return "\u041A\u0442\u043E \u043F\u0435\u0440\u0432\u044B\u043C \u043D\u0430\u0431\u0435\u0440\u0435\u0442 ".concat(outcome.condition, " ").concat(plural(outcome.condition, ['очко', 'очков', 'очков']), " \u0432 \u0434\u0435\u0441\u044F\u0442\u043E\u0439 \u043F\u0430\u0440\u0442\u0438\u0438"); };
var bo_y27 = function (match, outcome) { return "\u041A\u0442\u043E \u043F\u0435\u0440\u0432\u044B\u043C \u043D\u0430\u0431\u0435\u0440\u0435\u0442 ".concat(outcome.condition, " ").concat(plural(outcome.condition, ['очко', 'очков', 'очков']), " \u0432 \u043E\u0434\u0438\u043D\u043D\u0430\u0434\u0446\u0430\u0442\u043E\u0439 \u043F\u0430\u0440\u0442\u0438\u0438"); };
var bo_z27 = function (match, outcome) { return "\u041A\u0442\u043E \u043F\u0435\u0440\u0432\u044B\u043C \u043D\u0430\u0431\u0435\u0440\u0435\u0442 ".concat(outcome.condition, " ").concat(plural(outcome.condition, ['очко', 'очков', 'очков']), " \u0432 \u0434\u0432\u0435\u043D\u0430\u0434\u0446\u0430\u0442\u043E\u0439 \u043F\u0430\u0440\u0442\u0438\u0438"); };
var bo_a28 = function (match, outcome) { return "\u041A\u0442\u043E \u043F\u0435\u0440\u0432\u044B\u043C \u043D\u0430\u0431\u0435\u0440\u0435\u0442 ".concat(outcome.condition, " ").concat(plural(outcome.condition, ['очко', 'очков', 'очков']), " \u0432 \u0442\u0440\u0438\u043D\u0430\u0434\u0446\u0430\u0442\u043E\u0439 \u043F\u0430\u0440\u0442\u0438\u0438"); };
var bo_b28 = function (match, outcome) { return "\u041A\u0442\u043E \u043F\u0435\u0440\u0432\u044B\u043C \u043D\u0430\u0431\u0435\u0440\u0435\u0442 ".concat(outcome.condition, " ").concat(plural(outcome.condition, ['очко', 'очков', 'очков']), " \u0432 \u0447\u0435\u0442\u044B\u0440\u043D\u0430\u0434\u0446\u0430\u0442\u043E\u0439 \u043F\u0430\u0440\u0442\u0438\u0438"); };
var bo_c28 = function (match, outcome) { return "\u041A\u0442\u043E \u043F\u0435\u0440\u0432\u044B\u043C \u043D\u0430\u0431\u0435\u0440\u0435\u0442 ".concat(outcome.condition, " ").concat(plural(outcome.condition, ['очко', 'очков', 'очков']), " \u0432 \u043F\u044F\u0442\u043D\u0430\u0434\u0446\u0430\u0442\u043E\u0439 \u043F\u0430\u0440\u0442\u0438\u0438"); };
var bo_d28 = function (match, outcome) { return "\u041A\u0442\u043E \u043F\u0435\u0440\u0432\u044B\u043C \u043D\u0430\u0431\u0435\u0440\u0435\u0442 ".concat(outcome.condition, " ").concat(plural(outcome.condition, ['очко', 'очков', 'очков']), " \u0432 \u0448\u0435\u0441\u0442\u043D\u0430\u0434\u0446\u0430\u0442\u043E\u0439 \u043F\u0430\u0440\u0442\u0438\u0438"); };
var bo_e28 = function (match, outcome) { return "\u041A\u0442\u043E \u043F\u0435\u0440\u0432\u044B\u043C \u043D\u0430\u0431\u0435\u0440\u0435\u0442 ".concat(outcome.condition, " ").concat(plural(outcome.condition, ['очко', 'очков', 'очков']), " \u0432 \u0441\u0435\u043C\u043D\u0430\u0434\u0446\u0430\u0442\u043E\u0439 \u043F\u0430\u0440\u0442\u0438\u0438"); };
var bo_f28 = function (match, outcome) { return "\u041A\u0442\u043E \u043F\u0435\u0440\u0432\u044B\u043C \u043D\u0430\u0431\u0435\u0440\u0435\u0442 ".concat(outcome.condition, " ").concat(plural(outcome.condition, ['очко', 'очков', 'очков']), " \u0432 \u0432\u043E\u0441\u0435\u043C\u043D\u0430\u0434\u0446\u0430\u0442\u043E\u0439 \u043F\u0430\u0440\u0442\u0438\u0438"); };
var bo_g28 = function (match, outcome) { return "\u041A\u0442\u043E \u043F\u0435\u0440\u0432\u044B\u043C \u043D\u0430\u0431\u0435\u0440\u0435\u0442 ".concat(outcome.condition, " ").concat(plural(outcome.condition, ['очко', 'очков', 'очков']), " \u0432 \u0434\u0435\u0432\u044F\u0442\u043D\u0430\u0434\u0446\u0430\u0442\u043E\u0439 \u043F\u0430\u0440\u0442\u0438\u0438"); };
var bo_h28 = function (match, outcome) { return "\u041A\u0442\u043E \u043F\u0435\u0440\u0432\u044B\u043C \u043D\u0430\u0431\u0435\u0440\u0435\u0442 ".concat(outcome.condition, " ").concat(plural(outcome.condition, ['очко', 'очков', 'очков']), " \u0432 \u0434\u0432\u0430\u0434\u0446\u0430\u0442\u043E\u0439 \u043F\u0430\u0440\u0442\u0438\u0438"); };
var bo_i28 = function (match, outcome) { return "\u041A\u0442\u043E \u043F\u0435\u0440\u0432\u044B\u043C \u043D\u0430\u0431\u0435\u0440\u0435\u0442 ".concat(outcome.condition, " ").concat(plural(outcome.condition, ['очко', 'очков', 'очков']), " \u0432 \u0434\u0432\u0430\u0434\u0446\u0430\u0442\u044C \u043F\u0435\u0440\u0432\u043E\u0439 \u043F\u0430\u0440\u0442\u0438\u0438"); };
var bo_j28 = function (match, outcome) { return "\u041A\u0442\u043E \u043F\u0435\u0440\u0432\u044B\u043C \u043D\u0430\u0431\u0435\u0440\u0435\u0442 ".concat(outcome.condition, " ").concat(plural(outcome.condition, ['очко', 'очков', 'очков']), " \u0432 \u0434\u0432\u0430\u0434\u0446\u0430\u0442\u044C \u0432\u0442\u043E\u0440\u043E\u0439 \u043F\u0430\u0440\u0442\u0438\u0438"); };
var bo_k28 = function (match, outcome) { return "\u041A\u0442\u043E \u043F\u0435\u0440\u0432\u044B\u043C \u043D\u0430\u0431\u0435\u0440\u0435\u0442 ".concat(outcome.condition, " ").concat(plural(outcome.condition, ['очко', 'очков', 'очков']), " \u0432 \u0434\u0432\u0430\u0434\u0446\u0430\u0442\u044C \u0442\u0440\u0435\u0442\u044C\u0435\u0439 \u043F\u0430\u0440\u0442\u0438\u0438"); };
var bo_l28 = function (match, outcome) { return "\u041A\u0442\u043E \u043F\u0435\u0440\u0432\u044B\u043C \u043D\u0430\u0431\u0435\u0440\u0435\u0442 ".concat(outcome.condition, " ").concat(plural(outcome.condition, ['очко', 'очков', 'очков']), " \u0432 \u0434\u0432\u0430\u0434\u0446\u0430\u0442\u044C \u0447\u0435\u0442\u0432\u0435\u0440\u0442\u043E\u0439 \u043F\u0430\u0440\u0442\u0438\u0438"); };
var bo_m28 = function (match, outcome) { return "\u041A\u0442\u043E \u043F\u0435\u0440\u0432\u044B\u043C \u043D\u0430\u0431\u0435\u0440\u0435\u0442 ".concat(outcome.condition, " ").concat(plural(outcome.condition, ['очко', 'очков', 'очков']), " \u0432 \u0434\u0432\u0430\u0434\u0446\u0430\u0442\u044C \u043F\u044F\u0442\u043E\u0439 \u043F\u0430\u0440\u0442\u0438\u0438"); };
var bo_n28 = function (match, outcome) { return "\u041A\u0442\u043E \u043F\u0435\u0440\u0432\u044B\u043C \u043D\u0430\u0431\u0435\u0440\u0435\u0442 ".concat(outcome.condition, " ").concat(plural(outcome.condition, ['очко', 'очков', 'очков']), " \u0432 \u0434\u0432\u0430\u0434\u0446\u0430\u0442\u044C \u0448\u0435\u0441\u0442\u043E\u0439 \u043F\u0430\u0440\u0442\u0438\u0438"); };
var bo_o28 = function (match, outcome) { return "\u041A\u0442\u043E \u043F\u0435\u0440\u0432\u044B\u043C \u043D\u0430\u0431\u0435\u0440\u0435\u0442 ".concat(outcome.condition, " ").concat(plural(outcome.condition, ['очко', 'очков', 'очков']), " \u0432 \u0434\u0432\u0430\u0434\u0446\u0430\u0442\u044C \u0441\u0435\u0434\u044C\u043C\u043E\u0439 \u043F\u0430\u0440\u0442\u0438\u0438"); };
var bo_p28 = function (match, outcome) { return "\u041A\u0442\u043E \u043F\u0435\u0440\u0432\u044B\u043C \u043D\u0430\u0431\u0435\u0440\u0435\u0442 ".concat(outcome.condition, " ").concat(plural(outcome.condition, ['очко', 'очков', 'очков']), " \u0432 \u0434\u0432\u0430\u0434\u0446\u0430\u0442\u044C \u0432\u043E\u0441\u044C\u043C\u043E\u0439 \u043F\u0430\u0440\u0442\u0438\u0438"); };
var bo_q28 = function (match, outcome) { return "\u041A\u0442\u043E \u043F\u0435\u0440\u0432\u044B\u043C \u043D\u0430\u0431\u0435\u0440\u0435\u0442 ".concat(outcome.condition, " ").concat(plural(outcome.condition, ['очко', 'очков', 'очков']), " \u0432 \u0434\u0432\u0430\u0434\u0446\u0430\u0442\u044C \u0434\u0435\u0432\u044F\u0442\u043E\u0439 \u043F\u0430\u0440\u0442\u0438\u0438"); };
var bo_r28 = function (match, outcome) { return "\u041A\u0442\u043E \u043F\u0435\u0440\u0432\u044B\u043C \u043D\u0430\u0431\u0435\u0440\u0435\u0442 ".concat(outcome.condition, " ").concat(plural(outcome.condition, ['очко', 'очков', 'очков']), " \u0432 \u0442\u0440\u0438\u0434\u0446\u0430\u0442\u043E\u0439 \u043F\u0430\u0440\u0442\u0438\u0438"); };
var bo_s28 = function (match, outcome) { return "\u041A\u0442\u043E \u043F\u0435\u0440\u0432\u044B\u043C \u043D\u0430\u0431\u0435\u0440\u0435\u0442 ".concat(outcome.condition, " ").concat(plural(outcome.condition, ['очко', 'очков', 'очков']), " \u0432 \u0442\u0440\u0438\u0434\u0446\u0430\u0442\u044C \u043F\u0435\u0440\u0432\u043E\u0439 \u043F\u0430\u0440\u0442\u0438\u0438"); };
var bo_t28 = function (match, outcome) { return "\u041A\u0442\u043E \u043F\u0435\u0440\u0432\u044B\u043C \u043D\u0430\u0431\u0435\u0440\u0435\u0442 ".concat(outcome.condition, " ").concat(plural(outcome.condition, ['очко', 'очков', 'очков']), " \u0432 \u0442\u0440\u0438\u0434\u0446\u0430\u0442\u044C \u0432\u0442\u043E\u0440\u043E\u0439 \u043F\u0430\u0440\u0442\u0438\u0438"); };
var bo_u28 = function (match, outcome) { return "\u041A\u0442\u043E \u043F\u0435\u0440\u0432\u044B\u043C \u043D\u0430\u0431\u0435\u0440\u0435\u0442 ".concat(outcome.condition, " ").concat(plural(outcome.condition, ['очко', 'очков', 'очков']), " \u0432 \u0442\u0440\u0438\u0434\u0446\u0430\u0442\u044C \u0442\u0440\u0435\u0442\u044C\u0435\u0439 \u043F\u0430\u0440\u0442\u0438\u0438"); };
var bo_v28 = function (match, outcome) { return "\u041A\u0442\u043E \u043F\u0435\u0440\u0432\u044B\u043C \u043D\u0430\u0431\u0435\u0440\u0435\u0442 ".concat(outcome.condition, " ").concat(plural(outcome.condition, ['очко', 'очков', 'очков']), " \u0432 \u0442\u0440\u0438\u0434\u0446\u0430\u0442\u044C \u0447\u0435\u0442\u0432\u0435\u0440\u0442\u043E\u0439 \u043F\u0430\u0440\u0442\u0438\u0438"); };
var bo_w28 = function (match, outcome) { return "\u041A\u0442\u043E \u043F\u0435\u0440\u0432\u044B\u043C \u043D\u0430\u0431\u0435\u0440\u0435\u0442 ".concat(outcome.condition, " ").concat(plural(outcome.condition, ['очко', 'очков', 'очков']), " \u0432 \u0442\u0440\u0438\u0434\u0446\u0430\u0442\u044C \u043F\u044F\u0442\u043E\u0439 \u043F\u0430\u0440\u0442\u0438\u0438"); };
var bo_x28 = function (match, outcome) { return "\u041A\u0442\u043E \u043F\u0435\u0440\u0432\u044B\u043C \u043D\u0430\u0431\u0435\u0440\u0435\u0442 ".concat(outcome.condition, " ").concat(plural(outcome.condition, ['очко', 'очков', 'очков']), " \u0432 \u0442\u0440\u0438\u0434\u0446\u0430\u0442\u044C \u0448\u0435\u0441\u0442\u043E\u0439 \u043F\u0430\u0440\u0442\u0438\u0438"); };
var bo_y28 = function (match, outcome) { return "\u041A\u0442\u043E \u043F\u0435\u0440\u0432\u044B\u043C \u043D\u0430\u0431\u0435\u0440\u0435\u0442 ".concat(outcome.condition, " ").concat(plural(outcome.condition, ['очко', 'очков', 'очков']), " \u0432 \u0442\u0440\u0438\u0434\u0446\u0430\u0442\u044C \u0441\u0435\u0434\u044C\u043C\u043E\u0439 \u043F\u0430\u0440\u0442\u0438\u0438"); };
var bo_z28 = function (match, outcome) { return 'Чет/Нечет первой партии'; };
var bo_a29 = function (match, outcome) { return 'Чет/Нечет второй партии'; };
var bo_b29 = function (match, outcome) { return 'Чет/Нечет третьей партии'; };
var bo_c29 = function (match, outcome) { return 'Чет/Нечет четвертой партии'; };
var bo_d29 = function (match, outcome) { return 'Чет/Нечет пятой партии'; };
var bo_e29 = function (match, outcome) { return 'Чет/Нечет шестой партии'; };
var bo_f29 = function (match, outcome) { return 'Чет/Нечет седьмой партии'; };
var bo_g29 = function (match, outcome) { return 'Чет/Нечет восьмой партии'; };
var bo_h29 = function (match, outcome) { return 'Чет/Нечет девятой партии'; };
var bo_i29 = function (match, outcome) { return 'Чет/Нечет десятой партии'; };
var bo_j29 = function (match, outcome) { return 'Чет/Нечет одиннадцатой партии'; };
var bo_k29 = function (match, outcome) { return 'Чет/Нечет двенадцатой партии'; };
var bo_l29 = function (match, outcome) { return 'Чет/Нечет тринадцатой партии'; };
var bo_m29 = function (match, outcome) { return 'Чет/Нечет четырнадцатой партии'; };
var bo_n29 = function (match, outcome) { return 'Чет/Нечет пятнадцатой партии'; };
var bo_o29 = function (match, outcome) { return 'Чет/Нечет шестнадцатой партии'; };
var bo_p29 = function (match, outcome) { return 'Чет/Нечет семнадцатой партии'; };
var bo_q29 = function (match, outcome) { return 'Тотал сенчури брейков в матче'; };
var bo_r29 = function (match, outcome) { return 'Фора в первой партии'; };
var bo_s29 = function (match, outcome) { return 'Фора во второй партии'; };
var bo_t29 = function (match, outcome) { return 'Фора в третьей партии'; };
var bo_u29 = function (match, outcome) { return 'Фора в четвертой партии'; };
var bo_v29 = function (match, outcome) { return 'Фора в пятой партии'; };
var bo_w29 = function (match, outcome) { return 'Фора в шестой партии'; };
var bo_x29 = function (match, outcome) { return 'Фора в седьмой партии'; };
var bo_y29 = function (match, outcome) { return 'Фора в восьмой партии'; };
var bo_z29 = function (match, outcome) { return 'Фора в девятой партии'; };
var bo_a30 = function (match, outcome) { return 'Фора в десятой партии'; };
var bo_b30 = function (match, outcome) { return 'Фора в одиннадцатой партии'; };
var bo_c30 = function (match, outcome) { return 'Фора в двенадцатой партии'; };
var bo_d30 = function (match, outcome) { return 'Фора в тринадцатой партии'; };
var bo_e30 = function (match, outcome) { return 'Фора в четырнадцатой партии'; };
var bo_f30 = function (match, outcome) { return 'Фора в пятнадцатой партии'; };
var bo_g30 = function (match, outcome) { return 'Фора в шестнадцатой партии'; };
var bo_h30 = function (match, outcome) { return 'Фора в семнадцатой партии'; };
var bo_i30 = function (match, outcome) { return 'Фора в восемнадцатой партии'; };
var bo_j30 = function (match, outcome) { return 'Фора в девятнадцатой партии'; };
var bo_k30 = function (match, outcome) { return 'Фора в двадцатой партии'; };
var bo_l30 = function (match, outcome) { return 'Фора в двадцать первой партии'; };
var bo_m30 = function (match, outcome) { return 'Фора в двадцать второй партии'; };
var bo_n30 = function (match, outcome) { return 'Фора в двадцать третьей партии'; };
var bo_o30 = function (match, outcome) { return 'Фора в двадцать четвертой партии'; };
var bo_p30 = function (match, outcome) { return 'Фора в двадцать пятой партии'; };
var bo_q30 = function (match, outcome) { return 'Фора в двадцать шестой партии'; };
var bo_r30 = function (match, outcome) { return 'Фора в двадцать седьмой партии'; };
var bo_s30 = function (match, outcome) { return 'Фора в двадцать восьмой партии'; };
var bo_t30 = function (match, outcome) { return 'Фора в двадцать девятой партии'; };
var bo_u30 = function (match, outcome) { return 'Фора в тридцатой партии'; };
var bo_v30 = function (match, outcome) { return 'Фора в тридцать первой партии'; };
var bo_w30 = function (match, outcome) { return 'Фора в тридцать второй партии'; };
var bo_x30 = function (match, outcome) { return 'Фора в тридцать третьей партии'; };
var bo_y30 = function (match, outcome) { return 'Фора в тридцать четвертой партии'; };
var bo_z30 = function (match, outcome) { return 'Фора в тридцать пятой партии'; };
var bo_a31 = function (match, outcome) { return 'Фора в тридцать шестой партии'; };
var bo_b31 = function (match, outcome) { return 'Фора в тридцать седьмой партии'; };
var bo_c31 = function (match, outcome) { return 'Тотал первой партии'; };
var bo_d31 = function (match, outcome) { return 'Тотал второй партии'; };
var bo_e31 = function (match, outcome) { return 'Тотал третьей партии'; };
var bo_f31 = function (match, outcome) { return 'Тотал четвертой партии'; };
var bo_g31 = function (match, outcome) { return 'Тотал пятой партии'; };
var bo_h31 = function (match, outcome) { return 'Тотал шестой партии'; };
var bo_i31 = function (match, outcome) { return 'Тотал седьмой партии'; };
var bo_j31 = function (match, outcome) { return 'Тотал восьмой партии'; };
var bo_k31 = function (match, outcome) { return 'Тотал девятой партии'; };
var bo_l31 = function (match, outcome) { return 'Тотал десятой партии'; };
var bo_m31 = function (match, outcome) { return 'Тотал одиннадцатой партии'; };
var bo_n31 = function (match, outcome) { return 'Тотал двенадцатой партии'; };
var bo_o31 = function (match, outcome) { return 'Тотал тринадцатой партии'; };
var bo_p31 = function (match, outcome) { return 'Тотал четырнадцатой партии'; };
var bo_q31 = function (match, outcome) { return 'Тотал пятнадцатой партии'; };
var bo_r31 = function (match, outcome) { return 'Тотал шестнадцатой партии'; };
var bo_s31 = function (match, outcome) { return 'Тотал семнадцатой партии'; };
var bo_t31 = function (match, outcome) { return 'Тотал восемнадцатой партии'; };
var bo_u31 = function (match, outcome) { return 'Тотал девятнадцатой партии'; };
var bo_v31 = function (match, outcome) { return 'Тотал двадцатой партии'; };
var bo_w31 = function (match, outcome) { return 'Тотал двадцать первой партии'; };
var bo_x31 = function (match, outcome) { return 'Тотал двадцать второй партии'; };
var bo_y31 = function (match, outcome) { return 'Тотал двадцать третьей партии'; };
var bo_z31 = function (match, outcome) { return 'Тотал двадцать четвертой партии'; };
var bo_a32 = function (match, outcome) { return 'Тотал двадцать пятой партии'; };
var bo_b32 = function (match, outcome) { return 'Тотал двадцать шестой партии'; };
var bo_c32 = function (match, outcome) { return 'Тотал двадцать седьмой партии'; };
var bo_d32 = function (match, outcome) { return 'Тотал двадцать восьмой партии'; };
var bo_e32 = function (match, outcome) { return 'Тотал двадцать девятой партии'; };
var bo_f32 = function (match, outcome) { return 'Тотал тридцатой партии'; };
var bo_g32 = function (match, outcome) { return 'Тотал тридцать первой партии'; };
var bo_h32 = function (match, outcome) { return 'Тотал тридцать второй партии'; };
var bo_i32 = function (match, outcome) { return 'Тотал тридцать третьей партии'; };
var bo_j32 = function (match, outcome) { return 'Тотал тридцать четвертой партии'; };
var bo_k32 = function (match, outcome) { return 'Тотал тридцать пятой партии'; };
var bo_l32 = function (match, outcome) { return 'Тотал тридцать шестой партии'; };
var bo_m32 = function (match, outcome) { return 'Тотал тридцать седьмой партии'; };
var bo_n32 = function (match, outcome) { return 'Кто первым(ой) забьет шар в первой партии ?'; };
var bo_o32 = function (match, outcome) { return 'Кто первым(ой) забьет шар во второй партии ?'; };
var bo_p32 = function (match, outcome) { return 'Кто первым(ой) забьет шар в третьей партии ?'; };
var bo_q32 = function (match, outcome) { return 'Кто первым(ой) забьет шар в четвертой партии ?'; };
var bo_r32 = function (match, outcome) { return 'Кто первым(ой) забьет шар в пятой партии ?'; };
var bo_s32 = function (match, outcome) { return 'Кто первым(ой) забьет шар в шестой партии ?'; };
var bo_t32 = function (match, outcome) { return 'Тотал партий в матче'; };
var bo_u32 = function (match, outcome) { return "\u0422\u043E\u0442\u0430\u043B: ".concat(match.homeTeam, " \u0432 \u043F\u0435\u0440\u0432\u043E\u0439 \u043F\u0430\u0440\u0442\u0438\u0438"); };
var bo_v32 = function (match, outcome) { return "\u0422\u043E\u0442\u0430\u043B: ".concat(match.homeTeam, " \u0432\u043E \u0432\u0442\u043E\u0440\u043E\u0439 \u043F\u0430\u0440\u0442\u0438\u0438"); };
var bo_w32 = function (match, outcome) { return "\u0422\u043E\u0442\u0430\u043B: ".concat(match.homeTeam, " \u0432 \u0442\u0440\u0435\u0442\u044C\u0435\u0439 \u043F\u0430\u0440\u0442\u0438\u0438"); };
var bo_x32 = function (match, outcome) { return "\u0422\u043E\u0442\u0430\u043B: ".concat(match.homeTeam, " \u0432 \u0447\u0435\u0442\u0432\u0435\u0440\u0442\u043E\u0439 \u043F\u0430\u0440\u0442\u0438\u0438"); };
var bo_y32 = function (match, outcome) { return "\u0422\u043E\u0442\u0430\u043B: ".concat(match.homeTeam, " \u0432 \u043F\u044F\u0442\u043E\u0439 \u043F\u0430\u0440\u0442\u0438\u0438"); };
var bo_z32 = function (match, outcome) { return "\u0422\u043E\u0442\u0430\u043B: ".concat(match.homeTeam, " \u0432 \u0448\u0435\u0441\u0442\u043E\u0439 \u043F\u0430\u0440\u0442\u0438\u0438"); };
var bo_a33 = function (match, outcome) { return "\u0422\u043E\u0442\u0430\u043B: ".concat(match.homeTeam, " \u0432 \u0441\u0435\u0434\u044C\u043C\u043E\u0439 \u043F\u0430\u0440\u0442\u0438\u0438"); };
var bo_b33 = function (match, outcome) { return "\u0422\u043E\u0442\u0430\u043B: ".concat(match.awayTeam, " \u0432 \u043F\u0435\u0440\u0432\u043E\u0439 \u043F\u0430\u0440\u0442\u0438\u0438"); };
var bo_c33 = function (match, outcome) { return "\u0422\u043E\u0442\u0430\u043B: ".concat(match.awayTeam, " \u0432\u043E \u0432\u0442\u043E\u0440\u043E\u0439 \u043F\u0430\u0440\u0442\u0438\u0438"); };
var bo_d33 = function (match, outcome) { return "\u0422\u043E\u0442\u0430\u043B: ".concat(match.awayTeam, " \u0432 \u0442\u0440\u0435\u0442\u044C\u0435\u0439 \u043F\u0430\u0440\u0442\u0438\u0438"); };
var bo_e33 = function (match, outcome) { return "\u0422\u043E\u0442\u0430\u043B: ".concat(match.awayTeam, " \u0432 \u0447\u0435\u0442\u0432\u0435\u0440\u0442\u043E\u0439 \u043F\u0430\u0440\u0442\u0438\u0438"); };
var bo_f33 = function (match, outcome) { return "\u0422\u043E\u0442\u0430\u043B: ".concat(match.awayTeam, " \u0432 \u043F\u044F\u0442\u043E\u0439 \u043F\u0430\u0440\u0442\u0438\u0438"); };
var bo_g33 = function (match, outcome) { return "\u0422\u043E\u0442\u0430\u043B: ".concat(match.awayTeam, " \u0432 \u0448\u0435\u0441\u0442\u043E\u0439 \u043F\u0430\u0440\u0442\u0438\u0438"); };
var bo_h33 = function (match, outcome) { return "\u0422\u043E\u0442\u0430\u043B: ".concat(match.awayTeam, " \u0432 \u0441\u0435\u0434\u044C\u043C\u043E\u0439 \u043F\u0430\u0440\u0442\u0438\u0438"); };
var bo_i33 = function (match, outcome) { return "\u041A\u0442\u043E \u043F\u0435\u0440\u0432\u044B\u043C \u043D\u0430\u0431\u0435\u0440\u0435\u0442 ".concat(outcome.condition, " ").concat(plural(outcome.condition, ['очко', 'очка', 'очков']), " \u0432 1\u043E\u0439 \u043F\u0430\u0440\u0442\u0438\u0438"); };
var bo_j33 = function (match, outcome) { return "\u041A\u0442\u043E \u043F\u0435\u0440\u0432\u044B\u043C \u043D\u0430\u0431\u0435\u0440\u0435\u0442 ".concat(outcome.condition, " ").concat(plural(outcome.condition, ['очко', 'очка', 'очков']), " \u0432\u043E 2\u043E\u0439 \u043F\u0430\u0440\u0442\u0438\u0438"); };
var bo_k33 = function (match, outcome) { return "\u041A\u0442\u043E \u043F\u0435\u0440\u0432\u044B\u043C \u043D\u0430\u0431\u0435\u0440\u0435\u0442 ".concat(outcome.condition, " ").concat(plural(outcome.condition, ['очко', 'очка', 'очков']), " \u0432 3\u0435\u0439 \u043F\u0430\u0440\u0442\u0438\u0438"); };
var bo_l33 = function (match, outcome) { return "\u041A\u0442\u043E \u043F\u0435\u0440\u0432\u044B\u043C \u043D\u0430\u0431\u0435\u0440\u0435\u0442 ".concat(outcome.condition, " ").concat(plural(outcome.condition, ['очко', 'очка', 'очков']), " \u0432 4\u043E\u0439 \u043F\u0430\u0440\u0442\u0438\u0438"); };
var bo_m33 = function (match, outcome) { return "\u041A\u0442\u043E \u043F\u0435\u0440\u0432\u044B\u043C \u043D\u0430\u0431\u0435\u0440\u0435\u0442 ".concat(outcome.condition, " ").concat(plural(outcome.condition, ['очко', 'очка', 'очков']), " \u0432\u043E 5\u043E\u0439 \u043F\u0430\u0440\u0442\u0438\u0438"); };
var bo_n33 = function (match, outcome) { return "\u041A\u0442\u043E \u043F\u0435\u0440\u0432\u044B\u043C \u043D\u0430\u0431\u0435\u0440\u0435\u0442 ".concat(outcome.condition, " ").concat(plural(outcome.condition, ['очко', 'очка', 'очков']), " \u0432 6\u043E\u0439 \u043F\u0430\u0440\u0442\u0438\u0438"); };
var bo_o33 = function (match, outcome) { return "\u041A\u0442\u043E \u043F\u0435\u0440\u0432\u044B\u043C \u043D\u0430\u0431\u0435\u0440\u0435\u0442 ".concat(outcome.condition, " ").concat(plural(outcome.condition, ['очко', 'очка', 'очков']), " \u0432 7\u043E\u0439 \u043F\u0430\u0440\u0442\u0438\u0438"); };
var bo_p33 = function (match, outcome) { return "".concat(match.homeTeam, " \u043F\u043E\u0431\u0435\u0434\u0438\u0442 \u0440\u043E\u0432\u043D\u043E \u0432 ").concat(outcome.condition, " ").concat(plural(outcome.condition, ['очко', 'очка', 'очков']), " \u0432 \u043F\u0435\u0440\u0432\u043E\u0439 \u043F\u0430\u0440\u0442\u0438\u0438"); };
var bo_q33 = function (match, outcome) { return "".concat(match.homeTeam, " \u043F\u043E\u0431\u0435\u0434\u0438\u0442 \u0440\u043E\u0432\u043D\u043E \u0432 ").concat(outcome.condition, " ").concat(plural(outcome.condition, ['очко', 'очка', 'очков']), " \u0432\u043E \u0432\u0442\u043E\u0440\u043E\u0439 \u043F\u0430\u0440\u0442\u0438\u0438"); };
var bo_r33 = function (match, outcome) { return "".concat(match.homeTeam, " \u043F\u043E\u0431\u0435\u0434\u0438\u0442 \u0440\u043E\u0432\u043D\u043E \u0432 ").concat(outcome.condition, " ").concat(plural(outcome.condition, ['очко', 'очка', 'очков']), " \u0432 \u0442\u0440\u0435\u0442\u044C\u0435\u0439 \u043F\u0430\u0440\u0442\u0438\u0438"); };
var bo_s33 = function (match, outcome) { return "".concat(match.homeTeam, " \u043F\u043E\u0431\u0435\u0434\u0438\u0442 \u0440\u043E\u0432\u043D\u043E \u0432 ").concat(outcome.condition, " ").concat(plural(outcome.condition, ['очко', 'очка', 'очков']), " \u0432 \u0447\u0435\u0442\u0432\u0435\u0440\u0442\u043E\u0439 \u043F\u0430\u0440\u0442\u0438\u0438"); };
var bo_t33 = function (match, outcome) { return "".concat(match.homeTeam, " \u043F\u043E\u0431\u0435\u0434\u0438\u0442 \u0440\u043E\u0432\u043D\u043E \u0432 ").concat(outcome.condition, " ").concat(plural(outcome.condition, ['очко', 'очка', 'очков']), " \u0432 \u043F\u044F\u0442\u043E\u0439 \u043F\u0430\u0440\u0442\u0438\u0438"); };
var bo_u33 = function (match, outcome) { return "".concat(match.homeTeam, " \u043F\u043E\u0431\u0435\u0434\u0438\u0442 \u0440\u043E\u0432\u043D\u043E \u0432 ").concat(outcome.condition, " ").concat(plural(outcome.condition, ['очко', 'очка', 'очков']), " \u0432 \u0448\u0435\u0441\u0442\u043E\u0439 \u043F\u0430\u0440\u0442\u0438\u0438"); };
var bo_v33 = function (match, outcome) { return "".concat(match.homeTeam, " \u043F\u043E\u0431\u0435\u0434\u0438\u0442 \u0440\u043E\u0432\u043D\u043E \u0432 ").concat(outcome.condition, " ").concat(plural(outcome.condition, ['очко', 'очка', 'очков']), " \u0432 \u0441\u0435\u0434\u044C\u043C\u043E\u0439 \u043F\u0430\u0440\u0442\u0438\u0438"); };
var bo_w33 = function (match, outcome) { return "".concat(match.awayTeam, " \u043F\u043E\u0431\u0435\u0434\u0438\u0442 \u0440\u043E\u0432\u043D\u043E \u0432 ").concat(outcome.condition, " ").concat(plural(outcome.condition, ['очко', 'очка', 'очков']), " \u0432 \u043F\u0435\u0440\u0432\u043E\u0439 \u043F\u0430\u0440\u0442\u0438\u0438"); };
var bo_x33 = function (match, outcome) { return "".concat(match.awayTeam, " \u043F\u043E\u0431\u0435\u0434\u0438\u0442 \u0440\u043E\u0432\u043D\u043E \u0432 ").concat(outcome.condition, " ").concat(plural(outcome.condition, ['очко', 'очка', 'очков']), " \u0432\u043E \u0432\u0442\u043E\u0440\u043E\u0439 \u043F\u0430\u0440\u0442\u0438\u0438"); };
var bo_y33 = function (match, outcome) { return "".concat(match.awayTeam, " \u043F\u043E\u0431\u0435\u0434\u0438\u0442 \u0440\u043E\u0432\u043D\u043E \u0432 ").concat(outcome.condition, " ").concat(plural(outcome.condition, ['очко', 'очка', 'очков']), " \u0432 \u0442\u0440\u0435\u0442\u044C\u0435\u0439 \u043F\u0430\u0440\u0442\u0438\u0438"); };
var bo_z33 = function (match, outcome) { return "".concat(match.awayTeam, " \u043F\u043E\u0431\u0435\u0434\u0438\u0442 \u0440\u043E\u0432\u043D\u043E \u0432 ").concat(outcome.condition, " ").concat(plural(outcome.condition, ['очко', 'очка', 'очков']), " \u0432 \u0447\u0435\u0442\u0432\u0435\u0440\u0442\u043E\u0439 \u043F\u0430\u0440\u0442\u0438\u0438"); };
var bo_a34 = function (match, outcome) { return "".concat(match.awayTeam, " \u043F\u043E\u0431\u0435\u0434\u0438\u0442 \u0440\u043E\u0432\u043D\u043E \u0432 ").concat(outcome.condition, " ").concat(plural(outcome.condition, ['очко', 'очка', 'очков']), " \u0432 \u043F\u044F\u0442\u043E\u0439 \u043F\u0430\u0440\u0442\u0438\u0438"); };
var bo_b34 = function (match, outcome) { return "".concat(match.awayTeam, " \u043F\u043E\u0431\u0435\u0434\u0438\u0442 \u0440\u043E\u0432\u043D\u043E \u0432 ").concat(outcome.condition, " ").concat(plural(outcome.condition, ['очко', 'очка', 'очков']), " \u0432 \u0448\u0435\u0441\u0442\u043E\u0439 \u043F\u0430\u0440\u0442\u0438\u0438"); };
var bo_c34 = function (match, outcome) { return "".concat(match.awayTeam, " \u043F\u043E\u0431\u0435\u0434\u0438\u0442 \u0440\u043E\u0432\u043D\u043E \u0432 ").concat(outcome.condition, " ").concat(plural(outcome.condition, ['очко', 'очка', 'очков']), " \u0432 \u0441\u0435\u0434\u044C\u043C\u043E\u0439 \u043F\u0430\u0440\u0442\u0438\u0438"); };
var bo_d34 = function (match, outcome) { return 'Точный тотал первой партии'; };
var bo_e34 = function (match, outcome) { return 'Точный тотал второй партии'; };
var bo_f34 = function (match, outcome) { return 'Точный тотал третьей партии'; };
var bo_g34 = function (match, outcome) { return 'Точный тотал четвертой партии'; };
var bo_h34 = function (match, outcome) { return 'Точный тотал пятой партии'; };
var bo_i34 = function (match, outcome) { return 'Точный тотал шестой партии'; };
var bo_j34 = function (match, outcome) { return 'Точный тотал седьмой партии'; };
var bo_k34 = function (match, outcome) { return "\u041A\u0442\u043E \u0432\u044B\u0438\u0433\u0440\u0430\u0435\u0442 ".concat(numeralNeuterEnding(outcome.condition), " \u043E\u0447\u043A\u043E \u0432 \u043F\u0435\u0440\u0432\u043E\u0439 \u043F\u0430\u0440\u0442\u0438\u0438"); };
var bo_l34 = function (match, outcome) { return "\u041A\u0442\u043E \u0432\u044B\u0438\u0433\u0440\u0430\u0435\u0442 ".concat(numeralNeuterEnding(outcome.condition), " \u043E\u0447\u043A\u043E \u0432\u043E \u0432\u0442\u043E\u0440\u043E\u0439 \u043F\u0430\u0440\u0442\u0438\u0438"); };
var bo_m34 = function (match, outcome) { return "\u041A\u0442\u043E \u0432\u044B\u0438\u0433\u0440\u0430\u0435\u0442 ".concat(numeralNeuterEnding(outcome.condition), " \u043E\u0447\u043A\u043E \u0432 \u0442\u0440\u0435\u0442\u044C\u0435\u0439 \u043F\u0430\u0440\u0442\u0438\u0438"); };
var bo_n34 = function (match, outcome) { return "\u041A\u0442\u043E \u0432\u044B\u0438\u0433\u0440\u0430\u0435\u0442 ".concat(numeralNeuterEnding(outcome.condition), " \u043E\u0447\u043A\u043E \u0432 \u0447\u0435\u0442\u0432\u0435\u0440\u0442\u043E\u0439 \u043F\u0430\u0440\u0442\u0438\u0438"); };
var bo_o34 = function (match, outcome) { return "\u041A\u0442\u043E \u0432\u044B\u0438\u0433\u0440\u0430\u0435\u0442 ".concat(numeralNeuterEnding(outcome.condition), " \u043E\u0447\u043A\u043E \u0432 \u043F\u044F\u0442\u043E\u0439 \u043F\u0430\u0440\u0442\u0438\u0438"); };
var bo_p34 = function (match, outcome) { return "\u041A\u0442\u043E \u0432\u044B\u0438\u0433\u0440\u0430\u0435\u0442 ".concat(numeralNeuterEnding(outcome.condition), " \u043E\u0447\u043A\u043E \u0432 \u0448\u0435\u0441\u0442\u043E\u0439 \u043F\u0430\u0440\u0442\u0438\u0438"); };
var bo_q34 = function (match, outcome) { return "\u041A\u0442\u043E \u0432\u044B\u0438\u0433\u0440\u0430\u0435\u0442 ".concat(numeralNeuterEnding(outcome.condition), " \u043E\u0447\u043A\u043E \u0432 \u0441\u0435\u0434\u044C\u043C\u043E\u0439 \u043F\u0430\u0440\u0442\u0438\u0438"); };
var bo_r34 = function (match, outcome) { return 'Чет/Нечет тотала первого периода'; };
var bo_s34 = function (match, outcome) { return 'Чет/Нечет тотала второго периода'; };
var bo_t34 = function (match, outcome) { return 'Чет/Нечет тотала третьего периода'; };
var bo_u34 = function (match, outcome) { return 'Чет/Нечет тотала четвертого периода'; };
var bo_v34 = function (match, outcome) { return 'Чет/Нечет тотала пятого периода'; };
var bo_w34 = function (match, outcome) { return 'Чет/Нечет тотала шестого периода'; };
var bo_x34 = function (match, outcome) { return 'Чет/Нечет тотала седьмого периода'; };
var bo_y34 = function (match, outcome) { return 'Точный счет матча'; };
var bo_z34 = function (match, outcome) { return "".concat(match.awayTeam, " \u0441\u0434\u0435\u043B\u0430\u0435\u0442 \u0431\u0440\u0435\u0439\u043A \u0432 1-\u043C \u0438\u043B\u0438 \u0432\u043E 2-\u043C \u0433\u0435\u0439\u043C\u0430\u0445"); };
var bo_a35 = function (match, outcome) { return 'Максимальное количество геймов взятых подряд теннисистом'; };
var bo_b35 = function (match, outcome) { return 'Будет ли обмен брейками (два подряд)?'; };
var bo_c35 = function (match, outcome) { return "\u0422\u043E\u0442\u0430\u043B: ".concat(match.homeTeam, " \u0432 \u0447\u0435\u0442\u0432\u0435\u0440\u0442\u043E\u043C \u0441\u0435\u0442\u0435"); };
var bo_d35 = function (match, outcome) { return "\u0422\u043E\u0442\u0430\u043B: ".concat(match.homeTeam, " \u0432 \u043F\u044F\u0442\u043E\u043C \u0441\u0435\u0442\u0435"); };
var bo_e35 = function (match, outcome) { return "\u0422\u043E\u0442\u0430\u043B: ".concat(match.awayTeam, " \u0432 \u0447\u0435\u0442\u0432\u0435\u0440\u0442\u043E\u043C \u0441\u0435\u0442\u0435"); };
var bo_f35 = function (match, outcome) { return "\u0422\u043E\u0442\u0430\u043B: ".concat(match.awayTeam, " \u0432 \u043F\u044F\u0442\u043E\u043C \u0441\u0435\u0442\u0435"); };
var bo_g35 = function (match, outcome) { return 'Чет/Нечет четвертого сета'; };
var bo_h35 = function (match, outcome) { return 'Чет/Нечет пятого сета'; };
var bo_i35 = function (match, outcome) { return 'Первый сет/матч'; };
var bo_j35 = function (match, outcome) { return "\u0411\u0440\u0435\u0439\u043A \u043F\u043E\u0439\u043D\u0442 \u0432 ".concat(outcome.condition, " \u0433\u0435\u0439\u043C\u0435"); };
var bo_k35 = function (match, outcome) { return 'Тотал брейков во втором сете'; };
var bo_l35 = function (match, outcome) { return 'Тотал брейков в третьем сете'; };
var bo_m35 = function (match, outcome) { return 'Тотал брейков в четвертом сете'; };
var bo_n35 = function (match, outcome) { return 'Тотал брейков в пятом сете'; };
var bo_o35 = function (match, outcome) { return "\u041F\u043E\u0431\u0435\u0434\u0430 \u0438 \u0442\u043E\u0442\u0430\u043B \u0447\u0435\u0442\u0432\u0435\u0440\u0442\u043E\u0433\u043E \u0441\u0435\u0442\u0430 ".concat(outcome.condition); };
var bo_p35 = function (match, outcome) { return "\u041F\u043E\u0431\u0435\u0434\u0430 \u0438 \u0442\u043E\u0442\u0430\u043B \u043F\u044F\u0442\u043E\u0433\u043E \u0441\u0435\u0442\u0430 ".concat(outcome.condition); };
var bo_q35 = function (match, outcome) { return "\u0422\u043E\u0442\u0430\u043B \u0431\u0440\u0435\u0439\u043A\u043E\u0432: ".concat(match.homeTeam, " \u0432 \u043F\u0435\u0440\u0432\u043E\u043C \u0441\u0435\u0442\u0435"); };
var bo_r35 = function (match, outcome) { return "\u0422\u043E\u0442\u0430\u043B \u0431\u0440\u0435\u0439\u043A\u043E\u0432: ".concat(match.homeTeam, " \u0432\u043E \u0432\u0442\u043E\u0440\u043E\u043C \u0441\u0435\u0442\u0435"); };
var bo_s35 = function (match, outcome) { return "\u0422\u043E\u0442\u0430\u043B \u0431\u0440\u0435\u0439\u043A\u043E\u0432: ".concat(match.homeTeam, " \u0432 \u0442\u0440\u0435\u0442\u044C\u0435\u043C \u0441\u0435\u0442\u0435"); };
var bo_t35 = function (match, outcome) { return "\u0422\u043E\u0442\u0430\u043B \u0431\u0440\u0435\u0439\u043A\u043E\u0432: ".concat(match.homeTeam, " \u0432 \u0447\u0435\u0442\u0432\u0435\u0440\u0442\u043E\u043C \u0441\u0435\u0442\u0435"); };
var bo_u35 = function (match, outcome) { return "\u0422\u043E\u0442\u0430\u043B \u0431\u0440\u0435\u0439\u043A\u043E\u0432: ".concat(match.homeTeam, " \u0432 \u043F\u044F\u0442\u043E\u043C \u0441\u0435\u0442\u0435"); };
var bo_v35 = function (match, outcome) { return "\u0422\u043E\u0442\u0430\u043B \u0431\u0440\u0435\u0439\u043A\u043E\u0432: ".concat(match.awayTeam, " \u0432 \u043F\u0435\u0440\u0432\u043E\u043C \u0441\u0435\u0442\u0435"); };
var bo_w35 = function (match, outcome) { return "\u0422\u043E\u0442\u0430\u043B \u0431\u0440\u0435\u0439\u043A\u043E\u0432: ".concat(match.awayTeam, " \u0432\u043E \u0432\u0442\u043E\u0440\u043E\u043C \u0441\u0435\u0442\u0435"); };
var bo_x35 = function (match, outcome) { return "\u0422\u043E\u0442\u0430\u043B \u0431\u0440\u0435\u0439\u043A\u043E\u0432: ".concat(match.awayTeam, " \u0432 \u0442\u0440\u0435\u0442\u044C\u0435\u043C \u0441\u0435\u0442\u0435"); };
var bo_y35 = function (match, outcome) { return "\u0422\u043E\u0442\u0430\u043B \u0431\u0440\u0435\u0439\u043A\u043E\u0432: ".concat(match.awayTeam, " \u0432 \u0447\u0435\u0442\u0432\u0435\u0440\u0442\u043E\u043C \u0441\u0435\u0442\u0435"); };
var bo_z35 = function (match, outcome) { return "\u0422\u043E\u0442\u0430\u043B \u0431\u0440\u0435\u0439\u043A\u043E\u0432: ".concat(match.awayTeam, " \u0432 \u043F\u044F\u0442\u043E\u043C \u0441\u0435\u0442\u0435"); };
var bo_a36 = function (match, outcome) { return "\u0412\u044B\u0438\u0433\u0440\u0430\u0435\u0442 \u043B\u0438 \u043A\u0442\u043E-\u043D\u0438\u0431\u0443\u0434\u044C \u043F\u043E\u0434\u0440\u044F\u0434 ".concat(outcome.condition, " ").concat(plural(outcome.condition, ['гейм', 'гейма', 'геймов']), " \u0432 \u043F\u0435\u0440\u0432\u043E\u043C \u0441\u0435\u0442\u0435?"); };
var bo_b36 = function (match, outcome) { return "\u0412\u044B\u0438\u0433\u0440\u0430\u0435\u0442 \u043B\u0438 \u043A\u0442\u043E-\u043D\u0438\u0431\u0443\u0434\u044C \u043F\u043E\u0434\u0440\u044F\u0434 ".concat(outcome.condition, " ").concat(plural(outcome.condition, ['гейм', 'гейма', 'геймов']), " \u0432\u043E \u0432\u0442\u043E\u0440\u043E\u043C \u0441\u0435\u0442\u0435?"); };
var bo_c36 = function (match, outcome) { return "\u0412\u044B\u0438\u0433\u0440\u0430\u0435\u0442 \u043B\u0438 \u043A\u0442\u043E-\u043D\u0438\u0431\u0443\u0434\u044C \u043F\u043E\u0434\u0440\u044F\u0434 ".concat(outcome.condition, " ").concat(plural(outcome.condition, ['гейм', 'гейма', 'геймов']), " \u0432 \u0442\u0440\u0435\u0442\u044C\u0435\u043C \u0441\u0435\u0442\u0435?"); };
var bo_d36 = function (match, outcome) { return "\u0412\u044B\u0438\u0433\u0440\u0430\u0435\u0442 \u043B\u0438 \u043A\u0442\u043E-\u043D\u0438\u0431\u0443\u0434\u044C \u043F\u043E\u0434\u0440\u044F\u0434 ".concat(outcome.condition, " ").concat(plural(outcome.condition, ['гейм', 'гейма', 'геймов']), " \u0432 \u0447\u0435\u0442\u0432\u0435\u0440\u0442\u043E\u043C \u0441\u0435\u0442\u0435?"); };
var bo_e36 = function (match, outcome) { return "\u0412\u044B\u0438\u0433\u0440\u0430\u0435\u0442 \u043B\u0438 \u043A\u0442\u043E-\u043D\u0438\u0431\u0443\u0434\u044C \u043F\u043E\u0434\u0440\u044F\u0434 ".concat(outcome.condition, " ").concat(plural(outcome.condition, ['гейм', 'гейма', 'геймов']), " \u0432 \u043F\u044F\u0442\u043E\u043C \u0441\u0435\u0442\u0435?"); };
var bo_f36 = function (match, outcome) { return "\u0412\u044B\u0438\u0433\u0440\u0430\u0435\u0442 \u043B\u0438 ".concat(match.homeTeam, " \u043F\u043E\u0434\u0440\u044F\u0434 ").concat(outcome.condition, " ").concat(plural(outcome.condition, ['гейм', 'гейма', 'геймов']), " \u0432 \u043F\u0435\u0440\u0432\u043E\u043C \u0441\u0435\u0442\u0435?"); };
var bo_g36 = function (match, outcome) { return "\u0412\u044B\u0438\u0433\u0440\u0430\u0435\u0442 \u043B\u0438 ".concat(match.homeTeam, " \u043F\u043E\u0434\u0440\u044F\u0434 ").concat(outcome.condition, " ").concat(plural(outcome.condition, ['гейм', 'гейма', 'геймов']), " \u0432\u043E \u0432\u0442\u043E\u0440\u043E\u043C \u0441\u0435\u0442\u0435?"); };
var bo_h36 = function (match, outcome) { return "\u0412\u044B\u0438\u0433\u0440\u0430\u0435\u0442 \u043B\u0438 ".concat(match.homeTeam, " \u043F\u043E\u0434\u0440\u044F\u0434 ").concat(outcome.condition, " ").concat(plural(outcome.condition, ['гейм', 'гейма', 'геймов']), " \u0432 \u0442\u0440\u0435\u0442\u044C\u0435\u043C \u0441\u0435\u0442\u0435?"); };
var bo_i36 = function (match, outcome) { return "\u0412\u044B\u0438\u0433\u0440\u0430\u0435\u0442 \u043B\u0438 ".concat(match.homeTeam, " \u043F\u043E\u0434\u0440\u044F\u0434 ").concat(outcome.condition, " ").concat(plural(outcome.condition, ['гейм', 'гейма', 'геймов']), " \u0432 \u0447\u0435\u0442\u0432\u0435\u0440\u0442\u043E\u043C \u0441\u0435\u0442\u0435?"); };
var bo_j36 = function (match, outcome) { return "\u0412\u044B\u0438\u0433\u0440\u0430\u0435\u0442 \u043B\u0438 ".concat(match.homeTeam, " \u043F\u043E\u0434\u0440\u044F\u0434 ").concat(outcome.condition, " ").concat(plural(outcome.condition, ['гейм', 'гейма', 'геймов']), " \u0432 \u043F\u044F\u0442\u043E\u043C \u0441\u0435\u0442\u0435?"); };
var bo_k36 = function (match, outcome) { return "\u0412\u044B\u0438\u0433\u0440\u0430\u0435\u0442 \u043B\u0438 ".concat(match.awayTeam, " \u043F\u043E\u0434\u0440\u044F\u0434 ").concat(outcome.condition, " ").concat(plural(outcome.condition, ['гейм', 'гейма', 'геймов']), " \u0432 \u043F\u0435\u0440\u0432\u043E\u043C \u0441\u0435\u0442\u0435?"); };
var bo_l36 = function (match, outcome) { return "\u0412\u044B\u0438\u0433\u0440\u0430\u0435\u0442 \u043B\u0438 ".concat(match.awayTeam, " \u043F\u043E\u0434\u0440\u044F\u0434 ").concat(outcome.condition, " ").concat(plural(outcome.condition, ['гейм', 'гейма', 'геймов']), " \u0432\u043E \u0432\u0442\u043E\u0440\u043E\u043C \u0441\u0435\u0442\u0435?"); };
var bo_m36 = function (match, outcome) { return "\u0412\u044B\u0438\u0433\u0440\u0430\u0435\u0442 \u043B\u0438 ".concat(match.awayTeam, " \u043F\u043E\u0434\u0440\u044F\u0434 ").concat(outcome.condition, " ").concat(plural(outcome.condition, ['гейм', 'гейма', 'геймов']), " \u0432 \u0442\u0440\u0435\u0442\u044C\u0435\u043C \u0441\u0435\u0442\u0435?"); };
var bo_n36 = function (match, outcome) { return "\u0412\u044B\u0438\u0433\u0440\u0430\u0435\u0442 \u043B\u0438 ".concat(match.awayTeam, " \u043F\u043E\u0434\u0440\u044F\u0434 ").concat(outcome.condition, " ").concat(plural(outcome.condition, ['гейм', 'гейма', 'геймов']), " \u0432 \u0447\u0435\u0442\u0432\u0435\u0440\u0442\u043E\u043C \u0441\u0435\u0442\u0435?"); };
var bo_o36 = function (match, outcome) { return "\u0412\u044B\u0438\u0433\u0440\u0430\u0435\u0442 \u043B\u0438 ".concat(match.awayTeam, " \u043F\u043E\u0434\u0440\u044F\u0434 ").concat(outcome.condition, " ").concat(plural(outcome.condition, ['гейм', 'гейма', 'геймов']), " \u0432 \u043F\u044F\u0442\u043E\u043C \u0441\u0435\u0442\u0435?"); };
var bo_p36 = function (match, outcome) { return 'Фора в четвертом сете'; };
var bo_q36 = function (match, outcome) { return 'Фора в пятом сете'; };
var bo_r36 = function (match, outcome) { return 'Тотал четвертого сета'; };
var bo_s36 = function (match, outcome) { return 'Тотал пятого сета'; };
var bo_t36 = function (match, outcome) { return "\u0422\u043E\u0447\u043D\u044B\u0439 \u0441\u0447\u0435\u0442 ".concat(outcome.condition, " \u0433\u0435\u0439\u043C\u0430"); };
var bo_u36 = function (match, outcome) { return "\u041A\u0442\u043E \u0432\u043E\u0437\u044C\u043C\u0435\u0442 ".concat(outcome.condition, " \u0433\u0435\u0439\u043C?"); };
var bo_v36 = function (match, outcome) { return 'Точный счет первого сета'; };
var bo_w36 = function (match, outcome) { return 'Точный счет второго сета'; };
var bo_x36 = function (match, outcome) { return 'Точный счет третьего сета'; };
var bo_y36 = function (match, outcome) { return 'Точный счет четвертого сета'; };
var bo_z36 = function (match, outcome) { return 'Точный счет пятого сета'; };
var bo_a37 = function (match, outcome) { return "\u0411\u0443\u0434\u0435\u0442 \u043B\u0438 15x15 \u0432 ".concat(outcome.condition, " \u0433\u0435\u0439\u043C\u0435?"); };
var bo_b37 = function (match, outcome) { return "\u0411\u0443\u0434\u0435\u0442 \u043B\u0438 30x30 \u0432 ".concat(outcome.condition, " \u0433\u0435\u0439\u043C\u0435?"); };
var bo_c37 = function (match, outcome) { return "\u0411\u0443\u0434\u0435\u0442 \u043B\u0438 40x40 \u0432 ".concat(outcome.condition, " \u0433\u0435\u0439\u043C\u0435?"); };
var bo_d37 = function (match, outcome) { return "\u041A\u0442\u043E \u043F\u0435\u0440\u0432\u044B\u043C \u0432\u043E\u0437\u044C\u043C\u0435\u0442 ".concat(outcome.condition, " ").concat(plural(outcome.condition, ['гейм', 'гейма', 'геймов']), " \u0432 1\u043E\u043C \u0441\u0435\u0442\u0435"); };
var bo_e37 = function (match, outcome) { return "\u041A\u0442\u043E \u043F\u0435\u0440\u0432\u044B\u043C \u0432\u043E\u0437\u044C\u043C\u0435\u0442 ".concat(outcome.condition, " ").concat(plural(outcome.condition, ['гейм', 'гейма', 'геймов']), " \u0432 2\u043E\u043C \u0441\u0435\u0442\u0435"); };
var bo_f37 = function (match, outcome) { return "\u041A\u0442\u043E \u043F\u0435\u0440\u0432\u044B\u043C \u0432\u043E\u0437\u044C\u043C\u0435\u0442 ".concat(outcome.condition, " ").concat(plural(outcome.condition, ['гейм', 'гейма', 'геймов']), " \u0432 3\u0435\u043C \u0441\u0435\u0442\u0435"); };
var bo_g37 = function (match, outcome) { return "\u041A\u0442\u043E \u043F\u0435\u0440\u0432\u044B\u043C \u0432\u043E\u0437\u044C\u043C\u0435\u0442 ".concat(outcome.condition, " ").concat(plural(outcome.condition, ['гейм', 'гейма', 'геймов']), " \u0432 4\u043E\u043C \u0441\u0435\u0442\u0435"); };
var bo_h37 = function (match, outcome) { return "\u041A\u0442\u043E \u043F\u0435\u0440\u0432\u044B\u043C \u0432\u043E\u0437\u044C\u043C\u0435\u0442 ".concat(outcome.condition, " ").concat(plural(outcome.condition, ['гейм', 'гейма', 'геймов']), " \u0432 5\u043E\u043C \u0441\u0435\u0442\u0435"); };
var bo_i37 = function (match, outcome) { return 'Результат четвертого сета'; };
var bo_j37 = function (match, outcome) { return 'Результат пятого сета'; };
var bo_k37 = function (match, outcome) { return "\u041F\u0435\u0440\u0432\u043E\u0435 \u043E\u0447\u043A\u043E \u0432 ".concat(outcome.condition, " \u0433\u0435\u0439\u043C\u0435"); };
var bo_l37 = function (match, outcome) { return 'Будет ли тай-брейк в первом сете?'; };
var bo_m37 = function (match, outcome) { return 'Будет ли тай-брейк во втором сете?'; };
var bo_n37 = function (match, outcome) { return 'Будет ли тай-брейк в третьем сете?'; };
var bo_o37 = function (match, outcome) { return 'Будет ли тай-брейк в четвертом сете?'; };
var bo_p37 = function (match, outcome) { return 'Будет ли тай-брейк в пятом сете?'; };
var bo_q37 = function (match, outcome) { return 'Будет ли тай-брейк в матче?'; };
var bo_r37 = function (match, outcome) { return 'Тотал тай-брейка в первом сете'; };
var bo_s37 = function (match, outcome) { return 'Тотал тай-брейка во втором сете'; };
var bo_t37 = function (match, outcome) { return 'Тотал тай-брейка в третьем сете'; };
var bo_u37 = function (match, outcome) { return 'Тотал тай-брейка в четвертом сете'; };
var bo_v37 = function (match, outcome) { return 'Тотал тай-брейка в пятом сете'; };
var bo_w37 = function (match, outcome) { return 'Точный счет тай-брейка в первом сете'; };
var bo_x37 = function (match, outcome) { return 'Точный счет тай-брейка во втором сете'; };
var bo_y37 = function (match, outcome) { return 'Точный счет тай-брейка в третьем сете'; };
var bo_z37 = function (match, outcome) { return 'Точный счет тай-брейка в четвертом сете'; };
var bo_a38 = function (match, outcome) { return 'Точный счет тай-брейка в пятом сете'; };
var bo_b38 = function (match, outcome) { return 'Точный тотал тай-брейка в первом сете'; };
var bo_c38 = function (match, outcome) { return 'Точный тотал тай-брейка во втором сете'; };
var bo_d38 = function (match, outcome) { return 'Точный тотал тай-брейка в третьем сете'; };
var bo_e38 = function (match, outcome) { return 'Точный тотал тай-брейка в четвертом сете'; };
var bo_f38 = function (match, outcome) { return 'Точный тотал тай-брейка в пятом сете'; };
var bo_g38 = function (match, outcome) { return 'Кто победит в тай-брейке в первом сете?'; };
var bo_h38 = function (match, outcome) { return 'Кто победит в тай-брейке во втором сете?'; };
var bo_i38 = function (match, outcome) { return 'Кто победит в тай-брейке в третьем сете?'; };
var bo_j38 = function (match, outcome) { return 'Кто победит в тай-брейке в четвертом сете?'; };
var bo_k38 = function (match, outcome) { return 'Кто победит в тай-брейке в пятом сете?'; };
var bo_l38 = function (match, outcome) { return 'Тотал брейков в первом сете'; };
var bo_m38 = function (match, outcome) { return 'Тотал брейков в матче'; };
var bo_n38 = function (match, outcome) { return "".concat(match.homeTeam, " \u0432\u044B\u0438\u0433\u0440\u0430\u0435\u0442 \u0441\u0435\u0442 \u0432 \u043C\u0430\u0442\u0447\u0435"); };
var bo_o38 = function (match, outcome) { return "".concat(match.awayTeam, " \u0432\u044B\u0438\u0433\u0440\u0430\u0435\u0442 \u0441\u0435\u0442 \u0432 \u043C\u0430\u0442\u0447\u0435"); };
var bo_p38 = function (match, outcome) { return 'Тотал самого нерезультативного сета'; };
var bo_q38 = function (match, outcome) { return 'Кто подаст первый эйс в матче'; };
var bo_r38 = function (match, outcome) { return 'Кто сделает первую двойную ошибку в матче'; };
var bo_s38 = function (match, outcome) { return "".concat(match.homeTeam, ": \u043C\u0430\u043A\u0441\u0438\u043C\u0430\u043B\u044C\u043D\u0430\u044F \u0441\u043A\u043E\u0440\u043E\u0441\u0442\u044C \u043F\u043E\u0434\u0430\u0447\u0438 (\u043A\u043C/\u0447)"); };
var bo_t38 = function (match, outcome) { return "".concat(match.awayTeam, ": \u043C\u0430\u043A\u0441\u0438\u043C\u0430\u043B\u044C\u043D\u0430\u044F \u0441\u043A\u043E\u0440\u043E\u0441\u0442\u044C \u043F\u043E\u0434\u0430\u0447\u0438 (\u043A\u043C/\u0447)"); };
var bo_u38 = function (match, outcome) { return 'Победа в матче после проигрыша первого сета'; };
var bo_v38 = function (match, outcome) { return "".concat(match.homeTeam, ": % \u043F\u0435\u0440\u0432\u043E\u0439 \u043F\u043E\u0434\u0430\u0447\u0438"); };
var bo_w38 = function (match, outcome) { return "".concat(match.awayTeam, ": % \u043F\u0435\u0440\u0432\u043E\u0439 \u043F\u043E\u0434\u0430\u0447\u0438"); };
var bo_x38 = function (match, outcome) { return 'Результат по брейкам в матче'; };
var bo_y38 = function (match, outcome) { return "\u0422\u043E\u0442\u0430\u043B \u0431\u0440\u0435\u0439\u043A\u043E\u0432: ".concat(match.homeTeam); };
var bo_z38 = function (match, outcome) { return "\u0422\u043E\u0442\u0430\u043B \u0431\u0440\u0435\u0439\u043A\u043E\u0432: ".concat(match.awayTeam); };
var bo_a39 = function (match, outcome) { return 'Кто сделает первый брейк в матче'; };
var bo_b39 = function (match, outcome) { return "".concat(match.homeTeam, " \u0441\u0434\u0435\u043B\u0430\u0435\u0442 \u0431\u0440\u0435\u0439\u043A \u0432 1-\u043C \u0438\u043B\u0438 \u0432\u043E 2-\u043C \u0433\u0435\u0439\u043C\u0430\u0445"); };
var bo_c39 = function (match, outcome) { return 'Будет ли в матче сет со счетом 6:0 или 0:6?'; };
var bo_d39 = function (match, outcome) { return 'Тотал эйсов в матче'; };
var bo_e39 = function (match, outcome) { return "\u0422\u043E\u0442\u0430\u043B \u044D\u0439\u0441\u043E\u0432 \u0432 \u043C\u0430\u0442\u0447\u0435: ".concat(match.homeTeam); };
var bo_f39 = function (match, outcome) { return "\u0422\u043E\u0442\u0430\u043B \u044D\u0439\u0441\u043E\u0432 \u0432 \u043C\u0430\u0442\u0447\u0435: ".concat(match.awayTeam); };
var bo_g39 = function (match, outcome) { return 'Тотал двойных ошибок в матче'; };
var bo_h39 = function (match, outcome) { return "\u0422\u043E\u0442\u0430\u043B \u0434\u0432\u043E\u0439\u043D\u044B\u0445 \u043E\u0448\u0438\u0431\u043E\u043A \u0432 \u043C\u0430\u0442\u0447\u0435: ".concat(match.homeTeam); };
var bo_i39 = function (match, outcome) { return "\u0422\u043E\u0442\u0430\u043B \u0434\u0432\u043E\u0439\u043D\u044B\u0445 \u043E\u0448\u0438\u0431\u043E\u043A \u0432 \u043C\u0430\u0442\u0447\u0435: ".concat(match.awayTeam); };
var bo_j39 = function (match, outcome) { return 'Результативность сетов(Тотал)'; };
var bo_k39 = function (match, outcome) { return 'Матч будет выигран подачей навылет'; };
var bo_l39 = function (match, outcome) { return "\u042D\u0439\u0441 \u0432 1-\u043C \u0438\u043B\u0438 2-\u043C \u0433\u0435\u0439\u043C\u0430\u0445: ".concat(match.homeTeam); };
var bo_m39 = function (match, outcome) { return "\u042D\u0439\u0441 \u0432 1-\u043C \u0438\u043B\u0438 2-\u043C \u0433\u0435\u0439\u043C\u0430\u0445: ".concat(match.awayTeam); };
var bo_n39 = function (match, outcome) { return "\u0414\u0432\u043E\u0439\u043D\u0430\u044F \u043E\u0448\u0438\u0431\u043A\u0430 \u0432 1-\u043C \u0438\u043B\u0438 2-\u043C \u0433\u0435\u0439\u043C\u0430\u0445: ".concat(match.homeTeam); };
var bo_o39 = function (match, outcome) { return "\u0414\u0432\u043E\u0439\u043D\u0430\u044F \u043E\u0448\u0438\u0431\u043A\u0430 \u0432 1-\u043C \u0438\u043B\u0438 2-\u043C \u0433\u0435\u0439\u043C\u0430\u0445: ".concat(match.awayTeam); };
var bo_p39 = function (match, outcome) { return 'Тотал эйсов в первом сете'; };
var bo_q39 = function (match, outcome) { return 'Спортсмен снимется (дискв.) в течение матча'; };
var bo_r39 = function (match, outcome) { return "% \u043F\u043E\u043F\u0430\u0434\u0430\u043D\u0438\u044F \u043F\u0435\u0440\u0432\u043E\u0439 \u043F\u043E\u0434\u0430\u0447\u0438 ".concat(match.homeTeam); };
var bo_s39 = function (match, outcome) { return "% \u043F\u043E\u043F\u0430\u0434\u0430\u043D\u0438\u044F \u043F\u0435\u0440\u0432\u043E\u0439 \u043F\u043E\u0434\u0430\u0447\u0438 ".concat(match.awayTeam); };
var bo_t39 = function (match, outcome) { return 'Результат по брейкам в первом сете'; };
var bo_u39 = function (match, outcome) { return 'Результат по брейкам во втором сете'; };
var bo_v39 = function (match, outcome) { return 'Результат по брейкам в третьем сете'; };
var bo_w39 = function (match, outcome) { return 'Результат по брейкам в четвертом сете'; };
var bo_x39 = function (match, outcome) { return 'Результат по брейкам в пятом сете'; };
var bo_y39 = function (match, outcome) { return 'Фора по брейкам в матче'; };
var bo_z39 = function (match, outcome) { return 'Фора по брейкам в первом сете'; };
var bo_a40 = function (match, outcome) { return 'Фора по брейкам во втором сете'; };
var bo_b40 = function (match, outcome) { return 'Фора по брейкам в третьем сете'; };
var bo_c40 = function (match, outcome) { return 'Фора по брейкам в четвертом сете'; };
var bo_d40 = function (match, outcome) { return 'Фора по брейкам в пятом сете'; };
var bo_e40 = function (match, outcome) { return "\u041A\u0442\u043E \u0432\u043E\u0437\u044C\u043C\u0435\u0442 ".concat(outcome.conditionTwo, " \u043E\u0447\u043A\u043E \u0432 ").concat(outcome.condition, " \u0433\u0435\u0439\u043C\u0435"); };
var bo_f40 = function (match, outcome) { return "\u0420\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442 \u0432 ".concat(outcome.condition, " \u0438 ").concat(outcome.conditionTwo, " \u0433\u0435\u0439\u043C\u0430\u0445"); };
var bo_g40 = function (match, outcome) { return "\u0424\u043E\u0440\u0430 \u0432 ".concat(outcome.conditionTwo, " \u0433\u0435\u0439\u043C\u0435"); };
var bo_h40 = function (match, outcome) { return "\u0422\u043E\u0442\u0430\u043B \u0432 ".concat(outcome.conditionTwo, " \u0433\u0435\u0439\u043C\u0435"); };
var bo_i40 = function (match, outcome) { return "\u041A\u0442\u043E \u043F\u0435\u0440\u0432\u044B\u043C \u043D\u0430\u0431\u0435\u0440\u0435\u0442 ".concat(outcome.condition, " ").concat(plural(outcome.condition, ['очко', 'очков', 'очков']), " \u0432 4\u043E\u043C \u0441\u0435\u0442\u0435"); };
var bo_j40 = function (match, outcome) { return "\u041A\u0442\u043E \u043F\u0435\u0440\u0432\u044B\u043C \u043D\u0430\u0431\u0435\u0440\u0435\u0442 ".concat(outcome.condition, " ").concat(plural(outcome.condition, ['очко', 'очков', 'очков']), " \u0432\u043E 5\u043E\u043C \u0441\u0435\u0442\u0435"); };
var bo_k40 = function (match, outcome) { return 'Точный тотал четвертого сета'; };
var bo_l40 = function (match, outcome) { return 'Точный тотал пятого сета'; };
var bo_m40 = function (match, outcome) { return "".concat(match.homeTeam, " \u043F\u043E\u0431\u0435\u0434\u0438\u0442 \u0441 \u0440\u0430\u0437\u043D\u0438\u0446\u0435\u0439 \u0432 \u0447\u0435\u0442\u0432\u0435\u0440\u0442\u043E\u043C \u0441\u0435\u0442\u0435"); };
var bo_n40 = function (match, outcome) { return "".concat(match.homeTeam, " \u043F\u043E\u0431\u0435\u0434\u0438\u0442 \u0441 \u0440\u0430\u0437\u043D\u0438\u0446\u0435\u0439 \u0432 \u043F\u044F\u0442\u043E\u043C \u0441\u0435\u0442\u0435"); };
var bo_o40 = function (match, outcome) { return "".concat(match.awayTeam, " \u043F\u043E\u0431\u0435\u0434\u0438\u0442 \u0441 \u0440\u0430\u0437\u043D\u0438\u0446\u0435\u0439 \u0432 \u0447\u0435\u0442\u0432\u0435\u0440\u0442\u043E\u043C \u0441\u0435\u0442\u0435"); };
var bo_p40 = function (match, outcome) { return "".concat(match.awayTeam, " \u043F\u043E\u0431\u0435\u0434\u0438\u0442 \u0441 \u0440\u0430\u0437\u043D\u0438\u0446\u0435\u0439 \u0432 \u043F\u044F\u0442\u043E\u043C \u0441\u0435\u0442\u0435"); };
var bo_q40 = function (match, outcome) { return 'Тотал самого результативного сета'; };
var bo_r40 = function (match, outcome) { return 'Победа с разницей в четвертом сете'; };
var bo_s40 = function (match, outcome) { return 'Победа с разницей в пятом сете'; };
var bo_t40 = function (match, outcome) { return 'Победа в минисете до 10 очков четвертого сета'; };
var bo_u40 = function (match, outcome) { return 'Фора в минисете до 10 очков четвертого сета'; };
var bo_v40 = function (match, outcome) { return 'Тотал в минисете до 10 очков четвертого сета'; };
var bo_w40 = function (match, outcome) { return 'Победа в минисете до 15 очков четвертого сета'; };
var bo_x40 = function (match, outcome) { return 'Фора в минисете до 15 очков четвертого сета'; };
var bo_y40 = function (match, outcome) { return 'Тотал в минисете до 15 очков четвертого сета'; };
var bo_z40 = function (match, outcome) { return "\u041A\u0442\u043E \u0432\u044B\u0438\u0433\u0440\u0430\u0435\u0442 ".concat(numeralNeuterEnding(outcome.condition), " \u043E\u0447\u043A\u043E \u0432 \u0447\u0435\u0442\u0432\u0435\u0440\u0442\u043E\u043C \u0441\u0435\u0442\u0435"); };
var bo_a41 = function (match, outcome) { return "\u041A\u0442\u043E \u0432\u044B\u0438\u0433\u0440\u0430\u0435\u0442 ".concat(numeralNeuterEnding(outcome.condition), " \u043E\u0447\u043A\u043E \u0432 \u043F\u044F\u0442\u043E\u043C \u0441\u0435\u0442\u0435"); };
var bo_b41 = function (match, outcome) { return 'Фора в Золотом сете'; };
var bo_c41 = function (match, outcome) { return 'Тотал Золотого сета'; };
var bo_d41 = function (match, outcome) { return "\u0422\u043E\u0442\u0430\u043B: ".concat(match.homeTeam, " \u0432 \u0417\u043E\u043B\u043E\u0442\u043E\u043C \u0441\u0435\u0442\u0435"); };
var bo_e41 = function (match, outcome) { return "\u0422\u043E\u0442\u0430\u043B: ".concat(match.awayTeam, " \u0432 \u0417\u043E\u043B\u043E\u0442\u043E\u043C \u0441\u0435\u0442\u0435"); };
var bo_f41 = function (match, outcome) { return 'Результат Золотого сета'; };
var bo_g41 = function (match, outcome) { return "\u041A\u0442\u043E \u043F\u0435\u0440\u0432\u044B\u043C \u043D\u0430\u0431\u0435\u0440\u0435\u0442 ".concat(outcome.condition, " ").concat(plural(outcome.condition, ['очко', 'очков', 'очков']), " \u0432 \u0417\u043E\u043B\u043E\u0442\u043E\u043C \u0441\u0435\u0442\u0435"); };
var bo_h41 = function (match, outcome) { return 'Точный тотал Золотого сета'; };
var bo_i41 = function (match, outcome) { return 'Чет/Нечет Золотого сета'; };
var bo_j41 = function (match, outcome) { return "\u041F\u043E\u0431\u0435\u0434\u0430 \u0438 \u0442\u043E\u0442\u0430\u043B \u0417\u043E\u043B\u043E\u0442\u043E\u0433\u043E \u0441\u0435\u0442\u0430 ".concat(outcome.condition); };
var bo_k41 = function (match, outcome) { return 'Победа с разницей в Золотом сете'; };
var bo_l41 = function (match, outcome) { return 'В скольких сетах будет мини тай-брейк?'; };
var bo_m41 = function (match, outcome) { return "\u041A\u0442\u043E \u0432\u044B\u0438\u0433\u0440\u0430\u0435\u0442 ".concat(outcome.condition, "\u0439 \u0440\u0430\u0443\u043D\u0434?"); };
var bo_n41 = function (match, outcome) { return 'Выпадет ли 13 сектор?'; };
var bo_o41 = function (match, outcome) { return "\u0412\u044B\u043F\u0430\u0434\u0435\u0442 \u043B\u0438 13 \u0441\u0435\u043A\u0442\u043E\u0440 \u0432 ".concat(outcome.condition, "-\u043C \u0440\u0430\u0443\u043D\u0434\u0435?"); };
var fa_b1 = function (match, outcome) { return "\u04241(".concat(signed(outcome.condition), ")"); };
var fa_c1 = function (match, outcome) { return "\u04242(".concat(signed(-outcome.condition), ")"); };
var fa_d1 = function (match, outcome) { return "\u041C\u0435\u043D. ".concat(outcome.condition); };
var fa_e1 = function (match, outcome) { return "\u0411\u043E\u043B. ".concat(outcome.condition); };
var fa_f1 = function (match, outcome) { return 'Чет'; };
var fa_g1 = function (match, outcome) { return 'Нечет'; };
var fa_h1 = function (match, outcome) { return "".concat(match.homeTeam); };
var fa_i1 = function (match, outcome) { return "".concat(match.awayTeam); };
var fa_j1 = function (match, outcome) { return '1-ая выше'; };
var fa_k1 = function (match, outcome) { return '2-ая выше'; };
var fa_l1 = function (match, outcome) { return 'Да'; };
var fa_m1 = function (match, outcome) { return 'Нет'; };
var fa_n1 = function (match, outcome) { return '0-2'; };
var fa_o1 = function (match, outcome) { return '0-3'; };
var fa_p1 = function (match, outcome) { return '1-2'; };
var fa_q1 = function (match, outcome) { return '1-3'; };
var fa_r1 = function (match, outcome) { return '2-0'; };
var fa_s1 = function (match, outcome) { return '2-1'; };
var fa_t1 = function (match, outcome) { return '2-3'; };
var fa_u1 = function (match, outcome) { return '3-0'; };
var fa_v1 = function (match, outcome) { return '3-1'; };
var fa_w1 = function (match, outcome) { return '3-2'; };
var fa_x1 = function (match, outcome) { return 'П1'; };
var fa_y1 = function (match, outcome) { return 'П2'; };
var fa_z1 = function (match, outcome) { return 'Х'; };
var fa_a2 = function (match, outcome) { return 'Никто'; };
var fa_b2 = function (match, outcome) { return '1X'; };
var fa_c2 = function (match, outcome) { return '12'; };
var fa_d2 = function (match, outcome) { return '2X'; };
var fa_e2 = function (match, outcome) { return "\u041F1\u0422\u043C ".concat(outcome.condition); };
var fa_f2 = function (match, outcome) { return "\u041F1\u0422\u0431 ".concat(outcome.condition); };
var fa_g2 = function (match, outcome) { return "\u041F2\u0422\u043C ".concat(outcome.condition); };
var fa_h2 = function (match, outcome) { return "\u041F2\u0422\u0431 ".concat(outcome.condition); };
var fa_i2 = function (match, outcome) { return "\u0425\u0422\u043C ".concat(outcome.condition); };
var fa_j2 = function (match, outcome) { return "\u0425\u0422\u0431 ".concat(outcome.condition); };
var fa_k2 = function (match, outcome) { return '0'; };
var fa_l2 = function (match, outcome) { return '1'; };
var fa_m2 = function (match, outcome) { return '2'; };
var fa_n2 = function (match, outcome) { return '3'; };
var fa_o2 = function (match, outcome) { return '4'; };
var fa_p2 = function (match, outcome) { return '≥ 5'; };
var fa_q2 = function (match, outcome) { return 'Обе забьют'; };
var fa_r2 = function (match, outcome) { return 'Одна забьёт'; };
var fa_s2 = function (match, outcome) { return 'Обе не забьют'; };
var fa_t2 = function (match, outcome) { return '0-0'; };
var fa_u2 = function (match, outcome) { return '0-1'; };
var fa_v2 = function (match, outcome) { return '0-4'; };
var fa_w2 = function (match, outcome) { return '0-5'; };
var fa_x2 = function (match, outcome) { return '1-0'; };
var fa_y2 = function (match, outcome) { return '1-1'; };
var fa_z2 = function (match, outcome) { return '1-4'; };
var fa_a3 = function (match, outcome) { return '1-5'; };
var fa_b3 = function (match, outcome) { return '2-2'; };
var fa_c3 = function (match, outcome) { return '2-4'; };
var fa_d3 = function (match, outcome) { return '2-5'; };
var fa_e3 = function (match, outcome) { return '2-6'; };
var fa_f3 = function (match, outcome) { return '3-3'; };
var fa_g3 = function (match, outcome) { return '3-4'; };
var fa_h3 = function (match, outcome) { return '3-5'; };
var fa_i3 = function (match, outcome) { return '4-0'; };
var fa_j3 = function (match, outcome) { return '4-1'; };
var fa_k3 = function (match, outcome) { return '4-2'; };
var fa_l3 = function (match, outcome) { return '4-3'; };
var fa_m3 = function (match, outcome) { return '4-4'; };
var fa_n3 = function (match, outcome) { return '5-0'; };
var fa_o3 = function (match, outcome) { return '5-1'; };
var fa_p3 = function (match, outcome) { return '5-2'; };
var fa_q3 = function (match, outcome) { return '5-3'; };
var fa_r3 = function (match, outcome) { return 'Любой другой'; };
var fa_s3 = function (match, outcome) { return "\u2264 ".concat(outcome.condition); };
var fa_t3 = function (match, outcome) { return "".concat(outcome.condition + 1, " - ").concat(outcome.condition + 2); };
var fa_u3 = function (match, outcome) { return "".concat(outcome.condition + 3, " - ").concat(outcome.condition + 4); };
var fa_v3 = function (match, outcome) { return "".concat(outcome.condition + 5, " - ").concat(outcome.condition + 6); };
var fa_w3 = function (match, outcome) { return "".concat(outcome.condition + 7, " - ").concat(outcome.condition + 8); };
var fa_x3 = function (match, outcome) { return "\u2265 ".concat(outcome.condition + 9); };
var fa_y3 = function (match, outcome) { return '6-9'; };
var fa_z3 = function (match, outcome) { return '10-12'; };
var fa_a4 = function (match, outcome) { return '13-16'; };
var fa_b4 = function (match, outcome) { return '17-20'; };
var fa_c4 = function (match, outcome) { return '≥21'; };
var fa_d4 = function (match, outcome) { return "\u041F\u0440\u043E\u0445\u043E\u0434: ".concat(match.homeTeam); };
var fa_e4 = function (match, outcome) { return "\u041F\u0440\u043E\u0445\u043E\u0434: ".concat(match.awayTeam); };
var fa_f4 = function (match, outcome) { return '1-ая половина'; };
var fa_g4 = function (match, outcome) { return '2-ая половина'; };
var fa_h4 = function (match, outcome) { return '1-ая четверть'; };
var fa_i4 = function (match, outcome) { return '2-ая четверть'; };
var fa_j4 = function (match, outcome) { return '3-ая четверть'; };
var fa_k4 = function (match, outcome) { return '4-ая четверть'; };
var fa_l4 = function (match, outcome) { return 'П1: 1-2'; };
var fa_m4 = function (match, outcome) { return 'П1: 3-5'; };
var fa_n4 = function (match, outcome) { return 'П1: 6-9'; };
var fa_o4 = function (match, outcome) { return 'П1: 10-12'; };
var fa_p4 = function (match, outcome) { return 'П1: 13-16'; };
var fa_q4 = function (match, outcome) { return 'П1: 17-20'; };
var fa_r4 = function (match, outcome) { return 'П1: ≥21'; };
var fa_s4 = function (match, outcome) { return 'П2: 1-2'; };
var fa_t4 = function (match, outcome) { return 'П2: 3-5'; };
var fa_u4 = function (match, outcome) { return 'П2: 6-9'; };
var fa_v4 = function (match, outcome) { return 'П2: 10-12'; };
var fa_w4 = function (match, outcome) { return 'П2: 13-16'; };
var fa_x4 = function (match, outcome) { return 'П2: 17-20'; };
var fa_y4 = function (match, outcome) { return 'П2: ≥21'; };
var fa_z4 = function (match, outcome) { return 'П1: 3-4'; };
var fa_a5 = function (match, outcome) { return 'П1: 5-7'; };
var fa_b5 = function (match, outcome) { return 'П1: ≥8'; };
var fa_c5 = function (match, outcome) { return 'Х2'; };
var fa_d5 = function (match, outcome) { return 'П2: 3-4'; };
var fa_e5 = function (match, outcome) { return 'П2: 5-7'; };
var fa_f5 = function (match, outcome) { return 'П2: ≥8'; };
var fa_g5 = function (match, outcome) { return 'Х1'; };
var fa_h5 = function (match, outcome) { return 'Штрафной'; };
var fa_i5 = function (match, outcome) { return '3-очковый'; };
var fa_j5 = function (match, outcome) { return '2-очковый'; };
var fa_k5 = function (match, outcome) { return "\u041F1 \u2265 ".concat(outcome.condition); };
var fa_l5 = function (match, outcome) { return "\u0420\u0430\u0437\u043D\u0438\u0446\u0430 \u043C\u0435\u043D\u044C\u0448\u0435 ".concat(outcome.condition); };
var fa_m5 = function (match, outcome) { return "\u041F2 \u2265 ".concat(outcome.condition); };
var fa_n5 = function (match, outcome) { return "\u041F1: \u0411\u043E\u043B. ".concat(outcome.condition, "=21"); };
var fa_o5 = function (match, outcome) { return "\u041F2: \u0411\u043E\u043B. ".concat(outcome.condition, "=21"); };
var fa_p5 = function (match, outcome) { return 'П1: 8 и более'; };
var fa_q5 = function (match, outcome) { return 'П2: 8 и более'; };
var fa_r5 = function (match, outcome) { return 'Никакая'; };
var fa_s5 = function (match, outcome) { return 'П1: 1'; };
var fa_t5 = function (match, outcome) { return 'П1: 2'; };
var fa_u5 = function (match, outcome) { return 'П1: 3'; };
var fa_v5 = function (match, outcome) { return 'П1: 4'; };
var fa_w5 = function (match, outcome) { return 'П1: ≥ 5'; };
var fa_x5 = function (match, outcome) { return 'П2: 1'; };
var fa_y5 = function (match, outcome) { return 'П2: 2'; };
var fa_z5 = function (match, outcome) { return 'П2: 3'; };
var fa_a6 = function (match, outcome) { return 'П2: 4'; };
var fa_b6 = function (match, outcome) { return 'П2: ≥ 5'; };
var fa_c6 = function (match, outcome) { return '1Х'; };
var fa_d6 = function (match, outcome) { return 'Обе'; };
var fa_e6 = function (match, outcome) { return 'Одна'; };
var fa_f6 = function (match, outcome) { return 'Ни одна'; };
var fa_g6 = function (match, outcome) { return '0 или 1'; };
var fa_h6 = function (match, outcome) { return '5'; };
var fa_i6 = function (match, outcome) { return '6'; };
var fa_j6 = function (match, outcome) { return '7'; };
var fa_k6 = function (match, outcome) { return '≥ 8'; };
var fa_l6 = function (match, outcome) { return 'П1П1'; };
var fa_m6 = function (match, outcome) { return 'П1Н'; };
var fa_n6 = function (match, outcome) { return 'П1П2'; };
var fa_o6 = function (match, outcome) { return 'НП1'; };
var fa_p6 = function (match, outcome) { return 'НН'; };
var fa_q6 = function (match, outcome) { return 'НП2'; };
var fa_r6 = function (match, outcome) { return 'П2П1'; };
var fa_s6 = function (match, outcome) { return 'П2Н'; };
var fa_t6 = function (match, outcome) { return 'П2П2'; };
var fa_u6 = function (match, outcome) { return "".concat(outcome.condition + 1); };
var fa_v6 = function (match, outcome) { return "".concat(outcome.condition + 2); };
var fa_w6 = function (match, outcome) { return "".concat(outcome.condition + 3); };
var fa_x6 = function (match, outcome) { return "".concat(outcome.condition + 4); };
var fa_y6 = function (match, outcome) { return "".concat(outcome.condition + 5); };
var fa_z6 = function (match, outcome) { return "".concat(outcome.condition + 6); };
var fa_a7 = function (match, outcome) { return "\u2265 ".concat(outcome.condition + 7); };
var fa_b7 = function (match, outcome) { return "\u043E\u0442 ".concat(outcome.condition + 1, " \u0434\u043E ").concat(outcome.condition + 2); };
var fa_c7 = function (match, outcome) { return "\u043E\u0442 ".concat(outcome.condition + 3, " \u0434\u043E ").concat(outcome.condition + 4); };
var fa_d7 = function (match, outcome) { return "\u043E\u0442 ".concat(outcome.condition + 5, " \u0434\u043E ").concat(outcome.condition + 6); };
var fa_e7 = function (match, outcome) { return '4-6'; };
var fa_f7 = function (match, outcome) { return '7 и более'; };
var fa_g7 = function (match, outcome) { return 'П1Тм'; };
var fa_h7 = function (match, outcome) { return 'П1Тб'; };
var fa_i7 = function (match, outcome) { return 'П2Тм'; };
var fa_j7 = function (match, outcome) { return 'П2Тб'; };
var fa_k7 = function (match, outcome) { return 'П1: 2-3'; };
var fa_l7 = function (match, outcome) { return 'П1: 4-6'; };
var fa_m7 = function (match, outcome) { return 'П1: ≥7'; };
var fa_n7 = function (match, outcome) { return 'П2: 2-3'; };
var fa_o7 = function (match, outcome) { return 'П2: 4-6'; };
var fa_p7 = function (match, outcome) { return 'П2: ≥7'; };
var fa_q7 = function (match, outcome) { return "".concat(outcome.condition); };
var fa_r7 = function (match, outcome) { return "\u2265 ".concat(outcome.condition + 6); };
var fa_s7 = function (match, outcome) { return 'П1: досрочная победа'; };
var fa_t7 = function (match, outcome) { return 'П1: победа по очкам'; };
var fa_u7 = function (match, outcome) { return 'Ничья'; };
var fa_v7 = function (match, outcome) { return 'П2: досрочная победа'; };
var fa_w7 = function (match, outcome) { return 'П2: победа по очкам'; };
var fa_x7 = function (match, outcome) { return 'П1: 1 раунд'; };
var fa_y7 = function (match, outcome) { return 'П1: 2 раунд'; };
var fa_z7 = function (match, outcome) { return 'П1: 3 раунд'; };
var fa_a8 = function (match, outcome) { return 'П1: 4 раунд'; };
var fa_b8 = function (match, outcome) { return 'П1: 5 раунд'; };
var fa_c8 = function (match, outcome) { return 'П1: 6 раунд'; };
var fa_d8 = function (match, outcome) { return 'П1: 7 раунд'; };
var fa_e8 = function (match, outcome) { return 'П1: 8 раунд'; };
var fa_f8 = function (match, outcome) { return 'П1: 9 раунд'; };
var fa_g8 = function (match, outcome) { return 'П1: 10 раунд'; };
var fa_h8 = function (match, outcome) { return 'П1: 11 раунд'; };
var fa_i8 = function (match, outcome) { return 'П1: 12 раунд'; };
var fa_j8 = function (match, outcome) { return 'П2: 1 раунд'; };
var fa_k8 = function (match, outcome) { return 'П2: 2 раунд'; };
var fa_l8 = function (match, outcome) { return 'П2: 3 раунд'; };
var fa_m8 = function (match, outcome) { return 'П2: 4 раунд'; };
var fa_n8 = function (match, outcome) { return 'П2: 5 раунд'; };
var fa_o8 = function (match, outcome) { return 'П2: 6 раунд'; };
var fa_p8 = function (match, outcome) { return 'П2: 7 раунд'; };
var fa_q8 = function (match, outcome) { return 'П2: 8 раунд'; };
var fa_r8 = function (match, outcome) { return 'П2: 9 раунд'; };
var fa_s8 = function (match, outcome) { return 'П2: 10 раунд'; };
var fa_t8 = function (match, outcome) { return 'П2: 11 раунд'; };
var fa_u8 = function (match, outcome) { return 'П2: 12 раунд'; };
var fa_v8 = function (match, outcome) { return 'X'; };
var fa_w8 = function (match, outcome) { return '5 и более'; };
var fa_x8 = function (match, outcome) { return 'Ни одной'; };
var fa_y8 = function (match, outcome) { return "\u041A\u0430\u0436\u0434\u0430\u044F \u0438\u0437 \u043A\u043E\u043C\u0430\u043D\u0434 \u0437\u0430\u0431\u044C\u0451\u0442 ".concat(outcome.condition + 1, " \u0438\u043B\u0438 \u0431\u043E\u043B\u0435\u0435 \u0433\u043E\u043B\u043E\u0432"); };
var fa_z8 = function (match, outcome) { return "\u0420\u043E\u0432\u043D\u043E \u043E\u0434\u043D\u0430 \u0437\u0430\u0431\u044C\u0451\u0442 ".concat(outcome.condition + 1, " \u0438\u043B\u0438 \u0431\u043E\u043B\u0435\u0435 \u0433\u043E\u043B\u043E\u0432"); };
var fa_a9 = function (match, outcome) { return "\u041D\u0438\u043A\u0442\u043E \u043D\u0435 \u0437\u0430\u0431\u044C\u0451\u0442 ".concat(outcome.condition + 1, " \u0438\u043B\u0438 \u0431\u043E\u043B\u0435\u0435 \u0433\u043E\u043B\u043E\u0432"); };
var fa_b9 = function (match, outcome) { return 'Головой'; };
var fa_c9 = function (match, outcome) { return 'Ногой(с игры)'; };
var fa_d9 = function (match, outcome) { return 'Автоголом'; };
var fa_e9 = function (match, outcome) { return 'С пенальти'; };
var fa_f9 = function (match, outcome) { return 'Угловой'; };
var fa_g9 = function (match, outcome) { return 'Офсайд'; };
var fa_h9 = function (match, outcome) { return 'ЖК'; };
var fa_i9 = function (match, outcome) { return 'Гол'; };
var fa_j9 = function (match, outcome) { return 'Будет'; };
var fa_k9 = function (match, outcome) { return 'Не будет'; };
var fa_l9 = function (match, outcome) { return "\u0420\u0430\u043D\u044C\u0448\u0435 ".concat(outcome.condition); };
var fa_m9 = function (match, outcome) { return "\u041F\u043E\u0437\u0436\u0435 ".concat(outcome.condition); };
var fa_n9 = function (match, outcome) { return 'В первом тайме'; };
var fa_o9 = function (match, outcome) { return 'Во втором тайме'; };
var fa_p9 = function (match, outcome) { return 'Гола не будет'; };
var fa_q9 = function (match, outcome) { return 'Не забьет'; };
var fa_r9 = function (match, outcome) { return '0-6'; };
var fa_s9 = function (match, outcome) { return '1-6'; };
var fa_t9 = function (match, outcome) { return '6-0'; };
var fa_u9 = function (match, outcome) { return '6-1'; };
var fa_v9 = function (match, outcome) { return 'Голевая ничья'; };
var fa_w9 = function (match, outcome) { return 'Безголевая ничья'; };
var fa_x9 = function (match, outcome) { return 'Не ничья'; };
var fa_y9 = function (match, outcome) { return 'Забьет'; };
var fa_z9 = function (match, outcome) { return 'Первый меньше'; };
var fa_a10 = function (match, outcome) { return 'Равенство'; };
var fa_b10 = function (match, outcome) { return 'Первый больше'; };
var fa_c10 = function (match, outcome) { return 'Да/Да'; };
var fa_d10 = function (match, outcome) { return 'Да/Нет'; };
var fa_e10 = function (match, outcome) { return 'Нет/Да'; };
var fa_f10 = function (match, outcome) { return 'Нет/Нет'; };
var fa_g10 = function (match, outcome) { return "\u0422\u0431".concat(outcome.condition, "/\u0414\u0430"); };
var fa_h10 = function (match, outcome) { return "\u0422\u0431".concat(outcome.condition, "/\u041D\u0435\u0442"); };
var fa_i10 = function (match, outcome) { return "\u0422\u043C".concat(outcome.condition, "/\u0414\u0430"); };
var fa_j10 = function (match, outcome) { return "\u0422\u043C".concat(outcome.condition, "/\u041D\u0435\u0442"); };
var fa_k10 = function (match, outcome) { return 'П1 в основное время'; };
var fa_l10 = function (match, outcome) { return 'П2 в основное время'; };
var fa_m10 = function (match, outcome) { return 'П1 в доп. время'; };
var fa_n10 = function (match, outcome) { return 'П2 в доп. время'; };
var fa_o10 = function (match, outcome) { return 'П1 в серии пенальти'; };
var fa_p10 = function (match, outcome) { return 'П2 в серии пенальти'; };
var fa_q10 = function (match, outcome) { return '1 тайм'; };
var fa_r10 = function (match, outcome) { return 'Перерыв'; };
var fa_s10 = function (match, outcome) { return '2 тайм'; };
var fa_t10 = function (match, outcome) { return '5-4'; };
var fa_u10 = function (match, outcome) { return 'П1 с любым другим'; };
var fa_v10 = function (match, outcome) { return '4-5'; };
var fa_w10 = function (match, outcome) { return 'П2 с любым другим'; };
var fa_x10 = function (match, outcome) { return '1-10'; };
var fa_y10 = function (match, outcome) { return '11-20'; };
var fa_z10 = function (match, outcome) { return '21-30'; };
var fa_a11 = function (match, outcome) { return '31-40'; };
var fa_b11 = function (match, outcome) { return '41-50'; };
var fa_c11 = function (match, outcome) { return '51-60'; };
var fa_d11 = function (match, outcome) { return '61-70'; };
var fa_e11 = function (match, outcome) { return '71-80'; };
var fa_f11 = function (match, outcome) { return '81-конец ОВ'; };
var fa_g11 = function (match, outcome) { return 'Нет гола'; };
var fa_h11 = function (match, outcome) { return 'X2'; };
var fa_i11 = function (match, outcome) { return '1<2'; };
var fa_j11 = function (match, outcome) { return '1=2'; };
var fa_k11 = function (match, outcome) { return '1>2'; };
var fa_l11 = function (match, outcome) { return '1<3'; };
var fa_m11 = function (match, outcome) { return '1=3'; };
var fa_n11 = function (match, outcome) { return '1>3'; };
var fa_o11 = function (match, outcome) { return '2<3'; };
var fa_p11 = function (match, outcome) { return '2=3'; };
var fa_q11 = function (match, outcome) { return '2>3'; };
var fa_r11 = function (match, outcome) { return 'да'; };
var fa_s11 = function (match, outcome) { return 'нет'; };
var fa_t11 = function (match, outcome) { return 'Желтый шар'; };
var fa_u11 = function (match, outcome) { return 'Зеленый шар'; };
var fa_v11 = function (match, outcome) { return 'Коричневый шар'; };
var fa_w11 = function (match, outcome) { return 'Голубой шар'; };
var fa_x11 = function (match, outcome) { return 'Розовый шар'; };
var fa_y11 = function (match, outcome) { return 'Черный шар'; };
var fa_z11 = function (match, outcome) { return "\u2265 ".concat(outcome.condition + 5); };
var fa_a12 = function (match, outcome) { return '≤ 14'; };
var fa_b12 = function (match, outcome) { return 'от 15 до 17'; };
var fa_c12 = function (match, outcome) { return 'от 18 до 19'; };
var fa_d12 = function (match, outcome) { return '≥ 20'; };
var fa_e12 = function (match, outcome) { return 'П1-0'; };
var fa_f12 = function (match, outcome) { return 'П1-15'; };
var fa_g12 = function (match, outcome) { return 'П1-30'; };
var fa_h12 = function (match, outcome) { return 'П1-40'; };
var fa_i12 = function (match, outcome) { return '0-П2'; };
var fa_j12 = function (match, outcome) { return '15-П2'; };
var fa_k12 = function (match, outcome) { return '30-П2'; };
var fa_l12 = function (match, outcome) { return '40-П2'; };
var fa_m12 = function (match, outcome) { return '3-6'; };
var fa_n12 = function (match, outcome) { return '5-7'; };
var fa_o12 = function (match, outcome) { return '6-2'; };
var fa_p12 = function (match, outcome) { return '6-3'; };
var fa_q12 = function (match, outcome) { return '6-4'; };
var fa_r12 = function (match, outcome) { return '6-7'; };
var fa_s12 = function (match, outcome) { return '7-5'; };
var fa_t12 = function (match, outcome) { return '7-6'; };
var fa_u12 = function (match, outcome) { return '7-0'; };
var fa_v12 = function (match, outcome) { return '7-1'; };
var fa_w12 = function (match, outcome) { return '7-2'; };
var fa_x12 = function (match, outcome) { return '7-3'; };
var fa_y12 = function (match, outcome) { return '7-4'; };
var fa_z12 = function (match, outcome) { return '0-7'; };
var fa_a13 = function (match, outcome) { return '1-7'; };
var fa_b13 = function (match, outcome) { return '2-7'; };
var fa_c13 = function (match, outcome) { return '3-7'; };
var fa_d13 = function (match, outcome) { return '4-7'; };
var fa_e13 = function (match, outcome) { return '8'; };
var fa_f13 = function (match, outcome) { return '9'; };
var fa_g13 = function (match, outcome) { return '10'; };
var fa_h13 = function (match, outcome) { return '11'; };
var fa_i13 = function (match, outcome) { return '≥ 13'; };
var fa_j13 = function (match, outcome) { return "".concat(match.homeTeam, " (\u0421.\u041F.)"); };
var fa_k13 = function (match, outcome) { return "".concat(match.awayTeam, " (\u0421.\u041F.)"); };
var fa_l13 = function (match, outcome) { return 'Оба П1'; };
var fa_m13 = function (match, outcome) { return 'Оба П2'; };
var fa_n13 = function (match, outcome) { return 'Ф1'; };
var fa_o13 = function (match, outcome) { return 'Ф2'; };
var fa_p13 = function (match, outcome) { return 'П1: 7 и более'; };
var fa_q13 = function (match, outcome) { return 'П2: 7 и более'; };
var fa_r13 = function (match, outcome) { return '6-5'; };
var fa_s13 = function (match, outcome) { return '5-6'; };
var baseOutcomeConfig = {
    11: {
        74: bo_b1,
        349: bo_c1,
        256: bo_d1,
        306: bo_e1,
        103: bo_f1,
        403: bo_g1,
        443: bo_h1,
        608: bo_i1
    },
    32: {
        73: bo_b1,
        318: bo_c1,
        21: bo_j1,
        22: bo_k1,
        23: bo_l1,
        195: bo_m1,
        196: bo_n1,
        197: bo_o1,
        352: bo_p1,
        748: bo_q1,
        102: bo_f1,
        403: bo_g1,
        366: bo_r1,
        367: bo_s1,
        368: bo_t1,
        138: bo_u1,
        139: bo_v1,
        140: bo_w1,
        182: bo_x1,
        183: bo_y1,
        184: bo_z1,
        122: bo_a2,
        123: bo_b2,
        124: bo_c2,
        129: bo_d2,
        130: bo_e2,
        131: bo_f2,
        566: bo_g2,
        567: bo_h2,
        568: bo_i2,
        616: bo_j2,
        617: bo_k2,
        618: bo_l2,
        257: bo_d1,
        307: bo_e1,
        443: bo_h1,
        608: bo_i1,
        362: bo_m2,
        363: bo_n2,
        364: bo_o2,
        17: bo_p2,
        18: bo_q2,
        19: bo_r2,
        176: bo_s2,
        177: bo_t2,
        178: bo_u2,
        358: bo_v2,
        359: bo_w2,
        360: bo_x2,
        13: bo_y2,
        14: bo_z2,
        15: bo_a3,
        172: bo_b3,
        173: bo_c3,
        174: bo_d3,
        256: bo_d1,
        306: bo_e1
    },
    35: {
        138: bo_e3,
        256: bo_d1,
        21: bo_f3,
        673: bo_g3,
        182: bo_h3,
        306: bo_e1,
        698: bo_g1,
        731: bo_i3,
        656: bo_j3,
        195: bo_k3,
        74: bo_b1,
        349: bo_c1,
        443: bo_h1,
        608: bo_i1,
        911: bo_l3,
        426: bo_m3,
        535: bo_n3,
        871: bo_o3,
        710: bo_p3,
        742: bo_q3
    },
    10: {
        74: bo_b1,
        349: bo_c1,
        256: bo_d1,
        306: bo_e1,
        103: bo_f1,
        403: bo_g1,
        1: bo_r3,
        443: bo_h1,
        608: bo_i1
    },
    31: {
        74: bo_b1,
        349: bo_c1,
        21: bo_s3,
        22: bo_t3,
        23: bo_u3,
        24: bo_v3,
        256: bo_d1,
        306: bo_e1,
        195: bo_w3,
        196: bo_x3,
        197: bo_y3,
        198: bo_z3,
        673: bo_a4,
        674: bo_b4,
        675: bo_c4,
        676: bo_d4,
        103: bo_f1,
        403: bo_g1,
        138: bo_e4,
        139: bo_f4,
        140: bo_g4,
        141: bo_h4,
        182: bo_i4,
        183: bo_j4,
        184: bo_k4,
        185: bo_l4,
        238: bo_m4,
        682: bo_n4,
        239: bo_o4,
        58: bo_p4,
        59: bo_q4,
        681: bo_r4,
        234: bo_s4,
        235: bo_t4,
        236: bo_u4,
        237: bo_v4,
        725: bo_w4,
        726: bo_x4,
        727: bo_y4,
        728: bo_z4,
        782: bo_o3,
        778: bo_a5,
        779: bo_b5,
        780: bo_c5,
        781: bo_d5,
        783: bo_e5,
        773: bo_f5,
        474: bo_g5,
        421: bo_h5,
        530: bo_i5,
        422: bo_j5,
        531: bo_k5,
        444: bo_l5,
        888: bo_m5,
        280: bo_n5,
        317: bo_o5,
        424: bo_p5,
        533: bo_q5,
        423: bo_r5,
        532: bo_s5,
        637: bo_t5,
        788: bo_u5,
        784: bo_v5,
        785: bo_w5,
        786: bo_x5,
        787: bo_y5,
        774: bo_v5,
        775: bo_w5,
        776: bo_x5,
        777: bo_y5,
        281: bo_z5,
        137: bo_a6,
        246: bo_b6,
        248: bo_c6,
        240: bo_d6,
        232: bo_e6,
        241: bo_f6,
        233: bo_g6,
        61: bo_h6,
        62: bo_i6,
        684: bo_j6,
        685: bo_k6,
        443: bo_h1,
        608: bo_i1,
        890: bo_l6,
        242: bo_m6,
        245: bo_n6,
        243: bo_o6,
        60: bo_p6,
        683: bo_q6,
        406: bo_r6,
        405: bo_s6,
        404: bo_t6,
        700: bo_u6,
        408: bo_v6,
        407: bo_w6,
        247: bo_x6,
        244: bo_y6,
        638: bo_z6,
        639: bo_a7,
        640: bo_b7,
        641: bo_c7,
        646: bo_d7,
        642: bo_e7,
        643: bo_f7,
        644: bo_g7,
        645: bo_h7
    },
    41: {
        74: bo_b1,
        349: bo_c1,
        21: bo_p4,
        22: bo_q4,
        403: bo_g1,
        673: bo_i7,
        674: bo_j7,
        195: bo_m4,
        196: bo_o4,
        791: bo_k7,
        792: bo_l7,
        637: bo_t5,
        796: bo_u5,
        794: bo_m7,
        795: bo_n7,
        789: bo_m7,
        790: bo_n7,
        725: bo_o7,
        726: bo_p7,
        793: bo_o3,
        411: bo_w6,
        701: bo_l5,
        251: bo_q7,
        252: bo_r7,
        409: bo_j5,
        430: bo_k5,
        410: bo_r5,
        431: bo_s5,
        281: bo_z5,
        137: bo_a6,
        249: bo_b6,
        250: bo_c6,
        63: bo_h6,
        64: bo_i6,
        686: bo_j6,
        687: bo_k6,
        103: bo_f1,
        256: bo_d1,
        306: bo_e1,
        138: bo_s4,
        139: bo_t4,
        182: bo_u4,
        183: bo_v4,
        443: bo_h1,
        608: bo_i1,
        648: bo_s7,
        649: bo_t7
    },
    18: {
        74: bo_b1,
        349: bo_c1,
        656: bo_j3,
        698: bo_g1,
        256: bo_d1,
        306: bo_e1,
        195: bo_u7,
        196: bo_v7,
        197: bo_w7,
        673: bo_x7,
        674: bo_y7,
        675: bo_z7,
        610: bo_a8,
        443: bo_h1,
        608: bo_i1,
        806: bo_b8,
        893: bo_c8,
        707: bo_d8,
        708: bo_e8,
        709: bo_f8,
        889: bo_o3,
        904: bo_g8,
        253: bo_h8,
        688: bo_i8,
        65: bo_j8,
        751: bo_q3,
        21: bo_k8,
        22: bo_l8,
        23: bo_m8,
        743: bo_n8,
        744: bo_o8,
        745: bo_p8,
        615: bo_i3,
        350: bo_h8
    },
    3: {
        73: bo_b1,
        318: bo_c1,
        21: bo_j1,
        22: bo_k1,
        23: bo_l1,
        195: bo_m1,
        196: bo_n1,
        197: bo_o1,
        352: bo_p1,
        746: bo_q3,
        102: bo_f1,
        403: bo_g1,
        138: bo_u1,
        139: bo_v1,
        140: bo_w1,
        182: bo_x1,
        183: bo_y1,
        184: bo_z1,
        366: bo_r1,
        367: bo_s1,
        368: bo_t1,
        566: bo_q8,
        567: bo_r8,
        568: bo_s8,
        74: bo_t8,
        854: bo_u8,
        855: bo_v8,
        856: bo_w8,
        857: bo_u8,
        858: bo_v8,
        859: bo_w8,
        797: bo_x8,
        798: bo_y8,
        799: bo_z8,
        851: bo_a9,
        852: bo_b9,
        853: bo_c9,
        83: bo_d9,
        84: bo_e9,
        85: bo_f9,
        905: bo_g9,
        906: bo_h9,
        907: bo_i9,
        443: bo_h1,
        608: bo_i1,
        362: bo_m2,
        363: bo_n2,
        17: bo_p2,
        18: bo_q2,
        176: bo_s2,
        177: bo_t2,
        358: bo_v2,
        359: bo_w2,
        13: bo_y2,
        14: bo_z2,
        172: bo_b3,
        173: bo_c3,
        616: bo_j2,
        617: bo_k2,
        618: bo_l2,
        891: bo_l3,
        257: bo_d1,
        307: bo_e1,
        800: bo_j9,
        801: bo_k9,
        802: bo_l9
    },
    20: {
        74: bo_b1,
        349: bo_c1,
        256: bo_d1,
        306: bo_e1,
        698: bo_g1,
        195: bo_m9,
        196: bo_n9,
        197: bo_o9,
        198: bo_p9,
        199: bo_q9,
        200: bo_r9,
        201: bo_s9,
        202: bo_t9,
        138: bo_u9,
        139: bo_v9,
        140: bo_w9,
        141: bo_x9,
        142: bo_y9,
        143: bo_z9,
        144: bo_a10,
        145: bo_b10,
        182: bo_c10,
        183: bo_d10,
        184: bo_e10,
        185: bo_f10,
        186: bo_g10,
        187: bo_h10,
        188: bo_i10,
        189: bo_j10,
        21: bo_k10,
        22: bo_l10,
        23: bo_m10,
        24: bo_n10,
        25: bo_o10,
        26: bo_p10,
        27: bo_q10,
        28: bo_r10,
        673: bo_s10,
        674: bo_t10,
        675: bo_u10,
        676: bo_v10,
        677: bo_w10,
        678: bo_x10,
        679: bo_y10,
        680: bo_z10,
        860: bo_a11,
        861: bo_b11,
        862: bo_c11,
        863: bo_d11,
        864: bo_e11,
        865: bo_f11,
        866: bo_g11,
        867: bo_h11,
        443: bo_h1,
        608: bo_i1
    },
    5: {
        349: bo_c1,
        698: bo_g1,
        443: bo_h1,
        608: bo_i1,
        945: bo_i11,
        948: bo_j11,
        949: bo_k11
    },
    40: {
        656: bo_j3,
        698: bo_g1,
        443: bo_h1,
        608: bo_i1
    },
    37: {
        443: bo_h1,
        608: bo_i1
    },
    38: {
        403: bo_g1,
        443: bo_h1,
        608: bo_i1,
        74: bo_b1,
        349: bo_l11,
        615: bo_m11,
        413: bo_n11,
        414: bo_o11
    },
    42: {
        403: bo_g1,
        443: bo_h1,
        608: bo_i1,
        74: bo_b1,
        349: bo_l11,
        615: bo_p11,
        413: bo_n11,
        414: bo_q11,
        566: bo_r11,
        567: bo_s11,
        568: bo_t11,
        569: bo_u11,
        570: bo_v11,
        698: bo_w11,
        366: bo_x11,
        367: bo_y11,
        368: bo_z11,
        369: bo_a12,
        370: bo_b12,
        940: bo_c12,
        941: bo_d12,
        942: bo_e12,
        943: bo_f12,
        944: bo_g12
    },
    26: {
        443: bo_h1,
        608: bo_i1
    },
    25: {
        443: bo_h1,
        608: bo_i1
    },
    16: {
        443: bo_h1,
        608: bo_i1
    },
    12: {
        74: bo_b1,
        349: bo_c1,
        656: bo_j3,
        698: bo_g1,
        256: bo_d1,
        306: bo_e1,
        103: bo_f1,
        443: bo_h1,
        608: bo_i1
    },
    36: {
        610: bo_h12,
        698: bo_g1,
        656: bo_j3,
        74: bo_b1,
        349: bo_c1,
        615: bo_i3,
        256: bo_d1,
        306: bo_e1,
        673: bo_x7,
        21: bo_k8,
        195: bo_u7,
        443: bo_h1,
        608: bo_i1
    },
    7: {
        425: bo_i12,
        534: bo_j12,
        540: bo_k12,
        343: bo_l12,
        345: bo_m12,
        260: bo_n12,
        261: bo_o12,
        83: bo_p12,
        84: bo_q12,
        803: bo_r12,
        868: bo_s12,
        869: bo_t12,
        870: bo_u12,
        805: bo_v12,
        892: bo_w12,
        346: bo_x12,
        419: bo_y12,
        528: bo_z12,
        420: bo_a13,
        529: bo_b13,
        707: bo_c13,
        708: bo_d13,
        706: bo_e13,
        804: bo_f13,
        474: bo_g13,
        614: bo_h13,
        609: bo_i13,
        416: bo_j13,
        732: bo_k13,
        525: bo_l13,
        850: bo_m13,
        473: bo_n13,
        442: bo_o13,
        729: bo_p13,
        538: bo_q13,
        542: bo_r13,
        730: bo_s13,
        471: bo_t13,
        635: bo_u13,
        714: bo_v13,
        624: bo_w13,
        625: bo_x13,
        715: bo_y13,
        650: bo_z13,
        651: bo_a14,
        652: bo_b14,
        653: bo_c14,
        654: bo_d14,
        655: bo_e14,
        634: bo_f14,
        626: bo_g14,
        733: bo_h14,
        734: bo_i14,
        258: bo_j14,
        259: bo_k14,
        66: bo_l14,
        67: bo_m14,
        81: bo_n14,
        68: bo_o14,
        689: bo_p14,
        690: bo_q14,
        699: bo_r14,
        691: bo_s14,
        723: bo_t14,
        633: bo_u14,
        74: bo_b1,
        349: bo_c1,
        656: bo_j3,
        698: bo_g1,
        322: bo_v14,
        904: bo_w14,
        1: bo_r3,
        136: bo_x14,
        747: bo_q3,
        871: bo_o3,
        255: bo_y14,
        705: bo_z14,
        323: bo_a15,
        324: bo_b15,
        702: bo_c15,
        278: bo_d15,
        256: bo_d1,
        306: bo_e1,
        195: bo_k3,
        196: bo_e15,
        21: bo_f3,
        22: bo_f15,
        282: bo_g15,
        911: bo_l3,
        353: bo_h15,
        673: bo_g3,
        674: bo_i15,
        2: bo_j15,
        5: bo_k15,
        7: bo_l15,
        939: bo_m15,
        9: bo_n15,
        12: bo_o15,
        417: bo_p15,
        526: bo_q15,
        325: bo_r15,
        103: bo_f1,
        160: bo_s15,
        163: bo_t15,
        165: bo_u15,
        166: bo_v15,
        168: bo_w15,
        171: bo_x15,
        148: bo_y15,
        149: bo_z15,
        150: bo_a16,
        151: bo_b16,
        152: bo_c16,
        153: bo_d16,
        154: bo_e16,
        155: bo_f16,
        156: bo_g16,
        157: bo_h16,
        158: bo_i16,
        159: bo_j16,
        731: bo_i3,
        765: bo_k16,
        766: bo_l16,
        415: bo_m16,
        524: bo_n16,
        418: bo_o16,
        527: bo_p16,
        743: bo_q16,
        744: bo_r16,
        710: bo_p3,
        321: bo_s16,
        326: bo_t16,
        327: bo_u16,
        724: bo_v16,
        661: bo_w16,
        664: bo_x16,
        666: bo_y16,
        667: bo_z16,
        669: bo_a17,
        672: bo_b17,
        426: bo_m3,
        535: bo_n3,
        537: bo_c17,
        541: bo_d17,
        539: bo_e17,
        138: bo_e3,
        139: bo_f17,
        182: bo_h3,
        183: bo_g17,
        437: bo_h17,
        436: bo_i17,
        694: bo_j17,
        71: bo_k17,
        271: bo_c1,
        268: bo_l17,
        265: bo_m17,
        267: bo_n17,
        270: bo_o17,
        272: bo_p17,
        269: bo_q17,
        266: bo_r17,
        264: bo_s17,
        281: bo_z5,
        137: bo_a6,
        660: bo_j3,
        880: bo_t17,
        879: bo_u17,
        429: bo_v17,
        433: bo_w17,
        443: bo_h1,
        608: bo_i1,
        881: bo_x17,
        273: bo_y17,
        274: bo_z17,
        435: bo_a18,
        704: bo_b18,
        432: bo_c18,
        428: bo_d18,
        434: bo_e18,
        439: bo_f18,
        440: bo_g18,
        441: bo_h18,
        438: bo_i18,
        623: bo_j18,
        180: bo_k18,
        146: bo_l18,
        659: bo_m18,
        749: bo_n18,
        69: bo_o18,
        262: bo_p18,
        692: bo_q18,
        703: bo_r18,
        70: bo_s18,
        263: bo_t18,
        693: bo_u18,
        72: bo_v18,
        277: bo_w18,
        695: bo_x18,
        750: bo_y18,
        181: bo_z18,
        147: bo_a19,
        276: bo_b19,
        275: bo_c19,
        735: bo_d19,
        736: bo_e19,
        737: bo_f19,
        738: bo_g19,
        739: bo_h19,
        740: bo_i19,
        356: bo_j19,
        357: bo_k19,
        354: bo_l19,
        355: bo_m19,
        937: bo_n19,
        657: bo_o19,
        658: bo_p19,
        412: bo_q19
    },
    14: {
        443: bo_h1,
        608: bo_i1
    },
    34: {
        425: bo_i12,
        534: bo_j12,
        540: bo_k12,
        343: bo_l12,
        345: bo_m12,
        260: bo_n12,
        261: bo_o12,
        83: bo_p12,
        84: bo_q12,
        803: bo_r12,
        868: bo_s12,
        869: bo_t12,
        870: bo_u12,
        346: bo_x12,
        419: bo_y12,
        528: bo_z12,
        420: bo_a13,
        529: bo_b13,
        707: bo_c13,
        708: bo_d13,
        706: bo_e13,
        538: bo_q13,
        74: bo_b1,
        349: bo_c1,
        656: bo_j3,
        698: bo_g1,
        322: bo_v14,
        904: bo_w14,
        1: bo_r3,
        136: bo_x14,
        747: bo_q3,
        871: bo_o3,
        255: bo_y14,
        705: bo_z14,
        323: bo_a15,
        324: bo_b15,
        702: bo_c15,
        278: bo_d15,
        256: bo_d1,
        306: bo_e1,
        195: bo_k3,
        196: bo_e15,
        21: bo_f3,
        22: bo_f15,
        282: bo_g15,
        911: bo_l3,
        353: bo_h15,
        673: bo_g3,
        674: bo_i15,
        2: bo_j15,
        5: bo_k15,
        7: bo_l15,
        939: bo_m15,
        9: bo_n15,
        12: bo_o15,
        417: bo_p15,
        526: bo_q15,
        325: bo_r15,
        103: bo_f1,
        160: bo_s15,
        163: bo_t15,
        165: bo_u15,
        166: bo_v15,
        168: bo_w15,
        171: bo_x15,
        148: bo_y15,
        149: bo_z15,
        150: bo_a16,
        151: bo_b16,
        152: bo_c16,
        153: bo_d16,
        154: bo_e16,
        155: bo_f16,
        156: bo_g16,
        157: bo_h16,
        158: bo_i16,
        159: bo_j16,
        731: bo_i3,
        765: bo_k16,
        766: bo_l16,
        415: bo_m16,
        524: bo_n16,
        418: bo_o16,
        527: bo_p16,
        743: bo_q16,
        744: bo_r16,
        710: bo_p3,
        321: bo_r19,
        326: bo_t16,
        327: bo_u16,
        724: bo_v16,
        661: bo_w16,
        664: bo_x16,
        666: bo_y16,
        667: bo_z16,
        669: bo_a17,
        672: bo_b17,
        426: bo_m3,
        535: bo_n3,
        537: bo_c17,
        541: bo_d17,
        539: bo_e17,
        138: bo_e3,
        139: bo_f17,
        182: bo_h3,
        183: bo_g17,
        443: bo_h1,
        608: bo_i1
    },
    19: {
        74: bo_b1,
        349: bo_c1,
        698: bo_g1,
        256: bo_d1,
        306: bo_e1,
        195: bo_k3,
        196: bo_e15,
        103: bo_f1,
        615: bo_i3,
        886: bo_k16,
        887: bo_l16,
        911: bo_l3,
        884: bo_s19,
        885: bo_t19,
        882: bo_u19,
        883: bo_v19,
        723: bo_t14,
        673: bo_g3,
        674: bo_i15,
        21: bo_f3,
        22: bo_f15,
        138: bo_e3,
        182: bo_h3,
        443: bo_h1,
        608: bo_i1
    },
    30: {
        74: bo_b1,
        349: bo_c1,
        656: bo_j3,
        698: bo_g1,
        21: bo_k8,
        22: bo_l8,
        23: bo_m8,
        279: bo_w19,
        610: bo_h12,
        256: bo_d1,
        306: bo_e1,
        195: bo_u7,
        196: bo_v7,
        197: bo_w7,
        673: bo_x7,
        674: bo_y7,
        675: bo_z7,
        350: bo_h8,
        103: bo_f1,
        415: bo_m16,
        524: bo_n16,
        743: bo_n8,
        744: bo_o8,
        745: bo_p8,
        710: bo_p3,
        403: bo_g1,
        426: bo_m3,
        535: bo_n3,
        706: bo_e13,
        343: bo_l12,
        346: bo_x12,
        83: bo_x19,
        84: bo_y19,
        85: bo_z19,
        344: bo_a20,
        347: bo_b20,
        765: bo_c20,
        766: bo_d20,
        767: bo_e20,
        138: bo_f20,
        139: bo_g20,
        140: bo_h20,
        182: bo_i20,
        183: bo_j20,
        184: bo_k20,
        751: bo_q3,
        911: bo_l3,
        889: bo_o3,
        637: bo_t5,
        615: bo_i3,
        412: bo_l20,
        634: bo_m20,
        626: bo_n20,
        611: bo_o20,
        443: bo_h1,
        608: bo_i1,
        904: bo_g8,
        449: bo_p20,
        446: bo_q20,
        451: bo_r20,
        711: bo_s20,
        712: bo_t20,
        713: bo_u20,
        450: bo_v20,
        447: bo_w20,
        448: bo_x20,
        662: bo_y20,
        663: bo_z20,
        665: bo_a21,
        668: bo_b21,
        670: bo_c21,
        671: bo_d21,
        3: bo_e21,
        4: bo_f21,
        6: bo_g21,
        8: bo_h21,
        10: bo_i21,
        11: bo_j21,
        161: bo_k21,
        162: bo_l21,
        164: bo_m21,
        167: bo_n21,
        169: bo_o21,
        170: bo_p21,
        707: bo_d8,
        708: bo_e8,
        709: bo_f8,
        946: bo_j13,
        947: bo_l13
    },
    23: {
        443: bo_h1,
        608: bo_i1
    },
    13: {
        468: bo_q21,
        470: bo_r21,
        467: bo_s21,
        469: bo_t21,
        464: bo_u21,
        466: bo_v21,
        465: bo_w21,
        463: bo_x21,
        289: bo_y21,
        288: bo_z21,
        292: bo_a22,
        461: bo_b22,
        283: bo_c22,
        295: bo_d22,
        293: bo_e22,
        284: bo_f22,
        285: bo_g22,
        316: bo_h22,
        286: bo_i22,
        287: bo_j22,
        290: bo_k22,
        291: bo_l22,
        462: bo_m22,
        294: bo_n22
    },
    39: {
        403: bo_g1,
        443: bo_h1,
        608: bo_i1,
        698: bo_g1,
        349: bo_c1,
        950: bo_k11,
        955: bo_i11,
        951: bo_o22,
        952: bo_p22,
        953: bo_q22,
        954: bo_r22
    },
    33: {
        348: bo_s22,
        443: bo_h1,
        608: bo_i1
    },
    24: {
        443: bo_h1,
        608: bo_i1
    },
    9: {
        74: bo_b1,
        349: bo_c1,
        656: bo_j3,
        698: bo_g1,
        256: bo_d1,
        306: bo_e1,
        195: bo_k3,
        196: bo_e15,
        673: bo_g3,
        674: bo_i15,
        443: bo_h1,
        608: bo_i1
    },
    21: {
        443: bo_h1,
        608: bo_i1
    },
    29: {
        394: bo_t22,
        395: bo_u22,
        396: bo_v22,
        397: bo_w22,
        398: bo_x22,
        399: bo_y22,
        400: bo_z22,
        401: bo_a23,
        402: bo_b23,
        100: bo_c23,
        101: bo_d23,
        104: bo_e23,
        105: bo_f23,
        106: bo_g23,
        107: bo_h23,
        108: bo_i23,
        109: bo_j23,
        110: bo_k23,
        111: bo_l23,
        112: bo_m23,
        113: bo_n23,
        114: bo_o23,
        115: bo_p23,
        116: bo_q23,
        117: bo_r23,
        118: bo_s23,
        119: bo_t23,
        120: bo_u23,
        121: bo_v23,
        808: bo_w23,
        809: bo_x23,
        810: bo_y23,
        811: bo_z23,
        812: bo_a24,
        813: bo_b24,
        814: bo_c24,
        815: bo_d24,
        816: bo_e24,
        817: bo_f24,
        818: bo_g24,
        819: bo_h24,
        820: bo_i24,
        821: bo_j24,
        822: bo_k24,
        823: bo_l24,
        824: bo_m24,
        825: bo_n24,
        826: bo_o24,
        827: bo_p24,
        828: bo_q24,
        829: bo_r24,
        830: bo_s24,
        831: bo_t24,
        832: bo_u24,
        833: bo_v24,
        834: bo_w24,
        835: bo_x24,
        836: bo_y24,
        837: bo_z24,
        838: bo_a25,
        839: bo_b25,
        840: bo_c25,
        841: bo_d25,
        842: bo_e25,
        843: bo_f25,
        844: bo_g25,
        366: bo_h25,
        367: bo_i25,
        368: bo_j25,
        369: bo_k25,
        370: bo_l25,
        371: bo_m25,
        372: bo_n25,
        373: bo_o25,
        374: bo_p25,
        375: bo_q25,
        376: bo_r25,
        377: bo_s25,
        378: bo_t25,
        379: bo_u25,
        380: bo_v25,
        381: bo_w25,
        382: bo_x25,
        383: bo_y25,
        384: bo_z25,
        385: bo_a26,
        386: bo_b26,
        387: bo_c26,
        388: bo_d26,
        389: bo_e26,
        390: bo_f26,
        391: bo_g26,
        392: bo_h26,
        393: bo_i26,
        481: bo_j26,
        482: bo_k26,
        483: bo_l26,
        484: bo_m26,
        485: bo_n26,
        486: bo_o26,
        487: bo_p26,
        488: bo_q26,
        489: bo_r26,
        490: bo_s26,
        491: bo_t26,
        492: bo_u26,
        493: bo_v26,
        494: bo_w26,
        495: bo_x26,
        496: bo_y26,
        497: bo_z26,
        498: bo_a27,
        499: bo_b27,
        500: bo_c27,
        501: bo_d27,
        502: bo_e27,
        503: bo_f27,
        504: bo_g27,
        505: bo_h27,
        506: bo_i27,
        507: bo_j27,
        508: bo_k27,
        509: bo_l27,
        510: bo_m27,
        511: bo_n27,
        566: bo_o27,
        567: bo_p27,
        568: bo_q27,
        569: bo_r27,
        570: bo_s27,
        571: bo_t27,
        572: bo_u27,
        573: bo_v27,
        574: bo_w27,
        575: bo_x27,
        576: bo_y27,
        577: bo_z27,
        578: bo_a28,
        579: bo_b28,
        580: bo_c28,
        581: bo_d28,
        582: bo_e28,
        583: bo_f28,
        584: bo_g28,
        585: bo_h28,
        586: bo_i28,
        587: bo_j28,
        588: bo_k28,
        589: bo_l28,
        590: bo_m28,
        591: bo_n28,
        592: bo_o28,
        593: bo_p28,
        594: bo_q28,
        595: bo_r28,
        596: bo_s28,
        597: bo_t28,
        598: bo_u28,
        599: bo_v28,
        600: bo_w28,
        601: bo_x28,
        602: bo_y28,
        83: bo_z28,
        84: bo_a29,
        85: bo_b29,
        86: bo_c29,
        87: bo_d29,
        88: bo_e29,
        89: bo_f29,
        90: bo_g29,
        91: bo_h29,
        92: bo_i29,
        93: bo_j29,
        94: bo_k29,
        95: bo_l29,
        96: bo_m29,
        97: bo_n29,
        98: bo_o29,
        99: bo_p29,
        74: bo_b1,
        349: bo_c1,
        254: bo_q29,
        403: bo_g1,
        21: bo_r29,
        22: bo_s29,
        23: bo_t29,
        24: bo_u29,
        25: bo_v29,
        26: bo_w29,
        27: bo_x29,
        28: bo_y29,
        29: bo_z29,
        30: bo_a30,
        31: bo_b30,
        32: bo_c30,
        33: bo_d30,
        34: bo_e30,
        35: bo_f30,
        36: bo_g30,
        37: bo_h30,
        38: bo_i30,
        39: bo_j30,
        40: bo_k30,
        41: bo_l30,
        42: bo_m30,
        43: bo_n30,
        44: bo_o30,
        45: bo_p30,
        46: bo_q30,
        47: bo_r30,
        48: bo_s30,
        49: bo_t30,
        50: bo_u30,
        51: bo_v30,
        52: bo_w30,
        53: bo_x30,
        54: bo_y30,
        55: bo_z30,
        56: bo_a31,
        57: bo_b31,
        195: bo_c31,
        196: bo_d31,
        197: bo_e31,
        198: bo_f31,
        199: bo_g31,
        200: bo_h31,
        201: bo_i31,
        202: bo_j31,
        203: bo_k31,
        204: bo_l31,
        205: bo_m31,
        206: bo_n31,
        207: bo_o31,
        208: bo_p31,
        209: bo_q31,
        210: bo_r31,
        211: bo_s31,
        212: bo_t31,
        213: bo_u31,
        214: bo_v31,
        215: bo_w31,
        216: bo_x31,
        217: bo_y31,
        218: bo_z31,
        219: bo_a32,
        220: bo_b32,
        221: bo_c32,
        222: bo_d32,
        223: bo_e32,
        224: bo_f32,
        225: bo_g32,
        226: bo_h32,
        227: bo_i32,
        228: bo_j32,
        229: bo_k32,
        230: bo_l32,
        231: bo_m32,
        475: bo_n32,
        476: bo_o32,
        477: bo_p32,
        478: bo_q32,
        479: bo_r32,
        480: bo_s32,
        443: bo_h1,
        608: bo_i1
    },
    15: {
        443: bo_h1,
        608: bo_i1
    },
    2: {
        73: bo_b1,
        318: bo_c1,
        21: bo_r29,
        22: bo_s29,
        23: bo_t29,
        24: bo_u29,
        25: bo_v29,
        26: bo_w29,
        27: bo_x29,
        195: bo_c31,
        196: bo_d31,
        197: bo_e31,
        198: bo_f31,
        199: bo_g31,
        200: bo_h31,
        201: bo_i31,
        352: bo_t32,
        102: bo_f1,
        403: bo_g1,
        138: bo_u32,
        139: bo_v32,
        140: bo_w32,
        141: bo_x32,
        142: bo_y32,
        143: bo_z32,
        144: bo_a33,
        182: bo_b33,
        183: bo_c33,
        184: bo_d33,
        185: bo_e33,
        186: bo_f33,
        187: bo_g33,
        188: bo_h33,
        566: bo_i33,
        567: bo_j33,
        568: bo_k33,
        569: bo_l33,
        570: bo_m33,
        571: bo_n33,
        572: bo_o33,
        366: bo_h25,
        367: bo_i25,
        368: bo_j25,
        369: bo_k25,
        370: bo_l25,
        371: bo_m25,
        372: bo_n25,
        122: bo_p33,
        123: bo_q33,
        124: bo_r33,
        125: bo_s33,
        126: bo_t33,
        127: bo_u33,
        128: bo_v33,
        129: bo_w33,
        130: bo_x33,
        131: bo_y33,
        132: bo_z33,
        133: bo_a34,
        134: bo_b34,
        135: bo_c34,
        872: bo_d34,
        873: bo_e34,
        874: bo_f34,
        875: bo_g34,
        876: bo_h34,
        877: bo_i34,
        878: bo_j34,
        616: bo_k34,
        617: bo_l34,
        618: bo_m34,
        619: bo_n34,
        620: bo_o34,
        621: bo_p34,
        622: bo_q34,
        894: bo_d34,
        895: bo_e34,
        896: bo_f34,
        897: bo_g34,
        898: bo_h34,
        899: bo_i34,
        900: bo_j34,
        443: bo_h1,
        608: bo_i1,
        83: bo_r34,
        84: bo_s34,
        85: bo_t34,
        86: bo_u34,
        87: bo_v34,
        88: bo_w34,
        89: bo_x34,
        257: bo_d1,
        307: bo_e1,
        752: bo_y34,
        753: bo_y34
    },
    6: {
        553: bo_z34,
        339: bo_a35,
        547: bo_b35,
        138: bo_u1,
        139: bo_v1,
        140: bo_w1,
        141: bo_c35,
        142: bo_d35,
        182: bo_x1,
        183: bo_y1,
        184: bo_z1,
        185: bo_e35,
        186: bo_f35,
        83: bo_d9,
        84: bo_e9,
        85: bo_f9,
        86: bo_g35,
        87: bo_h35,
        807: bo_i35,
        636: bo_j35,
        334: bo_k35,
        335: bo_l35,
        336: bo_m35,
        337: bo_n35,
        906: bo_h9,
        907: bo_i9,
        908: bo_o35,
        909: bo_p35,
        300: bo_q35,
        301: bo_r35,
        302: bo_s35,
        303: bo_t35,
        304: bo_u35,
        310: bo_v35,
        311: bo_w35,
        312: bo_x35,
        313: bo_y35,
        314: bo_z35,
        554: bo_a36,
        555: bo_b36,
        556: bo_c36,
        557: bo_d36,
        558: bo_e36,
        517: bo_f36,
        518: bo_g36,
        519: bo_h36,
        520: bo_i36,
        521: bo_j36,
        561: bo_k36,
        562: bo_l36,
        563: bo_m36,
        564: bo_n36,
        565: bo_o36,
        73: bo_b1,
        318: bo_c1,
        21: bo_j1,
        22: bo_k1,
        23: bo_l1,
        24: bo_p36,
        25: bo_q36,
        195: bo_m1,
        196: bo_n1,
        197: bo_o1,
        198: bo_r36,
        199: bo_s36,
        352: bo_p1,
        748: bo_q1,
        102: bo_f1,
        403: bo_g1,
        903: bo_t36,
        445: bo_u36,
        754: bo_v36,
        755: bo_w36,
        756: bo_x36,
        757: bo_y36,
        758: bo_z36,
        452: bo_a37,
        453: bo_b37,
        454: bo_c37,
        566: bo_d37,
        567: bo_e37,
        568: bo_f37,
        569: bo_g37,
        570: bo_h37,
        366: bo_r1,
        367: bo_s1,
        368: bo_t1,
        369: bo_i37,
        370: bo_j37,
        522: bo_k37,
        627: bo_l37,
        628: bo_m37,
        629: bo_n37,
        630: bo_o37,
        631: bo_p37,
        632: bo_q37,
        190: bo_r37,
        191: bo_s37,
        192: bo_t37,
        193: bo_u37,
        194: bo_v37,
        759: bo_w37,
        760: bo_x37,
        761: bo_y37,
        762: bo_z37,
        763: bo_a38,
        768: bo_b38,
        769: bo_c38,
        770: bo_d38,
        771: bo_e38,
        772: bo_f38,
        603: bo_g38,
        604: bo_h38,
        605: bo_i38,
        606: bo_j38,
        607: bo_k38,
        257: bo_d1,
        307: bo_e1,
        696: bo_g1,
        333: bo_l38,
        341: bo_m38,
        427: bo_n38,
        536: bo_o38,
        905: bo_g9,
        320: bo_p38,
        514: bo_q38,
        516: bo_r38,
        305: bo_s38,
        315: bo_t38,
        523: bo_u38,
        299: bo_v38,
        309: bo_w38,
        697: bo_x38,
        298: bo_y38,
        308: bo_z38,
        515: bo_a39,
        549: bo_b39,
        548: bo_c39,
        443: bo_h1,
        608: bo_i1,
        550: bo_u36,
        551: bo_u36,
        455: bo_a37,
        456: bo_a37,
        457: bo_b37,
        458: bo_b37,
        459: bo_c37,
        460: bo_c37,
        512: bo_k37,
        513: bo_k37,
        901: bo_t36,
        902: bo_t36,
        340: bo_d39,
        328: bo_e39,
        329: bo_f39,
        342: bo_g39,
        330: bo_h39,
        331: bo_i39,
        722: bo_j39,
        560: bo_k39,
        543: bo_l39,
        544: bo_m39,
        545: bo_n39,
        546: bo_o39,
        332: bo_p39,
        559: bo_q39,
        296: bo_r39,
        297: bo_s39,
        717: bo_t39,
        718: bo_u39,
        719: bo_v39,
        720: bo_w39,
        721: bo_x39,
        552: bo_y39,
        76: bo_z39,
        77: bo_a40,
        78: bo_b40,
        79: bo_c40,
        80: bo_d40,
        647: bo_e40,
        741: bo_f40,
        82: bo_g40,
        338: bo_h40
    },
    17: {
        348: bo_s22,
        443: bo_h1,
        608: bo_i1
    },
    4: {
        73: bo_b1,
        318: bo_c1,
        21: bo_j1,
        22: bo_k1,
        23: bo_l1,
        24: bo_p36,
        25: bo_q36,
        195: bo_m1,
        196: bo_n1,
        197: bo_o1,
        198: bo_r36,
        199: bo_s36,
        352: bo_p1,
        764: bo_q3,
        102: bo_f1,
        403: bo_g1,
        138: bo_u1,
        139: bo_v1,
        140: bo_w1,
        141: bo_c35,
        142: bo_d35,
        182: bo_x1,
        183: bo_y1,
        184: bo_z1,
        185: bo_e35,
        186: bo_f35,
        366: bo_r1,
        367: bo_s1,
        368: bo_t1,
        369: bo_i37,
        370: bo_j37,
        566: bo_g2,
        567: bo_h2,
        568: bo_i2,
        569: bo_i40,
        570: bo_j40,
        74: bo_t8,
        923: bo_u8,
        924: bo_v8,
        925: bo_w8,
        926: bo_k40,
        927: bo_l40,
        929: bo_u8,
        930: bo_v8,
        931: bo_w8,
        932: bo_k40,
        933: bo_l40,
        845: bo_x8,
        846: bo_y8,
        847: bo_z8,
        848: bo_m40,
        849: bo_n40,
        918: bo_a9,
        919: bo_b9,
        920: bo_c9,
        921: bo_o40,
        922: bo_p40,
        83: bo_d9,
        84: bo_e9,
        85: bo_f9,
        86: bo_g35,
        87: bo_h35,
        905: bo_g9,
        906: bo_h9,
        907: bo_i9,
        908: bo_o35,
        909: bo_p35,
        807: bo_i35,
        319: bo_q40,
        320: bo_p38,
        912: bo_j9,
        913: bo_k9,
        914: bo_l9,
        915: bo_r40,
        916: bo_s40,
        443: bo_h1,
        608: bo_i1,
        257: bo_d1,
        307: bo_e1,
        362: bo_m2,
        363: bo_n2,
        364: bo_o2,
        365: bo_t40,
        17: bo_p2,
        18: bo_q2,
        19: bo_r2,
        20: bo_u40,
        176: bo_s2,
        177: bo_t2,
        178: bo_u2,
        179: bo_v40,
        358: bo_v2,
        359: bo_w2,
        360: bo_x2,
        361: bo_w40,
        13: bo_y2,
        14: bo_z2,
        15: bo_a3,
        16: bo_x40,
        172: bo_b3,
        173: bo_c3,
        174: bo_d3,
        175: bo_y40,
        281: bo_z5,
        137: bo_a6,
        616: bo_j2,
        617: bo_k2,
        618: bo_l2,
        619: bo_z40,
        620: bo_a41,
        891: bo_l3,
        26: bo_b41,
        200: bo_c41,
        143: bo_d41,
        187: bo_e41,
        371: bo_f41,
        571: bo_g41,
        928: bo_h41,
        934: bo_h41,
        88: bo_i41,
        910: bo_j41,
        917: bo_k41,
        936: bo_l41
    },
    8: {
        74: bo_b1,
        349: bo_c1,
        656: bo_j3,
        698: bo_g1,
        256: bo_d1,
        306: bo_e1,
        195: bo_w3,
        196: bo_x3,
        197: bo_y3,
        198: bo_z3,
        673: bo_a4,
        674: bo_b4,
        675: bo_c4,
        676: bo_d4,
        103: bo_f1,
        443: bo_h1,
        608: bo_i1
    },
    27: {
        443: bo_h1,
        608: bo_i1
    },
    28: {
        403: bo_g1,
        615: bo_m41,
        74: bo_b1,
        349: bo_c1,
        256: bo_d1,
        306: bo_e1,
        103: bo_f1,
        935: bo_q3,
        612: bo_n41,
        613: bo_o41,
        443: bo_h1,
        608: bo_i1
    }
};
var outcomeConfig = {
    7: {
        426: function (match, outcome) { return "".concat(match.homeTeam, " \u043F\u043E\u0431\u0435\u0434\u0438\u0442 \u0441 \u0440\u0430\u0437\u043D\u0438\u0446\u0435\u0439 \u0440\u043E\u0432\u043D\u043E \u0432 ").concat(outcome.condition, " ").concat(plural(outcome.condition, ['гол', 'гола', 'голов'])); },
        535: function (match, outcome) { return "".concat(match.awayTeam, " \u043F\u043E\u0431\u0435\u0434\u0438\u0442 \u0441 \u0440\u0430\u0437\u043D\u0438\u0446\u0435\u0439 \u0440\u043E\u0432\u043D\u043E \u0432 ").concat(outcome.condition, " ").concat(plural(outcome.condition, ['гол', 'гола', 'голов'])); }
    },
    6: {
        455: function (match, outcome) { return "\u0411\u0443\u0434\u0435\u0442 \u043B\u0438 15x15 \u0432 ".concat(outcome.condition, " \u0433\u0435\u0439\u043C\u0435?"); },
        456: function (match, outcome) { return "\u0411\u0443\u0434\u0435\u0442 \u043B\u0438 15x15 \u0432 ".concat(outcome.condition, " \u0433\u0435\u0439\u043C\u0435?"); },
        457: function (match, outcome) { return "\u0411\u0443\u0434\u0435\u0442 \u043B\u0438 30x30 \u0432 ".concat(outcome.condition, " \u0433\u0435\u0439\u043C\u0435?"); },
        458: function (match, outcome) { return "\u0411\u0443\u0434\u0435\u0442 \u043B\u0438 30x30 \u0432 ".concat(outcome.condition, " \u0433\u0435\u0439\u043C\u0435?"); },
        459: function (match, outcome) { return "\u0411\u0443\u0434\u0435\u0442 \u043B\u0438 40x40 \u0432 ".concat(outcome.condition, " \u0433\u0435\u0439\u043C\u0435?"); },
        460: function (match, outcome) { return "\u0411\u0443\u0434\u0435\u0442 \u043B\u0438 40x40 \u0432 ".concat(outcome.condition, " \u0433\u0435\u0439\u043C\u0435?"); }
    }
};
var baseFactorNameConfig = {
    11: {
        74: {
            1: fa_b1,
            2: fa_c1
        },
        349: {
            1: fa_d1,
            2: fa_e1
        },
        256: {
            1: fa_d1,
            2: fa_e1
        },
        306: {
            1: fa_d1,
            2: fa_e1
        },
        103: {
            1: fa_f1,
            2: fa_g1
        },
        403: {
            1: fa_h1,
            2: fa_i1
        },
        443: {
            1: fa_j1,
            2: fa_k1
        },
        608: {
            1: fa_l1,
            2: fa_m1
        }
    },
    32: {
        73: {
            1: fa_b1,
            2: fa_c1
        },
        318: {
            1: fa_d1,
            2: fa_e1
        },
        21: {
            1: fa_b1,
            2: fa_c1
        },
        22: {
            1: fa_b1,
            2: fa_c1
        },
        23: {
            1: fa_b1,
            2: fa_c1
        },
        195: {
            1: fa_d1,
            2: fa_e1
        },
        196: {
            1: fa_d1,
            2: fa_e1
        },
        197: {
            1: fa_d1,
            2: fa_e1
        },
        352: {
            1: fa_d1,
            2: fa_e1
        },
        748: {
            1: fa_n1,
            2: fa_o1,
            3: fa_p1,
            4: fa_q1,
            5: fa_r1,
            6: fa_s1,
            7: fa_t1,
            8: fa_u1,
            9: fa_v1,
            10: fa_w1
        },
        102: {
            1: fa_f1,
            2: fa_g1
        },
        403: {
            1: fa_x1,
            2: fa_y1
        },
        366: {
            1: fa_x1,
            2: fa_y1
        },
        367: {
            1: fa_x1,
            2: fa_y1
        },
        368: {
            1: fa_x1,
            2: fa_y1
        },
        138: {
            1: fa_d1,
            2: fa_e1
        },
        139: {
            1: fa_d1,
            2: fa_e1
        },
        140: {
            1: fa_d1,
            2: fa_e1
        },
        182: {
            1: fa_d1,
            2: fa_e1
        },
        183: {
            1: fa_d1,
            2: fa_e1
        },
        184: {
            1: fa_d1,
            2: fa_e1
        },
        122: {
            1: fa_l1,
            2: fa_m1
        },
        123: {
            1: fa_l1,
            2: fa_m1
        },
        124: {
            1: fa_l1,
            2: fa_m1
        },
        129: {
            1: fa_l1,
            2: fa_m1
        },
        130: {
            1: fa_l1,
            2: fa_m1
        },
        131: {
            1: fa_l1,
            2: fa_m1
        },
        566: {
            1: fa_h1,
            2: fa_i1
        },
        567: {
            1: fa_h1,
            2: fa_i1
        },
        568: {
            1: fa_h1,
            2: fa_i1
        },
        616: {
            1: fa_h1,
            2: fa_i1
        },
        617: {
            1: fa_h1,
            2: fa_i1
        },
        618: {
            1: fa_h1,
            2: fa_i1
        },
        257: {
            1: fa_d1,
            2: fa_e1
        },
        307: {
            1: fa_d1,
            2: fa_e1
        },
        443: {
            1: fa_j1,
            2: fa_k1
        },
        608: {
            1: fa_l1,
            2: fa_m1
        },
        362: {
            1: fa_x1,
            2: fa_y1
        },
        363: {
            1: fa_x1,
            2: fa_y1
        },
        364: {
            1: fa_x1,
            2: fa_y1
        },
        17: {
            1: fa_b1,
            2: fa_c1
        },
        18: {
            1: fa_b1,
            2: fa_c1
        },
        19: {
            1: fa_b1,
            2: fa_c1
        },
        176: {
            1: fa_d1,
            2: fa_e1
        },
        177: {
            1: fa_d1,
            2: fa_e1
        },
        178: {
            1: fa_d1,
            2: fa_e1
        },
        358: {
            1: fa_x1,
            2: fa_y1
        },
        359: {
            1: fa_x1,
            2: fa_y1
        },
        360: {
            1: fa_x1,
            2: fa_y1
        },
        13: {
            1: fa_b1,
            2: fa_c1
        },
        14: {
            1: fa_b1,
            2: fa_c1
        },
        15: {
            1: fa_b1,
            2: fa_c1
        },
        172: {
            1: fa_d1,
            2: fa_e1
        },
        173: {
            1: fa_d1,
            2: fa_e1
        },
        174: {
            1: fa_d1,
            2: fa_e1
        },
        256: {
            1: fa_d1,
            2: fa_e1
        },
        306: {
            1: fa_d1,
            2: fa_e1
        }
    },
    35: {
        138: {
            1: fa_d1,
            2: fa_e1
        },
        256: {
            1: fa_d1,
            2: fa_e1
        },
        21: {
            1: fa_b1,
            2: fa_c1
        },
        673: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        182: {
            1: fa_d1,
            2: fa_e1
        },
        306: {
            1: fa_d1,
            2: fa_e1
        },
        698: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        731: {
            1: fa_h1,
            2: fa_a2,
            3: fa_i1
        },
        656: {
            1: fa_b2,
            2: fa_c2,
            3: fa_d2
        },
        195: {
            1: fa_d1,
            2: fa_e1
        },
        74: {
            1: fa_b1,
            2: fa_c1
        },
        349: {
            1: fa_d1,
            2: fa_e1
        },
        443: {
            1: fa_j1,
            2: fa_k1
        },
        608: {
            1: fa_l1,
            2: fa_m1
        },
        911: {
            1: fa_e2,
            2: fa_f2,
            3: fa_g2,
            4: fa_h2,
            5: fa_i2,
            6: fa_j2
        },
        426: {
            1: fa_l1,
            2: fa_m1
        },
        535: {
            1: fa_l1,
            2: fa_m1
        },
        871: {
            1: fa_k2,
            2: fa_l2,
            3: fa_m2,
            4: fa_n2,
            5: fa_o2,
            6: fa_p2
        },
        710: {
            1: fa_q2,
            2: fa_r2,
            3: fa_s2
        },
        742: {
            1: fa_t2,
            2: fa_u2,
            3: fa_n1,
            4: fa_o1,
            5: fa_v2,
            6: fa_w2,
            7: fa_x2,
            8: fa_y2,
            9: fa_p1,
            10: fa_q1,
            11: fa_z2,
            12: fa_a3,
            13: fa_r1,
            14: fa_s1,
            15: fa_b3,
            16: fa_t1,
            17: fa_c3,
            18: fa_d3,
            19: fa_e3,
            20: fa_u1,
            21: fa_v1,
            22: fa_w1,
            23: fa_f3,
            24: fa_g3,
            25: fa_h3,
            26: fa_i3,
            27: fa_j3,
            28: fa_k3,
            29: fa_l3,
            30: fa_m3,
            31: fa_n3,
            32: fa_o3,
            33: fa_p3,
            34: fa_q3,
            35: fa_r3
        }
    },
    10: {
        74: {
            1: fa_b1,
            2: fa_c1
        },
        349: {
            1: fa_d1,
            2: fa_e1
        },
        256: {
            1: fa_d1,
            2: fa_e1
        },
        306: {
            1: fa_d1,
            2: fa_e1
        },
        103: {
            1: fa_f1,
            2: fa_g1
        },
        403: {
            1: fa_x1,
            2: fa_y1
        },
        1: {
            1: fa_b1,
            2: fa_c1
        },
        443: {
            1: fa_j1,
            2: fa_k1
        },
        608: {
            1: fa_l1,
            2: fa_m1
        }
    },
    31: {
        74: {
            1: fa_b1,
            2: fa_c1
        },
        349: {
            1: fa_d1,
            2: fa_e1
        },
        21: {
            1: fa_b1,
            2: fa_c1
        },
        22: {
            1: fa_b1,
            2: fa_c1
        },
        23: {
            1: fa_b1,
            2: fa_c1
        },
        24: {
            1: fa_b1,
            2: fa_c1
        },
        256: {
            1: fa_d1,
            2: fa_e1
        },
        306: {
            1: fa_d1,
            2: fa_e1
        },
        195: {
            1: fa_d1,
            2: fa_e1
        },
        196: {
            1: fa_d1,
            2: fa_e1
        },
        197: {
            1: fa_d1,
            2: fa_e1
        },
        198: {
            1: fa_d1,
            2: fa_e1
        },
        673: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        674: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        675: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        676: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        103: {
            1: fa_f1,
            2: fa_g1
        },
        403: {
            1: fa_x1,
            2: fa_y1
        },
        138: {
            1: fa_d1,
            2: fa_e1
        },
        139: {
            1: fa_d1,
            2: fa_e1
        },
        140: {
            1: fa_d1,
            2: fa_e1
        },
        141: {
            1: fa_d1,
            2: fa_e1
        },
        182: {
            1: fa_d1,
            2: fa_e1
        },
        183: {
            1: fa_d1,
            2: fa_e1
        },
        184: {
            1: fa_d1,
            2: fa_e1
        },
        185: {
            1: fa_d1,
            2: fa_e1
        },
        238: {
            1: fa_d1,
            2: fa_e1
        },
        682: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        239: {
            1: fa_d1,
            2: fa_e1
        },
        58: {
            1: fa_b1,
            2: fa_c1
        },
        59: {
            1: fa_b1,
            2: fa_c1
        },
        681: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        234: {
            1: fa_d1,
            2: fa_e1
        },
        235: {
            1: fa_d1,
            2: fa_e1
        },
        236: {
            1: fa_d1,
            2: fa_e1
        },
        237: {
            1: fa_d1,
            2: fa_e1
        },
        725: {
            1: fa_h1,
            2: fa_a2,
            3: fa_i1
        },
        726: {
            1: fa_h1,
            2: fa_a2,
            3: fa_i1
        },
        727: {
            1: fa_h1,
            2: fa_a2,
            3: fa_i1
        },
        728: {
            1: fa_h1,
            2: fa_a2,
            3: fa_i1
        },
        782: {
            1: fa_s3,
            2: fa_t3,
            3: fa_u3,
            4: fa_v3,
            5: fa_w3,
            6: fa_x3
        },
        778: {
            1: fa_s3,
            2: fa_t3,
            3: fa_u3,
            4: fa_v3,
            5: fa_w3,
            6: fa_x3
        },
        779: {
            1: fa_s3,
            2: fa_t3,
            3: fa_u3,
            4: fa_v3,
            5: fa_w3,
            6: fa_x3
        },
        780: {
            1: fa_s3,
            2: fa_t3,
            3: fa_u3,
            4: fa_v3,
            5: fa_w3,
            6: fa_x3
        },
        781: {
            1: fa_s3,
            2: fa_t3,
            3: fa_u3,
            4: fa_v3,
            5: fa_w3,
            6: fa_x3
        },
        783: {
            1: fa_p1,
            2: fa_h3,
            3: fa_y3,
            4: fa_z3,
            5: fa_a4,
            6: fa_b4,
            7: fa_c4,
            8: fa_y1
        },
        773: {
            1: fa_p1,
            2: fa_h3,
            3: fa_y3,
            4: fa_z3,
            5: fa_a4,
            6: fa_b4,
            7: fa_c4,
            8: fa_x1
        },
        474: {
            1: fa_d4,
            2: fa_e4
        },
        421: {
            1: fa_l1,
            2: fa_m1
        },
        530: {
            1: fa_l1,
            2: fa_m1
        },
        422: {
            1: fa_l1,
            2: fa_m1
        },
        531: {
            1: fa_l1,
            2: fa_m1
        },
        444: {
            1: fa_f4,
            2: fa_g4
        },
        888: {
            1: fa_h4,
            2: fa_i4,
            3: fa_j4,
            4: fa_k4
        },
        280: {
            1: fa_d1,
            2: fa_e1
        },
        317: {
            1: fa_d1,
            2: fa_e1
        },
        424: {
            1: fa_l1,
            2: fa_m1
        },
        533: {
            1: fa_l1,
            2: fa_m1
        },
        423: {
            1: fa_l1,
            2: fa_m1
        },
        532: {
            1: fa_l1,
            2: fa_m1
        },
        637: {
            1: fa_l1,
            2: fa_m1
        },
        788: {
            1: fa_l4,
            2: fa_m4,
            3: fa_n4,
            4: fa_o4,
            5: fa_p4,
            6: fa_q4,
            7: fa_r4,
            8: fa_s4,
            9: fa_t4,
            10: fa_u4,
            11: fa_v4,
            12: fa_w4,
            13: fa_x4,
            14: fa_y4
        },
        784: {
            1: fa_l4,
            2: fa_z4,
            3: fa_a5,
            4: fa_b5,
            5: fa_c5
        },
        785: {
            1: fa_l4,
            2: fa_z4,
            3: fa_a5,
            4: fa_b5,
            5: fa_c5
        },
        786: {
            1: fa_l4,
            2: fa_z4,
            3: fa_a5,
            4: fa_b5,
            5: fa_c5
        },
        787: {
            1: fa_l4,
            2: fa_z4,
            3: fa_a5,
            4: fa_b5,
            5: fa_c5
        },
        774: {
            1: fa_s4,
            2: fa_d5,
            3: fa_e5,
            4: fa_f5,
            5: fa_g5
        },
        775: {
            1: fa_s4,
            2: fa_d5,
            3: fa_e5,
            4: fa_f5,
            5: fa_g5
        },
        776: {
            1: fa_s4,
            2: fa_d5,
            3: fa_e5,
            4: fa_f5,
            5: fa_g5
        },
        777: {
            1: fa_s4,
            2: fa_d5,
            3: fa_e5,
            4: fa_f5,
            5: fa_g5
        },
        281: {
            1: fa_d1,
            2: fa_e1
        },
        137: {
            1: fa_d1,
            2: fa_e1
        },
        246: {
            1: fa_d1,
            2: fa_e1
        },
        248: {
            1: fa_d1,
            2: fa_e1
        },
        240: {
            1: fa_d1,
            2: fa_e1
        },
        232: {
            1: fa_d1,
            2: fa_e1
        },
        241: {
            1: fa_d1,
            2: fa_e1
        },
        233: {
            1: fa_d1,
            2: fa_e1
        },
        61: {
            1: fa_b1,
            2: fa_c1
        },
        62: {
            1: fa_b1,
            2: fa_c1
        },
        684: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        685: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        443: {
            1: fa_j1,
            2: fa_k1
        },
        608: {
            1: fa_l1,
            2: fa_m1
        },
        890: {
            1: fa_h4,
            2: fa_i4,
            3: fa_j4,
            4: fa_k4
        },
        242: {
            1: fa_d1,
            2: fa_e1
        },
        245: {
            1: fa_d1,
            2: fa_e1
        },
        243: {
            1: fa_d1,
            2: fa_e1
        },
        60: {
            1: fa_b1,
            2: fa_c1
        },
        683: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        406: {
            1: fa_h1,
            2: fa_i1
        },
        405: {
            1: fa_h1,
            2: fa_i1
        },
        404: {
            1: fa_h1,
            2: fa_i1
        },
        700: {
            1: fa_h5,
            2: fa_i5,
            3: fa_j5
        },
        408: {
            1: fa_h1,
            2: fa_i1
        },
        407: {
            1: fa_h1,
            2: fa_i1
        },
        247: {
            1: fa_d1,
            2: fa_e1
        },
        244: {
            1: fa_d1,
            2: fa_e1
        },
        638: {
            1: fa_h1,
            2: fa_i1
        },
        639: {
            1: fa_h1,
            2: fa_i1
        },
        640: {
            1: fa_h1,
            2: fa_i1
        },
        641: {
            1: fa_h1,
            2: fa_i1
        },
        646: {
            1: fa_k5,
            2: fa_l5,
            3: fa_m5
        },
        642: {
            1: fa_k5,
            2: fa_l5,
            3: fa_m5
        },
        643: {
            1: fa_k5,
            2: fa_l5,
            3: fa_m5
        },
        644: {
            1: fa_k5,
            2: fa_l5,
            3: fa_m5
        },
        645: {
            1: fa_k5,
            2: fa_l5,
            3: fa_m5
        }
    },
    41: {
        74: {
            1: fa_b1,
            2: fa_c1
        },
        349: {
            1: fa_d1,
            2: fa_e1
        },
        21: {
            1: fa_b1,
            2: fa_c1
        },
        22: {
            1: fa_b1,
            2: fa_c1
        },
        403: {
            1: fa_x1,
            2: fa_y1
        },
        673: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        674: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        195: {
            1: fa_d1,
            2: fa_e1
        },
        196: {
            1: fa_d1,
            2: fa_e1
        },
        791: {
            1: fa_s3,
            2: fa_t3,
            3: fa_u3,
            4: fa_v3,
            5: fa_w3,
            6: fa_x3
        },
        792: {
            1: fa_s3,
            2: fa_t3,
            3: fa_u3,
            4: fa_v3,
            5: fa_w3,
            6: fa_x3
        },
        637: {
            1: fa_l1,
            2: fa_m1
        },
        796: {
            1: fa_l4,
            2: fa_m4,
            3: fa_n4,
            4: fa_o4,
            5: fa_p4,
            6: fa_q4,
            7: fa_n5,
            8: fa_s4,
            9: fa_t4,
            10: fa_u4,
            11: fa_v4,
            12: fa_w4,
            13: fa_x4,
            14: fa_o5
        },
        794: {
            1: fa_l4,
            2: fa_z4,
            3: fa_a5,
            4: fa_p5,
            5: fa_c5
        },
        795: {
            1: fa_l4,
            2: fa_z4,
            3: fa_a5,
            4: fa_p5,
            5: fa_c5
        },
        789: {
            1: fa_s4,
            2: fa_d5,
            3: fa_e5,
            4: fa_q5,
            5: fa_g5
        },
        790: {
            1: fa_s4,
            2: fa_d5,
            3: fa_e5,
            4: fa_q5,
            5: fa_g5
        },
        725: {
            1: fa_h1,
            2: fa_a2,
            3: fa_i1
        },
        726: {
            1: fa_h1,
            2: fa_a2,
            3: fa_i1
        },
        793: {
            1: fa_s3,
            2: fa_t3,
            3: fa_u3,
            4: fa_v3,
            5: fa_w3,
            6: fa_x3
        },
        411: {
            1: fa_h1,
            2: fa_i1
        },
        701: {
            1: fa_f4,
            2: fa_g4,
            3: fa_r5
        },
        251: {
            1: fa_d1,
            2: fa_e1
        },
        252: {
            1: fa_d1,
            2: fa_e1
        },
        409: {
            1: fa_l1,
            2: fa_m1
        },
        430: {
            1: fa_l1,
            2: fa_m1
        },
        410: {
            1: fa_l1,
            2: fa_m1
        },
        431: {
            1: fa_l1,
            2: fa_m1
        },
        281: {
            1: fa_d1,
            2: fa_e1
        },
        137: {
            1: fa_d1,
            2: fa_e1
        },
        249: {
            1: fa_d1,
            2: fa_e1
        },
        250: {
            1: fa_d1,
            2: fa_e1
        },
        63: {
            1: fa_b1,
            2: fa_c1
        },
        64: {
            1: fa_b1,
            2: fa_c1
        },
        686: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        687: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        103: {
            1: fa_f1,
            2: fa_g1
        },
        256: {
            1: fa_d1,
            2: fa_e1
        },
        306: {
            1: fa_d1,
            2: fa_e1
        },
        138: {
            1: fa_d1,
            2: fa_e1
        },
        139: {
            1: fa_d1,
            2: fa_e1
        },
        182: {
            1: fa_d1,
            2: fa_e1
        },
        183: {
            1: fa_d1,
            2: fa_e1
        },
        443: {
            1: fa_j1,
            2: fa_k1
        },
        608: {
            1: fa_l1,
            2: fa_m1
        },
        648: {
            1: fa_h1,
            2: fa_i1
        },
        649: {
            1: fa_h1,
            2: fa_i1
        }
    },
    18: {
        74: {
            1: fa_b1,
            2: fa_c1
        },
        349: {
            1: fa_d1,
            2: fa_e1
        },
        656: {
            1: fa_b2,
            2: fa_c2,
            3: fa_d2
        },
        698: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        256: {
            1: fa_d1,
            2: fa_e1
        },
        306: {
            1: fa_d1,
            2: fa_e1
        },
        195: {
            1: fa_d1,
            2: fa_e1
        },
        196: {
            1: fa_d1,
            2: fa_e1
        },
        197: {
            1: fa_d1,
            2: fa_e1
        },
        673: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        674: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        675: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        610: {
            1: fa_x1,
            2: fa_y1
        },
        443: {
            1: fa_j1,
            2: fa_k1
        },
        608: {
            1: fa_l1,
            2: fa_m1
        },
        806: {
            1: fa_s5,
            2: fa_t5,
            3: fa_u5,
            4: fa_v5,
            5: fa_w5,
            6: fa_c5
        },
        893: {
            1: fa_x5,
            2: fa_y5,
            3: fa_z5,
            4: fa_a6,
            5: fa_b6,
            6: fa_c6
        },
        707: {
            1: fa_d6,
            2: fa_e6,
            3: fa_f6
        },
        708: {
            1: fa_d6,
            2: fa_e6,
            3: fa_f6
        },
        709: {
            1: fa_d6,
            2: fa_e6,
            3: fa_f6
        },
        889: {
            1: fa_g6,
            2: fa_m2,
            3: fa_n2,
            4: fa_o2,
            5: fa_h6,
            6: fa_i6,
            7: fa_j6,
            8: fa_k6
        },
        904: {
            1: fa_l6,
            2: fa_m6,
            3: fa_n6,
            4: fa_o6,
            5: fa_p6,
            6: fa_q6,
            7: fa_r6,
            8: fa_s6,
            9: fa_t6
        },
        253: {
            1: fa_d1,
            2: fa_e1
        },
        688: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        65: {
            1: fa_b1,
            2: fa_c1
        },
        751: {
            1: fa_t2,
            2: fa_u2,
            3: fa_n1,
            4: fa_o1,
            5: fa_v2,
            6: fa_w2,
            7: fa_x2,
            8: fa_y2,
            9: fa_p1,
            10: fa_q1,
            11: fa_z2,
            12: fa_a3,
            13: fa_r1,
            14: fa_s1,
            15: fa_b3,
            16: fa_t1,
            17: fa_c3,
            18: fa_d3,
            19: fa_e3,
            20: fa_u1,
            21: fa_v1,
            22: fa_w1,
            23: fa_f3,
            24: fa_g3,
            25: fa_h3,
            26: fa_i3,
            27: fa_j3,
            28: fa_k3,
            29: fa_l3,
            30: fa_m3,
            31: fa_n3,
            32: fa_o3,
            33: fa_p3,
            34: fa_q3,
            35: fa_r3
        },
        21: {
            1: fa_b1,
            2: fa_c1
        },
        22: {
            1: fa_b1,
            2: fa_c1
        },
        23: {
            1: fa_b1,
            2: fa_c1
        },
        743: {
            1: fa_t2,
            2: fa_u2,
            3: fa_n1,
            4: fa_o1,
            5: fa_x2,
            6: fa_y2,
            7: fa_p1,
            8: fa_q1,
            9: fa_r1,
            10: fa_s1,
            11: fa_b3,
            12: fa_t1,
            13: fa_u1,
            14: fa_v1,
            15: fa_w1,
            16: fa_f3,
            17: fa_r3
        },
        744: {
            1: fa_t2,
            2: fa_u2,
            3: fa_n1,
            4: fa_o1,
            5: fa_x2,
            6: fa_y2,
            7: fa_p1,
            8: fa_q1,
            9: fa_r1,
            10: fa_s1,
            11: fa_b3,
            12: fa_t1,
            13: fa_u1,
            14: fa_v1,
            15: fa_w1,
            16: fa_f3,
            17: fa_r3
        },
        745: {
            1: fa_t2,
            2: fa_u2,
            3: fa_n1,
            4: fa_o1,
            5: fa_x2,
            6: fa_y2,
            7: fa_p1,
            8: fa_q1,
            9: fa_r1,
            10: fa_s1,
            11: fa_b3,
            12: fa_t1,
            13: fa_u1,
            14: fa_v1,
            15: fa_w1,
            16: fa_f3,
            17: fa_r3
        },
        615: {
            1: fa_h1,
            2: fa_i1
        },
        350: {
            1: fa_d1,
            2: fa_e1
        }
    },
    3: {
        73: {
            1: fa_b1,
            2: fa_c1
        },
        318: {
            1: fa_d1,
            2: fa_e1
        },
        21: {
            1: fa_b1,
            2: fa_c1
        },
        22: {
            1: fa_b1,
            2: fa_c1
        },
        23: {
            1: fa_b1,
            2: fa_c1
        },
        195: {
            1: fa_d1,
            2: fa_e1
        },
        196: {
            1: fa_d1,
            2: fa_e1
        },
        197: {
            1: fa_d1,
            2: fa_e1
        },
        352: {
            1: fa_d1,
            2: fa_e1
        },
        746: {
            1: fa_r1,
            2: fa_s1,
            3: fa_p1,
            4: fa_n1
        },
        102: {
            1: fa_f1,
            2: fa_g1
        },
        403: {
            1: fa_x1,
            2: fa_y1
        },
        138: {
            1: fa_d1,
            2: fa_e1
        },
        139: {
            1: fa_d1,
            2: fa_e1
        },
        140: {
            1: fa_d1,
            2: fa_e1
        },
        182: {
            1: fa_d1,
            2: fa_e1
        },
        183: {
            1: fa_d1,
            2: fa_e1
        },
        184: {
            1: fa_d1,
            2: fa_e1
        },
        366: {
            1: fa_x1,
            2: fa_y1
        },
        367: {
            1: fa_x1,
            2: fa_y1
        },
        368: {
            1: fa_x1,
            2: fa_y1
        },
        566: {
            1: fa_h1,
            2: fa_i1
        },
        567: {
            1: fa_h1,
            2: fa_i1
        },
        568: {
            1: fa_h1,
            2: fa_i1
        },
        74: {
            1: fa_b1,
            2: fa_c1
        },
        854: {
            1: fa_s3,
            2: fa_u6,
            3: fa_v6,
            4: fa_w6,
            5: fa_x6,
            6: fa_y6,
            7: fa_z6,
            8: fa_a7
        },
        855: {
            1: fa_s3,
            2: fa_u6,
            3: fa_v6,
            4: fa_w6,
            5: fa_x6,
            6: fa_y6,
            7: fa_z6,
            8: fa_a7
        },
        856: {
            1: fa_s3,
            2: fa_u6,
            3: fa_v6,
            4: fa_w6,
            5: fa_x6,
            6: fa_y6,
            7: fa_z6,
            8: fa_a7
        },
        857: {
            1: fa_s3,
            2: fa_b7,
            3: fa_c7,
            4: fa_d7,
            5: fa_a7
        },
        858: {
            1: fa_s3,
            2: fa_b7,
            3: fa_c7,
            4: fa_d7,
            5: fa_a7
        },
        859: {
            1: fa_s3,
            2: fa_b7,
            3: fa_c7,
            4: fa_d7,
            5: fa_a7
        },
        797: {
            1: fa_t1,
            2: fa_e7,
            3: fa_f7,
            4: fa_y1
        },
        798: {
            1: fa_t1,
            2: fa_e7,
            3: fa_f7,
            4: fa_y1
        },
        799: {
            1: fa_t1,
            2: fa_e7,
            3: fa_f7,
            4: fa_y1
        },
        851: {
            1: fa_t1,
            2: fa_e7,
            3: fa_f7,
            4: fa_x1
        },
        852: {
            1: fa_t1,
            2: fa_e7,
            3: fa_f7,
            4: fa_x1
        },
        853: {
            1: fa_t1,
            2: fa_e7,
            3: fa_f7,
            4: fa_x1
        },
        83: {
            1: fa_f1,
            2: fa_g1
        },
        84: {
            1: fa_f1,
            2: fa_g1
        },
        85: {
            1: fa_f1,
            2: fa_g1
        },
        905: {
            1: fa_g7,
            2: fa_h7,
            3: fa_i7,
            4: fa_j7
        },
        906: {
            1: fa_g7,
            2: fa_h7,
            3: fa_i7,
            4: fa_j7
        },
        907: {
            1: fa_g7,
            2: fa_h7,
            3: fa_i7,
            4: fa_j7
        },
        443: {
            1: fa_j1,
            2: fa_k1
        },
        608: {
            1: fa_l1,
            2: fa_m1
        },
        362: {
            1: fa_x1,
            2: fa_y1
        },
        363: {
            1: fa_x1,
            2: fa_y1
        },
        17: {
            1: fa_b1,
            2: fa_c1
        },
        18: {
            1: fa_b1,
            2: fa_c1
        },
        176: {
            1: fa_d1,
            2: fa_e1
        },
        177: {
            1: fa_d1,
            2: fa_e1
        },
        358: {
            1: fa_x1,
            2: fa_y1
        },
        359: {
            1: fa_x1,
            2: fa_y1
        },
        13: {
            1: fa_b1,
            2: fa_c1
        },
        14: {
            1: fa_b1,
            2: fa_c1
        },
        172: {
            1: fa_d1,
            2: fa_e1
        },
        173: {
            1: fa_d1,
            2: fa_e1
        },
        616: {
            1: fa_h1,
            2: fa_i1
        },
        617: {
            1: fa_h1,
            2: fa_i1
        },
        618: {
            1: fa_h1,
            2: fa_i1
        },
        891: {
            1: fa_e2,
            2: fa_f2,
            3: fa_g2,
            4: fa_h2
        },
        257: {
            1: fa_d1,
            2: fa_e1
        },
        307: {
            1: fa_d1,
            2: fa_e1
        },
        800: {
            1: fa_k7,
            2: fa_l7,
            3: fa_m7,
            4: fa_n7,
            5: fa_o7,
            6: fa_p7
        },
        801: {
            1: fa_k7,
            2: fa_l7,
            3: fa_m7,
            4: fa_n7,
            5: fa_o7,
            6: fa_p7
        },
        802: {
            1: fa_k7,
            2: fa_l7,
            3: fa_m7,
            4: fa_n7,
            5: fa_o7,
            6: fa_p7
        }
    },
    20: {
        74: {
            1: fa_b1,
            2: fa_c1
        },
        349: {
            1: fa_d1,
            2: fa_e1
        },
        256: {
            1: fa_d1,
            2: fa_e1
        },
        306: {
            1: fa_d1,
            2: fa_e1
        },
        698: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        195: {
            1: fa_d1,
            2: fa_e1
        },
        196: {
            1: fa_d1,
            2: fa_e1
        },
        197: {
            1: fa_d1,
            2: fa_e1
        },
        198: {
            1: fa_d1,
            2: fa_e1
        },
        199: {
            1: fa_d1,
            2: fa_e1
        },
        200: {
            1: fa_d1,
            2: fa_e1
        },
        201: {
            1: fa_d1,
            2: fa_e1
        },
        202: {
            1: fa_d1,
            2: fa_e1
        },
        138: {
            1: fa_d1,
            2: fa_e1
        },
        139: {
            1: fa_d1,
            2: fa_e1
        },
        140: {
            1: fa_d1,
            2: fa_e1
        },
        141: {
            1: fa_d1,
            2: fa_e1
        },
        142: {
            1: fa_d1,
            2: fa_e1
        },
        143: {
            1: fa_d1,
            2: fa_e1
        },
        144: {
            1: fa_d1,
            2: fa_e1
        },
        145: {
            1: fa_d1,
            2: fa_e1
        },
        182: {
            1: fa_d1,
            2: fa_e1
        },
        183: {
            1: fa_d1,
            2: fa_e1
        },
        184: {
            1: fa_d1,
            2: fa_e1
        },
        185: {
            1: fa_d1,
            2: fa_e1
        },
        186: {
            1: fa_d1,
            2: fa_e1
        },
        187: {
            1: fa_d1,
            2: fa_e1
        },
        188: {
            1: fa_d1,
            2: fa_e1
        },
        189: {
            1: fa_d1,
            2: fa_e1
        },
        21: {
            1: fa_b1,
            2: fa_c1
        },
        22: {
            1: fa_b1,
            2: fa_c1
        },
        23: {
            1: fa_b1,
            2: fa_c1
        },
        24: {
            1: fa_b1,
            2: fa_c1
        },
        25: {
            1: fa_b1,
            2: fa_c1
        },
        26: {
            1: fa_b1,
            2: fa_c1
        },
        27: {
            1: fa_b1,
            2: fa_c1
        },
        28: {
            1: fa_b1,
            2: fa_c1
        },
        673: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        674: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        675: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        676: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        677: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        678: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        679: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        680: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        860: {
            1: fa_q7,
            2: fa_u6,
            3: fa_v6,
            4: fa_w6,
            5: fa_x6,
            6: fa_y6,
            7: fa_r7
        },
        861: {
            1: fa_q7,
            2: fa_u6,
            3: fa_v6,
            4: fa_w6,
            5: fa_x6,
            6: fa_y6,
            7: fa_r7
        },
        862: {
            1: fa_q7,
            2: fa_u6,
            3: fa_v6,
            4: fa_w6,
            5: fa_x6,
            6: fa_y6,
            7: fa_r7
        },
        863: {
            1: fa_q7,
            2: fa_u6,
            3: fa_v6,
            4: fa_w6,
            5: fa_x6,
            6: fa_y6,
            7: fa_r7
        },
        864: {
            1: fa_q7,
            2: fa_u6,
            3: fa_v6,
            4: fa_w6,
            5: fa_x6,
            6: fa_y6,
            7: fa_r7
        },
        865: {
            1: fa_q7,
            2: fa_u6,
            3: fa_v6,
            4: fa_w6,
            5: fa_x6,
            6: fa_y6,
            7: fa_r7
        },
        866: {
            1: fa_q7,
            2: fa_u6,
            3: fa_v6,
            4: fa_w6,
            5: fa_x6,
            6: fa_y6,
            7: fa_r7
        },
        867: {
            1: fa_q7,
            2: fa_u6,
            3: fa_v6,
            4: fa_w6,
            5: fa_x6,
            6: fa_y6,
            7: fa_r7
        },
        443: {
            1: fa_j1,
            2: fa_k1
        },
        608: {
            1: fa_l1,
            2: fa_m1
        }
    },
    5: {
        349: {
            1: fa_d1,
            2: fa_e1
        },
        698: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        443: {
            1: fa_j1,
            2: fa_k1
        },
        608: {
            1: fa_l1,
            2: fa_m1
        },
        945: {
            1: fa_l1,
            2: fa_m1
        },
        948: {
            1: fa_s7,
            2: fa_t7,
            3: fa_u7,
            4: fa_v7,
            5: fa_w7
        },
        949: {
            1: fa_x7,
            2: fa_y7,
            3: fa_z7,
            4: fa_a8,
            5: fa_b8,
            6: fa_c8,
            7: fa_d8,
            8: fa_e8,
            9: fa_f8,
            10: fa_g8,
            11: fa_h8,
            12: fa_i8,
            13: fa_t7,
            14: fa_u7,
            15: fa_j8,
            16: fa_k8,
            17: fa_l8,
            18: fa_m8,
            19: fa_n8,
            20: fa_o8,
            21: fa_p8,
            22: fa_q8,
            23: fa_r8,
            24: fa_s8,
            25: fa_t8,
            26: fa_u8,
            27: fa_w7
        }
    },
    40: {
        656: {
            1: fa_b2,
            2: fa_c2,
            3: fa_d2
        },
        698: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        443: {
            1: fa_j1,
            2: fa_k1
        },
        608: {
            1: fa_l1,
            2: fa_m1
        }
    },
    37: {
        443: {
            1: fa_j1,
            2: fa_k1
        },
        608: {
            1: fa_l1,
            2: fa_m1
        }
    },
    38: {
        403: {
            1: fa_x1,
            2: fa_y1
        },
        443: {
            1: fa_j1,
            2: fa_k1
        },
        608: {
            1: fa_l1,
            2: fa_m1
        },
        74: {
            1: fa_b1,
            2: fa_c1
        },
        349: {
            1: fa_d1,
            2: fa_e1
        },
        615: {
            1: fa_h1,
            2: fa_i1
        },
        413: {
            1: fa_h1,
            2: fa_i1
        },
        414: {
            1: fa_h1,
            2: fa_i1
        }
    },
    42: {
        403: {
            1: fa_x1,
            2: fa_y1
        },
        443: {
            1: fa_j1,
            2: fa_k1
        },
        608: {
            1: fa_l1,
            2: fa_m1
        },
        74: {
            1: fa_b1,
            2: fa_c1
        },
        349: {
            1: fa_d1,
            2: fa_e1
        },
        615: {
            1: fa_h1,
            2: fa_i1
        },
        413: {
            1: fa_h1,
            2: fa_i1
        },
        414: {
            1: fa_h1,
            2: fa_i1
        },
        566: {
            1: fa_h1,
            2: fa_i1
        },
        567: {
            1: fa_h1,
            2: fa_i1
        },
        568: {
            1: fa_h1,
            2: fa_i1
        },
        569: {
            1: fa_h1,
            2: fa_i1
        },
        570: {
            1: fa_h1,
            2: fa_i1
        },
        698: {
            1: fa_x1,
            2: fa_v8,
            3: fa_y1
        },
        366: {
            1: fa_x1,
            2: fa_y1
        },
        367: {
            1: fa_x1,
            2: fa_y1
        },
        368: {
            1: fa_x1,
            2: fa_y1
        },
        369: {
            1: fa_x1,
            2: fa_y1
        },
        370: {
            1: fa_x1,
            2: fa_y1
        },
        940: {
            1: fa_x1,
            2: fa_y1
        },
        941: {
            1: fa_x1,
            2: fa_y1
        },
        942: {
            1: fa_x1,
            2: fa_y1
        },
        943: {
            1: fa_x1,
            2: fa_y1
        },
        944: {
            1: fa_x1,
            2: fa_y1
        }
    },
    26: {
        443: {
            1: fa_j1,
            2: fa_k1
        },
        608: {
            1: fa_l1,
            2: fa_m1
        }
    },
    25: {
        443: {
            1: fa_j1,
            2: fa_k1
        },
        608: {
            1: fa_l1,
            2: fa_m1
        }
    },
    16: {
        443: {
            1: fa_j1,
            2: fa_k1
        },
        608: {
            1: fa_l1,
            2: fa_m1
        }
    },
    12: {
        74: {
            1: fa_b1,
            2: fa_c1
        },
        349: {
            1: fa_d1,
            2: fa_e1
        },
        656: {
            1: fa_b2,
            2: fa_c2,
            3: fa_d2
        },
        698: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        256: {
            1: fa_d1,
            2: fa_e1
        },
        306: {
            1: fa_d1,
            2: fa_e1
        },
        103: {
            1: fa_f1,
            2: fa_g1
        },
        443: {
            1: fa_j1,
            2: fa_k1
        },
        608: {
            1: fa_l1,
            2: fa_m1
        }
    },
    36: {
        610: {
            1: fa_x1,
            2: fa_y1
        },
        698: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        656: {
            1: fa_b2,
            2: fa_c2,
            3: fa_d2
        },
        74: {
            1: fa_b1,
            2: fa_c1
        },
        349: {
            1: fa_d1,
            2: fa_e1
        },
        615: {
            1: fa_h1,
            2: fa_i1
        },
        256: {
            1: fa_d1,
            2: fa_e1
        },
        306: {
            1: fa_d1,
            2: fa_e1
        },
        673: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        21: {
            1: fa_b1,
            2: fa_c1
        },
        195: {
            1: fa_d1,
            2: fa_e1
        },
        443: {
            1: fa_j1,
            2: fa_k1
        },
        608: {
            1: fa_l1,
            2: fa_m1
        }
    },
    7: {
        425: {
            1: fa_l1,
            2: fa_m1
        },
        534: {
            1: fa_l1,
            2: fa_m1
        },
        540: {
            1: fa_d1,
            2: fa_e1
        },
        343: {
            1: fa_d1,
            2: fa_e1
        },
        345: {
            1: fa_d1,
            2: fa_e1
        },
        260: {
            1: fa_l1,
            2: fa_m1
        },
        261: {
            1: fa_l1,
            2: fa_m1
        },
        83: {
            1: fa_f1,
            2: fa_g1
        },
        84: {
            1: fa_f1,
            2: fa_g1
        },
        803: {
            1: fa_k2,
            2: fa_l2,
            3: fa_m2,
            4: fa_n2,
            5: fa_o2,
            6: fa_w8
        },
        868: {
            1: fa_k2,
            2: fa_l2,
            3: fa_m2,
            4: fa_n2,
            5: fa_o2,
            6: fa_w8
        },
        869: {
            1: fa_k2,
            2: fa_l2,
            3: fa_m2,
            4: fa_n2,
            5: fa_o2,
            6: fa_w8
        },
        870: {
            1: fa_k2,
            2: fa_l2,
            3: fa_m2,
            4: fa_n2,
            5: fa_o2,
            6: fa_w8
        },
        805: {
            1: fa_k2,
            2: fa_l2,
            3: fa_m2,
            4: fa_n2,
            5: fa_o2,
            6: fa_w8
        },
        892: {
            1: fa_k2,
            2: fa_l2,
            3: fa_m2,
            4: fa_n2,
            5: fa_o2,
            6: fa_w8
        },
        346: {
            1: fa_d1,
            2: fa_e1
        },
        419: {
            1: fa_l1,
            2: fa_m1
        },
        528: {
            1: fa_l1,
            2: fa_m1
        },
        420: {
            1: fa_l1,
            2: fa_m1
        },
        529: {
            1: fa_l1,
            2: fa_m1
        },
        707: {
            1: fa_d6,
            2: fa_e6,
            3: fa_x8
        },
        708: {
            1: fa_d6,
            2: fa_e6,
            3: fa_x8
        },
        706: {
            1: fa_y8,
            2: fa_z8,
            3: fa_a9
        },
        804: {
            1: fa_b9,
            2: fa_c9,
            3: fa_d9,
            4: fa_e9
        },
        474: {
            1: fa_d4,
            2: fa_e4
        },
        614: {
            1: fa_h1,
            2: fa_i1
        },
        609: {
            1: fa_l1,
            2: fa_m1
        },
        416: {
            1: fa_l1,
            2: fa_m1
        },
        732: {
            1: fa_h1,
            2: fa_a2,
            3: fa_i1
        },
        525: {
            1: fa_l1,
            2: fa_m1
        },
        850: {
            1: fa_f9,
            2: fa_g9,
            3: fa_h9,
            4: fa_i9
        },
        473: {
            1: fa_j9,
            2: fa_k9
        },
        442: {
            1: fa_j9,
            2: fa_k9
        },
        729: {
            1: fa_h1,
            2: fa_a2,
            3: fa_i1
        },
        538: {
            1: fa_d1,
            2: fa_e1
        },
        542: {
            1: fa_l1,
            2: fa_m1
        },
        730: {
            1: fa_h1,
            2: fa_a2,
            3: fa_i1
        },
        471: {
            1: fa_j9,
            2: fa_k9
        },
        635: {
            1: fa_l1,
            2: fa_m1
        },
        714: {
            1: fa_l9,
            2: fa_a2,
            3: fa_m9
        },
        624: {
            1: fa_h1,
            2: fa_i1
        },
        625: {
            1: fa_h1,
            2: fa_i1
        },
        715: {
            1: fa_n9,
            2: fa_o9,
            3: fa_p9
        },
        650: {
            1: fa_b2,
            2: fa_c2,
            3: fa_d2
        },
        651: {
            1: fa_b2,
            2: fa_c2,
            3: fa_d2
        },
        652: {
            1: fa_b2,
            2: fa_c2,
            3: fa_d2
        },
        653: {
            1: fa_b2,
            2: fa_c2,
            3: fa_d2
        },
        654: {
            1: fa_b2,
            2: fa_c2,
            3: fa_d2
        },
        655: {
            1: fa_b2,
            2: fa_c2,
            3: fa_d2
        },
        634: {
            1: fa_l1,
            2: fa_m1
        },
        626: {
            1: fa_l1,
            2: fa_m1
        },
        733: {
            1: fa_n9,
            2: fa_o9,
            3: fa_q9
        },
        734: {
            1: fa_n9,
            2: fa_o9,
            3: fa_q9
        },
        258: {
            1: fa_d1,
            2: fa_e1
        },
        259: {
            1: fa_d1,
            2: fa_e1
        },
        66: {
            1: fa_b1,
            2: fa_c1
        },
        67: {
            1: fa_b1,
            2: fa_c1
        },
        81: {
            1: fa_b1,
            2: fa_c1
        },
        68: {
            1: fa_b1,
            2: fa_c1
        },
        689: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        690: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        699: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        691: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        723: {
            1: fa_h1,
            2: fa_a2,
            3: fa_i1
        },
        633: {
            1: fa_l1,
            2: fa_m1
        },
        74: {
            1: fa_b1,
            2: fa_c1
        },
        349: {
            1: fa_d1,
            2: fa_e1
        },
        656: {
            1: fa_b2,
            2: fa_c2,
            3: fa_d2
        },
        698: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        322: {
            1: fa_d1,
            2: fa_e1
        },
        904: {
            1: fa_l6,
            2: fa_m6,
            3: fa_n6,
            4: fa_o6,
            5: fa_p6,
            6: fa_q6,
            7: fa_r6,
            8: fa_s6,
            9: fa_t6
        },
        1: {
            1: fa_b1,
            2: fa_c1
        },
        136: {
            1: fa_d1,
            2: fa_e1
        },
        747: {
            1: fa_t2,
            2: fa_u2,
            3: fa_n1,
            4: fa_o1,
            5: fa_v2,
            6: fa_w2,
            7: fa_r9,
            8: fa_x2,
            9: fa_y2,
            10: fa_p1,
            11: fa_q1,
            12: fa_z2,
            13: fa_a3,
            14: fa_s9,
            15: fa_r1,
            16: fa_s1,
            17: fa_b3,
            18: fa_t1,
            19: fa_c3,
            20: fa_u1,
            21: fa_v1,
            22: fa_w1,
            23: fa_f3,
            24: fa_i3,
            25: fa_j3,
            26: fa_k3,
            27: fa_n3,
            28: fa_o3,
            29: fa_t9,
            30: fa_u9,
            31: fa_r3
        },
        871: {
            1: fa_k2,
            2: fa_l2,
            3: fa_m2,
            4: fa_n2,
            5: fa_o2,
            6: fa_p2
        },
        255: {
            1: fa_d1,
            2: fa_e1
        },
        705: {
            1: fa_v9,
            2: fa_w9,
            3: fa_x9
        },
        323: {
            1: fa_d1,
            2: fa_e1
        },
        324: {
            1: fa_d1,
            2: fa_e1
        },
        702: {
            1: fa_l9,
            2: fa_a2,
            3: fa_m9
        },
        278: {
            1: fa_d1,
            2: fa_e1
        },
        256: {
            1: fa_d1,
            2: fa_e1
        },
        306: {
            1: fa_d1,
            2: fa_e1
        },
        195: {
            1: fa_d1,
            2: fa_e1
        },
        196: {
            1: fa_d1,
            2: fa_e1
        },
        21: {
            1: fa_b1,
            2: fa_c1
        },
        22: {
            1: fa_b1,
            2: fa_c1
        },
        282: {
            1: fa_d1,
            2: fa_e1
        },
        911: {
            1: fa_e2,
            2: fa_f2,
            3: fa_g2,
            4: fa_h2,
            5: fa_i2,
            6: fa_j2
        },
        353: {
            1: fa_d1,
            2: fa_e1
        },
        673: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        674: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        2: {
            1: fa_b1,
            2: fa_c1
        },
        5: {
            1: fa_b1,
            2: fa_c1
        },
        7: {
            1: fa_b1,
            2: fa_c1
        },
        939: {
            1: fa_b1,
            2: fa_c1
        },
        9: {
            1: fa_b1,
            2: fa_c1
        },
        12: {
            1: fa_b1,
            2: fa_c1
        },
        417: {
            1: fa_y9,
            2: fa_q9
        },
        526: {
            1: fa_y9,
            2: fa_q9
        },
        325: {
            1: fa_d1,
            2: fa_e1
        },
        103: {
            1: fa_f1,
            2: fa_g1
        },
        160: {
            1: fa_d1,
            2: fa_e1
        },
        163: {
            1: fa_d1,
            2: fa_e1
        },
        165: {
            1: fa_d1,
            2: fa_e1
        },
        166: {
            1: fa_d1,
            2: fa_e1
        },
        168: {
            1: fa_d1,
            2: fa_e1
        },
        171: {
            1: fa_d1,
            2: fa_e1
        },
        148: {
            1: fa_d1,
            2: fa_e1
        },
        149: {
            1: fa_d1,
            2: fa_e1
        },
        150: {
            1: fa_d1,
            2: fa_e1
        },
        151: {
            1: fa_d1,
            2: fa_e1
        },
        152: {
            1: fa_d1,
            2: fa_e1
        },
        153: {
            1: fa_d1,
            2: fa_e1
        },
        154: {
            1: fa_d1,
            2: fa_e1
        },
        155: {
            1: fa_d1,
            2: fa_e1
        },
        156: {
            1: fa_d1,
            2: fa_e1
        },
        157: {
            1: fa_d1,
            2: fa_e1
        },
        158: {
            1: fa_d1,
            2: fa_e1
        },
        159: {
            1: fa_d1,
            2: fa_e1
        },
        731: {
            1: fa_h1,
            2: fa_a2,
            3: fa_i1
        },
        765: {
            1: fa_k2,
            2: fa_l2,
            3: fa_m2,
            4: fa_n2,
            5: fa_o2,
            6: fa_p2
        },
        766: {
            1: fa_k2,
            2: fa_l2,
            3: fa_m2,
            4: fa_n2,
            5: fa_o2,
            6: fa_p2
        },
        415: {
            1: fa_l1,
            2: fa_m1
        },
        524: {
            1: fa_l1,
            2: fa_m1
        },
        418: {
            1: fa_l1,
            2: fa_m1
        },
        527: {
            1: fa_l1,
            2: fa_m1
        },
        743: {
            1: fa_t2,
            2: fa_u2,
            3: fa_n1,
            4: fa_o1,
            5: fa_x2,
            6: fa_y2,
            7: fa_p1,
            8: fa_q1,
            9: fa_r1,
            10: fa_s1,
            11: fa_b3,
            12: fa_t1,
            13: fa_u1,
            14: fa_v1,
            15: fa_w1,
            16: fa_f3,
            17: fa_r3
        },
        744: {
            1: fa_t2,
            2: fa_u2,
            3: fa_n1,
            4: fa_o1,
            5: fa_x2,
            6: fa_y2,
            7: fa_p1,
            8: fa_q1,
            9: fa_r1,
            10: fa_s1,
            11: fa_b3,
            12: fa_t1,
            13: fa_u1,
            14: fa_v1,
            15: fa_w1,
            16: fa_f3,
            17: fa_r3
        },
        710: {
            1: fa_q2,
            2: fa_r2,
            3: fa_s2
        },
        321: {
            1: fa_d1,
            2: fa_e1
        },
        326: {
            1: fa_l1,
            2: fa_m1
        },
        327: {
            1: fa_l1,
            2: fa_m1
        },
        724: {
            1: fa_z9,
            2: fa_a10,
            3: fa_b10
        },
        661: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        664: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        666: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        667: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        669: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        672: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        426: {
            1: fa_l1,
            2: fa_m1
        },
        535: {
            1: fa_l1,
            2: fa_m1
        },
        537: {
            1: fa_l1,
            2: fa_m1
        },
        541: {
            1: fa_l1,
            2: fa_m1
        },
        539: {
            1: fa_d1,
            2: fa_e1
        },
        138: {
            1: fa_d1,
            2: fa_e1
        },
        139: {
            1: fa_d1,
            2: fa_e1
        },
        182: {
            1: fa_d1,
            2: fa_e1
        },
        183: {
            1: fa_d1,
            2: fa_e1
        },
        437: {
            1: fa_l1,
            2: fa_m1
        },
        436: {
            1: fa_l1,
            2: fa_m1
        },
        694: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        71: {
            1: fa_b1,
            2: fa_c1
        },
        271: {
            1: fa_d1,
            2: fa_e1
        },
        268: {
            1: fa_d1,
            2: fa_e1
        },
        265: {
            1: fa_d1,
            2: fa_e1
        },
        267: {
            1: fa_d1,
            2: fa_e1
        },
        270: {
            1: fa_d1,
            2: fa_e1
        },
        272: {
            1: fa_d1,
            2: fa_e1
        },
        269: {
            1: fa_d1,
            2: fa_e1
        },
        266: {
            1: fa_d1,
            2: fa_e1
        },
        264: {
            1: fa_d1,
            2: fa_e1
        },
        281: {
            1: fa_d1,
            2: fa_e1
        },
        137: {
            1: fa_d1,
            2: fa_e1
        },
        660: {
            1: fa_b2,
            2: fa_c2,
            3: fa_d2
        },
        880: {
            1: fa_c10,
            2: fa_d10,
            3: fa_e10,
            4: fa_f10
        },
        879: {
            1: fa_g10,
            2: fa_h10,
            3: fa_i10,
            4: fa_j10
        },
        429: {
            1: fa_l1,
            2: fa_m1
        },
        433: {
            1: fa_l1,
            2: fa_m1
        },
        443: {
            1: fa_j1,
            2: fa_k1
        },
        608: {
            1: fa_l1,
            2: fa_m1
        },
        881: {
            1: fa_k10,
            2: fa_l10,
            3: fa_m10,
            4: fa_n10,
            5: fa_o10,
            6: fa_p10
        },
        273: {
            1: fa_d1,
            2: fa_e1
        },
        274: {
            1: fa_d1,
            2: fa_e1
        },
        435: {
            1: fa_l1,
            2: fa_m1
        },
        704: {
            1: fa_q10,
            2: fa_r10,
            3: fa_s10
        },
        432: {
            1: fa_l1,
            2: fa_m1
        },
        428: {
            1: fa_l1,
            2: fa_m1
        },
        434: {
            1: fa_l1,
            2: fa_m1
        },
        439: {
            1: fa_l1,
            2: fa_m1
        },
        440: {
            1: fa_l1,
            2: fa_m1
        },
        441: {
            1: fa_l1,
            2: fa_m1
        },
        438: {
            1: fa_l1,
            2: fa_m1
        },
        623: {
            1: fa_h1,
            2: fa_i1
        },
        180: {
            1: fa_d1,
            2: fa_e1
        },
        146: {
            1: fa_d1,
            2: fa_e1
        },
        659: {
            1: fa_b2,
            2: fa_c2,
            3: fa_d2
        },
        749: {
            1: fa_t2,
            2: fa_u2,
            3: fa_n1,
            4: fa_o1,
            5: fa_x2,
            6: fa_y2,
            7: fa_p1,
            8: fa_q1,
            9: fa_r1,
            10: fa_s1,
            11: fa_b3,
            12: fa_t1,
            13: fa_u1,
            14: fa_v1,
            15: fa_w1,
            16: fa_f3,
            17: fa_r3
        },
        69: {
            1: fa_b1,
            2: fa_c1
        },
        262: {
            1: fa_d1,
            2: fa_e1
        },
        692: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        703: {
            1: fa_h1,
            2: fa_a2,
            3: fa_i1
        },
        70: {
            1: fa_b1,
            2: fa_c1
        },
        263: {
            1: fa_d1,
            2: fa_e1
        },
        693: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        72: {
            1: fa_b1,
            2: fa_c1
        },
        277: {
            1: fa_d1,
            2: fa_e1
        },
        695: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        750: {
            1: fa_x2,
            2: fa_r1,
            3: fa_u1,
            4: fa_s1,
            5: fa_v1,
            6: fa_w1,
            7: fa_j3,
            8: fa_k3,
            9: fa_l3,
            10: fa_q3,
            11: fa_t10,
            12: fa_u10,
            13: fa_u2,
            14: fa_n1,
            15: fa_o1,
            16: fa_p1,
            17: fa_q1,
            18: fa_t1,
            19: fa_z2,
            20: fa_c3,
            21: fa_g3,
            22: fa_h3,
            23: fa_v10,
            24: fa_w10
        },
        181: {
            1: fa_d1,
            2: fa_e1
        },
        147: {
            1: fa_d1,
            2: fa_e1
        },
        276: {
            1: fa_d1,
            2: fa_e1
        },
        275: {
            1: fa_d1,
            2: fa_e1
        },
        735: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        736: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        737: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        738: {
            1: fa_h1,
            2: fa_a2,
            3: fa_i1
        },
        739: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        740: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        356: {
            1: fa_d1,
            2: fa_e1
        },
        357: {
            1: fa_d1,
            2: fa_e1
        },
        354: {
            1: fa_d1,
            2: fa_e1
        },
        355: {
            1: fa_d1,
            2: fa_e1
        },
        937: {
            1: fa_x10,
            2: fa_y10,
            3: fa_z10,
            4: fa_a11,
            5: fa_b11,
            6: fa_c11,
            7: fa_d11,
            8: fa_e11,
            9: fa_f11,
            10: fa_g11
        },
        657: {
            1: fa_b2,
            2: fa_c2,
            3: fa_d2
        },
        658: {
            1: fa_b2,
            2: fa_c2,
            3: fa_d2
        },
        412: {
            1: fa_l1,
            2: fa_m1
        }
    },
    14: {
        443: {
            1: fa_j1,
            2: fa_k1
        },
        608: {
            1: fa_l1,
            2: fa_m1
        }
    },
    34: {
        425: {
            1: fa_l1,
            2: fa_m1
        },
        534: {
            1: fa_l1,
            2: fa_m1
        },
        540: {
            1: fa_d1,
            2: fa_e1
        },
        343: {
            1: fa_d1,
            2: fa_e1
        },
        345: {
            1: fa_d1,
            2: fa_e1
        },
        260: {
            1: fa_l1,
            2: fa_m1
        },
        261: {
            1: fa_l1,
            2: fa_m1
        },
        83: {
            1: fa_f1,
            2: fa_g1
        },
        84: {
            1: fa_f1,
            2: fa_g1
        },
        803: {
            1: fa_k2,
            2: fa_l2,
            3: fa_m2,
            4: fa_n2,
            5: fa_o2,
            6: fa_w8
        },
        868: {
            1: fa_k2,
            2: fa_l2,
            3: fa_m2,
            4: fa_n2,
            5: fa_o2,
            6: fa_w8
        },
        869: {
            1: fa_k2,
            2: fa_l2,
            3: fa_m2,
            4: fa_n2,
            5: fa_o2,
            6: fa_w8
        },
        870: {
            1: fa_k2,
            2: fa_l2,
            3: fa_m2,
            4: fa_n2,
            5: fa_o2,
            6: fa_w8
        },
        346: {
            1: fa_d1,
            2: fa_e1
        },
        419: {
            1: fa_l1,
            2: fa_m1
        },
        528: {
            1: fa_l1,
            2: fa_m1
        },
        420: {
            1: fa_l1,
            2: fa_m1
        },
        529: {
            1: fa_l1,
            2: fa_m1
        },
        707: {
            1: fa_d6,
            2: fa_e6,
            3: fa_x8
        },
        708: {
            1: fa_d6,
            2: fa_e6,
            3: fa_x8
        },
        706: {
            1: fa_y8,
            2: fa_z8,
            3: fa_a9
        },
        538: {
            1: fa_d1,
            2: fa_e1
        },
        74: {
            1: fa_b1,
            2: fa_c1
        },
        349: {
            1: fa_d1,
            2: fa_e1
        },
        656: {
            1: fa_b2,
            2: fa_c2,
            3: fa_d2
        },
        698: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        322: {
            1: fa_d1,
            2: fa_e1
        },
        904: {
            1: fa_l6,
            2: fa_m6,
            3: fa_n6,
            4: fa_o6,
            5: fa_p6,
            6: fa_q6,
            7: fa_r6,
            8: fa_s6,
            9: fa_t6
        },
        1: {
            1: fa_b1,
            2: fa_c1
        },
        136: {
            1: fa_d1,
            2: fa_e1
        },
        747: {
            1: fa_t2,
            2: fa_u2,
            3: fa_n1,
            4: fa_o1,
            5: fa_v2,
            6: fa_w2,
            7: fa_r9,
            8: fa_x2,
            9: fa_y2,
            10: fa_p1,
            11: fa_q1,
            12: fa_z2,
            13: fa_a3,
            14: fa_s9,
            15: fa_r1,
            16: fa_s1,
            17: fa_b3,
            18: fa_t1,
            19: fa_c3,
            20: fa_u1,
            21: fa_v1,
            22: fa_w1,
            23: fa_f3,
            24: fa_i3,
            25: fa_j3,
            26: fa_k3,
            27: fa_n3,
            28: fa_o3,
            29: fa_t9,
            30: fa_u9,
            31: fa_r3
        },
        871: {
            1: fa_k2,
            2: fa_l2,
            3: fa_m2,
            4: fa_n2,
            5: fa_o2,
            6: fa_p2
        },
        255: {
            1: fa_d1,
            2: fa_e1
        },
        705: {
            1: fa_v9,
            2: fa_w9,
            3: fa_x9
        },
        323: {
            1: fa_d1,
            2: fa_e1
        },
        324: {
            1: fa_d1,
            2: fa_e1
        },
        702: {
            1: fa_l9,
            2: fa_a2,
            3: fa_m9
        },
        278: {
            1: fa_d1,
            2: fa_e1
        },
        256: {
            1: fa_d1,
            2: fa_e1
        },
        306: {
            1: fa_d1,
            2: fa_e1
        },
        195: {
            1: fa_d1,
            2: fa_e1
        },
        196: {
            1: fa_d1,
            2: fa_e1
        },
        21: {
            1: fa_b1,
            2: fa_c1
        },
        22: {
            1: fa_b1,
            2: fa_c1
        },
        282: {
            1: fa_d1,
            2: fa_e1
        },
        911: {
            1: fa_e2,
            2: fa_f2,
            3: fa_g2,
            4: fa_h2,
            5: fa_i2,
            6: fa_j2
        },
        353: {
            1: fa_d1,
            2: fa_e1
        },
        673: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        674: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        2: {
            1: fa_b1,
            2: fa_c1
        },
        5: {
            1: fa_b1,
            2: fa_c1
        },
        7: {
            1: fa_b1,
            2: fa_c1
        },
        939: {
            1: fa_b1,
            2: fa_c1
        },
        9: {
            1: fa_b1,
            2: fa_c1
        },
        12: {
            1: fa_b1,
            2: fa_c1
        },
        417: {
            1: fa_y9,
            2: fa_q9
        },
        526: {
            1: fa_y9,
            2: fa_q9
        },
        325: {
            1: fa_d1,
            2: fa_e1
        },
        103: {
            1: fa_f1,
            2: fa_g1
        },
        160: {
            1: fa_d1,
            2: fa_e1
        },
        163: {
            1: fa_d1,
            2: fa_e1
        },
        165: {
            1: fa_d1,
            2: fa_e1
        },
        166: {
            1: fa_d1,
            2: fa_e1
        },
        168: {
            1: fa_d1,
            2: fa_e1
        },
        171: {
            1: fa_d1,
            2: fa_e1
        },
        148: {
            1: fa_d1,
            2: fa_e1
        },
        149: {
            1: fa_d1,
            2: fa_e1
        },
        150: {
            1: fa_d1,
            2: fa_e1
        },
        151: {
            1: fa_d1,
            2: fa_e1
        },
        152: {
            1: fa_d1,
            2: fa_e1
        },
        153: {
            1: fa_d1,
            2: fa_e1
        },
        154: {
            1: fa_d1,
            2: fa_e1
        },
        155: {
            1: fa_d1,
            2: fa_e1
        },
        156: {
            1: fa_d1,
            2: fa_e1
        },
        157: {
            1: fa_d1,
            2: fa_e1
        },
        158: {
            1: fa_d1,
            2: fa_e1
        },
        159: {
            1: fa_d1,
            2: fa_e1
        },
        731: {
            1: fa_h1,
            2: fa_a2,
            3: fa_i1
        },
        765: {
            1: fa_k2,
            2: fa_l2,
            3: fa_m2,
            4: fa_n2,
            5: fa_o2,
            6: fa_p2
        },
        766: {
            1: fa_k2,
            2: fa_l2,
            3: fa_m2,
            4: fa_n2,
            5: fa_o2,
            6: fa_p2
        },
        415: {
            1: fa_l1,
            2: fa_m1
        },
        524: {
            1: fa_l1,
            2: fa_m1
        },
        418: {
            1: fa_l1,
            2: fa_m1
        },
        527: {
            1: fa_l1,
            2: fa_m1
        },
        743: {
            1: fa_t2,
            2: fa_u2,
            3: fa_n1,
            4: fa_o1,
            5: fa_x2,
            6: fa_y2,
            7: fa_p1,
            8: fa_q1,
            9: fa_r1,
            10: fa_s1,
            11: fa_b3,
            12: fa_t1,
            13: fa_u1,
            14: fa_v1,
            15: fa_w1,
            16: fa_f3,
            17: fa_r3
        },
        744: {
            1: fa_t2,
            2: fa_u2,
            3: fa_n1,
            4: fa_o1,
            5: fa_x2,
            6: fa_y2,
            7: fa_p1,
            8: fa_q1,
            9: fa_r1,
            10: fa_s1,
            11: fa_b3,
            12: fa_t1,
            13: fa_u1,
            14: fa_v1,
            15: fa_w1,
            16: fa_f3,
            17: fa_r3
        },
        710: {
            1: fa_q2,
            2: fa_r2,
            3: fa_s2
        },
        321: {
            1: fa_d1,
            2: fa_e1
        },
        326: {
            1: fa_l1,
            2: fa_m1
        },
        327: {
            1: fa_l1,
            2: fa_m1
        },
        724: {
            1: fa_z9,
            2: fa_a10,
            3: fa_b10
        },
        661: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        664: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        666: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        667: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        669: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        672: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        426: {
            1: fa_l1,
            2: fa_m1
        },
        535: {
            1: fa_l1,
            2: fa_m1
        },
        537: {
            1: fa_l1,
            2: fa_m1
        },
        541: {
            1: fa_l1,
            2: fa_m1
        },
        539: {
            1: fa_d1,
            2: fa_e1
        },
        138: {
            1: fa_d1,
            2: fa_e1
        },
        139: {
            1: fa_d1,
            2: fa_e1
        },
        182: {
            1: fa_d1,
            2: fa_e1
        },
        183: {
            1: fa_d1,
            2: fa_e1
        },
        443: {
            1: fa_j1,
            2: fa_k1
        },
        608: {
            1: fa_l1,
            2: fa_m1
        }
    },
    19: {
        74: {
            1: fa_b1,
            2: fa_c1
        },
        349: {
            1: fa_d1,
            2: fa_e1
        },
        698: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        256: {
            1: fa_d1,
            2: fa_e1
        },
        306: {
            1: fa_d1,
            2: fa_e1
        },
        195: {
            1: fa_d1,
            2: fa_e1
        },
        196: {
            1: fa_d1,
            2: fa_e1
        },
        103: {
            1: fa_f1,
            2: fa_g1
        },
        615: {
            1: fa_h1,
            2: fa_i1
        },
        886: {
            1: fa_s3,
            2: fa_t3,
            3: fa_u3,
            4: fa_v3,
            5: fa_w3,
            6: fa_x3
        },
        887: {
            1: fa_s3,
            2: fa_t3,
            3: fa_u3,
            4: fa_v3,
            5: fa_w3,
            6: fa_x3
        },
        911: {
            1: fa_e2,
            2: fa_f2,
            3: fa_g2,
            4: fa_h2,
            5: fa_i2,
            6: fa_j2
        },
        884: {
            1: fa_l4,
            2: fa_z4,
            3: fa_a5,
            4: fa_p5,
            5: fa_c5
        },
        885: {
            1: fa_l4,
            2: fa_z4,
            3: fa_a5,
            4: fa_p5,
            5: fa_h11
        },
        882: {
            1: fa_s4,
            2: fa_d5,
            3: fa_e5,
            4: fa_q5,
            5: fa_b2
        },
        883: {
            1: fa_s4,
            2: fa_d5,
            3: fa_e5,
            4: fa_q5,
            5: fa_b2
        },
        723: {
            1: fa_h1,
            2: fa_a2,
            3: fa_i1
        },
        673: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        674: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        21: {
            1: fa_b1,
            2: fa_c1
        },
        22: {
            1: fa_b1,
            2: fa_c1
        },
        138: {
            1: fa_d1,
            2: fa_e1
        },
        182: {
            1: fa_d1,
            2: fa_e1
        },
        443: {
            1: fa_j1,
            2: fa_k1
        },
        608: {
            1: fa_l1,
            2: fa_m1
        }
    },
    30: {
        74: {
            1: fa_b1,
            2: fa_c1
        },
        349: {
            1: fa_d1,
            2: fa_e1
        },
        656: {
            1: fa_b2,
            2: fa_c2,
            3: fa_d2
        },
        698: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        21: {
            1: fa_b1,
            2: fa_c1
        },
        22: {
            1: fa_b1,
            2: fa_c1
        },
        23: {
            1: fa_b1,
            2: fa_c1
        },
        279: {
            1: fa_d1,
            2: fa_e1
        },
        610: {
            1: fa_x1,
            2: fa_y1
        },
        256: {
            1: fa_d1,
            2: fa_e1
        },
        306: {
            1: fa_d1,
            2: fa_e1
        },
        195: {
            1: fa_d1,
            2: fa_e1
        },
        196: {
            1: fa_d1,
            2: fa_e1
        },
        197: {
            1: fa_d1,
            2: fa_e1
        },
        673: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        674: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        675: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        350: {
            1: fa_d1,
            2: fa_e1
        },
        103: {
            1: fa_f1,
            2: fa_g1
        },
        415: {
            1: fa_l1,
            2: fa_m1
        },
        524: {
            1: fa_l1,
            2: fa_m1
        },
        743: {
            1: fa_t2,
            2: fa_u2,
            3: fa_n1,
            4: fa_o1,
            5: fa_x2,
            6: fa_y2,
            7: fa_p1,
            8: fa_q1,
            9: fa_r1,
            10: fa_s1,
            11: fa_b3,
            12: fa_t1,
            13: fa_u1,
            14: fa_v1,
            15: fa_w1,
            16: fa_f3,
            17: fa_r3
        },
        744: {
            1: fa_t2,
            2: fa_u2,
            3: fa_n1,
            4: fa_o1,
            5: fa_x2,
            6: fa_y2,
            7: fa_p1,
            8: fa_q1,
            9: fa_r1,
            10: fa_s1,
            11: fa_b3,
            12: fa_t1,
            13: fa_u1,
            14: fa_v1,
            15: fa_w1,
            16: fa_f3,
            17: fa_r3
        },
        745: {
            1: fa_t2,
            2: fa_u2,
            3: fa_n1,
            4: fa_o1,
            5: fa_x2,
            6: fa_y2,
            7: fa_p1,
            8: fa_q1,
            9: fa_r1,
            10: fa_s1,
            11: fa_b3,
            12: fa_t1,
            13: fa_u1,
            14: fa_v1,
            15: fa_w1,
            16: fa_f3,
            17: fa_r3
        },
        710: {
            1: fa_q2,
            2: fa_r2,
            3: fa_s2
        },
        403: {
            1: fa_x1,
            2: fa_y1
        },
        426: {
            1: fa_l1,
            2: fa_m1
        },
        535: {
            1: fa_l1,
            2: fa_m1
        },
        706: {
            1: fa_y8,
            2: fa_z8,
            3: fa_a9
        },
        343: {
            1: fa_d1,
            2: fa_e1
        },
        346: {
            1: fa_d1,
            2: fa_e1
        },
        83: {
            1: fa_f1,
            2: fa_g1
        },
        84: {
            1: fa_f1,
            2: fa_g1
        },
        85: {
            1: fa_f1,
            2: fa_g1
        },
        344: {
            1: fa_d1,
            2: fa_e1
        },
        347: {
            1: fa_d1,
            2: fa_e1
        },
        765: {
            1: fa_k2,
            2: fa_l2,
            3: fa_m2,
            4: fa_n2,
            5: fa_o2,
            6: fa_p2
        },
        766: {
            1: fa_k2,
            2: fa_l2,
            3: fa_m2,
            4: fa_n2,
            5: fa_o2,
            6: fa_p2
        },
        767: {
            1: fa_k2,
            2: fa_l2,
            3: fa_m2,
            4: fa_n2,
            5: fa_o2,
            6: fa_p2
        },
        138: {
            1: fa_d1,
            2: fa_e1
        },
        139: {
            1: fa_d1,
            2: fa_e1
        },
        140: {
            1: fa_d1,
            2: fa_e1
        },
        182: {
            1: fa_d1,
            2: fa_e1
        },
        183: {
            1: fa_d1,
            2: fa_e1
        },
        184: {
            1: fa_d1,
            2: fa_e1
        },
        751: {
            1: fa_t2,
            2: fa_u2,
            3: fa_n1,
            4: fa_o1,
            5: fa_v2,
            6: fa_w2,
            7: fa_x2,
            8: fa_y2,
            9: fa_p1,
            10: fa_q1,
            11: fa_z2,
            12: fa_a3,
            13: fa_r1,
            14: fa_s1,
            15: fa_b3,
            16: fa_t1,
            17: fa_c3,
            18: fa_d3,
            19: fa_e3,
            20: fa_u1,
            21: fa_v1,
            22: fa_w1,
            23: fa_f3,
            24: fa_g3,
            25: fa_h3,
            26: fa_i3,
            27: fa_j3,
            28: fa_k3,
            29: fa_l3,
            30: fa_m3,
            31: fa_n3,
            32: fa_o3,
            33: fa_p3,
            34: fa_q3,
            35: fa_r3
        },
        911: {
            1: fa_e2,
            2: fa_f2,
            3: fa_g2,
            4: fa_h2,
            5: fa_i2,
            6: fa_j2
        },
        889: {
            1: fa_g6,
            2: fa_m2,
            3: fa_n2,
            4: fa_o2,
            5: fa_h6,
            6: fa_i6,
            7: fa_j6,
            8: fa_k6
        },
        637: {
            1: fa_l1,
            2: fa_m1
        },
        615: {
            1: fa_h1,
            2: fa_i1
        },
        412: {
            1: fa_l1,
            2: fa_m1
        },
        634: {
            1: fa_l1,
            2: fa_m1
        },
        626: {
            1: fa_l1,
            2: fa_m1
        },
        611: {
            1: fa_x1,
            2: fa_y1
        },
        443: {
            1: fa_j1,
            2: fa_k1
        },
        608: {
            1: fa_l1,
            2: fa_m1
        },
        904: {
            1: fa_l6,
            2: fa_m6,
            3: fa_n6,
            4: fa_o6,
            5: fa_p6,
            6: fa_q6,
            7: fa_r6,
            8: fa_s6,
            9: fa_t6
        },
        449: {
            1: fa_l1,
            2: fa_m1
        },
        446: {
            1: fa_l1,
            2: fa_m1
        },
        451: {
            1: fa_l1,
            2: fa_m1
        },
        711: {
            1: fa_i11,
            2: fa_j11,
            3: fa_k11
        },
        712: {
            1: fa_l11,
            2: fa_m11,
            3: fa_n11
        },
        713: {
            1: fa_o11,
            2: fa_p11,
            3: fa_q11
        },
        450: {
            1: fa_l1,
            2: fa_m1
        },
        447: {
            1: fa_l1,
            2: fa_m1
        },
        448: {
            1: fa_l1,
            2: fa_m1
        },
        662: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        663: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        665: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        668: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        670: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        671: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        3: {
            1: fa_b1,
            2: fa_c1
        },
        4: {
            1: fa_b1,
            2: fa_c1
        },
        6: {
            1: fa_b1,
            2: fa_c1
        },
        8: {
            1: fa_b1,
            2: fa_c1
        },
        10: {
            1: fa_b1,
            2: fa_c1
        },
        11: {
            1: fa_b1,
            2: fa_c1
        },
        161: {
            1: fa_d1,
            2: fa_e1
        },
        162: {
            1: fa_d1,
            2: fa_e1
        },
        164: {
            1: fa_d1,
            2: fa_e1
        },
        167: {
            1: fa_d1,
            2: fa_e1
        },
        169: {
            1: fa_d1,
            2: fa_e1
        },
        170: {
            1: fa_d1,
            2: fa_e1
        },
        707: {
            1: fa_d6,
            2: fa_e6,
            3: fa_f6
        },
        708: {
            1: fa_d6,
            2: fa_e6,
            3: fa_f6
        },
        709: {
            1: fa_d6,
            2: fa_e6,
            3: fa_f6
        },
        946: {
            1: fa_l1,
            2: fa_m1
        },
        947: {
            1: fa_l1,
            2: fa_m1
        }
    },
    23: {
        443: {
            1: fa_j1,
            2: fa_k1
        },
        608: {
            1: fa_l1,
            2: fa_m1
        }
    },
    13: {
        468: {
            1: fa_f1,
            2: fa_g1
        },
        470: {
            1: fa_f1,
            2: fa_g1
        },
        467: {
            1: fa_f1,
            2: fa_g1
        },
        469: {
            1: fa_f1,
            2: fa_g1
        },
        464: {
            1: fa_z9,
            2: fa_b10
        },
        466: {
            1: fa_l1,
            2: fa_m1
        },
        465: {
            1: fa_l1,
            2: fa_m1
        },
        463: {
            1: fa_l1,
            2: fa_m1
        },
        289: {
            1: fa_d1,
            2: fa_e1
        },
        288: {
            1: fa_d1,
            2: fa_e1
        },
        292: {
            1: fa_d1,
            2: fa_e1
        },
        461: {
            1: fa_l1,
            2: fa_m1
        },
        283: {
            1: fa_d1,
            2: fa_e1
        },
        295: {
            1: fa_d1,
            2: fa_e1
        },
        293: {
            1: fa_d1,
            2: fa_e1
        },
        284: {
            1: fa_d1,
            2: fa_e1
        },
        285: {
            1: fa_d1,
            2: fa_e1
        },
        316: {
            1: fa_d1,
            2: fa_e1
        },
        286: {
            1: fa_d1,
            2: fa_e1
        },
        287: {
            1: fa_d1,
            2: fa_e1
        },
        290: {
            1: fa_d1,
            2: fa_e1
        },
        291: {
            1: fa_d1,
            2: fa_e1
        },
        462: {
            1: fa_l1,
            2: fa_m1
        },
        294: {
            1: fa_d1,
            2: fa_e1
        }
    },
    39: {
        403: {
            1: fa_x1,
            2: fa_y1
        },
        443: {
            1: fa_j1,
            2: fa_k1
        },
        608: {
            1: fa_l1,
            2: fa_m1
        },
        698: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        349: {
            1: fa_d1,
            2: fa_e1
        },
        950: {
            1: fa_x7,
            2: fa_y7,
            3: fa_z7,
            4: fa_a8,
            5: fa_b8,
            6: fa_t7,
            7: fa_u7,
            8: fa_j8,
            9: fa_k8,
            10: fa_l8,
            11: fa_m8,
            12: fa_n8,
            13: fa_w7
        },
        955: {
            1: fa_l1,
            2: fa_m1
        },
        951: {
            1: fa_r11,
            2: fa_s11
        },
        952: {
            1: fa_r11,
            2: fa_s11
        },
        953: {
            1: fa_r11,
            2: fa_s11
        },
        954: {
            1: fa_r11,
            2: fa_s11
        }
    },
    33: {
        348: {
            1: fa_d1,
            2: fa_e1
        },
        443: {
            1: fa_j1,
            2: fa_k1
        },
        608: {
            1: fa_l1,
            2: fa_m1
        }
    },
    24: {
        443: {
            1: fa_j1,
            2: fa_k1
        },
        608: {
            1: fa_l1,
            2: fa_m1
        }
    },
    9: {
        74: {
            1: fa_b1,
            2: fa_c1
        },
        349: {
            1: fa_d1,
            2: fa_e1
        },
        656: {
            1: fa_b2,
            2: fa_c2,
            3: fa_d2
        },
        698: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        256: {
            1: fa_d1,
            2: fa_e1
        },
        306: {
            1: fa_d1,
            2: fa_e1
        },
        195: {
            1: fa_d1,
            2: fa_e1
        },
        196: {
            1: fa_d1,
            2: fa_e1
        },
        673: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        674: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        443: {
            1: fa_j1,
            2: fa_k1
        },
        608: {
            1: fa_l1,
            2: fa_m1
        }
    },
    21: {
        443: {
            1: fa_j1,
            2: fa_k1
        },
        608: {
            1: fa_l1,
            2: fa_m1
        }
    },
    29: {
        394: {
            1: fa_x1,
            2: fa_y1
        },
        395: {
            1: fa_x1,
            2: fa_y1
        },
        396: {
            1: fa_x1,
            2: fa_y1
        },
        397: {
            1: fa_x1,
            2: fa_y1
        },
        398: {
            1: fa_x1,
            2: fa_y1
        },
        399: {
            1: fa_x1,
            2: fa_y1
        },
        400: {
            1: fa_x1,
            2: fa_y1
        },
        401: {
            1: fa_x1,
            2: fa_y1
        },
        402: {
            1: fa_x1,
            2: fa_y1
        },
        100: {
            1: fa_f1,
            2: fa_g1
        },
        101: {
            1: fa_f1,
            2: fa_g1
        },
        104: {
            1: fa_f1,
            2: fa_g1
        },
        105: {
            1: fa_f1,
            2: fa_g1
        },
        106: {
            1: fa_f1,
            2: fa_g1
        },
        107: {
            1: fa_f1,
            2: fa_g1
        },
        108: {
            1: fa_f1,
            2: fa_g1
        },
        109: {
            1: fa_f1,
            2: fa_g1
        },
        110: {
            1: fa_f1,
            2: fa_g1
        },
        111: {
            1: fa_f1,
            2: fa_g1
        },
        112: {
            1: fa_f1,
            2: fa_g1
        },
        113: {
            1: fa_f1,
            2: fa_g1
        },
        114: {
            1: fa_f1,
            2: fa_g1
        },
        115: {
            1: fa_f1,
            2: fa_g1
        },
        116: {
            1: fa_f1,
            2: fa_g1
        },
        117: {
            1: fa_f1,
            2: fa_g1
        },
        118: {
            1: fa_f1,
            2: fa_g1
        },
        119: {
            1: fa_f1,
            2: fa_g1
        },
        120: {
            1: fa_f1,
            2: fa_g1
        },
        121: {
            1: fa_f1,
            2: fa_g1
        },
        808: {
            1: fa_t11,
            2: fa_u11,
            3: fa_v11,
            4: fa_w11,
            5: fa_x11,
            6: fa_y11
        },
        809: {
            1: fa_t11,
            2: fa_u11,
            3: fa_v11,
            4: fa_w11,
            5: fa_x11,
            6: fa_y11
        },
        810: {
            1: fa_t11,
            2: fa_u11,
            3: fa_v11,
            4: fa_w11,
            5: fa_x11,
            6: fa_y11
        },
        811: {
            1: fa_t11,
            2: fa_u11,
            3: fa_v11,
            4: fa_w11,
            5: fa_x11,
            6: fa_y11
        },
        812: {
            1: fa_t11,
            2: fa_u11,
            3: fa_v11,
            4: fa_w11,
            5: fa_x11,
            6: fa_y11
        },
        813: {
            1: fa_t11,
            2: fa_u11,
            3: fa_v11,
            4: fa_w11,
            5: fa_x11,
            6: fa_y11
        },
        814: {
            1: fa_t11,
            2: fa_u11,
            3: fa_v11,
            4: fa_w11,
            5: fa_x11,
            6: fa_y11
        },
        815: {
            1: fa_t11,
            2: fa_u11,
            3: fa_v11,
            4: fa_w11,
            5: fa_x11,
            6: fa_y11
        },
        816: {
            1: fa_t11,
            2: fa_u11,
            3: fa_v11,
            4: fa_w11,
            5: fa_x11,
            6: fa_y11
        },
        817: {
            1: fa_t11,
            2: fa_u11,
            3: fa_v11,
            4: fa_w11,
            5: fa_x11,
            6: fa_y11
        },
        818: {
            1: fa_t11,
            2: fa_u11,
            3: fa_v11,
            4: fa_w11,
            5: fa_x11,
            6: fa_y11
        },
        819: {
            1: fa_t11,
            2: fa_u11,
            3: fa_v11,
            4: fa_w11,
            5: fa_x11,
            6: fa_y11
        },
        820: {
            1: fa_t11,
            2: fa_u11,
            3: fa_v11,
            4: fa_w11,
            5: fa_x11,
            6: fa_y11
        },
        821: {
            1: fa_t11,
            2: fa_u11,
            3: fa_v11,
            4: fa_w11,
            5: fa_x11,
            6: fa_y11
        },
        822: {
            1: fa_t11,
            2: fa_u11,
            3: fa_v11,
            4: fa_w11,
            5: fa_x11,
            6: fa_y11
        },
        823: {
            1: fa_t11,
            2: fa_u11,
            3: fa_v11,
            4: fa_w11,
            5: fa_x11,
            6: fa_y11
        },
        824: {
            1: fa_t11,
            2: fa_u11,
            3: fa_v11,
            4: fa_w11,
            5: fa_x11,
            6: fa_y11
        },
        825: {
            1: fa_t11,
            2: fa_u11,
            3: fa_v11,
            4: fa_w11,
            5: fa_x11,
            6: fa_y11
        },
        826: {
            1: fa_t11,
            2: fa_u11,
            3: fa_v11,
            4: fa_w11,
            5: fa_x11,
            6: fa_y11
        },
        827: {
            1: fa_t11,
            2: fa_u11,
            3: fa_v11,
            4: fa_w11,
            5: fa_x11,
            6: fa_y11
        },
        828: {
            1: fa_t11,
            2: fa_u11,
            3: fa_v11,
            4: fa_w11,
            5: fa_x11,
            6: fa_y11
        },
        829: {
            1: fa_t11,
            2: fa_u11,
            3: fa_v11,
            4: fa_w11,
            5: fa_x11,
            6: fa_y11
        },
        830: {
            1: fa_t11,
            2: fa_u11,
            3: fa_v11,
            4: fa_w11,
            5: fa_x11,
            6: fa_y11
        },
        831: {
            1: fa_t11,
            2: fa_u11,
            3: fa_v11,
            4: fa_w11,
            5: fa_x11,
            6: fa_y11
        },
        832: {
            1: fa_t11,
            2: fa_u11,
            3: fa_v11,
            4: fa_w11,
            5: fa_x11,
            6: fa_y11
        },
        833: {
            1: fa_t11,
            2: fa_u11,
            3: fa_v11,
            4: fa_w11,
            5: fa_x11,
            6: fa_y11
        },
        834: {
            1: fa_t11,
            2: fa_u11,
            3: fa_v11,
            4: fa_w11,
            5: fa_x11,
            6: fa_y11
        },
        835: {
            1: fa_t11,
            2: fa_u11,
            3: fa_v11,
            4: fa_w11,
            5: fa_x11,
            6: fa_y11
        },
        836: {
            1: fa_t11,
            2: fa_u11,
            3: fa_v11,
            4: fa_w11,
            5: fa_x11,
            6: fa_y11
        },
        837: {
            1: fa_t11,
            2: fa_u11,
            3: fa_v11,
            4: fa_w11,
            5: fa_x11,
            6: fa_y11
        },
        838: {
            1: fa_t11,
            2: fa_u11,
            3: fa_v11,
            4: fa_w11,
            5: fa_x11,
            6: fa_y11
        },
        839: {
            1: fa_t11,
            2: fa_u11,
            3: fa_v11,
            4: fa_w11,
            5: fa_x11,
            6: fa_y11
        },
        840: {
            1: fa_t11,
            2: fa_u11,
            3: fa_v11,
            4: fa_w11,
            5: fa_x11,
            6: fa_y11
        },
        841: {
            1: fa_t11,
            2: fa_u11,
            3: fa_v11,
            4: fa_w11,
            5: fa_x11,
            6: fa_y11
        },
        842: {
            1: fa_t11,
            2: fa_u11,
            3: fa_v11,
            4: fa_w11,
            5: fa_x11,
            6: fa_y11
        },
        843: {
            1: fa_t11,
            2: fa_u11,
            3: fa_v11,
            4: fa_w11,
            5: fa_x11,
            6: fa_y11
        },
        844: {
            1: fa_t11,
            2: fa_u11,
            3: fa_v11,
            4: fa_w11,
            5: fa_x11,
            6: fa_y11
        },
        366: {
            1: fa_x1,
            2: fa_y1
        },
        367: {
            1: fa_x1,
            2: fa_y1
        },
        368: {
            1: fa_x1,
            2: fa_y1
        },
        369: {
            1: fa_x1,
            2: fa_y1
        },
        370: {
            1: fa_x1,
            2: fa_y1
        },
        371: {
            1: fa_x1,
            2: fa_y1
        },
        372: {
            1: fa_x1,
            2: fa_y1
        },
        373: {
            1: fa_x1,
            2: fa_y1
        },
        374: {
            1: fa_x1,
            2: fa_y1
        },
        375: {
            1: fa_x1,
            2: fa_y1
        },
        376: {
            1: fa_x1,
            2: fa_y1
        },
        377: {
            1: fa_x1,
            2: fa_y1
        },
        378: {
            1: fa_x1,
            2: fa_y1
        },
        379: {
            1: fa_x1,
            2: fa_y1
        },
        380: {
            1: fa_x1,
            2: fa_y1
        },
        381: {
            1: fa_x1,
            2: fa_y1
        },
        382: {
            1: fa_x1,
            2: fa_y1
        },
        383: {
            1: fa_x1,
            2: fa_y1
        },
        384: {
            1: fa_x1,
            2: fa_y1
        },
        385: {
            1: fa_x1,
            2: fa_y1
        },
        386: {
            1: fa_x1,
            2: fa_y1
        },
        387: {
            1: fa_x1,
            2: fa_y1
        },
        388: {
            1: fa_x1,
            2: fa_y1
        },
        389: {
            1: fa_x1,
            2: fa_y1
        },
        390: {
            1: fa_x1,
            2: fa_y1
        },
        391: {
            1: fa_x1,
            2: fa_y1
        },
        392: {
            1: fa_x1,
            2: fa_y1
        },
        393: {
            1: fa_x1,
            2: fa_y1
        },
        481: {
            1: fa_h1,
            2: fa_i1
        },
        482: {
            1: fa_h1,
            2: fa_i1
        },
        483: {
            1: fa_h1,
            2: fa_i1
        },
        484: {
            1: fa_h1,
            2: fa_i1
        },
        485: {
            1: fa_h1,
            2: fa_i1
        },
        486: {
            1: fa_h1,
            2: fa_i1
        },
        487: {
            1: fa_h1,
            2: fa_i1
        },
        488: {
            1: fa_h1,
            2: fa_i1
        },
        489: {
            1: fa_h1,
            2: fa_i1
        },
        490: {
            1: fa_h1,
            2: fa_i1
        },
        491: {
            1: fa_h1,
            2: fa_i1
        },
        492: {
            1: fa_h1,
            2: fa_i1
        },
        493: {
            1: fa_h1,
            2: fa_i1
        },
        494: {
            1: fa_h1,
            2: fa_i1
        },
        495: {
            1: fa_h1,
            2: fa_i1
        },
        496: {
            1: fa_h1,
            2: fa_i1
        },
        497: {
            1: fa_h1,
            2: fa_i1
        },
        498: {
            1: fa_h1,
            2: fa_i1
        },
        499: {
            1: fa_h1,
            2: fa_i1
        },
        500: {
            1: fa_h1,
            2: fa_i1
        },
        501: {
            1: fa_h1,
            2: fa_i1
        },
        502: {
            1: fa_h1,
            2: fa_i1
        },
        503: {
            1: fa_h1,
            2: fa_i1
        },
        504: {
            1: fa_h1,
            2: fa_i1
        },
        505: {
            1: fa_h1,
            2: fa_i1
        },
        506: {
            1: fa_h1,
            2: fa_i1
        },
        507: {
            1: fa_h1,
            2: fa_i1
        },
        508: {
            1: fa_h1,
            2: fa_i1
        },
        509: {
            1: fa_h1,
            2: fa_i1
        },
        510: {
            1: fa_h1,
            2: fa_i1
        },
        511: {
            1: fa_h1,
            2: fa_i1
        },
        566: {
            1: fa_h1,
            2: fa_i1
        },
        567: {
            1: fa_h1,
            2: fa_i1
        },
        568: {
            1: fa_h1,
            2: fa_i1
        },
        569: {
            1: fa_h1,
            2: fa_i1
        },
        570: {
            1: fa_h1,
            2: fa_i1
        },
        571: {
            1: fa_h1,
            2: fa_i1
        },
        572: {
            1: fa_h1,
            2: fa_i1
        },
        573: {
            1: fa_h1,
            2: fa_i1
        },
        574: {
            1: fa_h1,
            2: fa_i1
        },
        575: {
            1: fa_h1,
            2: fa_i1
        },
        576: {
            1: fa_h1,
            2: fa_i1
        },
        577: {
            1: fa_h1,
            2: fa_i1
        },
        578: {
            1: fa_h1,
            2: fa_i1
        },
        579: {
            1: fa_h1,
            2: fa_i1
        },
        580: {
            1: fa_h1,
            2: fa_i1
        },
        581: {
            1: fa_h1,
            2: fa_i1
        },
        582: {
            1: fa_h1,
            2: fa_i1
        },
        583: {
            1: fa_h1,
            2: fa_i1
        },
        584: {
            1: fa_h1,
            2: fa_i1
        },
        585: {
            1: fa_h1,
            2: fa_i1
        },
        586: {
            1: fa_h1,
            2: fa_i1
        },
        587: {
            1: fa_h1,
            2: fa_i1
        },
        588: {
            1: fa_h1,
            2: fa_i1
        },
        589: {
            1: fa_h1,
            2: fa_i1
        },
        590: {
            1: fa_h1,
            2: fa_i1
        },
        591: {
            1: fa_h1,
            2: fa_i1
        },
        592: {
            1: fa_h1,
            2: fa_i1
        },
        593: {
            1: fa_h1,
            2: fa_i1
        },
        594: {
            1: fa_h1,
            2: fa_i1
        },
        595: {
            1: fa_h1,
            2: fa_i1
        },
        596: {
            1: fa_h1,
            2: fa_i1
        },
        597: {
            1: fa_h1,
            2: fa_i1
        },
        598: {
            1: fa_h1,
            2: fa_i1
        },
        599: {
            1: fa_h1,
            2: fa_i1
        },
        600: {
            1: fa_h1,
            2: fa_i1
        },
        601: {
            1: fa_h1,
            2: fa_i1
        },
        602: {
            1: fa_h1,
            2: fa_i1
        },
        83: {
            1: fa_f1,
            2: fa_g1
        },
        84: {
            1: fa_f1,
            2: fa_g1
        },
        85: {
            1: fa_f1,
            2: fa_g1
        },
        86: {
            1: fa_f1,
            2: fa_g1
        },
        87: {
            1: fa_f1,
            2: fa_g1
        },
        88: {
            1: fa_f1,
            2: fa_g1
        },
        89: {
            1: fa_f1,
            2: fa_g1
        },
        90: {
            1: fa_f1,
            2: fa_g1
        },
        91: {
            1: fa_f1,
            2: fa_g1
        },
        92: {
            1: fa_f1,
            2: fa_g1
        },
        93: {
            1: fa_f1,
            2: fa_g1
        },
        94: {
            1: fa_f1,
            2: fa_g1
        },
        95: {
            1: fa_f1,
            2: fa_g1
        },
        96: {
            1: fa_f1,
            2: fa_g1
        },
        97: {
            1: fa_f1,
            2: fa_g1
        },
        98: {
            1: fa_f1,
            2: fa_g1
        },
        99: {
            1: fa_f1,
            2: fa_g1
        },
        74: {
            1: fa_b1,
            2: fa_c1
        },
        349: {
            1: fa_d1,
            2: fa_e1
        },
        254: {
            1: fa_d1,
            2: fa_e1
        },
        403: {
            1: fa_x1,
            2: fa_y1
        },
        21: {
            1: fa_b1,
            2: fa_c1
        },
        22: {
            1: fa_b1,
            2: fa_c1
        },
        23: {
            1: fa_b1,
            2: fa_c1
        },
        24: {
            1: fa_b1,
            2: fa_c1
        },
        25: {
            1: fa_b1,
            2: fa_c1
        },
        26: {
            1: fa_b1,
            2: fa_c1
        },
        27: {
            1: fa_b1,
            2: fa_c1
        },
        28: {
            1: fa_b1,
            2: fa_c1
        },
        29: {
            1: fa_b1,
            2: fa_c1
        },
        30: {
            1: fa_b1,
            2: fa_c1
        },
        31: {
            1: fa_b1,
            2: fa_c1
        },
        32: {
            1: fa_b1,
            2: fa_c1
        },
        33: {
            1: fa_b1,
            2: fa_c1
        },
        34: {
            1: fa_b1,
            2: fa_c1
        },
        35: {
            1: fa_b1,
            2: fa_c1
        },
        36: {
            1: fa_b1,
            2: fa_c1
        },
        37: {
            1: fa_b1,
            2: fa_c1
        },
        38: {
            1: fa_b1,
            2: fa_c1
        },
        39: {
            1: fa_b1,
            2: fa_c1
        },
        40: {
            1: fa_b1,
            2: fa_c1
        },
        41: {
            1: fa_b1,
            2: fa_c1
        },
        42: {
            1: fa_b1,
            2: fa_c1
        },
        43: {
            1: fa_b1,
            2: fa_c1
        },
        44: {
            1: fa_b1,
            2: fa_c1
        },
        45: {
            1: fa_b1,
            2: fa_c1
        },
        46: {
            1: fa_b1,
            2: fa_c1
        },
        47: {
            1: fa_b1,
            2: fa_c1
        },
        48: {
            1: fa_b1,
            2: fa_c1
        },
        49: {
            1: fa_b1,
            2: fa_c1
        },
        50: {
            1: fa_b1,
            2: fa_c1
        },
        51: {
            1: fa_b1,
            2: fa_c1
        },
        52: {
            1: fa_b1,
            2: fa_c1
        },
        53: {
            1: fa_b1,
            2: fa_c1
        },
        54: {
            1: fa_b1,
            2: fa_c1
        },
        55: {
            1: fa_b1,
            2: fa_c1
        },
        56: {
            1: fa_b1,
            2: fa_c1
        },
        57: {
            1: fa_b1,
            2: fa_c1
        },
        195: {
            1: fa_d1,
            2: fa_e1
        },
        196: {
            1: fa_d1,
            2: fa_e1
        },
        197: {
            1: fa_d1,
            2: fa_e1
        },
        198: {
            1: fa_d1,
            2: fa_e1
        },
        199: {
            1: fa_d1,
            2: fa_e1
        },
        200: {
            1: fa_d1,
            2: fa_e1
        },
        201: {
            1: fa_d1,
            2: fa_e1
        },
        202: {
            1: fa_d1,
            2: fa_e1
        },
        203: {
            1: fa_d1,
            2: fa_e1
        },
        204: {
            1: fa_d1,
            2: fa_e1
        },
        205: {
            1: fa_d1,
            2: fa_e1
        },
        206: {
            1: fa_d1,
            2: fa_e1
        },
        207: {
            1: fa_d1,
            2: fa_e1
        },
        208: {
            1: fa_d1,
            2: fa_e1
        },
        209: {
            1: fa_d1,
            2: fa_e1
        },
        210: {
            1: fa_d1,
            2: fa_e1
        },
        211: {
            1: fa_d1,
            2: fa_e1
        },
        212: {
            1: fa_d1,
            2: fa_e1
        },
        213: {
            1: fa_d1,
            2: fa_e1
        },
        214: {
            1: fa_d1,
            2: fa_e1
        },
        215: {
            1: fa_d1,
            2: fa_e1
        },
        216: {
            1: fa_d1,
            2: fa_e1
        },
        217: {
            1: fa_d1,
            2: fa_e1
        },
        218: {
            1: fa_d1,
            2: fa_e1
        },
        219: {
            1: fa_d1,
            2: fa_e1
        },
        220: {
            1: fa_d1,
            2: fa_e1
        },
        221: {
            1: fa_d1,
            2: fa_e1
        },
        222: {
            1: fa_d1,
            2: fa_e1
        },
        223: {
            1: fa_d1,
            2: fa_e1
        },
        224: {
            1: fa_d1,
            2: fa_e1
        },
        225: {
            1: fa_d1,
            2: fa_e1
        },
        226: {
            1: fa_d1,
            2: fa_e1
        },
        227: {
            1: fa_d1,
            2: fa_e1
        },
        228: {
            1: fa_d1,
            2: fa_e1
        },
        229: {
            1: fa_d1,
            2: fa_e1
        },
        230: {
            1: fa_d1,
            2: fa_e1
        },
        231: {
            1: fa_d1,
            2: fa_e1
        },
        475: {
            1: fa_h1,
            2: fa_i1
        },
        476: {
            1: fa_h1,
            2: fa_i1
        },
        477: {
            1: fa_h1,
            2: fa_i1
        },
        478: {
            1: fa_h1,
            2: fa_i1
        },
        479: {
            1: fa_h1,
            2: fa_i1
        },
        480: {
            1: fa_h1,
            2: fa_i1
        },
        443: {
            1: fa_j1,
            2: fa_k1
        },
        608: {
            1: fa_l1,
            2: fa_m1
        }
    },
    15: {
        443: {
            1: fa_j1,
            2: fa_k1
        },
        608: {
            1: fa_l1,
            2: fa_m1
        }
    },
    2: {
        73: {
            1: fa_b1,
            2: fa_c1
        },
        318: {
            1: fa_d1,
            2: fa_e1
        },
        21: {
            1: fa_b1,
            2: fa_c1
        },
        22: {
            1: fa_b1,
            2: fa_c1
        },
        23: {
            1: fa_b1,
            2: fa_c1
        },
        24: {
            1: fa_b1,
            2: fa_c1
        },
        25: {
            1: fa_b1,
            2: fa_c1
        },
        26: {
            1: fa_b1,
            2: fa_c1
        },
        27: {
            1: fa_b1,
            2: fa_c1
        },
        195: {
            1: fa_d1,
            2: fa_e1
        },
        196: {
            1: fa_d1,
            2: fa_e1
        },
        197: {
            1: fa_d1,
            2: fa_e1
        },
        198: {
            1: fa_d1,
            2: fa_e1
        },
        199: {
            1: fa_d1,
            2: fa_e1
        },
        200: {
            1: fa_d1,
            2: fa_e1
        },
        201: {
            1: fa_d1,
            2: fa_e1
        },
        352: {
            1: fa_d1,
            2: fa_e1
        },
        102: {
            1: fa_f1,
            2: fa_g1
        },
        403: {
            1: fa_x1,
            2: fa_y1
        },
        138: {
            1: fa_d1,
            2: fa_e1
        },
        139: {
            1: fa_d1,
            2: fa_e1
        },
        140: {
            1: fa_d1,
            2: fa_e1
        },
        141: {
            1: fa_d1,
            2: fa_e1
        },
        142: {
            1: fa_d1,
            2: fa_e1
        },
        143: {
            1: fa_d1,
            2: fa_e1
        },
        144: {
            1: fa_d1,
            2: fa_e1
        },
        182: {
            1: fa_d1,
            2: fa_e1
        },
        183: {
            1: fa_d1,
            2: fa_e1
        },
        184: {
            1: fa_d1,
            2: fa_e1
        },
        185: {
            1: fa_d1,
            2: fa_e1
        },
        186: {
            1: fa_d1,
            2: fa_e1
        },
        187: {
            1: fa_d1,
            2: fa_e1
        },
        188: {
            1: fa_d1,
            2: fa_e1
        },
        566: {
            1: fa_h1,
            2: fa_i1
        },
        567: {
            1: fa_h1,
            2: fa_i1
        },
        568: {
            1: fa_h1,
            2: fa_i1
        },
        569: {
            1: fa_h1,
            2: fa_i1
        },
        570: {
            1: fa_h1,
            2: fa_i1
        },
        571: {
            1: fa_h1,
            2: fa_i1
        },
        572: {
            1: fa_h1,
            2: fa_i1
        },
        366: {
            1: fa_x1,
            2: fa_y1
        },
        367: {
            1: fa_x1,
            2: fa_y1
        },
        368: {
            1: fa_x1,
            2: fa_y1
        },
        369: {
            1: fa_x1,
            2: fa_y1
        },
        370: {
            1: fa_x1,
            2: fa_y1
        },
        371: {
            1: fa_x1,
            2: fa_y1
        },
        372: {
            1: fa_x1,
            2: fa_y1
        },
        122: {
            1: fa_l1,
            2: fa_m1
        },
        123: {
            1: fa_l1,
            2: fa_m1
        },
        124: {
            1: fa_l1,
            2: fa_m1
        },
        125: {
            1: fa_l1,
            2: fa_m1
        },
        126: {
            1: fa_l1,
            2: fa_m1
        },
        127: {
            1: fa_l1,
            2: fa_m1
        },
        128: {
            1: fa_l1,
            2: fa_m1
        },
        129: {
            1: fa_l1,
            2: fa_m1
        },
        130: {
            1: fa_l1,
            2: fa_m1
        },
        131: {
            1: fa_l1,
            2: fa_m1
        },
        132: {
            1: fa_l1,
            2: fa_m1
        },
        133: {
            1: fa_l1,
            2: fa_m1
        },
        134: {
            1: fa_l1,
            2: fa_m1
        },
        135: {
            1: fa_l1,
            2: fa_m1
        },
        872: {
            1: fa_s3,
            2: fa_u6,
            3: fa_v6,
            4: fa_w6,
            5: fa_x6,
            6: fa_z11
        },
        873: {
            1: fa_s3,
            2: fa_u6,
            3: fa_v6,
            4: fa_w6,
            5: fa_x6,
            6: fa_z11
        },
        874: {
            1: fa_s3,
            2: fa_u6,
            3: fa_v6,
            4: fa_w6,
            5: fa_x6,
            6: fa_z11
        },
        875: {
            1: fa_s3,
            2: fa_u6,
            3: fa_v6,
            4: fa_w6,
            5: fa_x6,
            6: fa_z11
        },
        876: {
            1: fa_s3,
            2: fa_u6,
            3: fa_v6,
            4: fa_w6,
            5: fa_x6,
            6: fa_z11
        },
        877: {
            1: fa_s3,
            2: fa_u6,
            3: fa_v6,
            4: fa_w6,
            5: fa_x6,
            6: fa_z11
        },
        878: {
            1: fa_s3,
            2: fa_u6,
            3: fa_v6,
            4: fa_w6,
            5: fa_x6,
            6: fa_z11
        },
        616: {
            1: fa_h1,
            2: fa_i1
        },
        617: {
            1: fa_h1,
            2: fa_i1
        },
        618: {
            1: fa_h1,
            2: fa_i1
        },
        619: {
            1: fa_h1,
            2: fa_i1
        },
        620: {
            1: fa_h1,
            2: fa_i1
        },
        621: {
            1: fa_h1,
            2: fa_i1
        },
        622: {
            1: fa_h1,
            2: fa_i1
        },
        894: {
            1: fa_a12,
            2: fa_b12,
            3: fa_c12,
            4: fa_d12
        },
        895: {
            1: fa_a12,
            2: fa_b12,
            3: fa_c12,
            4: fa_d12
        },
        896: {
            1: fa_a12,
            2: fa_b12,
            3: fa_c12,
            4: fa_d12
        },
        897: {
            1: fa_a12,
            2: fa_b12,
            3: fa_c12,
            4: fa_d12
        },
        898: {
            1: fa_a12,
            2: fa_b12,
            3: fa_c12,
            4: fa_d12
        },
        899: {
            1: fa_a12,
            2: fa_b12,
            3: fa_c12,
            4: fa_d12
        },
        900: {
            1: fa_a12,
            2: fa_b12,
            3: fa_c12,
            4: fa_d12
        },
        443: {
            1: fa_j1,
            2: fa_k1
        },
        608: {
            1: fa_l1,
            2: fa_m1
        },
        83: {
            1: fa_f1,
            2: fa_g1
        },
        84: {
            1: fa_f1,
            2: fa_g1
        },
        85: {
            1: fa_f1,
            2: fa_g1
        },
        86: {
            1: fa_f1,
            2: fa_g1
        },
        87: {
            1: fa_f1,
            2: fa_g1
        },
        88: {
            1: fa_f1,
            2: fa_g1
        },
        89: {
            1: fa_f1,
            2: fa_g1
        },
        257: {
            1: fa_d1,
            2: fa_e1
        },
        307: {
            1: fa_d1,
            2: fa_e1
        },
        752: {
            1: fa_u1,
            2: fa_v1,
            3: fa_w1,
            4: fa_t1,
            5: fa_q1,
            6: fa_o1
        },
        753: {
            1: fa_i3,
            2: fa_j3,
            3: fa_k3,
            4: fa_l3,
            5: fa_g3,
            6: fa_c3,
            7: fa_z2,
            8: fa_v2
        }
    },
    6: {
        553: {
            1: fa_l1,
            2: fa_m1
        },
        339: {
            1: fa_d1,
            2: fa_e1
        },
        547: {
            1: fa_l1,
            2: fa_m1
        },
        138: {
            1: fa_d1,
            2: fa_e1
        },
        139: {
            1: fa_d1,
            2: fa_e1
        },
        140: {
            1: fa_d1,
            2: fa_e1
        },
        141: {
            1: fa_d1,
            2: fa_e1
        },
        142: {
            1: fa_d1,
            2: fa_e1
        },
        182: {
            1: fa_d1,
            2: fa_e1
        },
        183: {
            1: fa_d1,
            2: fa_e1
        },
        184: {
            1: fa_d1,
            2: fa_e1
        },
        185: {
            1: fa_d1,
            2: fa_e1
        },
        186: {
            1: fa_d1,
            2: fa_e1
        },
        83: {
            1: fa_f1,
            2: fa_g1
        },
        84: {
            1: fa_f1,
            2: fa_g1
        },
        85: {
            1: fa_f1,
            2: fa_g1
        },
        86: {
            1: fa_f1,
            2: fa_g1
        },
        87: {
            1: fa_f1,
            2: fa_g1
        },
        807: {
            1: fa_l6,
            2: fa_n6,
            3: fa_r6,
            4: fa_t6
        },
        636: {
            1: fa_l1,
            2: fa_m1
        },
        334: {
            1: fa_d1,
            2: fa_e1
        },
        335: {
            1: fa_d1,
            2: fa_e1
        },
        336: {
            1: fa_d1,
            2: fa_e1
        },
        337: {
            1: fa_d1,
            2: fa_e1
        },
        906: {
            1: fa_g7,
            2: fa_h7,
            3: fa_i7,
            4: fa_j7
        },
        907: {
            1: fa_g7,
            2: fa_h7,
            3: fa_i7,
            4: fa_j7
        },
        908: {
            1: fa_g7,
            2: fa_h7,
            3: fa_i7,
            4: fa_j7
        },
        909: {
            1: fa_g7,
            2: fa_h7,
            3: fa_i7,
            4: fa_j7
        },
        300: {
            1: fa_d1,
            2: fa_e1
        },
        301: {
            1: fa_d1,
            2: fa_e1
        },
        302: {
            1: fa_d1,
            2: fa_e1
        },
        303: {
            1: fa_d1,
            2: fa_e1
        },
        304: {
            1: fa_d1,
            2: fa_e1
        },
        310: {
            1: fa_d1,
            2: fa_e1
        },
        311: {
            1: fa_d1,
            2: fa_e1
        },
        312: {
            1: fa_d1,
            2: fa_e1
        },
        313: {
            1: fa_d1,
            2: fa_e1
        },
        314: {
            1: fa_d1,
            2: fa_e1
        },
        554: {
            1: fa_l1,
            2: fa_m1
        },
        555: {
            1: fa_l1,
            2: fa_m1
        },
        556: {
            1: fa_l1,
            2: fa_m1
        },
        557: {
            1: fa_l1,
            2: fa_m1
        },
        558: {
            1: fa_l1,
            2: fa_m1
        },
        517: {
            1: fa_l1,
            2: fa_m1
        },
        518: {
            1: fa_l1,
            2: fa_m1
        },
        519: {
            1: fa_l1,
            2: fa_m1
        },
        520: {
            1: fa_l1,
            2: fa_m1
        },
        521: {
            1: fa_l1,
            2: fa_m1
        },
        561: {
            1: fa_l1,
            2: fa_m1
        },
        562: {
            1: fa_l1,
            2: fa_m1
        },
        563: {
            1: fa_l1,
            2: fa_m1
        },
        564: {
            1: fa_l1,
            2: fa_m1
        },
        565: {
            1: fa_l1,
            2: fa_m1
        },
        73: {
            1: fa_b1,
            2: fa_c1
        },
        318: {
            1: fa_d1,
            2: fa_e1
        },
        21: {
            1: fa_b1,
            2: fa_c1
        },
        22: {
            1: fa_b1,
            2: fa_c1
        },
        23: {
            1: fa_b1,
            2: fa_c1
        },
        24: {
            1: fa_b1,
            2: fa_c1
        },
        25: {
            1: fa_b1,
            2: fa_c1
        },
        195: {
            1: fa_d1,
            2: fa_e1
        },
        196: {
            1: fa_d1,
            2: fa_e1
        },
        197: {
            1: fa_d1,
            2: fa_e1
        },
        198: {
            1: fa_d1,
            2: fa_e1
        },
        199: {
            1: fa_d1,
            2: fa_e1
        },
        352: {
            1: fa_d1,
            2: fa_e1
        },
        748: {
            1: fa_n1,
            2: fa_o1,
            3: fa_p1,
            4: fa_q1,
            5: fa_r1,
            6: fa_s1,
            7: fa_t1,
            8: fa_u1,
            9: fa_v1,
            10: fa_w1
        },
        102: {
            1: fa_f1,
            2: fa_g1
        },
        403: {
            1: fa_x1,
            2: fa_y1
        },
        903: {
            1: fa_e12,
            2: fa_f12,
            3: fa_g12,
            4: fa_h12,
            5: fa_i12,
            6: fa_j12,
            7: fa_k12,
            8: fa_l12
        },
        445: {
            1: fa_h1,
            2: fa_i1
        },
        754: {
            1: fa_r9,
            2: fa_s9,
            3: fa_e3,
            4: fa_m12,
            5: fa_e7,
            6: fa_n12,
            7: fa_t9,
            8: fa_u9,
            9: fa_o12,
            10: fa_p12,
            11: fa_q12,
            12: fa_r12,
            13: fa_s12,
            14: fa_t12
        },
        755: {
            1: fa_r9,
            2: fa_s9,
            3: fa_e3,
            4: fa_m12,
            5: fa_e7,
            6: fa_n12,
            7: fa_t9,
            8: fa_u9,
            9: fa_o12,
            10: fa_p12,
            11: fa_q12,
            12: fa_r12,
            13: fa_s12,
            14: fa_t12
        },
        756: {
            1: fa_r9,
            2: fa_s9,
            3: fa_e3,
            4: fa_m12,
            5: fa_e7,
            6: fa_n12,
            7: fa_t9,
            8: fa_u9,
            9: fa_o12,
            10: fa_p12,
            11: fa_q12,
            12: fa_r12,
            13: fa_s12,
            14: fa_t12
        },
        757: {
            1: fa_r9,
            2: fa_s9,
            3: fa_e3,
            4: fa_m12,
            5: fa_e7,
            6: fa_n12,
            7: fa_t9,
            8: fa_u9,
            9: fa_o12,
            10: fa_p12,
            11: fa_q12,
            12: fa_r12,
            13: fa_s12,
            14: fa_t12
        },
        758: {
            1: fa_r9,
            2: fa_s9,
            3: fa_e3,
            4: fa_m12,
            5: fa_e7,
            6: fa_n12,
            7: fa_t9,
            8: fa_u9,
            9: fa_o12,
            10: fa_p12,
            11: fa_q12,
            12: fa_r12,
            13: fa_s12,
            14: fa_t12
        },
        452: {
            1: fa_l1,
            2: fa_m1
        },
        453: {
            1: fa_l1,
            2: fa_m1
        },
        454: {
            1: fa_l1,
            2: fa_m1
        },
        566: {
            1: fa_h1,
            2: fa_i1
        },
        567: {
            1: fa_h1,
            2: fa_i1
        },
        568: {
            1: fa_h1,
            2: fa_i1
        },
        569: {
            1: fa_h1,
            2: fa_i1
        },
        570: {
            1: fa_h1,
            2: fa_i1
        },
        366: {
            1: fa_x1,
            2: fa_y1
        },
        367: {
            1: fa_x1,
            2: fa_y1
        },
        368: {
            1: fa_x1,
            2: fa_y1
        },
        369: {
            1: fa_x1,
            2: fa_y1
        },
        370: {
            1: fa_x1,
            2: fa_y1
        },
        522: {
            1: fa_h1,
            2: fa_i1
        },
        627: {
            1: fa_l1,
            2: fa_m1
        },
        628: {
            1: fa_l1,
            2: fa_m1
        },
        629: {
            1: fa_l1,
            2: fa_m1
        },
        630: {
            1: fa_l1,
            2: fa_m1
        },
        631: {
            1: fa_l1,
            2: fa_m1
        },
        632: {
            1: fa_l1,
            2: fa_m1
        },
        190: {
            1: fa_d1,
            2: fa_e1
        },
        191: {
            1: fa_d1,
            2: fa_e1
        },
        192: {
            1: fa_d1,
            2: fa_e1
        },
        193: {
            1: fa_d1,
            2: fa_e1
        },
        194: {
            1: fa_d1,
            2: fa_e1
        },
        759: {
            1: fa_u12,
            2: fa_v12,
            3: fa_w12,
            4: fa_x12,
            5: fa_y12,
            6: fa_s12,
            7: fa_u10,
            8: fa_z12,
            9: fa_a13,
            10: fa_b13,
            11: fa_c13,
            12: fa_d13,
            13: fa_n12,
            14: fa_w10
        },
        760: {
            1: fa_u12,
            2: fa_v12,
            3: fa_w12,
            4: fa_x12,
            5: fa_y12,
            6: fa_s12,
            7: fa_u10,
            8: fa_z12,
            9: fa_a13,
            10: fa_b13,
            11: fa_c13,
            12: fa_d13,
            13: fa_n12,
            14: fa_w10
        },
        761: {
            1: fa_u12,
            2: fa_v12,
            3: fa_w12,
            4: fa_x12,
            5: fa_y12,
            6: fa_s12,
            7: fa_u10,
            8: fa_z12,
            9: fa_a13,
            10: fa_b13,
            11: fa_c13,
            12: fa_d13,
            13: fa_n12,
            14: fa_w10
        },
        762: {
            1: fa_u12,
            2: fa_v12,
            3: fa_w12,
            4: fa_x12,
            5: fa_y12,
            6: fa_s12,
            7: fa_u10,
            8: fa_z12,
            9: fa_a13,
            10: fa_b13,
            11: fa_c13,
            12: fa_d13,
            13: fa_n12,
            14: fa_w10
        },
        763: {
            1: fa_u12,
            2: fa_v12,
            3: fa_w12,
            4: fa_x12,
            5: fa_y12,
            6: fa_s12,
            7: fa_u10,
            8: fa_z12,
            9: fa_a13,
            10: fa_b13,
            11: fa_c13,
            12: fa_d13,
            13: fa_n12,
            14: fa_w10
        },
        768: {
            1: fa_j6,
            2: fa_e13,
            3: fa_f13,
            4: fa_g13,
            5: fa_h13,
            6: fa_c2,
            7: fa_i13
        },
        769: {
            1: fa_j6,
            2: fa_e13,
            3: fa_f13,
            4: fa_g13,
            5: fa_h13,
            6: fa_c2,
            7: fa_i13
        },
        770: {
            1: fa_j6,
            2: fa_e13,
            3: fa_f13,
            4: fa_g13,
            5: fa_h13,
            6: fa_c2,
            7: fa_i13
        },
        771: {
            1: fa_j6,
            2: fa_e13,
            3: fa_f13,
            4: fa_g13,
            5: fa_h13,
            6: fa_c2,
            7: fa_i13
        },
        772: {
            1: fa_j6,
            2: fa_e13,
            3: fa_f13,
            4: fa_g13,
            5: fa_h13,
            6: fa_c2,
            7: fa_i13
        },
        603: {
            1: fa_h1,
            2: fa_i1
        },
        604: {
            1: fa_h1,
            2: fa_i1
        },
        605: {
            1: fa_h1,
            2: fa_i1
        },
        606: {
            1: fa_h1,
            2: fa_i1
        },
        607: {
            1: fa_h1,
            2: fa_i1
        },
        257: {
            1: fa_d1,
            2: fa_e1
        },
        307: {
            1: fa_d1,
            2: fa_e1
        },
        696: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        333: {
            1: fa_d1,
            2: fa_e1
        },
        341: {
            1: fa_d1,
            2: fa_e1
        },
        427: {
            1: fa_l1,
            2: fa_m1
        },
        536: {
            1: fa_l1,
            2: fa_m1
        },
        905: {
            1: fa_g7,
            2: fa_h7,
            3: fa_i7,
            4: fa_j7
        },
        320: {
            1: fa_d1,
            2: fa_e1
        },
        514: {
            1: fa_h1,
            2: fa_i1
        },
        516: {
            1: fa_h1,
            2: fa_i1
        },
        305: {
            1: fa_d1,
            2: fa_e1
        },
        315: {
            1: fa_d1,
            2: fa_e1
        },
        523: {
            1: fa_l1,
            2: fa_m1
        },
        299: {
            1: fa_d1,
            2: fa_e1
        },
        309: {
            1: fa_d1,
            2: fa_e1
        },
        697: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        298: {
            1: fa_d1,
            2: fa_e1
        },
        308: {
            1: fa_d1,
            2: fa_e1
        },
        515: {
            1: fa_h1,
            2: fa_i1
        },
        549: {
            1: fa_l1,
            2: fa_m1
        },
        548: {
            1: fa_l1,
            2: fa_m1
        },
        443: {
            1: fa_j1,
            2: fa_k1
        },
        608: {
            1: fa_l1,
            2: fa_m1
        },
        550: {
            1: fa_j13,
            2: fa_i1
        },
        551: {
            1: fa_h1,
            2: fa_k13
        },
        455: {
            1: fa_l1,
            2: fa_m1
        },
        456: {
            1: fa_l1,
            2: fa_m1
        },
        457: {
            1: fa_l1,
            2: fa_m1
        },
        458: {
            1: fa_l1,
            2: fa_m1
        },
        459: {
            1: fa_l1,
            2: fa_m1
        },
        460: {
            1: fa_l1,
            2: fa_m1
        },
        512: {
            1: fa_j13,
            2: fa_i1
        },
        513: {
            1: fa_h1,
            2: fa_k13
        },
        901: {
            1: fa_e12,
            2: fa_f12,
            3: fa_g12,
            4: fa_h12,
            5: fa_i12,
            6: fa_j12,
            7: fa_k12,
            8: fa_l12
        },
        902: {
            1: fa_e12,
            2: fa_f12,
            3: fa_g12,
            4: fa_h12,
            5: fa_i12,
            6: fa_j12,
            7: fa_k12,
            8: fa_l12
        },
        340: {
            1: fa_d1,
            2: fa_e1
        },
        328: {
            1: fa_d1,
            2: fa_e1
        },
        329: {
            1: fa_d1,
            2: fa_e1
        },
        342: {
            1: fa_d1,
            2: fa_e1
        },
        330: {
            1: fa_d1,
            2: fa_e1
        },
        331: {
            1: fa_d1,
            2: fa_e1
        },
        722: {
            1: fa_z9,
            2: fa_a10,
            3: fa_b10
        },
        560: {
            1: fa_l1,
            2: fa_m1
        },
        543: {
            1: fa_l1,
            2: fa_m1
        },
        544: {
            1: fa_l1,
            2: fa_m1
        },
        545: {
            1: fa_l1,
            2: fa_m1
        },
        546: {
            1: fa_l1,
            2: fa_m1
        },
        332: {
            1: fa_d1,
            2: fa_e1
        },
        559: {
            1: fa_l1,
            2: fa_m1
        },
        296: {
            1: fa_d1,
            2: fa_e1
        },
        297: {
            1: fa_d1,
            2: fa_e1
        },
        717: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        718: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        719: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        720: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        721: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        552: {
            1: fa_b1,
            2: fa_c1
        },
        76: {
            1: fa_b1,
            2: fa_c1
        },
        77: {
            1: fa_b1,
            2: fa_c1
        },
        78: {
            1: fa_b1,
            2: fa_c1
        },
        79: {
            1: fa_b1,
            2: fa_c1
        },
        80: {
            1: fa_b1,
            2: fa_c1
        },
        647: {
            1: fa_h1,
            2: fa_i1
        },
        741: {
            1: fa_l13,
            2: fa_u7,
            3: fa_m13
        },
        82: {
            1: fa_b1,
            2: fa_c1
        },
        338: {
            1: fa_d1,
            2: fa_e1
        }
    },
    17: {
        348: {
            1: fa_d1,
            2: fa_e1
        },
        443: {
            1: fa_j1,
            2: fa_k1
        },
        608: {
            1: fa_l1,
            2: fa_m1
        }
    },
    4: {
        73: {
            1: fa_b1,
            2: fa_c1
        },
        318: {
            1: fa_d1,
            2: fa_e1
        },
        21: {
            1: fa_b1,
            2: fa_c1
        },
        22: {
            1: fa_b1,
            2: fa_c1
        },
        23: {
            1: fa_b1,
            2: fa_c1
        },
        24: {
            1: fa_b1,
            2: fa_c1
        },
        25: {
            1: fa_b1,
            2: fa_c1
        },
        195: {
            1: fa_d1,
            2: fa_e1
        },
        196: {
            1: fa_d1,
            2: fa_e1
        },
        197: {
            1: fa_d1,
            2: fa_e1
        },
        198: {
            1: fa_d1,
            2: fa_e1
        },
        199: {
            1: fa_d1,
            2: fa_e1
        },
        352: {
            1: fa_d1,
            2: fa_e1
        },
        764: {
            1: fa_o1,
            2: fa_q1,
            3: fa_t1,
            4: fa_u1,
            5: fa_v1,
            6: fa_w1
        },
        102: {
            1: fa_f1,
            2: fa_g1
        },
        403: {
            1: fa_x1,
            2: fa_y1
        },
        138: {
            1: fa_d1,
            2: fa_e1
        },
        139: {
            1: fa_d1,
            2: fa_e1
        },
        140: {
            1: fa_d1,
            2: fa_e1
        },
        141: {
            1: fa_d1,
            2: fa_e1
        },
        142: {
            1: fa_d1,
            2: fa_e1
        },
        182: {
            1: fa_d1,
            2: fa_e1
        },
        183: {
            1: fa_d1,
            2: fa_e1
        },
        184: {
            1: fa_d1,
            2: fa_e1
        },
        185: {
            1: fa_d1,
            2: fa_e1
        },
        186: {
            1: fa_d1,
            2: fa_e1
        },
        366: {
            1: fa_x1,
            2: fa_y1
        },
        367: {
            1: fa_x1,
            2: fa_y1
        },
        368: {
            1: fa_x1,
            2: fa_y1
        },
        369: {
            1: fa_x1,
            2: fa_y1
        },
        370: {
            1: fa_x1,
            2: fa_y1
        },
        566: {
            1: fa_h1,
            2: fa_i1
        },
        567: {
            1: fa_h1,
            2: fa_i1
        },
        568: {
            1: fa_h1,
            2: fa_i1
        },
        569: {
            1: fa_h1,
            2: fa_i1
        },
        570: {
            1: fa_h1,
            2: fa_i1
        },
        74: {
            1: fa_b1,
            2: fa_c1
        },
        923: {
            1: fa_s3,
            2: fa_u6,
            3: fa_v6,
            4: fa_w6,
            5: fa_x6,
            6: fa_y6,
            7: fa_z6,
            8: fa_a7
        },
        924: {
            1: fa_s3,
            2: fa_u6,
            3: fa_v6,
            4: fa_w6,
            5: fa_x6,
            6: fa_y6,
            7: fa_z6,
            8: fa_a7
        },
        925: {
            1: fa_s3,
            2: fa_u6,
            3: fa_v6,
            4: fa_w6,
            5: fa_x6,
            6: fa_y6,
            7: fa_z6,
            8: fa_a7
        },
        926: {
            1: fa_s3,
            2: fa_u6,
            3: fa_v6,
            4: fa_w6,
            5: fa_x6,
            6: fa_y6,
            7: fa_z6,
            8: fa_a7
        },
        927: {
            1: fa_s3,
            2: fa_u6,
            3: fa_v6,
            4: fa_w6,
            5: fa_x6,
            6: fa_y6,
            7: fa_z6,
            8: fa_a7
        },
        929: {
            1: fa_s3,
            2: fa_b7,
            3: fa_c7,
            4: fa_d7,
            5: fa_a7
        },
        930: {
            1: fa_s3,
            2: fa_b7,
            3: fa_c7,
            4: fa_d7,
            5: fa_a7
        },
        931: {
            1: fa_s3,
            2: fa_b7,
            3: fa_c7,
            4: fa_d7,
            5: fa_a7
        },
        932: {
            1: fa_s3,
            2: fa_b7,
            3: fa_c7,
            4: fa_d7,
            5: fa_a7
        },
        933: {
            1: fa_s3,
            2: fa_b7,
            3: fa_c7,
            4: fa_d7,
            5: fa_a7
        },
        845: {
            1: fa_t1,
            2: fa_e7,
            3: fa_f7,
            4: fa_y1
        },
        846: {
            1: fa_t1,
            2: fa_e7,
            3: fa_f7,
            4: fa_y1
        },
        847: {
            1: fa_t1,
            2: fa_e7,
            3: fa_f7,
            4: fa_y1
        },
        848: {
            1: fa_t1,
            2: fa_e7,
            3: fa_f7,
            4: fa_y1
        },
        849: {
            1: fa_t1,
            2: fa_e7,
            3: fa_f7,
            4: fa_y1
        },
        918: {
            1: fa_t1,
            2: fa_e7,
            3: fa_f7,
            4: fa_x1
        },
        919: {
            1: fa_t1,
            2: fa_e7,
            3: fa_f7,
            4: fa_x1
        },
        920: {
            1: fa_t1,
            2: fa_e7,
            3: fa_f7,
            4: fa_x1
        },
        921: {
            1: fa_t1,
            2: fa_e7,
            3: fa_f7,
            4: fa_x1
        },
        922: {
            1: fa_t1,
            2: fa_e7,
            3: fa_f7,
            4: fa_x1
        },
        83: {
            1: fa_f1,
            2: fa_g1
        },
        84: {
            1: fa_f1,
            2: fa_g1
        },
        85: {
            1: fa_f1,
            2: fa_g1
        },
        86: {
            1: fa_f1,
            2: fa_g1
        },
        87: {
            1: fa_f1,
            2: fa_g1
        },
        905: {
            1: fa_g7,
            2: fa_h7,
            3: fa_i7,
            4: fa_j7
        },
        906: {
            1: fa_g7,
            2: fa_h7,
            3: fa_i7,
            4: fa_j7
        },
        907: {
            1: fa_g7,
            2: fa_h7,
            3: fa_i7,
            4: fa_j7
        },
        908: {
            1: fa_g7,
            2: fa_h7,
            3: fa_i7,
            4: fa_j7
        },
        909: {
            1: fa_g7,
            2: fa_h7,
            3: fa_i7,
            4: fa_j7
        },
        807: {
            1: fa_l6,
            2: fa_n6,
            3: fa_r6,
            4: fa_t6
        },
        319: {
            1: fa_d1,
            2: fa_e1
        },
        320: {
            1: fa_d1,
            2: fa_e1
        },
        912: {
            1: fa_k7,
            2: fa_l7,
            3: fa_m7,
            4: fa_n7,
            5: fa_o7,
            6: fa_p7
        },
        913: {
            1: fa_k7,
            2: fa_l7,
            3: fa_m7,
            4: fa_n7,
            5: fa_o7,
            6: fa_p7
        },
        914: {
            1: fa_k7,
            2: fa_l7,
            3: fa_m7,
            4: fa_n7,
            5: fa_o7,
            6: fa_p7
        },
        915: {
            1: fa_k7,
            2: fa_l7,
            3: fa_m7,
            4: fa_n7,
            5: fa_o7,
            6: fa_p7
        },
        916: {
            1: fa_k7,
            2: fa_l7,
            3: fa_m7,
            4: fa_n7,
            5: fa_o7,
            6: fa_p7
        },
        443: {
            1: fa_j1,
            2: fa_k1
        },
        608: {
            1: fa_l1,
            2: fa_m1
        },
        257: {
            1: fa_d1,
            2: fa_e1
        },
        307: {
            1: fa_d1,
            2: fa_e1
        },
        362: {
            1: fa_x1,
            2: fa_y1
        },
        363: {
            1: fa_x1,
            2: fa_y1
        },
        364: {
            1: fa_x1,
            2: fa_y1
        },
        365: {
            1: fa_x1,
            2: fa_y1
        },
        17: {
            1: fa_b1,
            2: fa_c1
        },
        18: {
            1: fa_b1,
            2: fa_c1
        },
        19: {
            1: fa_b1,
            2: fa_c1
        },
        20: {
            1: fa_b1,
            2: fa_c1
        },
        176: {
            1: fa_d1,
            2: fa_e1
        },
        177: {
            1: fa_d1,
            2: fa_e1
        },
        178: {
            1: fa_d1,
            2: fa_e1
        },
        179: {
            1: fa_d1,
            2: fa_e1
        },
        358: {
            1: fa_x1,
            2: fa_y1
        },
        359: {
            1: fa_x1,
            2: fa_y1
        },
        360: {
            1: fa_x1,
            2: fa_y1
        },
        361: {
            1: fa_x1,
            2: fa_y1
        },
        13: {
            1: fa_b1,
            2: fa_c1
        },
        14: {
            1: fa_b1,
            2: fa_c1
        },
        15: {
            1: fa_b1,
            2: fa_c1
        },
        16: {
            1: fa_b1,
            2: fa_c1
        },
        172: {
            1: fa_d1,
            2: fa_e1
        },
        173: {
            1: fa_d1,
            2: fa_e1
        },
        174: {
            1: fa_d1,
            2: fa_e1
        },
        175: {
            1: fa_d1,
            2: fa_e1
        },
        281: {
            1: fa_d1,
            2: fa_e1
        },
        137: {
            1: fa_d1,
            2: fa_e1
        },
        616: {
            1: fa_h1,
            2: fa_i1
        },
        617: {
            1: fa_h1,
            2: fa_i1
        },
        618: {
            1: fa_h1,
            2: fa_i1
        },
        619: {
            1: fa_h1,
            2: fa_i1
        },
        620: {
            1: fa_h1,
            2: fa_i1
        },
        891: {
            1: fa_e2,
            2: fa_f2,
            3: fa_g2,
            4: fa_h2
        },
        26: {
            1: fa_n13,
            2: fa_o13
        },
        200: {
            1: fa_d1,
            2: fa_e1
        },
        143: {
            1: fa_d1,
            2: fa_e1
        },
        187: {
            1: fa_d1,
            2: fa_e1
        },
        371: {
            1: fa_x1,
            2: fa_y1
        },
        571: {
            1: fa_h1,
            2: fa_i1
        },
        928: {
            1: fa_s3,
            2: fa_u6,
            3: fa_v6,
            4: fa_w6,
            5: fa_x6,
            6: fa_y6,
            7: fa_z6,
            8: fa_a7
        },
        934: {
            1: fa_s3,
            2: fa_b7,
            3: fa_c7,
            4: fa_d7,
            5: fa_a7
        },
        88: {
            1: fa_f1,
            2: fa_g1
        },
        910: {
            1: fa_g7,
            2: fa_h7,
            3: fa_i7,
            4: fa_j7
        },
        917: {
            1: fa_k7,
            2: fa_l7,
            3: fa_p13,
            4: fa_n7,
            5: fa_o7,
            6: fa_q13
        },
        936: {
            1: fa_k2,
            2: fa_l2,
            3: fa_m2,
            4: fa_n2,
            5: fa_o2,
            6: fa_h6
        }
    },
    8: {
        74: {
            1: fa_b1,
            2: fa_c1
        },
        349: {
            1: fa_d1,
            2: fa_e1
        },
        656: {
            1: fa_b2,
            2: fa_c2,
            3: fa_d2
        },
        698: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        256: {
            1: fa_d1,
            2: fa_e1
        },
        306: {
            1: fa_d1,
            2: fa_e1
        },
        195: {
            1: fa_d1,
            2: fa_e1
        },
        196: {
            1: fa_d1,
            2: fa_e1
        },
        197: {
            1: fa_d1,
            2: fa_e1
        },
        198: {
            1: fa_d1,
            2: fa_e1
        },
        673: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        674: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        675: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        676: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        103: {
            1: fa_f1,
            2: fa_g1
        },
        443: {
            1: fa_j1,
            2: fa_k1
        },
        608: {
            1: fa_l1,
            2: fa_m1
        }
    },
    27: {
        443: {
            1: fa_j1,
            2: fa_k1
        },
        608: {
            1: fa_l1,
            2: fa_m1
        }
    },
    28: {
        403: {
            1: fa_x1,
            2: fa_y1
        },
        615: {
            1: fa_h1,
            2: fa_i1
        },
        74: {
            1: fa_b1,
            2: fa_c1
        },
        349: {
            1: fa_d1,
            2: fa_e1
        },
        256: {
            1: fa_d1,
            2: fa_e1
        },
        306: {
            1: fa_d1,
            2: fa_e1
        },
        103: {
            1: fa_f1,
            2: fa_g1
        },
        935: {
            1: fa_t9,
            2: fa_u9,
            3: fa_o12,
            4: fa_p12,
            5: fa_q12,
            6: fa_r13,
            7: fa_r9,
            8: fa_s9,
            9: fa_e3,
            10: fa_m12,
            11: fa_e7,
            12: fa_s13
        },
        612: {
            1: fa_l1,
            2: fa_m1
        },
        613: {
            1: fa_l1,
            2: fa_m1
        },
        443: {
            1: fa_j1,
            2: fa_k1
        },
        608: {
            1: fa_l1,
            2: fa_m1
        }
    }
};
var periodConfig = {
    2: {
        208: 'Матч закончился',
        207: 'Седьмая партия',
        206: 'Шестая партия',
        205: 'Пятая партия',
        200: 'Матч еще не начался',
        203: 'Третья партия',
        202: 'Вторая партия',
        201: 'Первая партия',
        204: 'Четвертая партия'
    },
    3: {
        304: 'Матч закончился',
        303: 'Третий сет',
        302: 'Второй сет',
        301: 'Первый сет',
        300: 'Матч еще не начался'
    },
    4: {
        406: 'Матч закончился',
        403: 'Третий сет',
        402: 'Второй сет',
        401: 'Первый сет',
        400: 'Матч еще не начался',
        407: 'Золотой сет',
        405: 'Пятый сет',
        404: 'Четвертый сет'
    },
    5: {
        510: 'Десятый раунд',
        509: 'Девятый раунд',
        508: 'Восьмой раунд',
        507: 'Седьмой раунд',
        506: 'Шестой раунд',
        505: 'Пятый раунд',
        513: 'Матч закончился',
        503: 'Третий раунд',
        500: 'Матч еще не начался',
        501: 'Первый раунд',
        502: 'Второй раунд',
        511: 'Одиннадцатый раунд',
        512: 'Двенадцатый раунд',
        504: 'Четвертый раунд'
    },
    6: {
        600: 'Матч еще не начался',
        601: 'Первый сет',
        602: 'Второй сет',
        603: 'Третий сет',
        604: 'Четвертый сет',
        605: 'Пятый сет',
        606: 'Матч закончился'
    },
    7: {
        701: 'Первый тайм',
        700: 'Матч еще не начался',
        703: 'Второй тайм',
        704: 'Основное время закончилось',
        705: 'Первое дополнительное время',
        702: 'Перерыв',
        707: 'Второе дополнительное время',
        708: 'Закончилось второе дополнительное время',
        709: 'Пенальти',
        710: 'Матч закончился',
        706: 'Закончилось первое дополнительное время'
    },
    8: {
        808: 'Пауза',
        807: 'Четвёртая четверть',
        806: 'Пауза',
        805: 'Третья четверть',
        804: 'Перерыв',
        809: 'Овертайм',
        802: 'Пауза',
        801: 'Первая четверть',
        800: 'Матч еще не начался',
        810: 'Матч закончился',
        803: 'Вторая четверть'
    },
    9: {
        903: 'Второй тайм',
        902: 'Перерыв',
        901: 'Первый тайм',
        900: 'Матч еще не начался',
        904: 'Матч закончился'
    },
    12: {
        1203: 'Второй тайм',
        1202: 'Перерыв',
        1201: 'Первый тайм',
        1200: 'Матч еще не начался',
        1204: 'Матч закончился'
    },
    18: {
        1808: 'Закончился овертайм',
        1807: 'Овертайм',
        1806: 'Основное время закончилось',
        1805: 'Третий период',
        1804: 'Второй перерыв',
        1809: 'Пенальти',
        1802: 'Первый перерыв',
        1801: 'Первый период',
        1800: 'Матч еще не начался',
        1810: 'Матч закончился',
        1803: 'Второй период'
    },
    19: {
        1904: 'Основное время закончилось',
        1903: 'Второй тайм',
        1902: 'Перерыв',
        1901: 'Первый тайм',
        1900: 'Матч еще не начался',
        1905: 'Матч закончился'
    },
    20: {
        2016: 'Восьмой огневой рубеж',
        2017: 'Матч закончился',
        2000: 'Матч еще не начался',
        2001: 'Первый круг',
        2002: 'Первый огневой рубеж',
        2003: 'Второй круг',
        2004: 'Второй огневой рубеж',
        2005: 'Третий круг',
        2006: 'Третий огневой рубеж',
        2007: 'Четвертый круг',
        2008: 'Четвертый огневой рубеж',
        2009: 'Пятый круг',
        2010: 'Пятый огневой рубеж',
        2011: 'Шестой круг',
        2012: 'Шестой огневой рубеж',
        2013: 'Седьмой круг',
        2014: 'Седьмой огневой рубеж',
        2015: 'Восьмой круг'
    },
    28: {
        2801: 'Основное время',
        2802: 'Матч закончился',
        2800: 'Матч еще не начался'
    },
    29: {
        2911: '6-ая партия',
        2912: 'Перерыв',
        2913: '7-ая партия',
        2914: 'Перерыв',
        2915: '8-ая партия',
        2916: 'Перерыв',
        2917: '9-ая партия',
        2918: 'Перерыв',
        2919: '10-ая партия',
        2920: 'Перерыв',
        2921: '11-ая партия',
        2964: 'Перерыв',
        2965: '33-ья партия',
        2966: 'Перерыв',
        2967: '34-ая партия',
        2968: 'Перерыв',
        2969: '35-ая партия',
        2970: 'Перерыв',
        2971: '36-ая партия',
        2972: 'Перерыв',
        2973: '37-ая партия',
        2974: 'Матч закончился',
        2943: '22-ая партия',
        2944: 'Перерыв',
        2945: '23-ья партия',
        2946: 'Перерыв',
        2947: '24-ая партия',
        2948: 'Перерыв',
        2949: '25-ая партия',
        2950: 'Перерыв',
        2951: '26-ая партия',
        2952: 'Перерыв',
        2953: '27-ая партия',
        2954: 'Перерыв',
        2955: '28-ая партия',
        2956: 'Перерыв',
        2957: '29-ая партия',
        2958: 'Перерыв',
        2959: '30-ая партия',
        2960: 'Перерыв',
        2961: '31-ая партия',
        2962: 'Перерыв',
        2963: '32-ая партия',
        2922: 'Перерыв',
        2923: '12-ая партия',
        2924: 'Перерыв',
        2925: '13-ая партия',
        2926: 'Перерыв',
        2927: '14-ая партия',
        2928: 'Перерыв',
        2929: '15-ая партия',
        2930: 'Перерыв',
        2931: '16-ая партия',
        2932: 'Перерыв',
        2933: '17-ая партия',
        2934: 'Перерыв',
        2935: '18-ая партия',
        2936: 'Перерыв',
        2937: '19-ая партия',
        2938: 'Перерыв',
        2939: '20-ая партия',
        2940: 'Перерыв',
        2941: '21-ая партия',
        2942: 'Перерыв',
        2900: 'Матч еще не начался',
        2901: '1-ая партия',
        2902: 'Перерыв',
        2903: '2-ая партия',
        2904: 'Перерыв',
        2905: '3-ья партия',
        2906: 'Перерыв',
        2907: '4-ая партия',
        2908: 'Перерыв',
        2909: '5-ая партия',
        2910: 'Перерыв'
    },
    30: {
        3008: 'Закончилось дополнительное время',
        3007: 'Овертайм',
        3006: 'Основное время закончилось',
        3005: 'Третий период',
        3004: 'Второй перерыв',
        3009: 'Буллиты',
        3002: 'Первый перерыв',
        3001: 'Первый период',
        3000: 'Матч еще не начался',
        3010: 'Матч закончился',
        3003: 'Второй период'
    },
    31: {
        3108: 'Пауза',
        3107: 'Четвёртая четверть',
        3106: 'Пауза',
        3105: 'Третья четверть',
        3104: 'Перерыв',
        3109: 'Овертайм',
        3102: 'Пауза',
        3101: 'Первая четверть',
        3100: 'Матч еще не начался',
        3110: 'Матч закончился',
        3103: 'Вторая четверть'
    },
    32: {
        3203: 'Третий сет',
        3202: 'Второй сет',
        3201: 'Первый сет',
        3200: 'Матч еще не начался',
        3204: 'Матч закончился'
    },
    34: {
        3400: 'Матч еще не начался',
        3401: 'Первый тайм',
        3402: 'Перерыв',
        3403: 'Второй тайм',
        3404: 'Основное время закончилось',
        3410: 'Матч закончился',
        3406: 'Закончилось первое дополнительное время',
        3407: 'Второе дополнительное время',
        3408: 'Закончилось второе дополнительное время',
        3409: 'Пенальти',
        3405: 'Первое дополнительное время'
    },
    35: {
        3500: 'Матч еще не начался',
        3501: 'Первый тайм',
        3502: 'Перерыв',
        3503: 'Второй тайм',
        3504: 'Матч закончился'
    },
    36: {
        3601: 'Первый период',
        3602: 'Первый перерыв',
        3603: 'Второй период',
        3604: 'Второй перерыв',
        3605: 'Третий период',
        3600: 'Матч еще не начался',
        3607: 'Овертайм',
        3608: 'Закончилось дополнительное время',
        3609: 'Буллиты',
        3610: 'Матч закончился',
        3606: 'Основное время закончилось'
    },
    37: {
        3701: 'Матч закончился',
        3700: 'Матч еще не начался'
    },
    38: {
        3801: 'Матч закончился',
        3800: 'Матч еще не начался'
    },
    39: {
        3901: 'Матч закончился',
        3900: 'Матч еще не начался',
        3902: 'Первый раунд',
        3903: 'Второй раунд',
        3904: 'Третий раунд',
        3905: 'Четвертый раунд',
        3906: 'Пятый раунд',
    },
    40: {
        4001: 'Матч закончился',
        4000: 'Матч еще не начался'
    },
    41: {
        4102: 'Первый перерыв',
        4106: 'Матч закончился',
        4105: 'Овертайм',
        4104: 'Второй перерыв',
        4103: 'Вторая половина',
        4101: 'Первая половина',
        4100: 'Матч еще не начался'
    },
    42: {
        4202: 'Вторая карта',
        4206: 'Матч закончился',
        4205: 'Пятая карта',
        4204: 'Четвертая карта',
        4203: 'Третья карта',
        4201: 'Первая карта',
        4200: 'Матч еще не начался'
    }
};
export function getOutcomeName(sportId, outcome, match) {
    var func;
    if (baseOutcomeConfig !== undefined &&
        baseOutcomeConfig[sportId] !== undefined &&
        baseOutcomeConfig[sportId]) {
        func = baseOutcomeConfig[sportId][outcome.type];
    }
    if (outcomeConfig !== undefined &&
        outcomeConfig[sportId] !== undefined &&
        outcomeConfig[sportId][outcome.type] !== undefined) {
        func = outcomeConfig[sportId][outcome.type];
    }
    if (func === undefined) {
        return undefined;
    }
    return func(match, outcome);
}
export function getRateName(sportId, outcome, factorType, match) {
    var func;
    if (baseFactorNameConfig !== undefined &&
        baseFactorNameConfig[sportId] !== undefined &&
        baseFactorNameConfig[sportId][outcome.type] !== undefined) {
        func = baseFactorNameConfig[sportId][outcome.type][factorType];
    }
    if (func === undefined) {
        return undefined;
    }
    return func(match, outcome);
}
export function getPeriodName(sportId, periodId) {
    if (periodConfig !== undefined && periodConfig[sportId] !== undefined) {
        return periodConfig[sportId][periodId];
    }
    return undefined;
}



// WEBPACK FOOTER //
// ./src/localization/ru.js